webpackJsonp([2],{

/***/ "+070":
/***/ (function(module, exports) {

module.exports = {
	"https": true,
	"ws": "data.whispeer.de",
	"wsPort": 443,
	"debug": false,
	"production": true,
	"workerScript": "assets/js/build/worker.bundle.js",
	"serviceWorker": {
		"enabled": false
	}
};

/***/ }),

/***/ "+1JK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** our keystore.
	handles all the keys, passwords, etc.
	keys are a little difficult because some keys look different but are the same because they are encrypted differently
	also keys always have a decryptor because the are never distributed alone.

	uploading:
		key -> addSymDecryptor/addAsymDecryptor/addPWDecryptor -> intKey
		key -> getUploadData() -> intKey
		do for multiple keys, concat, submit.

	the key should cache which of its data is dirty and which is not.
	removing decryptors (later) should update directly if the key as such is already saved.

	keyid: identifier@timestamp
**/
/*
{
	"crv":"P-256",
	"ext":true,
	"key_ops":["verify"],
	"kty":"EC",
	"x":"_u7VBNaYjLEcaj2Vw1t-CiH_or3xPudekyW4iJrjwgs",
	"y":"YMv7KmTnxpU16ytQrAYgcw4bpoQuPZwLSwvM_imsqxA"
}
*/

var h = __webpack_require__("S8e/").default;
var chelper = __webpack_require__("WfiL");
var sjcl = __webpack_require__("kHLR");
var waitForReady = __webpack_require__("FISs");
var sjclWorkerInclude = __webpack_require__("OY2u");
var ObjectHasher = __webpack_require__("2KOF");
var errors = __webpack_require__("a86h");
var Bluebird = __webpack_require__("fp6q");
var debug = __webpack_require__("jcLW");
var Raven = __webpack_require__("jYBl");

var keyStoreDebug = debug("whispeer:keyStore");

var keyGetFunction,
    firstVerify = true,
    improvementListener = [],
    makeKey,
    keyStore,
    recovery = false,
    sjclWarning = true;

/** dirty and new keys to upload. */
var dirtyKeys = [],
    newKeys = [];

/** cache for keys */
var symKeys = {},
    cryptKeys = {},
    signKeys = {};
var password = "",
    keyGenIdentifier = "",
    mainKey;

/** identifier list of keys we can use for encryption. this is mainly a safeguard for coding bugs. */
var keysUsableForEncryption = [];

var privateActionsBlocked = false;

/** our classes */
var Key, SymKey, CryptKey, SignKey;

sjcl.random.startCollectors();

var MAXSPEED = 99999999999,
    SPEEDS = {
	symKey: {
		loaded: 3,
		unloaded: 50
	},
	cryptKey: {
		loaded: 100,
		unloaded: 150
	},
	pw: 3
};

try {
	if (localStorage) {
		var pw = localStorage.getItem("whispeer.session.password");
		if (pw && typeof pw === "string") {
			password = pw;
		}
	}
} catch (e) {
	keyStoreDebug(e);
}

function bufferToHex(buffer) {
	var hexCodes = [];
	var view = new DataView(buffer);
	for (var i = 0; i < view.byteLength; i += 4) {
		// Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
		var value = view.getUint32(i);
		// toString(16) will give the hex representation of the number without padding
		var stringValue = value.toString(16);
		// We use concatenation and slice for padding
		var padding = "00000000";
		var paddedValue = (padding + stringValue).slice(-padding.length);
		hexCodes.push(paddedValue);
	}

	// Join all the hex strings into one
	return hexCodes.join("");
}

function fingerPrintData(data) {
	return sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(data));
}

function fingerPrintPublicKey(publicKey) {
	//should we add the type and curve here too?
	//as the curve is fixed for now it should not be a problem
	return fingerPrintData(publicKey._point.toBits());
}

function fingerPrintSymKey(keyData) {
	if (keyData instanceof Array) {
		return fingerPrintData(keyData);
	} else {
		throw new errors.InvalidDataError("invalid key data");
	}
}

function getSubtle() {
	if (window.msCrypto && window.msCrypto.subtle) {
		return window.msCrypto.subtle;
	}

	if (!window.crypto) {
		return false;
	}

	if (window.crypto.subtle) {
		return window.crypto.subtle;
	}

	if (window.crypto.webkitSubtle) {
		return window.crypto.webkitSubtle;
	}

	return false;
}

function makeKeyUsableForEncryption(realid) {
	var fp = realid.split(":")[1];
	keysUsableForEncryption.push(fp);
}

function isKeyUsableForEncryption(realid) {
	var fp = realid.split(":")[1];
	return keysUsableForEncryption.indexOf(fp) > -1;
}

function toPrivateKey(type, curve) {
	return function (secret) {
		var exponent = new sjcl.bn(chelper.bits2hex(secret));

		return new type.secretKey(curve, exponent);
	};
}

function determineLength(object) {
	if ((typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") {
		return 0;
	}

	return Object.keys(object).reduce(function (prev, cur) {
		return prev + 1 + determineLength(object[cur]);
	}, 0);
}

function stringifyObject(object, version) {
	var length = determineLength(object);

	if (length < 50) {
		return new ObjectHasher(object, version).stringify();
	}

	console.warn("Length too long for stringify ", object._type, version, length);

	return sjclWorkerInclude.stringify(object, version);
}

function removeExpectedPrefix(bitArray, prefix) {
	var len = prefix.length,
	    part;
	prefix = sjcl.codec.utf8String.toBits(prefix);

	if (bitArray instanceof ArrayBuffer) {
		var buf8 = new Uint8Array(bitArray);
		part = sjcl.codec.arrayBuffer.toBits(new Uint8Array(buf8.subarray(0, len)).buffer);
		if (sjcl.bitArray.equal(prefix, part)) {
			return new Uint8Array(buf8.subarray(len)).buffer;
		}
	} else {
		part = sjcl.bitArray.bitSlice(bitArray, 0, 8 * len);
		if (sjcl.bitArray.equal(prefix, part)) {
			return sjcl.bitArray.bitSlice(bitArray, 8 * len);
		}
	}

	throw new errors.DecryptionError("invalid prefix (should be: " + prefix + ")");
}

//TODO: webworkers:
//var webWorker = Modernizr.webworkers;

/** generate an id */
function generateid(base) {
	var id = keyGenIdentifier + ":" + chelper.bits2hex(base);

	if (symKeys[id] || cryptKeys[id] || signKeys[id]) {
		throw new errors.SecurityError("key already existing with same content ... this should never happen!");
	}

	return id;
}

function correctKeyIdentifier(realid) {
	var parts = realid.split(":");

	if (parts.length !== 2) {
		throw new errors.InvalidDataError("Key id does not match format!");
	}

	if (parts[0].length === 0) {
		return keyGenIdentifier + ":" + parts[1];
	}

	return realid;
}

/** encrypt with password
* @param pw password to encrypt
* @param text text to encrypt
* @param callback callback
*/
function encryptPW(pw, text) {
	return Bluebird.try(function () {
		var result = sjcl.json._encrypt(pw, text);
		return chelper.sjclPacket2Object(result);
	});
}

/** our internal decryption function.
* @param decryptorid id of decryptor
* @param decryptortype decryptor type
* @param ctext crypted text
* @param callback called with results
* @param iv necessary for symkey/pw encrypted data
* @param salt necessary for pw encrypted data
*/
function internalDecrypt(decryptorid, decryptortype, ctext, iv, salt) {
	return Bluebird.try(function () {
		if (decryptortype === "symKey" || decryptortype === "backup") {
			return Bluebird.try(function () {
				return SymKey.get(decryptorid);
			}).then(function (theKey) {
				return theKey.decryptKey().thenReturn(theKey);
			}).then(function (theKey) {
				return theKey.decrypt(ctext, iv);
			}).then(function (decryptedData) {
				return removeExpectedPrefix(decryptedData, "key::");
			});
		} else if (decryptortype === "cryptKey") {
			return Bluebird.try(function () {
				return CryptKey.get(decryptorid);
			}).then(function (theKey) {
				return theKey.decryptKey().thenReturn(theKey);
			}).then(function (theKey) {
				return theKey.unkem(chelper.hex2bits(ctext));
			});
		} else if (decryptortype === "pw") {
			return Bluebird.try(function () {
				var jsonData = chelper.Object2sjclPacket({
					ct: ctext,
					iv: iv,
					salt: salt
				}),
				    result;
				if (password !== "") {
					result = sjcl.decrypt(password, jsonData, { raw: 1 });

					return removeExpectedPrefix(result, "key::");
				}

				throw new errors.DecryptionError("no pw");
			});
		} else {
			throw new errors.InvalidDataError("invalid decryptortype");
		}
	});
}

/** returns a decryptors object if loaded
* @param decryptorData
* @return decryptorObject or null
*/
function getDecryptor(decryptorData) {
	if (decryptorData.type === "symKey") {
		return symKeys[decryptorData.decryptorid];
	}

	if (decryptorData.type === "cryptKey") {
		return cryptKeys[decryptorData.decryptorid];
	}

	return null;
}

/** general key object.
* @param realid keys real id
* @param decryptors array of decryptor data
* @param optional secret unencrypted secret if we already have it
*/
Key = function keyConstructor(superKey, realid, decryptors, optionals) {
	var theKey = this,
	    decryptKeyPromise,
	    dirtyDecryptors = [],
	    internalSecret,
	    preSecret;

	if (!decryptors) {
		decryptors = [];
	}

	/** identity past processor */
	var pastProcessor = function pastProcessor(secret) {
		return secret;
	};

	optionals = optionals || {};

	if (typeof optionals.pastProcessor === "function") {
		pastProcessor = optionals.pastProcessor;
	}

	if (optionals.secret) {
		preSecret = optionals.secret;
		internalSecret = pastProcessor(optionals.secret);
		decryptKeyPromise = Bluebird.resolve();
	}

	/** is the key decrypted */
	this.decrypted = function decryptedF() {
		return decryptKeyPromise && decryptKeyPromise.isFulfilled();
	};

	function decryptKey() {
		var usedDecryptor;
		if (!decryptKeyPromise) {
			decryptKeyPromise = Bluebird.try(function () {
				usedDecryptor = theKey.getFastestDecryptor();

				if (!usedDecryptor || !usedDecryptor.decryptor) {
					throw new errors.DecryptionError("Could not Decrypt key!");
				}

				var d = usedDecryptor.decryptor;

				return internalDecrypt(d.decryptorid, d.type, d.ct, d.iv, d.salt);
			}).then(function (result) {
				if (result === false) {
					throw new Error("Could not decrypt");
				}

				if (usedDecryptor.decryptor.type === "cryptKey") {
					h.callEach(improvementListener, [theKey.getRealID()]);
				}

				return pastProcessor(result);
			}).then(function (pastProcessedSecret) {
				preSecret = internalSecret;
				internalSecret = pastProcessedSecret;
			}).catch(function (err) {
				Raven.captureException(err || { err: "internaldecryptor returned false for realid: " + realid });
				keyStoreDebug(err);
				keyStoreDebug("decryptor failed for key: " + realid);

				decryptors = decryptors.filter(function (decryptor) {
					return decryptor !== usedDecryptor.decryptor;
				});

				if (decryptors.length === 0) {
					throw new errors.DecryptionError("Could finally not decrypt key!");
				}

				decryptKeyPromise = undefined;

				return decryptKey();
			});
		}

		return decryptKeyPromise;
	}

	/** decrypt this key.
 * @param callback called with true/false
 * searches your whole keyspace for a decryptor and decrypts if possible
 */
	this.decryptKey = decryptKey;

	/** getter for real id */
	function getRealIDF() {
		return correctKeyIdentifier(realid);
	}
	this.getRealID = getRealIDF;

	this.getRealidFingerPrint = function () {
		return realid.split(":")[1];
	};

	/** getter for decryptors array
 * copies array before returning
 */
	function getDecryptorsF() {
		var result = [],
		    i,
		    tempR,
		    k;
		for (i = 0; i < decryptors.length; i += 1) {
			tempR = {};
			for (k in decryptors[i]) {
				if (decryptors[i].hasOwnProperty(k)) {
					tempR[k] = decryptors[i][k];
				}
			}

			result.push(tempR);
		}

		return result;
	}
	this.getDecryptors = getDecryptorsF;

	/** get the fastest decryptor for this key.
 * @param level only used for recursion prevention.
 * @return {
 *  speed: speed of decryptor found.
 *  decryptor: decryptor found.
 * }
 */
	function getFastestDecryptorF(level) {
		if (!level) {
			level = 0;
		}

		if (level > 100) {
			keyStoreDebug("dafuq, deeply nested keys");
			return MAXSPEED;
		}

		var i,
		    cur,
		    key,
		    decryptorIndex = 0,
		    smallest = MAXSPEED,
		    subKeyData,
		    speed,
		    curSpeeds;
		for (i = 0; i < decryptors.length; i += 1) {
			cur = decryptors[i];
			curSpeeds = SPEEDS[cur.type];

			if (!curSpeeds) {
				speed = MAXSPEED;
			} else if (typeof curSpeeds === "number") {
				speed = curSpeeds;
			} else {
				key = getDecryptor(cur);
				if (key) {
					if (key.decrypted()) {
						speed = curSpeeds.loaded;
					} else {
						subKeyData = key.getFastestDecryptor(level + 1);
						speed = curSpeeds.loaded + subKeyData.speed;
					}
				} else {
					speed = curSpeeds.unloaded;
				}
			}

			if (speed < smallest) {
				smallest = speed;
				decryptorIndex = i;
			}
		}

		return {
			speed: smallest,
			decryptor: decryptors[decryptorIndex]
		};
	}
	this.getFastestDecryptor = getFastestDecryptorF;

	/** add crypt Key decryptor
 * @param realid decryptor key realid
 * @param tag decryption tag
 * @param callback callback
 */
	function addAsymDecryptorF(realid, tag) {
		return Bluebird.try(function () {
			var decryptorData = {
				decryptorid: realid,
				type: "cryptKey",
				ct: chelper.bits2hex(tag),
				dirty: true
			};

			decryptors.push(decryptorData);
			dirtyKeys.push(superKey);
			dirtyDecryptors.push(decryptorData);
		});
	}

	/** add symKey decryptor.
 * @param realid realid of decryptor
 * @param callback callback
 */
	function addSymDecryptorF(realid) {
		return Bluebird.try(function () {
			if (realid instanceof SymKey) {
				return realid;
			}

			return SymKey.get(realid);
		}).then(function (cryptorKey) {
			return theKey.decryptKey().thenReturn(cryptorKey);
		}).then(function (cryptorKey) {
			var secret = preSecret || internalSecret;
			return cryptorKey.encryptWithPrefix("key::", secret).then(function (data) {
				var decryptorData = {
					decryptorid: cryptorKey.getRealID(),
					type: "symKey",
					ct: chelper.bits2hex(data.ct),
					iv: chelper.bits2hex(data.iv),
					dirty: true
				};

				decryptors.push(decryptorData);
				dirtyKeys.push(superKey);
				dirtyDecryptors.push(decryptorData);

				return cryptorKey.getRealID();
			});
		});
	}

	/** add a pw decryptor
 * @param pw password
 * @param callback callback
 */
	function addPWDecryptorF(pw) {
		return theKey.decryptKey().then(function () {
			var prefix = sjcl.codec.utf8String.toBits("key::");
			var data = sjcl.bitArray.concat(prefix, preSecret || internalSecret);

			return chelper.sjclPacket2Object(sjcl.json._encrypt(pw, data));
		}).then(function (data) {
			var decryptorData = {
				//Think, shortHash here? id: ?,
				type: "pw",
				ct: chelper.bits2hex(data.ct),
				iv: chelper.bits2hex(data.iv),
				salt: chelper.bits2hex(data.salt),
				dirty: true
			};

			decryptors.push(decryptorData);
			dirtyKeys.push(superKey);
			dirtyDecryptors.push(decryptorData);

			return decryptorData;
		});
	}

	this.addAsymDecryptor = addAsymDecryptorF;
	this.addSymDecryptor = addSymDecryptorF;
	this.addPWDecryptor = addPWDecryptorF;

	/** get all data which need uploading. */
	function getDecryptorDataF(includeAllDecryptors) {
		//get the upload data for the decryptors of this key.
		//this will be called in the keys upload() function.

		var decryptorArray = dirtyDecryptors;

		if (includeAllDecryptors) {
			decryptorArray = decryptors;
		}

		return decryptorArray.map(function (decryptor) {
			var tempR = {},
			    k;
			for (k in decryptor) {
				if (decryptor.hasOwnProperty(k)) {
					tempR[k] = decryptor[k];
				}
			}

			if (tempR.decryptorid) {
				tempR.decryptorid = correctKeyIdentifier(tempR.decryptorid);
			}

			return tempR;
		});
	}
	this.getDecryptorData = getDecryptorDataF;

	/** check if this key has dirty decryptors */
	function isDirtyF() {
		return theKey.dirtyDecryptors.length !== 0;
	}
	this.isDirty = isDirtyF;

	/** remove uploaded keys from dirty array */
	function removeDirtyF(keys) {
		var remaining = [],
		    i,
		    j,
		    isRemaining,
		    curD,
		    curK;
		for (i = 0; i < dirtyDecryptors.length; i += 1) {
			curD = dirtyDecryptors[i];
			isRemaining = true;
			for (j = 0; j < keys.length; j += 1) {
				curK = keys[j];
				if (curD.type === curK.type && curD.ct === curK.ct && curD.decryptorid === curK.decryptorid) {
					keys.splice(j, 1);
					isRemaining = false;

					break;
				}
			}

			if (isRemaining) {
				remaining.push(curD);
			}
		}

		dirtyDecryptors = remaining;
	}
	this.removeDirty = removeDirtyF;

	/** get the secret of this key */
	this.getSecret = function () {
		if (this.decrypted()) {
			return internalSecret;
		}

		return false;
	};
};

/** a SymKey.
* @param keyData if not set: generate key; if string: hex of unencrypted key; otherwise: key data
* @attribute id
* @attribute realid
* @attribute decryptor data
* @attribute encrypted key
* implements all symmetric key functions.
*/
SymKey = function SymKey(keyData) {
	var intKey,
	    comment = "";

	if (!keyData) {
		keyData = sjcl.random.randomWords(8);
	}

	if (typeof keyData === "string") {
		keyData = chelper.hex2bits(keyData);
	}

	if (keyData instanceof Array) {
		intKey = new Key(this, generateid(fingerPrintSymKey(keyData)), [], { secret: keyData });
	} else {
		intKey = new Key(this, keyData.realid, keyData.decryptors, {
			pastProcessor: function pastProcessor(secret) {
				var fp = fingerPrintSymKey(secret);
				if (fp !== intKey.getRealidFingerPrint()) {
					throw new errors.ValidationError("Fingerprint and Key id do not match");
				}
				return secret;
			}
		});
	}

	this.getAccessCount = function () {
		return keyData.accessCount;
	};

	this.getUploadData = function (includeAllDecryptors) {
		var data = {
			realid: intKey.getRealID(),
			type: "sym",
			decryptors: this.getDecryptorData(includeAllDecryptors),
			comment: comment
		};

		return data;
	};

	this.getDecryptorData = intKey.getDecryptorData;

	this.getRealID = intKey.getRealID;
	this.getDecryptors = intKey.getDecryptors;
	this.decrypted = intKey.decrypted;

	this.addAsymDecryptor = intKey.addAsymDecryptor;
	this.addSymDecryptor = intKey.addSymDecryptor;
	this.addPWDecryptor = intKey.addPWDecryptor;

	this.decryptKey = intKey.decryptKey;
	this.getFastestDecryptor = intKey.getFastestDecryptor;

	this.setComment = function setCommentF(theComment) {
		if (theComment) {
			comment = theComment;
		}
	};

	/** encrypt a text.
 * @param text text to encrypt
 * @param callback called with result
 * @param optional iv initialization vector
 */

	this.encryptWithPrefix = function (prefix, data, progressCallback, noDecode) {
		if (privateActionsBlocked) {
			throw new errors.SecurityError("Private Actions are blocked (encryptWithPrefix)");
		}

		if (!isKeyUsableForEncryption(intKey.getRealID())) {
			throw new errors.SecurityError("Key not usable for encryption: " + intKey.getRealID());
		}

		return intKey.decryptKey().then(function () {
			if (typeof data === "string") {
				data = sjcl.codec.utf8String.toBits(data);
			}

			prefix = sjcl.codec.utf8String.toBits(prefix);

			if (data instanceof ArrayBuffer) {
				prefix = sjcl.codec.arrayBuffer.fromBits(prefix, false);
				var l = prefix.byteLength + data.byteLength;
				var p = 16;
				var padding = new ArrayBuffer(p - l % p);
				data = h.concatBuffers(prefix, data, padding);
			} else {
				data = sjcl.bitArray.concat(prefix, data);
			}

			return sjclWorkerInclude.sym.encrypt(intKey.getSecret(), data, progressCallback);
		}).then(function (result) {
			if (noDecode) {
				return result;
			} else {
				return chelper.sjclPacket2Object(result);
			}
		});
	};

	/** decrypt some text.
 * @param ctext text to decrypt
 * @param callback called with results
 * @param optional iv initialization vector
 */
	this.decrypt = function (ctext, iv, progressCallback) {
		return intKey.decryptKey().then(function () {
			if ((typeof ctext === "undefined" ? "undefined" : _typeof(ctext)) !== "object") {
				if (h.isHex(ctext)) {
					ctext = chelper.hex2bits(ctext);
				}

				ctext = { ct: ctext };
			} else {
				if (h.isHex(ctext.iv)) {
					ctext.iv = chelper.hex2bits(ctext.iv);
				}

				if (h.isHex(ctext.ct)) {
					ctext.ct = chelper.hex2bits(ctext.ct);
				}
			}

			if (iv) {
				if (h.isHex(iv)) {
					iv = chelper.hex2bits(iv);
				}
				ctext.iv = iv;
			}

			if (ctext.ct.length < 500) {
				return sjcl.json._decrypt(intKey.getSecret(), ctext, { raw: 1 });
			} else {
				return sjclWorkerInclude.sym.decrypt(intKey.getSecret(), ctext, progressCallback);
			}
		});
	};
};

/** make a symkey out of keydata */
function makeSymKey(keyData) {
	if (keyData && keyData.realid) {
		if (!symKeys[keyData.realid]) {
			var key = new SymKey(keyData);
			symKeys[keyData.realid] = key;
		}

		return symKeys[keyData.realid];
	}
}

/** load a key and his keychain. remove loaded keys */
function getKey(realKeyID, callback) {
	return keyGetFunction(realKeyID, callback);
}

/** generates a symmetric key
* @param callback callback
*/
function symKeyGenerate(comment) {
	return Bluebird.try(function () {
		return new SymKey();
	}).then(function (key) {
		if (symKeys[key.getRealID()]) {
			return symKeyGenerate(comment);
		}

		symKeys[key.getRealID()] = key;
		newKeys.push(key);
		makeKeyUsableForEncryption(key.getRealID());

		key.setComment(comment);

		return symKeys[key.getRealID()];
	});
}

/** load  a symkey and its keychain */
SymKey.get = function (realKeyID) {
	return Bluebird.try(function () {
		if (!symKeys[realKeyID]) {
			return getKey(realKeyID);
		}
	}).then(function () {
		if (symKeys[realKeyID]) {
			return symKeys[realKeyID];
		}

		throw new errors.InvalidDataError("keychain not found (sym) " + realKeyID);
	});
};

SymKey.generate = symKeyGenerate;

/** a ecc crypto key
* @param keyData keys data.
*/
CryptKey = function CryptKey(keyData) {
	var publicKey,
	    intKey,
	    x,
	    y,
	    curve,
	    point,
	    realid,
	    isPrivateKey = false,
	    comment = "";

	if (!keyData || !keyData.point || !keyData.point.x || !keyData.point.y || !keyData.curve || !keyData.realid) {
		throw new errors.InvalidDataError("invalid data");
	}

	curve = chelper.getCurve(keyData.curve);

	x = curve.field.fromBits(chelper.hex2bits(keyData.point.x));
	y = curve.field.fromBits(chelper.hex2bits(keyData.point.y));
	point = new sjcl.ecc.point(curve, x, y);

	publicKey = new sjcl.ecc.elGamal.publicKey(curve, point);

	realid = keyData.realid;

	if (keyData.exponent) {
		isPrivateKey = true;

		intKey = new Key(this, realid, keyData.decryptors, {
			secret: keyData.exponent,
			pastProcessor: toPrivateKey(sjcl.ecc.elGamal, curve)
		});
	} else if (keyData.decryptors) {
		isPrivateKey = true;
		intKey = new Key(this, realid, keyData.decryptors, {
			pastProcessor: toPrivateKey(sjcl.ecc.elGamal, curve)
		});
	} else {
		intKey = new Key(this, realid, []);
	}

	if (fingerPrintPublicKey(publicKey) !== intKey.getRealidFingerPrint()) {
		throw new errors.ValidationError("Fingerprint and Key id do not match");
	}

	this.getRealID = intKey.getRealID;

	if (isPrivateKey) {
		this.decrypted = intKey.decrypted;
		this.decryptKey = intKey.decryptKey;

		this.getFastestDecryptor = intKey.getFastestDecryptor;

		this.getDecryptorsF = intKey.getDecryptors;

		this.addAsymDecryptor = intKey.addAsymDecryptor;
		this.addSymDecryptor = intKey.addSymDecryptor;
		this.addPWDecryptor = intKey.addPWDecryptor;

		this.getUploadData = function (includeAllDecryptors) {
			var p = publicKey._point,
			    data = {
				realid: intKey.getRealID(),
				point: {
					x: chelper.bits2hex(p.x.toBits()),
					y: chelper.bits2hex(p.y.toBits())
				},
				curve: chelper.getCurveName(publicKey._curve),
				type: "crypt",
				decryptors: this.getDecryptorData(includeAllDecryptors),
				comment: comment
			};

			return data;
		};

		this.setComment = function setCommentF(theComment) {
			if (theComment) {
				comment = theComment;
			}
		};

		this.getDecryptorData = intKey.getDecryptorData;
	}

	function getFingerPrintF() {
		return fingerPrintPublicKey(publicKey);
	}

	this.getFingerPrint = getFingerPrintF;

	/** create a key
 * param callback callback
 */
	this.kem = function () {
		if (privateActionsBlocked) {
			throw new errors.SecurityError("Private Actions are blocked (kem)");
		}

		if (!isKeyUsableForEncryption(intKey.getRealID())) {
			throw new errors.SecurityError("Key not usable for encryption: " + intKey.getRealID());
		}

		return Bluebird.try(function () {
			return publicKey.kem();
		}).then(function (keyData) {
			var resultKey = new SymKey(keyData.key);
			symKeys[resultKey.getRealID()] = resultKey;
			newKeys.push(resultKey);
			makeKeyUsableForEncryption(resultKey.getRealID());
			return resultKey.addAsymDecryptor(realid, keyData.tag).thenReturn(resultKey.getRealID());
		});
	};

	if (isPrivateKey) {
		/** unkem a key from a tag
  * @param tag the tag
  * @param callback callback
  */
		this.unkem = function (tag) {
			return Bluebird.try(function () {
				if (!isPrivateKey) {
					throw new Error("not a private key");
				}

				return intKey.decryptKey();
			}).then(function () {
				keyStoreDebug("slow decrypt");

				return intKey.getSecret().unkem(tag);
			});
		};
	}
};

/** make a crypt key out of keydata */
function makeCryptKey(keyData) {
	if (keyData && keyData.realid) {
		if (!cryptKeys[keyData.realid]) {
			var key = new CryptKey(keyData);
			cryptKeys[keyData.realid] = key;
		}

		return cryptKeys[keyData.realid];
	}
}

/** get a crypt key
* @param realKeyID keys real id
* @param callback callback
*/
CryptKey.get = function (realKeyID) {
	return Bluebird.try(function () {
		if (!cryptKeys[realKeyID]) {
			return getKey(realKeyID);
		}
	}).then(function () {
		if (cryptKeys[realKeyID]) {
			return cryptKeys[realKeyID];
		}

		throw new errors.InvalidDataError("keychain not found");
	});
};

/** generate a crypt key
* @param curve curve to use
* @param callback callback
*/
CryptKey.generate = function (curve, comment) {
	return waitForReady.async().then(function () {
		var curveO = chelper.getCurve(curve),
		    rawKey = sjcl.ecc.elGamal.generateKeys(curveO);

		/*jslint nomen: true*/
		var p = rawKey.pub._point,
		    data = {
			point: {
				x: chelper.bits2hex(p.x.toBits()),
				y: chelper.bits2hex(p.y.toBits())
			},
			exponent: rawKey.sec._exponent.toBits(),
			realid: generateid(fingerPrintPublicKey(rawKey.pub)),
			curve: chelper.getCurveName(rawKey.pub._curve),
			comment: comment
		};
		/*jslint nomen: false*/

		var key = makeCryptKey(data);
		newKeys.push(key);

		key.setComment(comment);

		makeKeyUsableForEncryption(key.getRealID());

		return key;
	});
};

/** a signature key
* @param keyData sign key data
*/
SignKey = function SignKey(keyData) {
	var publicKey,
	    intKey,
	    x,
	    y,
	    curve,
	    point,
	    realid,
	    isPrivateKey = false,
	    comment = "";

	if (!keyData || !keyData.point || !keyData.point.x || !keyData.point.y || !keyData.curve || !keyData.realid) {
		throw new errors.InvalidDataError("invalid sign key data");
	}

	curve = chelper.getCurve(keyData.curve);

	x = curve.field.fromBits(chelper.hex2bits(keyData.point.x));
	y = curve.field.fromBits(chelper.hex2bits(keyData.point.y));
	point = new sjcl.ecc.point(curve, x, y);

	publicKey = new sjcl.ecc.ecdsa.publicKey(curve, point);

	realid = keyData.realid;

	//add exponent/decryptors
	if (keyData.exponent) {
		isPrivateKey = true;

		intKey = new Key(this, realid, keyData.decryptors, {
			secret: keyData.exponent,
			pastProcessor: toPrivateKey(sjcl.ecc.ecdsa, curve)
		});
	} else if (keyData.decryptors) {
		isPrivateKey = true;
		intKey = new Key(this, realid, keyData.decryptors, {
			pastProcessor: toPrivateKey(sjcl.ecc.ecdsa, curve)
		});
	} else {
		intKey = new Key(this, realid, []);
	}

	if (fingerPrintPublicKey(publicKey) !== intKey.getRealidFingerPrint()) {
		throw new errors.ValidationError("Fingerprint and Key id do not match");
	}

	this.getRealID = intKey.getRealID;

	this.getJWKPublicKey = function () {
		var p = publicKey._point;

		return {
			"crv": "P-256",
			"ext": true,
			"key_ops": ["verify"],
			"kty": "EC",
			"x": keyStore.format.base64ToUrl(sjcl.codec.base64.fromBits(p.x.toBits())),
			"y": keyStore.format.base64ToUrl(sjcl.codec.base64.fromBits(p.y.toBits()))
		};
	};

	this.getSubtlePublicKey = function () {
		if (!this._getSubtlePublicKeyPromise) {
			this._getSubtlePublicKeyPromise = getSubtle().importKey("jwk", this.getJWKPublicKey(), {
				name: "ECDSA",
				namedCurve: "P-256"
			}, true, ["verify"]);
		}

		return this._getSubtlePublicKeyPromise;
	};

	//add private key functions
	if (isPrivateKey) {
		this.decrypted = intKey.decrypted;
		this.decryptKey = intKey.decryptKey;

		this.getRealID = intKey.getRealID;
		this.getDecryptorsF = intKey.getDecryptors;

		this.addAsymDecryptor = intKey.addAsymDecryptor;
		this.addSymDecryptor = intKey.addSymDecryptor;
		this.addPWDecryptor = intKey.addPWDecryptor;

		this.getUploadData = function (includeAllDecryptors) {
			var p = publicKey._point,
			    data = {
				realid: intKey.getRealID(),
				point: {
					x: chelper.bits2hex(p.x.toBits()),
					y: chelper.bits2hex(p.y.toBits())
				},
				curve: chelper.getCurveName(publicKey._curve),
				type: "sign",
				decryptors: this.getDecryptorData(includeAllDecryptors),
				comment: comment
			};

			return data;
		};

		this.getDecryptorData = intKey.getDecryptorData;

		this.setComment = function setCommentF(theComment) {
			if (theComment) {
				comment = theComment;
			}
		};
	}

	function getFingerPrintF() {
		return fingerPrintPublicKey(publicKey);
	}

	var theKey = this;

	function subtleVerify(key, signatureBuf, buf) {
		return getSubtle().verify({
			name: "ECDSA",
			namedCurve: "P-256",
			hash: "SHA-256"
		}, key.publicKey, signatureBuf, buf);
	}

	if (isPrivateKey) {
		this.sign = function (hash, type) {
			if (privateActionsBlocked) {
				throw new errors.SecurityError("Private Actions are blocked (sign)");
			}

			var trustManager = __webpack_require__("1mek").default;
			var signatureCache = __webpack_require__("YFD0");

			return Bluebird.try(function () {
				if (!trustManager.isLoaded) {
					return trustManager.listenPromise("loaded");
				}
			}).then(function () {
				if (!trustManager.hasKeyData(intKey.getRealID())) {
					keyStoreDebug("key not in key database");
					alert("key not in key database: " + intKey.getRealID() + " - please report this issue to feedback@whispeer.de!");
					throw new errors.SecurityError("key not in key database");
				}

				return intKey.decryptKey();
			}).then(function () {
				return intKey.getSecret().sign(hash);
				//return sjclWorkerInclude.asym.sign(intKey.getSecret(), hash).nodeify(this);
			}).then(function (signature) {
				if (signatureCache.isLoaded()) {
					signatureCache.addValidSignature(signature, hash, realid, type);
				}

				return signature;
			});
		};
	}

	function verifySjcl(signature, hash) {
		if (sjclWarning) {
			keyStoreDebug("Verifying with sjcl");
			sjclWarning = false;
		}
		if (firstVerify) {
			firstVerify = false;
			return Bluebird.resolve(publicKey.verify(hash, signature));
		}

		return sjclWorkerInclude.asym.verify(publicKey, signature, hash);
	}

	function verifySubtle(signature, text) {
		return Bluebird.try(function () {
			return theKey.getSubtlePublicKey();
		}).then(function (key) {
			var signatureBuf = sjcl.codec.arrayBuffer.fromBits(signature);
			var buf = new TextEncoder("utf-8").encode(text);

			return subtleVerify({ publicKey: key }, signatureBuf, buf);
		});
	}

	function verify(signature, text, hash) {
		if (!getSubtle()) {
			return verifySjcl(signature, hash);
		}

		return verifySubtle(signature, text).then(function (valid) {
			if (!valid) {
				return verifySjcl(signature, hash);
			}

			return valid;
		}).catch(function (e) {
			if (sjclWarning) {
				console.error(e);
			}
			return verifySjcl(signature, hash);
		});
	}

	function subtleToHex(buffer) {
		var hexCodes = [];
		var view = new DataView(buffer);
		for (var i = 0; i < view.byteLength; i += 4) {
			// Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
			var value = view.getUint32(i);
			// toString(16) will give the hex representation of the number without padding
			var stringValue = value.toString(16);
			// We use concatenation and slice for padding
			var padding = "00000000";
			var paddedValue = (padding + stringValue).slice(-padding.length);
			hexCodes.push(paddedValue);
		}

		// Join all the hex strings into one
		return hexCodes.join("");
	}

	function hash(text) {
		return Bluebird.resolve(text).then(function () {
			if (!getSubtle()) {
				throw new Error("subtle not available");
			}

			var buf = new TextEncoder("utf-8").encode(text);
			return getSubtle().digest("SHA-256", buf);
		}).then(function (hash) {
			return subtleToHex(hash);
		}).catch(function () {
			keyStoreDebug("Subtle hashing failed falling back to sjcl");
			return sjcl.hash.sha256.hash(text);
		});
	}

	this.getFingerPrint = getFingerPrintF;
	this.verify = function (signature, text, type, id) {
		var trustManager = __webpack_require__("1mek").default;
		var signatureCache = __webpack_require__("YFD0");
		var name = chelper.bits2hex(signature).substr(0, 10);

		if (debug.enabled("whispeer:keyStore")) {
			console.time("verify-" + name + "-" + type);
		}

		return hash(text).then(function (hash) {
			hash = chelper.hex2bits(hash);

			if (!trustManager.hasKeyData(intKey.getRealID())) {
				throw new errors.SecurityError("key not in key database");
			}

			if (signatureCache.isValidSignatureInCache(signature, hash, realid)) {
				signatureCache.addValidSignature(signature, hash, realid, type, id);
				return Bluebird.resolve(true);
			}

			keyStoreDebug("Slow verify of type: " + type);

			return verify(signature, text, hash).then(function (valid) {
				if (valid) {
					signatureCache.addValidSignature(signature, hash, realid, type, id);
				}

				return valid;
			}).catch(function (e) {
				console.error(e);
				return false;
			});
		}).finally(function () {
			if (debug.enabled("whispeer:keyStore")) {
				console.timeEnd("verify-" + name + "-" + type);
			}
		});
	};
};

/** make a sign key out of keydata */
function makeSignKey(keyData) {
	if (keyData && keyData.realid) {
		if (!signKeys[keyData.realid]) {
			var key = new SignKey(keyData);
			signKeys[keyData.realid] = key;
		}

		return signKeys[keyData.realid];
	}
}

/** get a signature key
* @param realKeyID the real id of the sign key
* @param callback callback
*/
SignKey.get = function signKeyGet(realKeyID) {
	if (signKeys[realKeyID]) {
		return Bluebird.resolve(signKeys[realKeyID]);
	}

	return getKey(realKeyID).then(function () {
		if (signKeys[realKeyID]) {
			return signKeys[realKeyID];
		}

		throw new errors.InvalidDataError("keychain not found (sign)");
	});
};

/** generate a sign key
* @param curve curve for the key
* @param callback callback
*/
SignKey.generate = function (curve, comment) {
	return waitForReady.async().then(function () {
		var curveO = chelper.getCurve(curve),
		    rawKey = sjcl.ecc.ecdsa.generateKeys(curveO);

		/*jslint nomen: true*/
		var p = rawKey.pub._point,
		    data = {
			point: {
				x: chelper.bits2hex(p.x.toBits()),
				y: chelper.bits2hex(p.y.toBits())
			},
			exponent: rawKey.sec._exponent.toBits(),
			realid: generateid(fingerPrintPublicKey(rawKey.pub)),
			curve: chelper.getCurveName(rawKey.pub._curve)
		};
		/*jslint nomen: false*/

		var key = makeSignKey(data);
		newKeys.push(key);

		key.setComment(comment);

		return key;
	});
};

/** make a key out of keyData. mainly checks type and calls appropriate function */
makeKey = function makeKeyF(key) {
	if (key.type === "sym") {
		makeSymKey(key);
	} else if (key.type === "crypt") {
		makeCryptKey(key);
	} else if (key.type === "sign") {
		makeSignKey(key);
	} else {
		throw new errors.InvalidDataError("unknown key type");
	}
};

var verifyAllAttributesAreHashes = function verifyAllAttributesAreHashes(data) {
	var attr;
	for (attr in data) {
		if (data.hasOwnProperty(attr)) {
			if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object") {
				verifyAllAttributesAreHashes(data[attr]);
			} else if (typeof data !== "string" || data.substr(0, 6) !== "hash") {
				throw new errors.ValidationError("invalid hashobject");
			}
		}
	}
};

var ObjectPadder = function ObjectPadder(obj, minLength) {
	this._obj = obj;
	this._minLength = minLength;
};

ObjectPadder.prototype._padObject = function (val) {
	return Bluebird.props(h.objectMap(val, function (value) {
		var padder = new ObjectPadder(value, this._minLength);
		return padder.pad();
	}, this));
};

ObjectPadder.prototype._padArray = function (val) {
	return Bluebird.resolve(val).bind(this).map(function (value) {
		var padder = new ObjectPadder(value, this._minLength);
		return padder.pad();
	});
};

ObjectPadder.prototype._padString = function (val) {
	var length = this._minLength - val.length % this._minLength + this._minLength;

	return Bluebird.try(function () {
		return keyStore.random.hex(length);
	}).then(function (rand) {
		return rand + "::" + val;
	});
};

ObjectPadder.prototype._padNumber = function (val) {
	return this._padString(val.toString()).then(function (padded) {
		return "num::" + padded;
	});
};

ObjectPadder.prototype._padAttribute = function (attr) {
	var type = typeof attr === "undefined" ? "undefined" : _typeof(attr);
	if (type === "object") {
		if (attr instanceof Array) {
			return this._padArray(attr);
		}

		return this._padObject(attr);
	} else if (type === "string") {
		return this._padString(attr);
	} else if (type === "number") {
		return this._padNumber(attr);
	} else if (type === "boolean") {
		return this._padNumber(attr ? 1 : 0);
	}

	throw new errors.InvalidDataError("could not pad value of type " + type);
};

ObjectPadder.prototype.pad = function () {
	return this._padAttribute(this._obj);
};

ObjectPadder.prototype._unpadObject = function (val) {
	var attr,
	    result = {};
	for (attr in val) {
		if (val.hasOwnProperty(attr)) {
			var padder = new ObjectPadder(val[attr], this._minLength);
			result[attr] = padder.unpad();
		}
	}

	return result;
};

ObjectPadder.prototype._unpadString = function (val) {
	var isNumber = false;

	if (val.indexOf("num::") === 0) {
		isNumber = true;

		val = val.substr(5);
	}

	if (val.length % this._minLength !== 2) {
		throw new errors.InvalidDataError("padding size invalid");
	}

	var paddingIndex = val.indexOf("::");

	if (paddingIndex === -1) {
		throw new errors.InvalidDataError("no padding seperator found");
	}

	var unpadded = val.substr(paddingIndex + 2);

	if (isNumber) {
		return parseFloat(unpadded);
	}

	return unpadded;
};

ObjectPadder.prototype._unpadArray = function (val) {
	var result = [],
	    i;
	for (i = 0; i < val.length; i += 1) {
		var padder = new ObjectPadder(val[i], this._minLength);
		result[i] = padder.unpad();
	}

	return result;
};

ObjectPadder.prototype._unpadAttribute = function (attr) {
	var type = typeof attr === "undefined" ? "undefined" : _typeof(attr);
	if (type === "object") {
		if (attr instanceof Array) {
			return this._unpadArray(attr);
			//TODO!
		} else {
			return this._unpadObject(attr);
		}
	} else if (type === "string") {
		return this._unpadString(attr);
	} else {
		throw new errors.InvalidDataError("could not pad value of type " + type);
	}
};

ObjectPadder.prototype.unpad = function () {
	return this._unpadAttribute(this._obj);
};

var ObjectCryptor = function ObjectCryptor(key, depth, object) {
	this._key = key;
	this._depth = depth;
	this._object = object;
};

ObjectCryptor.prototype._encryptAttr = function (cur) {
	if ((typeof cur === "undefined" ? "undefined" : _typeof(cur)) === "object") {
		return new ObjectCryptor(this._key, this._depth - 1, cur).encrypt();
	} else if (typeof cur === "string" || typeof cur === "number" || typeof cur === "boolean") {
		return this._key.encryptWithPrefix("data::", cur.toString());
	}

	throw new errors.InvalidDataError("Invalid encrypt!");
};

ObjectCryptor.prototype._encryptObject = function () {
	return Bluebird.props(h.objectMap(this._object, function (value, attr) {
		if (attr !== "key") {
			return this._encryptAttr(value);
		}
	}, this));
};

ObjectCryptor.prototype._encryptJSON = function () {
	return this._key.encryptWithPrefix("json::", JSON.stringify(this._object));
};

ObjectCryptor.prototype.encrypt = function () {
	if (this._depth > 0) {
		return this._encryptObject();
	} else {
		return this._encryptJSON();
	}
};

ObjectCryptor.prototype.decryptCorrectObject = function (obj) {
	if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && !(obj instanceof Array)) {
		return obj;
	} else {
		obj = sjcl.codec.utf8String.fromBits(obj);

		var prefix = obj.substr(0, 6);
		var content = obj.substr(6);

		if (prefix === "data::") {
			return content;
		} else if (prefix === "json::") {
			return JSON.parse(content);
		} else {
			throw new errors.ValidationError();
		}
	}
};

ObjectCryptor.prototype._decryptEndAttribute = function () {
	return this._key.decrypt(this._object).bind(this).then(function (result) {
		return this.decryptCorrectObject(result);
	});
};

ObjectCryptor.prototype._decryptPartialObjects = function () {
	return Bluebird.props(h.objectMap(this._object, function (value, attr) {
		if (attr !== "key") {
			return new ObjectCryptor(this._key, this._depth - 1, value).decrypt();
		}
	}, this));
};

ObjectCryptor.prototype.decrypt = function () {
	if (this._depth < 0) {
		throw new errors.DecryptionError("invalid decryption depth!");
	}

	if (this._object.iv && this._object.ct) {
		return this._decryptEndAttribute();
	} else {
		return this._decryptPartialObjects();
	}
};

/** our interface */
keyStore = {
	reset: function reset() {
		recovery = false;
		dirtyKeys = [];
		newKeys = [];

		keyGenIdentifier = "";

		symKeys = {};
		cryptKeys = {};
		signKeys = {};

		mainKey = undefined;

		password = "";
		keysUsableForEncryption = [];
		firstVerify = true;
	},

	setKeyGenIdentifier: function setKeyGenIdentifier(identifier) {
		keyGenIdentifier = identifier;
		//TODO: update all key identifiers for all keys.
	},

	getKeyGenIdentifier: function getKeyGenIdentifier() {
		return keyGenIdentifier;
	},

	correctKeyIdentifier: function correctKeyIdentifierF(realid) {
		return correctKeyIdentifier(realid);
	},

	addImprovementListener: function addImprovementListener(listener) {
		improvementListener.push(listener);
	},

	security: {
		blockPrivateActions: function blockPrivateActions() {
			privateActionsBlocked = true;
		},

		allowPrivateActions: function allowPrivateActions() {
			privateActionsBlocked = false;
		},

		arePrivateActionsBlocked: function arePrivateActionsBlocked() {
			return privateActionsBlocked;
		},

		addEncryptionIdentifier: function addEncryptionIdentifier(realid) {
			makeKeyUsableForEncryption(realid);
		},

		setPassword: function setPassword(pw) {
			recovery = false;
			password = pw;
		},

		verifyWithPW: function verifyWithPW(data, expectedResult) {
			if (!recovery) {
				//decrypt data with pw
				var result = sjcl.decrypt(password, chelper.Object2sjclPacket(data));
				//unpad data
				result = new ObjectPadder(JSON.parse(result), 128).unpad();

				//check with expectedresult
				if (!h.deepEqual(expectedResult, result)) {
					throw new errors.SecurityError("verify with pw failed");
				}
			}
		},

		makePWVerifiable: function makePWVerifiable(data, pw, cb) {
			return new ObjectPadder(data, 128).pad().then(function (paddedData) {
				return encryptPW(pw, JSON.stringify(paddedData));
			}).nodeify(cb);
		}
	},

	format: {
		urlToBase64: function urlToBase64(str) {
			return str.replace(/-/g, "+").replace(/_/g, "/");
		},
		base64ToUrl: function base64ToUrl(str) {
			return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
		},
		base64ToBits: function base64ToBits(base64) {
			return sjcl.codec.base64.toBits(base64);
		},
		bitsToBase64: function bitsToBase64(bits) {
			return sjcl.codec.base64.fromBits(bits);
		},
		fingerPrint: function fingerPrint(keyID) {
			var hex = keyID.split(":")[1];
			return sjcl.codec.base32.fromBits(sjcl.codec.hex.toBits(hex)).toUpperCase();
		},
		base32: function base32(bits) {
			return sjcl.codec.base32.fromBits(bits);
		},
		unBase32: function unBase32(bits) {
			return sjcl.codec.base32.toBits(bits);
		},
		unformat: function unformat(str, start) {
			if (str.indexOf(start + "::") !== 0) {
				throw new errors.InvalidDataError("format invalid");
			}

			return str.substr(start.length + 2);
		}
	},

	hash: {
		addPaddingToObject: function addPaddingToObject(obj, minLength) {
			minLength = minLength || 128;

			return new ObjectPadder(obj, minLength).pad();
		},
		removePaddingFromObject: function removePaddingFromObject(obj, padLength) {
			padLength = padLength || 128;
			return new ObjectPadder(obj, padLength).unpad();
		},
		hash: function hash(text) {
			return chelper.hash(text);
		},

		hashArrayBuffer: function hashArrayBuffer(buf) {
			return Bluebird.try(function () {
				return getSubtle().digest("SHA-256", buf);
			}).then(function (bufHash) {
				return bufferToHex(bufHash);
			}).catch(function () {
				return sjclWorkerInclude.hash(buf);
			});
		},

		hashPW: function hashPW(pw, salt) {
			return chelper.hashPW(pw, salt);
		},

		hashObjectOrValueHexAsync: function hashObjectOrValueHexAsync(val, version) {
			return Bluebird.try(function () {
				if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === "object") {
					return sjclWorkerInclude.stringify(val, version, true);
				} else {
					return sjcl.hash.sha256.hash("data::" + val);
				}
			}).then(function (value) {
				return chelper.bits2hex(value);
			}).then(function (hash) {
				return "hash::" + hash;
			});
		},

		hashObjectOrValueHex: function hashObjectOrValueHex(val, version) {
			if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === "object") {
				return "hash::" + new ObjectHasher(val, version).hash();
			} else {
				return "hash::" + chelper.bits2hex(sjcl.hash.sha256.hash("data::" + val));
			}
		}
	},

	upload: {
		preLoadMultiple: function preLoadMultiple(realids, cb) {
			return Bluebird.resolve(realids).map(function (realid) {
				return getKey(realid);
			}).nodeify(cb);
		},
		isKeyLoaded: function isKeyLoaded(realid) {
			return symKeys.hasOwnProperty(realid) || cryptKeys.hasOwnProperty(realid) || signKeys.hasOwnProperty(realid);
		},
		addKey: function addKey(keyData) {
			if (h.isRealID(keyData.realid)) {
				makeKey(keyData);
			}

			return keyData.realid;
		},
		getKeyAccessCount: function getKeyAccessCount(keyrealid) {
			var key = symKeys[keyrealid];
			if (key) {
				return key.getAccessCount();
			}

			return -1;
		},
		setKeyGet: function setKeyGet(_keyGetFunction) {
			keyGetFunction = _keyGetFunction;
		},
		getExistingKey: function getExistingKey(keyid) {
			if (!keyStore.upload.isKeyLoaded(keyid)) {
				return;
			}

			var key = symKeys[keyid] || cryptKeys[keyid] || signKeys[keyid];
			return key.getUploadData(true);
		},
		getKey: function getKey(keyid) {
			var i;
			for (i = 0; i < newKeys.length; i += 1) {
				if (keyid === newKeys[i].getRealID()) {
					return newKeys[i].getUploadData();
				}
			}
		},
		getKeys: function getKeys(keys) {
			var addKeys = [];
			var i;
			for (i = 0; i < newKeys.length; i += 1) {
				if (keys.indexOf(newKeys[i].getRealID()) > -1) {
					addKeys.push(newKeys[i].getUploadData());
				}
			}

			return addKeys;
		},
		getDecryptors: function getDecryptors(allowed, allowedEncryptors) {
			var addKeyDecryptors = {};

			dirtyKeys.filter(function (key) {
				return allowed.indexOf(key.getRealID()) !== -1;
			}).forEach(function (key) {
				var decryptors = key.getDecryptorData();

				if (allowedEncryptors) {
					decryptors = decryptors.filter(function (decryptor) {
						return allowedEncryptors.indexOf(decryptor.decryptorid) !== -1;
					});
				}

				addKeyDecryptors[key.getRealID()] = decryptors;
			});

			return addKeyDecryptors;
		},
		uploaded: function uploaded(data) {
			/*
   {
   	keys: {
   		realid1: realid1,
   		realid2: realid2,
   		realid3: realid3,
   		...
   	},
   	decryptors: {
   		realid1: data
   	}
   }
   */
			var realid;
			for (realid in data.decryptors) {
				if (data.decryptors.hasOwnProperty(realid)) {
					getKey(realid).removeDirty(data.decryptors[realid]);
				}
			}

			var remainedKeys = [];

			var i;
			for (i = 0; i < newKeys.length; i += 1) {
				realid = newKeys[i].getRealID();

				if (!data.keys[realid]) {
					remainedKeys.push(newKeys[i]);
				}
			}

			newKeys = remainedKeys;
		}
	},

	random: {
		hex: function hex(length, cb) {
			return waitForReady.async().then(function () {
				var res = chelper.bits2hex(sjcl.random.randomWords(Math.ceil(length / 8)));
				return res.substr(0, length);
			}).nodeify(cb);
		},
		words: function words(number, cb) {
			return waitForReady.async().then(function () {
				return sjcl.random.randomWords(number);
			}).nodeify(cb);
		}
	},

	sym: {
		registerMainKey: function registerMainKey(_mainKey) {
			mainKey = _mainKey;
		},

		/** generate a key
  * @param callback callback
  */
		generateKey: function generateKeyF(callback, comment) {
			return waitForReady.async().then(function () {
				return SymKey.generate(comment);
			}).then(function (key) {
				return key.getRealID();
			}).nodeify(callback);
		},

		createBackupKey: function createBackupKey(realID, callback) {
			/* two keys: key1 -> key2 -> main
   * key2 is on the server
   * key1 is downloaded/printed
   * server never distributes key2 except when advised to do so (manually for now!)
   */
			var backupKey, outerBackupKey, toBackupKey;

			return waitForReady.async().then(function () {
				return SymKey.get(realID);
			}).then(function (_toBackupKey) {
				toBackupKey = _toBackupKey;
				outerBackupKey = sjcl.random.randomWords(8);
				backupKey = new SymKey(sjcl.random.randomWords(8));

				makeKeyUsableForEncryption(backupKey.getRealID());
				makeKeyUsableForEncryption(new SymKey(outerBackupKey).getRealID());

				return Bluebird.all([toBackupKey.addSymDecryptor(backupKey), backupKey.addSymDecryptor(new SymKey(outerBackupKey))]);
			}).then(function () {
				var decryptorsAdded = keyStore.upload.getDecryptors([toBackupKey.getRealID()], [backupKey.getRealID()]);
				var backupKeyData = backupKey.getUploadData();

				backupKeyData.decryptors[0].type = "backup";

				return {
					decryptors: decryptorsAdded,
					innerKey: backupKeyData,
					outerKey: outerBackupKey
				};
			}).nodeify(callback);
		},

		loadBackupKey: function loadBackupKey(outerBackupKey) {
			var key = new SymKey(outerBackupKey);
			if (!symKeys[key.getRealID()]) {
				symKeys[key.getRealID()] = key;
			} else {
				throw new errors.SecurityError("Key already exists in symKey database (double add?)");
			}

			recovery = true;

			return key.getRealID();
		},

		/** encrypt key with sym key
  * @param realID key to encrypt
  * @param parentKeyID key to encrypt with
  * @param callback callback
  */
		symEncryptKey: function symEncryptKeyF(realID, parentKeyID, callback) {
			return SymKey.get(realID).then(function (key) {
				return key.addSymDecryptor(parentKeyID);
			}).nodeify(callback);
		},

		/** encrypt this key with an asymmetric key
  * @param realID key to encrypt
  * @param parentKeyID key to encrypt with
  * @param callback callback
  */
		asymEncryptKey: function asymEncryptKeyF(realID, parentKeyID, callback) {
			//ensure the key exists first!
			return SymKey.get(realID).then(function () {
				return CryptKey.get(parentKeyID);
			}).then(function (key) {
				return key.kem();
			}).then(function (parentRealID) {
				return keyStore.sym.symEncryptKey(realID, parentRealID);
			}).nodeify(callback);
		},

		/** encrypt key with password
  * @param realID key to encrypt
  * @param password password to encrypt with
  * @param callback callback
  */
		pwEncryptKey: function pwEncryptKeyF(realID, password, callback) {
			return SymKey.get(realID).then(function (key) {
				return key.addPWDecryptor(password);
			}).nodeify(callback);
		},

		/** encrypt text with this key.
  * @param text text to encrypt
  * @param realKeyID key to encrypt with
  * @param callback callback
  */
		encryptText: function encryptText(text, realKeyID, callback) {
			return SymKey.get(realKeyID).then(function (key) {
				return key.encryptWithPrefix("data::", text);
			}).nodeify(callback);
		},

		/** encrypt an object
  * @param object Object to encrypt
  * @param realKeyID key to encrypt with
  * @param callback callback
  */
		encryptObject: function encryptObject(object, realKeyID, depth, callback) {
			if (object.iv) {
				throw new errors.InvalidDataError("IV already set.");
			}

			return SymKey.get(realKeyID).then(function (key) {
				return new ObjectCryptor(key, depth, object).encrypt();
			}).nodeify(callback);
		},

		decryptObject: function decryptObject(cobject, depth, callback, keyID) {
			return SymKey.get(keyID || mainKey).then(function (key) {
				return new ObjectCryptor(key, depth, cobject).decrypt();
			}).nodeify(callback);
		},

		/** decrypt an encrypted text
  * @param ctext text to decrypt
  * @param realKeyID key to decrypt with
  * @param callback callback
  */
		decryptText: function decryptText(ctext, realKeyID, callback) {
			return SymKey.get(realKeyID).then(function (key) {
				return key.decrypt(ctext);
			}).then(function (decryptedData) {
				return sjcl.codec.utf8String.fromBits(removeExpectedPrefix(decryptedData, "data::"));
			}).nodeify(callback);
		},

		encryptArrayBuffer: function encryptArrayBuffer(buf, realKeyID, progressCallback) {
			return SymKey.get(realKeyID).then(function (key) {
				return key.encryptWithPrefix("buf::", buf, progressCallback, true);
			}).then(function (result) {
				result.iv = sjcl.codec.arrayBuffer.fromBits(result.iv, false);
				result.ct.tag = sjcl.codec.arrayBuffer.fromBits(result.ct.tag, false);
				return h.concatBuffers(result.iv, result.ct.ciphertext_buffer, result.ct.tag);
			});
		},

		decryptArrayBuffer: function decryptArrayBuffer(buf, realKeyID, progressCallback) {
			return SymKey.get(realKeyID).then(function (key) {
				var buf32 = new Uint32Array(buf);

				var decr = {
					iv: sjcl.codec.arrayBuffer.toBits(new Uint32Array(buf32.subarray(0, 4)).buffer),
					ct: new Uint32Array(buf32.subarray(4, buf32.byteLength / 4 - 2)).buffer,
					tag: sjcl.codec.arrayBuffer.toBits(new Uint32Array(buf32.subarray(buf32.byteLength / 4 - 2)).buffer)
				};

				return key.decrypt(decr, null, progressCallback);
			}).then(function (decryptedData) {
				return removeExpectedPrefix(decryptedData, "buf::");
			});
		},

		decryptBigBase64: function decryptBigBase64(bin, realKeyID, callback) {
			return SymKey.get(realKeyID).then(function (key) {
				bin = sjcl.codec.base64.toBits(bin);

				var decr = {
					iv: sjcl.bitArray.bitSlice(bin, 0, 32 * 4),
					ct: sjcl.bitArray.bitSlice(bin, 32 * 4)
				};

				return key.decrypt(decr);
			}).then(function (decryptedData) {
				return sjcl.codec.base64.fromBits(removeExpectedPrefix(decryptedData, "bin::"));
			}).nodeify(callback);
		}
	},

	asym: {
		/** generate a key
  * @param callback callback
  */
		generateKey: function generateKeyF(callback, comment) {
			return CryptKey.generate("256", comment).then(function (key) {
				return key.getRealID();
			}).nodeify(callback);
		},

		/** encrypt key with sym key
  * @param realID key to encrypt
  * @param parentKeyID key to encrypt with
  * @param callback callback
  */
		symEncryptKey: function symEncryptKeyF(realID, parentKeyID, callback) {
			return CryptKey.get(realID).then(function (key) {
				return key.addSymDecryptor(parentKeyID);
			}).nodeify(callback);
		},

		/** encrypt key with password
  * @param realID key to encrypt
  * @param password password to encrypt with
  * @param callback callback
  */
		pwEncryptKey: function pwEncryptKeyF(realID, password, callback) {
			return CryptKey.get(realID).then(function (key) {
				return key.addPWDecryptor(password);
			}).nodeify(callback);
		},

		fingerPrintKey: function fingerPrintKey(realID, cb) {
			return CryptKey.get(realID).then(function (key) {
				return key.getFingerPrint();
			}).nodeify(cb);
		}
	},

	sign: {
		/** generate a key
  * @param callback callback
  */
		generateKey: function generateKeyF(callback, comment) {
			return SignKey.generate("256", comment).then(function (key) {
				return key.getRealID();
			}).nodeify(callback);
		},

		/** encrypt key with sym key
  * @param realID key to encrypt
  * @param parentKeyID key to encrypt with
  * @param callback callback
  */
		symEncryptKey: function symEncryptKeyF(realID, parentKeyID, callback) {
			return SignKey.get(realID).then(function (key) {
				return key.addSymDecryptor(parentKeyID);
			}).nodeify(callback);
		},

		/** encrypt key with password
  * @param realID key to encrypt
  * @param password password to encrypt with
  * @param callback callback
  */
		pwEncryptKey: function pwEncryptKeyF(realID, password, callback) {
			return SignKey.get(realID).then(function (key) {
				return key.addPWDecryptor(password);
			}).nodeify(callback);
		},

		signObject: function signObject(object, realID, version, callback) {
			return Bluebird.all([SignKey.get(realID), sjclWorkerInclude.stringify(object, version, true)]).spread(function (key, hash) {
				return key.sign(hash, object._type);
			}).then(function (signature) {
				return chelper.bits2hex(signature);
			}).nodeify(callback);
		},

		verifyObject: function verifyObject(signature, object, realID, version, id) {
			signature = chelper.hex2bits(signature);

			return Bluebird.all([stringifyObject(object, version), SignKey.get(realID)]).spread(function (objectString, key) {
				return key.verify(signature, objectString, object._type, id);
			}).catch(function (e) {
				console.error(e);

				return false;
			});
		},

		fingerPrintKey: function fingerPrintKey(realID, cb) {
			return CryptKey.get(realID).then(function (key) {
				return key.getFingerPrint();
			}).nodeify(cb);
		}
	}
};

module.exports = keyStore;

/***/ }),

/***/ "+DAV":
/***/ (function(module, exports) {

var path = 'directives/modal.html';
var html = "<div class=modal data-ng-show=visible> <div class=modalBackground data-ng-click=hide()></div> <button class=\"modalClose btn btn--inverse btn--noRadius fa fa-times-circle\" data-ng-click=hide()></button> <div class=modalContentWrap ng-transclude> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "/d+L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");
var userService = __webpack_require__("UuKm").default;
var errorService = __webpack_require__("EFCD").errorServiceInstance;

"use strict";

var directivesModule = __webpack_require__("7Eh3");

// <loader data-model="user" data-ng-repeat="user in invite.usedBy" data-id="user" data-scope-attribute="user">

function loaderDirective() {
	return {
		restrict: "E",
		scope: {
			model: "@",
			id: "=",
			scopeAttribute: "@"
		},
		transclude: true,

		link: function link(scope, element, attrs, ctrl, transclude) {
			scope.loading = true;
			scope.loaded = false;

			if (scope.model === "user") {
				Bluebird.try(function () {
					return userService.get(scope.id);
				}).then(function (user) {
					return user.loadBasicData().thenReturn(user);
				}).then(function (user) {
					scope[scope.scopeAttribute] = user.data;
					scope.loaded = true;
					scope.loading = false;
				}).catch(errorService.criticalError);
			}

			transclude(scope, function (clone) {
				element.append(clone);
			});
		}
	};
}

directivesModule.directive("loader", [loaderDirective]);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "016n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var h = __webpack_require__("S8e/").default;
var directivesModule = __webpack_require__("7Eh3");
__webpack_require__("a6P3");

function validatedForm(localize) {
	return {
		scope: false,
		restrict: "A",
		link: function link(scope, iElement, iAttr) {
			var options = scope.$eval(iAttr.validatedForm);

			function getElementScope(element) {
				if (typeof element.scope() === "function" && element.scope()) {
					return element.scope();
				} else {
					return element.data("scopeFallback");
				}
			}

			var validations = [];
			iElement.find("[validation]").each(function (i, e) {
				var element = jQuery(e);
				validations.push({
					element: element,
					validator: element.attr("validation"),
					validations: []
				});
			});

			var activeFailedValidation = false;

			function removeErrorHints(e) {
				if (e && e.keyCode === 13) {
					return;
				}

				activeFailedValidation = false;
				validations.forEach(function (vElement) {
					vElement.element.qtip("destroy", true);
				});
			}

			function showErrorHint(element, failedValidation) {
				if (failedValidation === activeFailedValidation) {
					return;
				} else if (activeFailedValidation) {
					removeErrorHints();
				}

				if (!failedValidation.translation) {
					return;
				}

				activeFailedValidation = failedValidation;

				var showWhen = {
					ready: true
				};
				var hideWhen = false;

				element.qtip({
					content: {
						text: localize.getLocalizedString(failedValidation.translation)
					},
					style: {
						classes: "qtip-bootstrap"
					},
					position: {
						my: "top center",
						at: "bottom center"
					},
					show: showWhen,
					hide: hideWhen
				});
			}

			function validateOnChange(vElement, validation) {
				vElement.element.on("keyup", h.debounce(function () {
					if (getElementScope(vElement.element).$eval(validation.validator)) {
						showErrorHint(vElement.element, validation);
					}
				}, validation.onChange));
			}

			function registerChangeListener(vElement) {
				vElement.validations.forEach(function (validation) {
					if (validation.onChange) {
						validateOnChange(vElement, validation);
					}
				});
			}

			//expand all validations
			validations.forEach(function (vElement) {
				var scope = getElementScope(vElement.element);
				var deregister = scope.$watch(function () {
					return scope.$eval(vElement.validator);
				}, function (val) {
					if (val) {
						vElement.validations = val;
						registerChangeListener(vElement);
						deregister();
					}
				});
			});

			function checkValidations(ids, skipHints) {
				var invalidValidationFound = false;

				//run all validations and show errors in qtips.

				validations.forEach(function (vElement) {
					if (ids && ids.indexOf(vElement.element.attr("id")) === -1) {
						return;
					}
					if (invalidValidationFound) {
						return;
					}

					var scope = getElementScope(vElement.element);
					vElement.validations.forEach(function (validation) {
						if (invalidValidationFound) {
							return;
						}

						if (scope.$eval(validation.validator)) {
							invalidValidationFound = true;
							if (!skipHints) {
								showErrorHint(vElement.element, validation);
							}
						}
					});
				});

				if (!invalidValidationFound && !skipHints) {
					removeErrorHints();
				}

				return invalidValidationFound;
			}

			if (options.validateOnCallback) {
				options.checkValidations = checkValidations;
			} else {
				scope.$watch(function () {
					checkValidations();

					return "";
				}, function () {});
			}

			if (options.hideOnInteraction) {
				iElement.on("click keydown", "input", removeErrorHints);
			}
		}
	};
}

validatedForm.$inject = ["localize"];

directivesModule.directive("validatedForm", validatedForm);

directivesModule.directive("validation", function () {
	return {
		scope: false,
		restrict: "A",
		link: function link(scope, iElement) {
			iElement.data("scopeFallback", scope);
		}
	};
});

/***/ }),

/***/ "02Tt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainPage", function() { return mainPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "landingPage", function() { return landingPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoginPage", function() { return isLoginPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBusinessVersion", function() { return isBusinessVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSalesPage", function() { return isSalesPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginPage", function() { return loginPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToBusiness", function() { return goToBusiness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToSalesPage", function() { return goToSalesPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reloadApp", function() { return reloadApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIOS", function() { return isIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBlockedReturnUrl", function() { return isBlockedReturnUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReturnUrl", function() { return setReturnUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlParameter", function() { return getUrlParameter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_service__ = __webpack_require__("IJod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("juYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


var h = __webpack_require__("S8e/").default;
var config = __webpack_require__("b/6L");
var MS_YEAR = 365 * 24 * 60 * 60 * 1000;
var loginStorage = __WEBPACK_IMPORTED_MODULE_0__storage_service__["withPrefix"]("whispeer.login");
var blockedReturnUrls = ["/b2c", "/recovery"];
var removeOther = function (ele) {
    ele.siblings().remove();
    if (!ele.parent().is("body")) {
        removeOther(ele.parent());
    }
    else {
        ele.hide();
    }
};
var setTopLocation = function (url) {
    var locale = h.getLanguageFromPath() || "";
    if (__WEBPACK_IMPORTED_MODULE_0__storage_service__["storageInfo"].broken && url !== "/") {
        //if you read this code, welcome to my personal hell!
        /*
            So let me explain why this is necessary.
            Whispeer needs to store data locally, usually we use localStorage or indexedDB for that.
            This is an ugly quirks to move all content into an iframe and take the outer iframe as the
            storage area. This way the inner iframe could redirect as it wishes to without loosing the state.
            But why not use localStorage? We do, this is a fallback.
            Localstorage is not available in Safari Private Mode for example. Or if your disk is full.
        */
        console.log("promoting as main window");
        __WEBPACK_IMPORTED_MODULE_0__storage_service__["promoteMainWindow"]();
        if (window.frameElement) {
            removeOther(jQuery(window.frameElement));
        }
        else {
            jQuery(document.body).empty();
        }
        var body = jQuery(window.top.document.body);
        var iframe = jQuery("<iframe class='contentFallBack'></iframe>");
        body.append(iframe);
        iframe.attr("src", url);
    }
    else {
        window.top.location = "/" + locale + url;
    }
};
var mainPage = function () {
    setTopLocation("/main");
};
var landingPage = function () {
    setTopLocation("/");
};
var isLoginPage = function () {
    return window.top.location.pathname.indexOf("/login") !== -1;
};
var isBusinessVersion = function () { return !!false; };
var isSalesPage = function () {
    return window.top.location.href.indexOf(config.salesUrl) > -1;
};
var loginPage = function () {
    setTopLocation("/login");
};
var insertParam = function (key, value) {
    var currentSearch = document.location.search.substr(1).split('&');
    var newSearch = currentSearch.filter(function (val) { return val.split("=")[0] === key; });
    newSearch.push([key, value].join("="));
    document.location.search = newSearch.join('&');
};
var getParam = function (key) {
    var currentSearch = document.location.search.substr(1).split('&');
    return currentSearch.map(function (search) { return search.split("="); }).find(function (_a) {
        var k = _a[0];
        return k === key;
    });
};
var redirect = getParam("redirect");
var goToBusiness = function () {
    if (redirect) {
        return;
    }
    var expires = new Date(Date.now() + MS_YEAR);
    document.cookie = "business=1;path=/;expires=" + expires.toUTCString();
    insertParam("redirect", "true");
};
var goToSalesPage = function () {
    if (isSalesPage()) {
        return;
    }
    window.top.location.href = config.salesUrl;
};
var reloadApp = function () {
    return window.location.reload();
};
var isIOS = function () { return false; };
var isBlockedReturnUrl = function (url) {
    return blockedReturnUrls.filter(function (blockedUrl) {
        return url.indexOf(blockedUrl) !== -1;
    }).length > 0;
};
var setReturnUrl = function (url) {
    if (isBlockedReturnUrl(url)) {
        return;
    }
    loginStorage.set("returnUrl", url);
};
var getUrlParameter = function (param) {
    var search = window.top.location.search;
    var pairs = search.substr(1).split("&");
    var result = h.array.find(pairs.map(function (pair) {
        if (pair.indexOf("=") !== -1) {
            return {
                key: pair.substr(0, pair.indexOf("=")),
                value: pair.substr(pair.indexOf("=") + 1)
            };
        }
        else {
            return {
                key: pair,
                value: ""
            };
        }
    }), function (pair) {
        return pair.key === param;
    });
    if (result) {
        return result.value;
    }
};


/***/ }),

/***/ "07dH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// CONCATENATED MODULE: ./js/asset/voicemailPlayer.ts

var voicemailPlayer_VoicemailPlayer = /** @class */ (function () {
    function VoicemailPlayer(recordings) {
        var _this = this;
        this.playing = false;
        this.loaded = false;
        this.recordings = [];
        this.recordPlayingIndex = 0;
        this.loadingPromises = [];
        this.positionRAFListener = [];
        this.positionListener = function () {
            var position = _this.getPosition();
            _this.positionRAFListener.forEach(function (func) { return func(position); });
            if (_this.isPlaying()) {
                window.requestAnimationFrame(_this.positionListener);
            }
        };
        this.onPositionUpdateRAF = function (listener) { return _this.positionRAFListener.push(listener); };
        this.seekTo = function (time) {
            var timeInTrack = time;
            var recordPlayingIndex = _this.recordings.findIndex(function (_a) {
                var duration = _a.duration;
                if (timeInTrack < duration) {
                    return true;
                }
                timeInTrack -= duration;
                return false;
            });
            if (recordPlayingIndex === -1) {
                return;
            }
            _this.recordPlayingIndex = recordPlayingIndex;
            _this.recordings[_this.recordPlayingIndex].audio.currentTime = timeInTrack;
            _this.positionListener();
            if (_this.isPlaying()) {
                _this.recordings.forEach(function (_a, index) {
                    var audio = _a.audio;
                    if (index !== recordPlayingIndex) {
                        audio.pause();
                        audio.currentTime = 0;
                    }
                });
                _this.recordings[_this.recordPlayingIndex].audio.play();
            }
        };
        this.awaitLoading = function () {
            return bluebird["all"](_this.loadingPromises);
        };
        this.isLoaded = function () { return _this.loaded; };
        this.onEnded = function () {
            if (_this.isPlaying()) {
                // Use a Promise to trigger the angular zone. Zones are bad. Angular DI is bad.
                bluebird["resolve"]().then(function () {
                    _this.recordPlayingIndex += 1;
                    if (_this.recordPlayingIndex >= _this.recordings.length) {
                        _this.reset();
                        return;
                    }
                    _this.recordings[_this.recordPlayingIndex].audio.play();
                });
            }
        };
        recordings.map(function (_a) {
            var url = _a.url, estimatedDuration = _a.estimatedDuration;
            return _this.addRecording(url, estimatedDuration);
        });
    }
    VoicemailPlayer.prototype.play = function () {
        if (VoicemailPlayer.activePlayer) {
            VoicemailPlayer.activePlayer.pause();
        }
        this.recordings[this.recordPlayingIndex].audio.play();
        VoicemailPlayer.activePlayer = this;
        this.playing = true;
        this.loaded = true;
        this.positionListener();
    };
    VoicemailPlayer.prototype.pause = function () {
        this.recordings[this.recordPlayingIndex].audio.pause();
        VoicemailPlayer.activePlayer = null;
        this.playing = false;
    };
    VoicemailPlayer.prototype.toggle = function () {
        if (this.playing) {
            this.pause();
        }
        else {
            this.play();
        }
    };
    VoicemailPlayer.prototype.isPlaying = function () {
        return this.playing;
    };
    VoicemailPlayer.prototype.isPaused = function () {
        return !this.playing;
    };
    VoicemailPlayer.prototype.getDuration = function (beforeIndex) {
        return this.recordings.slice(0, beforeIndex).reduce(function (prev, next) { return prev + next.duration; }, 0);
    };
    VoicemailPlayer.prototype.getPosition = function () {
        var currentDuration = this.getDuration(this.recordPlayingIndex);
        return currentDuration + this.recordings[this.recordPlayingIndex].audio.currentTime;
    };
    VoicemailPlayer.prototype.reset = function () {
        this.recordings.forEach(function (_a) {
            var audio = _a.audio;
            audio.pause();
            audio.currentTime = 0;
        });
        this.recordPlayingIndex = 0;
        if (VoicemailPlayer.activePlayer && this !== VoicemailPlayer.activePlayer) {
            VoicemailPlayer.activePlayer.reset();
        }
        VoicemailPlayer.activePlayer = null;
        this.playing = false;
    };
    VoicemailPlayer.prototype.addRecording = function (url, duration) {
        var audio = new Audio(url);
        var audioInfo = {
            url: url,
            audio: audio,
            duration: duration
        };
        audio.addEventListener("ended", this.onEnded);
        var loadingPromise = new bluebird(function (resolve) { return audio.addEventListener("canplaythrough", resolve); });
        this.loadingPromises.push(loadingPromise);
        this.recordings.push(audioInfo);
    };
    VoicemailPlayer.prototype.destroy = function () {
        this.recordings.forEach(function (_a) {
            var audio = _a.audio, url = _a.url;
            audio.src = "";
            audio.load();
            // TODO delete file created!
            console.warn("TODO: delete file:", url);
        });
    };
    VoicemailPlayer.prototype.getRecordings = function () {
        return this.recordings.slice();
    };
    VoicemailPlayer.activePlayer = null;
    return VoicemailPlayer;
}());
/* harmony default export */ var voicemailPlayer = (voicemailPlayer_VoicemailPlayer);

// EXTERNAL MODULE: ./js/services/blobService.ts + 1 modules
var blobService = __webpack_require__("95Br");

// EXTERNAL MODULE: ./js/asset/Progress.ts
var Progress = __webpack_require__("P6+u");

// CONCATENATED MODULE: ./js/directives/voicemailPlayer.ts


var templateUrl = __webpack_require__("TTsU");
var directivesModule = __webpack_require__("7Eh3");



var ProgressBar = __webpack_require__("lLmO");
var loadVoicemail = function (voicemail) {
    var loadProgress = new Progress["a" /* default */]();
    voicemail.loading = true;
    voicemail.getProgress = function () { return loadProgress.getProgress(); };
    return blobService["default"].getBlobUrl(voicemail.blobID, voicemail.type, voicemail.size, loadProgress).then(function (url) {
        voicemail.url = url;
        voicemail.loading = false;
        voicemail.loaded = true;
        return voicemail;
    });
};
var voicemailPlayer_voicemailPlayerComponent = /** @class */ (function () {
    function voicemailPlayerComponent($element) {
        var _this = this;
        this.$element = $element;
        this.startTime = 0;
        this.seekVal = 0;
        this.toggle = function () { return _this.isPlaying() ? _this.pause() : _this.play(); };
        this.isPlaying = function () { return _this.player ? _this.player.isPlaying() : false; };
        this.isLoading = function () { return !!_this.voicemails.find(function (_a) {
            var loading = _a.loading;
            return loading;
        }); };
        this.getProgress = function () { return _this.voicemails.reduce(function (prev, _a) {
            var getProgress = _a.getProgress;
            return getProgress ? prev + getProgress() : 0;
        }, 0); };
        this.getSize = function () { return _this.voicemails.reduce(function (prev, _a) {
            var size = _a.size;
            return prev + size;
        }, 0); };
        this.isLoaded = function () { return _this.voicemails.reduce(function (prev, _a) {
            var loaded = _a.loaded;
            return prev && loaded;
        }, true); };
        this.timeUpdate = function (position) {
            var time = Math.floor(position);
            _this.progress.set(position / _this.getDuration());
            if (_this.previousTime === time) {
                return;
            }
            _this.previousTime = time;
            _this.$element.find("#position").text(_this.formatPosition(time));
        };
        this.formatPosition = function (position) {
            var minutes = Math.floor(position / 60);
            var seconds = position % 60;
            var minutesString = ("0" + minutes).substr(-2);
            var secondsString = ("0" + seconds).substr(-2);
            return minutesString + ":" + secondsString;
        };
        this.seekTo = function (position) {
            if (_this.player) {
                return _this.player.seekTo(position);
            }
            _this.startTime = position;
            _this.timeUpdate(position);
        };
        this.loadAndPlay = function () {
            var voicemails = _this.voicemails;
            return bluebird["resolve"](voicemails)
                .map(function (voicemail) { return loadVoicemail(voicemail); })
                .map(function (_a) {
                var url = _a.url, duration = _a.duration;
                return ({ url: url, estimatedDuration: duration });
            })
                .then(function (voicemails) { return new voicemailPlayer(voicemails); })
                .then(function (player) {
                _this.player = player;
                _this.player.onPositionUpdateRAF(_this.timeUpdate);
                _this.player.awaitLoading().then(function () {
                    _this.player.seekTo(_this.startTime);
                    _this.player.play();
                });
            });
        };
        this.play = function () { return _this.player ? _this.player.play() : _this.loadAndPlay(); };
        this.pause = function () { return _this.player.pause(); };
        this.getDuration = function () { return _this.player ? _this.player.getDuration() : _this.voicemails.reduce(function (prev, _a) {
            var duration = _a.duration;
            return prev + duration;
        }, 0); };
        this.$postLink = function () {
            var progressElement = _this.$element.find(".voicemail--progress")[0];
            _this.progress = new ProgressBar.Line(progressElement, {
                strokeWidth: 2,
                trailWidth: 2,
                svgStyle: { width: '100%', height: '25%' }
            });
            progressElement.addEventListener('click', function (event) {
                var rect = progressElement.getBoundingClientRect();
                var progress = (event.pageX - rect.left) / rect.width;
                _this.seekTo(_this.getDuration() * progress);
            });
        };
    }
    voicemailPlayerComponent.$inject = ["$element"];
    return voicemailPlayerComponent;
}());
directivesModule.component("voicemailPlayer", {
    bindings: {
        voicemails: "<"
    },
    templateUrl: templateUrl,
    controller: voicemailPlayer_voicemailPlayerComponent
});


/***/ }),

/***/ "0eEO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
* postService
**/

var Bluebird = __webpack_require__("fp6q");
var h = __webpack_require__("S8e/").default;
var Promise = __webpack_require__("fp6q");
var validator = __webpack_require__("WZDP");
var Observer = __webpack_require__("SiYL");
var SecuredData = __webpack_require__("eRn5").default;
var State = __webpack_require__("uJ4a");

var socket = __webpack_require__("8I7s").default;
var keyStore = __webpack_require__("IeOO").default;
var errorService = __webpack_require__("EFCD").errorServiceInstance;
var userService = __webpack_require__("UuKm").default;
var circleService = __webpack_require__("silk");
var screenSize = __webpack_require__("KEBJ").default;
var initService = __webpack_require__("EKxj");
var filterService = __webpack_require__("emzt").default;
var CommentModel = __webpack_require__("j5T1");

var postsById = {};
var postsByUserWall = {};
var timelinesCache = {};

var Post = function Post(data) {
	var thePost = this,
	    id = data.id,
	    privateData;

	var securedData = SecuredData.load(data.content, data.meta, { type: "post" });

	if (data.private) {
		privateData = SecuredData.load(data.private.content, data.private.meta, { type: "postPrivate" });
	}

	var comments = data.comments || [];
	comments = comments.map(function (comment) {
		return new CommentModel(comment, this);
	}, this);

	var commentState = new State.default();

	this.data = {
		loaded: false,
		id: data.id,
		info: {
			"with": ""
		},
		/* list of images with attributes: loaded, encrypting, decrypting, uploading, percent, url */
		images: [],
		time: securedData.metaAttr("time"),
		isWallPost: false,
		removable: false,
		remove: function remove() {
			thePost.remove(errorService.criticalError);
		},
		loadComments: function loadComments() {
			thePost.loadComments(errorService.criticalError);
		},
		newComment: {
			state: commentState.data,
			text: "",
			create: function create(text) {
				if (text === "") {
					commentState.fail();
					return;
				}

				commentState.pending();

				var promise = thePost.addComment(text).then(function () {
					thePost.data.newComment.text = "";

					return;
				});

				errorService.failOnErrorPromise(commentState, promise);

				return promise;
			}
		},
		comments: comments.map(function (comment) {
			return comment.data;
		})
	};

	this.removeComment = function (comment) {
		h.removeArray(this.data.comments, comment.data);
		h.removeArray(comments, comment);
	};

	this.getID = function () {
		return id;
	};

	this.getComments = function () {
		return comments;
	};

	function commentListener(e, data) {
		return Bluebird.try(function () {
			var comment = new CommentModel(data, thePost);

			return comment.load(comments[comments.length - 1]).thenReturn(comment);
		}).then(function (comment) {
			comments.push(comment);
			thePost.data.comments.push(comment.data);
		}).catch(errorService.criticalError);
	}

	socket.channel("post." + id + ".comment.new", commentListener);

	this.loadData = function (cb) {
		return Bluebird.try(function () {
			return Bluebird.all([thePost.getSender(), thePost.getWallUser()]);
		}).spread(function (sender, walluser) {
			var d = thePost.data;

			if (walluser) {
				d.isWallPost = true;
				d.walluser = walluser.data;
			}

			if (sender.isOwn() || walluser && walluser.isOwn()) {
				d.removable = true;
			}

			d.sender = sender.data;
			var promises = [securedData.verify(sender.getSignKey())];

			if (privateData) {
				promises.push(privateData.verify(sender.getSignKey()));
			}

			return Bluebird.all(promises);
		}).then(function () {
			keyStore.security.addEncryptionIdentifier(securedData.metaAttr("_key"));

			return Bluebird.all([thePost.getText(), thePost.getPrivate()]);
		}).spread(function (text, privateData) {
			var d = thePost.data;

			d.loaded = true;
			d.content = {
				text: text
			};

			d.visibleSelection = privateData;

			d.images = securedData.metaAttr("images");
		}).nodeify(cb);
	};

	this.getSecured = function () {
		return securedData;
	};

	this.loadComments = function (cb) {
		if (comments.length === 0) {
			return Bluebird.resolve().nodeify(cb);
		}

		return Bluebird.try(function () {
			thePost.data.commentsLoading = true;
		}).then(function () {
			return Bluebird.all(comments.map(function (comment, i) {
				return comment.load(comments[i - 1]);
			}));
		}).finally(function () {
			thePost.data.commentsLoading = false;
		}).nodeify(cb);
	};

	this.addComment = function (comment, cb) {
		return CommentModel.create(comment, thePost).then(function () {
			// clear promise content.
			return;
		}).nodeify(cb);
	};

	this.getHash = function () {
		return securedData.getHash();
	};

	this.getKey = function () {
		return securedData.metaAttr("_key");
	};

	this.getWallUser = function (cb) {
		if (!securedData.metaAttr("walluser")) {
			return Bluebird.resolve().nodeify(cb);
		}

		return userService.get(securedData.metaAttr("walluser")).then(function (user) {
			return user.loadBasicData().thenReturn(user);
		}).nodeify(cb);
	};

	this.getSender = function (cb) {
		return userService.get(securedData.metaAttr("sender")).then(function (user) {
			return user.loadBasicData().thenReturn(user);
		}).nodeify(cb);
	};

	this.remove = function (cb) {
		return Bluebird.try(function () {
			if (thePost.data.removable) {
				return socket.emit("posts.remove", {
					postid: id
				});
			}
		}).then(function () {
			h.objectEach(postsByUserWall, function (key, val) {
				h.removeArray(val.result, thePost.data);
			});
			h.objectEach(timelinesCache, function (key, timeline) {
				timeline.removePost(thePost);
			});

			delete postsById[id];

			return;
		}).nodeify(cb);
	};

	this.getPrivate = function (cb) {
		if (privateData) {
			return privateData.decrypt().then(function (visibleSelection) {
				return filterService.getFiltersByID(visibleSelection);
			}).nodeify(cb);
		} else {
			return Bluebird.resolve().nodeify(cb);
		}
	};

	this.getText = function (cb) {
		return securedData.decrypt().then(function (content) {
			return (typeof content === "undefined" ? "undefined" : _typeof(content)) === "object" ? content.text : content;
		}).nodeify(cb);
	};
};

function makePost(data) {
	var err = validator.validate("post", data);
	if (err) {
		throw err;
	}

	if (postsById[data.id]) {
		return postsById[data.id];
	}

	var p = new Post(data);
	postsById[p.getID()] = p;
	return p;
}

function circleFiltersToUser(filter) {
	if (filter.length === 0) {
		return Bluebird.resolve([]);
	}

	return circleService.loadAll().then(function () {
		var i,
		    user = [];
		for (i = 0; i < filter.length; i += 1) {
			user = user.concat(circleService.get(filter[i]).getUserIDs());
		}

		return h.arrayUnique(user);
	});
}

var Timeline = function Timeline(filter, sortByCommentTime) {
	this._filter = filter;
	this._posts = [];
	this._postsData = [];
	this._requested = 0;

	this._sortByCommentTime = sortByCommentTime;

	this.loading = false;
	this.loaded = false;
};

Timeline.prototype.getPosts = function () {
	return this._postsData;
};

Timeline.prototype.removePost = function (thePost) {
	this._posts = h.removeArray(this._posts, thePost);
	this._postsData = h.removeArray(this._postsData, thePost.data);
};

Timeline.prototype.getNewestID = function () {
	if (this._posts.length === 0) {
		return 0;
	}

	return this._posts[0].getID();
};

Timeline.prototype.getOldestID = function () {
	if (this._posts.length === 0) {
		return 0;
	}

	return this._posts[this._posts.length - 1].getID();
};

Timeline.prototype._expandFilter = function () {
	var that = this,
	    finalFilter = [];

	if (this._finalFilter) {
		return Bluebird.resolve();
	}

	return Bluebird.try(function () {
		var circles = [];

		that._filter.forEach(function (filterElement) {
			var split = filterElement.split(":");
			if (split[0] === "circle") {
				circles.push(split[1]);
			} else {
				finalFilter.push(filterElement);
			}
		});

		return circleFiltersToUser(circles);
	}).map(function (e) {
		return "user:" + e;
	}).then(function (users) {
		finalFilter = finalFilter.concat(users);

		that._finalFilter = finalFilter;

		return;
	});
};

Timeline.prototype.loadInitial = function (cb) {
	if (this.loaded) {
		return Bluebird.resolve().nodeify(cb);
	}

	return this.loadMorePosts(cb);
};

Timeline.prototype.loadMorePosts = function (cb) {
	if (this.loading) {
		cb();
		return;
	}

	if (this.end) {
		cb();
		return;
	}

	var that = this;
	this.loading = true;

	return Bluebird.try(function () {
		return that._expandFilter();
	}).then(function () {
		return initService.awaitLoading();
	}).then(function () {
		return socket.emit("posts.getTimeline", {
			afterID: that.getOldestID(),
			filter: that._finalFilter,
			sortByCommentTime: that._sortByCommentTime,
			count: screenSize.mobile ? 10 : 20
		});
	}).then(function (results) {
		var posts = results.posts || [];

		that.displayDonateHint = results.displayDonateHint;

		that._requested = socket.lastRequestTime;

		if (posts.length === 0) {
			that.end = true;
		}

		return posts;
	}).map(function (postData) {
		var post = makePost(postData);

		return post.loadData().thenReturn(post);
	}).then(function (posts) {
		that._posts = that._posts.concat(posts);

		that._postsData = that._posts.map(function (post) {
			return post.data;
		});
	}).then(function () {
		that.loaded = true;
	}).finally(function () {
		that.loading = false;
	}).nodeify(cb);
};

Timeline.prototype.addPost = function (newPost) {
	this._posts.unshift(newPost);

	this._postsData = this._posts.map(function (post) {
		return post.data;
	});
};

var extractImagesInfo = function extractImagesInfo(infos) {
	return infos.map(function (info) {
		return h.objectMap(info, function (val) {
			return Object.assign({}, val.meta, {
				gif: val.content.gif,
				blobHash: val.content.blobHash
			});
		});
	});
};

var postService = {
	getTimeline: function getTimeline(filter, sortByCommentTime) {
		filter.sort();

		var filterString = JSON.stringify(filter) + "-" + sortByCommentTime;

		if (sortByCommentTime) {
			delete timelinesCache[filterString];
		}

		if (!timelinesCache[filterString]) {
			timelinesCache[filterString] = new Timeline(filter, sortByCommentTime);
		}

		return timelinesCache[filterString];
	},
	getWallPosts: function getWallPosts(afterID, userid, limit, cb) {
		return Bluebird.try(function () {
			return socket.emit("posts.getWall", {
				afterID: afterID,
				userid: userid,
				count: limit
			});
		}).then(function (results) {
			return results.posts || [];
		}).map(function (postData) {
			var thePost = makePost(postData);
			return thePost.loadData().thenReturn(thePost.data);
		}).then(function (posts) {
			postsByUserWall[userid] = posts;

			return posts;
		}).nodeify(cb);
	},
	getPostByID: function getPostByID(postid, cb) {
		if (postsById[postid]) {
			return Bluebird.resolve(postsById[postid]).nodeify(cb);
		}

		return initService.awaitLoading().then(function () {
			return socket.definitlyEmit("posts.getPost", {
				postid: postid
			});
		}).then(function (data) {
			if (data.post) {
				return makePost(data.post);
			} else {
				throw new Error("error! no post data! maybe post does not exist?");
			}
		}).nodeify(cb);
	},
	reset: function reset() {
		postsById = {};
		postsByUserWall = {};
		timelinesCache = {};
	},
	createPost: function createPost(text, visibleSelection, wallUserID, images) {
		visibleSelection = visibleSelection.slice();

		var imagePreparation = Promise.resolve(images).map(function (image) {
			return image.prepare();
		});

		var keyGeneration = h.promisify(Promise, function (cb) {
			return keyStore.sym.generateKey(cb, "post key");
		});

		var symEncryptKey = keyStore.sym.symEncryptKey.bind(keyStore.sym);
		var filterToKeys = Promise.promisify(filterService.filterToKeys.bind(filterService));
		var socketEmit = Promise.promisify(socket.emit.bind(socket));
		var data, securedData;

		return Promise.all([keyGeneration, imagePreparation]).spread(function (postKey, imagesInfo) {
			var uploadImages = Promise.all(images.map(function (image) {
				return image.upload(postKey);
			}));

			var encryptPostKeys = filterToKeys(visibleSelection).map(function (key) {
				return symEncryptKey(postKey, key);
			});

			var meta = {};
			meta.time = new Date().getTime();
			meta.sender = userService.getOwn().getID();
			meta.walluser = wallUserID;
			meta.images = extractImagesInfo(imagesInfo);

			var ownUser = userService.getOwn();
			var secured = SecuredData.createPromisified(text, meta, { type: "post" }, ownUser.getSignKey(), postKey);

			securedData = secured.data;

			return Promise.all([uploadImages, secured.promise, encryptPostKeys]);
		}).spread(function (imageKeys, _data) {
			data = _data;

			imageKeys = h.array.flatten(imageKeys);

			data.imageKeys = imageKeys.map(keyStore.upload.getKey);
			data.meta._key = keyStore.upload.getKey(data.meta._key);

			var ownUser = userService.getOwn();

			var privateData = SecuredData.createPromisified(visibleSelection, {}, { type: "postPrivate" }, ownUser.getSignKey(), ownUser.getMainKey());
			privateData.data.setParent(securedData);
			return privateData.promise;
		}).then(function (privateData) {
			data.privateData = privateData;

			return socketEmit("posts.createPost", { postData: data });
		}).then(function (result) {
			if (result.error) {
				throw new Error("post creation failed on server");
			}

			var newPost = makePost(result.createdPost);

			if (h.parseDecimal(wallUserID) === 0) {
				wallUserID = userService.getOwn().getID();
			}

			if (postsByUserWall[wallUserID]) {
				postsByUserWall[wallUserID].unshift(newPost.data);
			}

			h.objectEach(timelinesCache, function (key, timeline) {
				timeline.addPost(newPost);
			});

			return newPost.loadData();
		});
	}
};

Observer.extend(postService);

module.exports = postService;

/***/ }),

/***/ "0kGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SessionService", function() { return SessionService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Cache__ = __webpack_require__("4PxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyStore_service__ = __webpack_require__("IeOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__location_manager__ = __webpack_require__("02Tt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storage_service__ = __webpack_require__("IJod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_helper__ = __webpack_require__("S8e/");






var SessionService = /** @class */ (function () {
    function SessionService() {
        var _this = this;
        this.sid = "";
        this.loggedin = false;
        this.sessionStorage = Object(__WEBPACK_IMPORTED_MODULE_4__storage_service__["withPrefix"])("whispeer.session");
        this.loginPromise = new __WEBPACK_IMPORTED_MODULE_0_bluebird__(function (loginResolve) {
            _this.loginResolve = loginResolve;
        });
        this.saveSession = function () {
            _this.sessionStorage.set("sid", _this.sid);
            _this.sessionStorage.set("userid", _this.userid);
            _this.sessionStorage.set("loggedin", true);
        };
        this.setLoginData = function (_sid, _userid) {
            _this.sid = _sid;
            _this.userid = parseInt(_userid, 10);
            _this.loggedin = true;
            _this.loginResolve();
        };
        this.awaitLogin = function () { return _this.loginPromise; };
        this.setPassword = function (password) {
            __WEBPACK_IMPORTED_MODULE_2__keyStore_service__["default"].security.setPassword(password);
            _this.sessionStorage.set("password", password);
        };
        this.bootLogin = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["default"].cacheResult(function () { return _this.loadLogin(); });
        this.loadLogin = function () {
            return _this.sessionStorage.awaitLoading().then(function () {
                var loggedin = _this.sessionStorage.get("loggedin") === "true" && _this.sessionStorage.get("password");
                if (!loggedin) {
                    return _this.clear().thenReturn(false);
                }
                _this.setPassword(_this.sessionStorage.get("password"));
                _this.setLoginData(_this.sessionStorage.get("sid"), _this.sessionStorage.get("userid"));
                return true;
            });
        };
        this.getSID = function () { return _this.sid; };
        this.getUserID = function () { return _this.userid; };
        this.isOwnUserID = function (id) { return parseInt(id, 10) === _this.userid; };
        this.clear = function () {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["all"]([
                _this.sessionStorage.clear().then(function () { return console.log("session storage"); }),
                __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](__WEBPACK_IMPORTED_MODULE_1__services_Cache__["a" /* default */].deleteDatabase()).then(function () { return console.log("cache deletedb"); }),
            ].map(function (p) { return p.reflect(); }));
        };
        this.logout = function () { return _this.clear().finally(__WEBPACK_IMPORTED_MODULE_3__location_manager__["landingPage"]); };
        this.isLoggedin = function () { return _this.loggedin; };
    }
    return SessionService;
}());

/* harmony default export */ __webpack_exports__["default"] = (new SessionService());


/***/ }),

/***/ "141t":
/***/ (function(module, exports) {

var path = 'directives/comment.html';
var html = "<li data-ng-class={me:comment.sender.me}> <a whispeer-sref=\"app.user.info({identifier: comment.sender.names.nickname})\" class=\"post-userimage post-userimage--small\"> <userimage data-user=comment.sender></userimage> </a> <a whispeer-sref=\"app.user.info({identifier: comment.sender.names.nickname})\" class=\"post-username post-comment-username\">{{comment.sender.name}}</a> <p class=\"post-content post-comment-content\" data-syntaxify=::comment.text></p> <aside class=\"post-meta post-comment-meta\"> <span class=\"post-date post-comment-date\"> <i class=\"fa fa-clock-o\"></i>&nbsp; <span class=\"post-date-time post-comment-date-time\" data-smart-date=::comment.time></span> </span> <span class=\"post-action post-action--pull-right\" data-accessible-click=comment.delete() data-ng-if=comment.sender.me> <i class=\"fa fa-times fa-fw\"></i>&nbsp;<span data-i18n=wall.removeComment></span> </span> </aside> </li> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "1IZJ":
/***/ (function(module, exports) {

module.exports = {
	"hashVersion": 3,
	"socket": {
		"autoConnect": true,
		"autoReconnect": true
	},
	"businessUrl": "https://business.whispeer.de",
	"salesUrl": "/sales",
	"serviceWorker": {
		"enabled": false
	}
};

/***/ }),

/***/ "1mek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRUST_SECURED_OPTIONS", function() { return TRUST_SECURED_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrustStore", function() { return TrustStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trustStates", function() { return trustStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformLegacy", function() { return transformLegacy; });
/* harmony export (immutable) */ __webpack_exports__["userToDataSet"] = userToDataSet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_socket_service__ = __webpack_require__("8I7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__asset_securedDataWithMetaData__ = __webpack_require__("eRn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_enum__ = __webpack_require__("pO06");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_error_service__ = __webpack_require__("EFCD");

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var errors = __webpack_require__("a86h");


var initService = __webpack_require__("EKxj");
var THROTTLE = 50;
var TRUST_SECURED_OPTIONS = {
    type: "trustManager"
};
var TrustStore = /** @class */ (function () {
    function TrustStore(_a) {
        var nicknames = _a.nicknames, ids = _a.ids, me = _a.me, keys = _a.keys, signature = _a.signature;
        var _this = this;
        this.getSignature = function () { return _this.signature; };
        this.update = function (_a) {
            var keys = _a.keys;
            var newKeys = Object.keys(keys)
                .filter(function (key) { return !_this.keys.hasOwnProperty(key); });
            var trustIncreasedKeys = Object.keys(keys)
                .filter(function (key) { return _this.keys.hasOwnProperty(key); })
                .filter(function (key) {
                var oldTrust = unserializeTrust(_this.keys[key].trust);
                var newTrust = unserializeTrust(keys[key].trust);
                return sortedTrustStates.indexOf(oldTrust) < sortedTrustStates.indexOf(newTrust);
            });
            newKeys
                .forEach(function (signKey) { return _this.add(keys[signKey]); });
            trustIncreasedKeys
                .forEach(function (key) { return _this.keys[key].trust = keys[key].trust; });
            if (newKeys.length > 0 || trustIncreasedKeys.length > 0) {
                scheduleTrustmanagerUpload();
            }
        };
        this.add = function (dataSet) {
            var key = dataSet.key, userid = dataSet.userid, nickname = dataSet.nickname;
            var idKey = _this.ids[userid];
            var nicknameKey = _this.nicknames[nickname];
            if (idKey && idKey !== key) {
                throw new errors.SecurityError("we already have got a key for this users id");
            }
            if (nicknameKey && nicknameKey !== key) {
                throw new errors.SecurityError("we already have got a key for this users nickname");
            }
            _this.keys[key] = dataSet;
            if (nickname) {
                _this.nicknames[nickname] = key;
            }
            _this.ids[userid] = key;
        };
        this.get = function (key) { return _this.keys[key]; };
        this.setKeyTrustLevel = function (key, trustLevel) {
            _this.keys[key].trust = trustLevel;
        };
        this.getUpdatedVersion = function () {
            var info = {
                nicknames: _this.nicknames,
                ids: _this.ids,
                me: _this.me
            };
            Object.keys(_this.keys).forEach(function (key) {
                info[key] = _this.keys[key];
            });
            var secured = new __WEBPACK_IMPORTED_MODULE_3__asset_securedDataWithMetaData__["SecuredData"](null, info, TRUST_SECURED_OPTIONS, true);
            return secured.sign(ownKey);
        };
        this.getTrustSet = function () { return ({
            nicknames: _this.nicknames,
            keys: _this.keys,
            ids: _this.ids,
            me: _this.me,
            signature: _this.signature
        }); };
        this.hasKeyData = function (key) { return _this.keys.hasOwnProperty(key); };
        this.nicknames = nicknames;
        this.ids = ids;
        this.me = me;
        this.keys = keys;
        this.signature = signature;
    }
    return TrustStore;
}());

var trustStore;
var loaded = false;
var fakeKeyExistence = 0;
var ownKey;
var sortedTrustStatesNames = ["BROKEN", "UNTRUSTED", "TIMETRUSTED", "WHISPEERVERIFIED", "NETWORKVERIFIED", "VERIFIED", "OWN"];
var trustStates = new __WEBPACK_IMPORTED_MODULE_4__asset_enum__["a" /* default */](sortedTrustStatesNames);
var transformLegacy = function (_a) {
    var nicknames = _a.nicknames, ids = _a.ids, me = _a.me, _signature = _a._signature, rest = __rest(_a, ["nicknames", "ids", "me", "_signature"]);
    var keys = {};
    Object.keys(rest).filter(function (key) { return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["default"].isRealID(key); }).forEach(function (key) {
        keys[key] = rest[key];
    });
    return {
        nicknames: nicknames,
        ids: ids,
        me: me,
        keys: keys,
        signature: _signature
    };
};
var sortedTrustStates = sortedTrustStatesNames.map(function (trustLevel) {
    return trustStates.fromString("|" + trustLevel + "|");
});
function serializeTrust(trustLevel) {
    return trustStates.toString(trustLevel);
}
function unserializeTrust(trustLevel) {
    return trustStates.fromString(trustLevel);
}
var KeyTrustData = /** @class */ (function () {
    function KeyTrustData(data) {
        var _this = this;
        this.data = data;
        this.getAddedTime = function () { return _this.data.added; };
        this.getKey = function () { return _this.data.key; };
        this.getUserID = function () { return _this.data.userid; };
        this.getNickname = function () { return _this.data.nickname; };
        this.getTrust = function () { return _this.trustSymbol; };
        this.isUntrusted = function () { return _this.trustSymbol === trustStates.UNTRUSTED; };
        this.isTimeTrusted = function () { return _this.trustSymbol === trustStates.TIMETRUSTED; };
        this.isWhispeerVerified = function () { return _this.trustSymbol === trustStates.WHISPEERVERIFIED; };
        this.isNetworkVerified = function () { return _this.trustSymbol === trustStates.NETWORKVERIFIED; };
        this.isVerified = function () { return _this.trustSymbol === trustStates.VERIFIED; };
        this.isOwn = function () { return _this.trustSymbol === trustStates.OWN; };
        this.trustSymbol = unserializeTrust(data.trust);
    }
    return KeyTrustData;
}());
function userToDataSet(_a, trustLevel) {
    var key = _a.key, userid = _a.userid, nickname = _a.nickname;
    if (trustLevel === void 0) { trustLevel = trustStates.UNTRUSTED; }
    return {
        added: new Date().getTime(),
        trust: serializeTrust(trustLevel),
        key: key,
        userid: userid,
        nickname: nickname
    };
}
var uploadDatabase = function () {
    return initService.awaitLoading()
        .then(function () { return trustStore.getUpdatedVersion(); })
        .then(function (content) { return __WEBPACK_IMPORTED_MODULE_1__services_socket_service__["default"].emit("trustManager.set", { content: content }); })
        .then(function (response) { return !response.success ? __WEBPACK_IMPORTED_MODULE_6__services_error_service__["default"].criticalError(response) : null; });
};
var scheduleTrustmanagerUpload = __WEBPACK_IMPORTED_MODULE_0__helper_helper__["default"].aggregateOnce(THROTTLE, uploadDatabase);
var trustManager = {
    notify: null,
    /*listen: <any> null,*/
    allow: function (count) {
        if (!loaded) {
            fakeKeyExistence = count;
        }
    },
    disallow: function () {
        fakeKeyExistence = 0;
    },
    isLoaded: function () { return loaded; },
    setOwnSignKey: function (_ownKey) {
        ownKey = _ownKey;
    },
    addDataSet: function (dataSet) {
        trustStore.add(dataSet);
    },
    updateDatabase: function (data, cb) {
        if (!loaded) {
            throw new Error("cant update database: not loaded");
        }
        var givenDatabase = __WEBPACK_IMPORTED_MODULE_3__asset_securedDataWithMetaData__["default"].load(undefined, data, TRUST_SECURED_OPTIONS);
        return __WEBPACK_IMPORTED_MODULE_5_bluebird__["try"](function () {
            if (data.me === ownKey) {
                return givenDatabase.verifyAsync(ownKey, "user");
            }
            throw new errors.SecurityError("not my trust database");
        }).then(function () { return trustStore.update(transformLegacy(givenDatabase.metaGet())); }).nodeify(cb);
    },
    hasKeyData: function (keyid) {
        if (!loaded) {
            if (keyid === ownKey) {
                return true;
            }
            else if (fakeKeyExistence > 0) {
                fakeKeyExistence -= 1;
                return true;
            }
            else {
                throw new Error("trust manager not yet loaded");
            }
        }
        return trustStore.hasKeyData(keyid);
    },
    getKeyData: function (keyid) {
        var keyData = trustStore.get(keyid);
        if (keyData) {
            return new KeyTrustData(keyData);
        }
        throw new Error("key not in trust database " + keyid);
    },
    uploadDatabase: uploadDatabase,
    verifyUser: function (user) {
        var signKey = user.getSignKey();
        if (signKey === ownKey) {
            throw new Error("Tried to verify own user.");
        }
        if (trustStore.hasKeyData(signKey)) {
            trustStore.setKeyTrustLevel(signKey, serializeTrust(trustStates.VERIFIED));
        }
        return uploadDatabase();
    },
    addNewUsers: function (userInfo) {
        if (trustManager.isLoaded() && !trustManager.hasKeyData(userInfo.key)) {
            trustManager.addDataSet(userToDataSet(userInfo));
            scheduleTrustmanagerUpload();
        }
    },
    setTrustStore: function (givenTrustStore) {
        if (trustStore) {
            throw new Error("trying to overwrite trust store. Please update instance");
        }
        trustManager.disallow();
        trustStore = givenTrustStore;
        loaded = true;
        trustManager.notify("", "loaded");
    }
};
__WEBPACK_IMPORTED_MODULE_2__asset_observer__["default"].extend(trustManager);
__WEBPACK_IMPORTED_MODULE_1__services_socket_service__["default"].channel("notify.trustManager", function (_e, data) {
    trustManager.updateDatabase(data).catch(__WEBPACK_IMPORTED_MODULE_6__services_error_service__["default"].criticalError);
});
/* harmony default export */ __webpack_exports__["default"] = (trustManager);


/***/ }),

/***/ "2KOF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var chelper = __webpack_require__("nZLN");
var sjcl = __webpack_require__("kHLR");

var ObjectHasher = function ObjectHasher(data, version) {
	this._data = data;
	this._version = parseInt(version, 10);
};

ObjectHasher.prototype.sjclHash = function (data) {
	return "hash::" + chelper.bits2hex(sjcl.hash.sha256.hash(data));
};

ObjectHasher.prototype._hashProperty = function (val) {
	return this._version >= 2 ? val.toString() : this.sjclHash("data::" + val.toString());
};

ObjectHasher.prototype._doHashNewObject = function (val) {
	var hasher = new ObjectHasher(val, this._version);
	if (this._version === 3) {
		return hasher.stringify();
	}

	return this.sjclHash(hasher.stringify());
};

ObjectHasher.prototype._doHash = function (val, attr) {
	var allowedTypes = ["number", "string", "boolean"];

	if (attr === "hash") {
		throw new Error("object can not have hash attributes");
	}

	var type = typeof val === "undefined" ? "undefined" : _typeof(val);
	if (type === "object") {
		return this._doHashNewObject(val);
	}

	if (allowedTypes.indexOf(type) > -1) {
		return this._hashProperty(val);
	}

	throw new Error("can not hash objects with " + type);
};

ObjectHasher.prototype._stringifyArray = function () {
	var i,
	    result = [];
	for (i = 0; i < this._data.length; i += 1) {
		result.push(this._doHash(this._data[i]), i);
	}

	return JSON.stringify(result);
};

ObjectHasher.prototype._jsonifyUnique = function (obj) {
	var sortation = Object.keys(obj).sort();
	return JSON.stringify(obj, sortation);
};

ObjectHasher.prototype._stringifyObject = function () {
	var attr,
	    hashObj = {};
	for (attr in this._data) {
		if (this._data.hasOwnProperty(attr)) {
			hashObj[attr] = this._doHash(this._data[attr], attr);
		}
	}

	return this._jsonifyUnique(hashObj);
};

ObjectHasher.prototype._stringifyObjectOrArray = function () {
	if (this._data instanceof Array) {
		return this._stringifyArray();
	} else {
		return this._stringifyObject();
	}
};

ObjectHasher.prototype.stringify = function () {
	if (_typeof(this._data) !== "object") {
		throw new Error("this is not an object!");
	}

	if (this._version === 4) {
		return JSON.stringify(ObjectHasher.handleVal(this._data));
	}

	return this._stringifyObjectOrArray();
};

ObjectHasher.prototype.hash = function () {
	return chelper.bits2hex(this.hashBits());
};

ObjectHasher.prototype.hashBits = function () {
	return sjcl.hash.sha256.hash(this.stringify());
};

ObjectHasher.getType = function (val) {
	if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === "object") {
		if (val instanceof Array) {
			return "arr";
		} else {
			return "obj";
		}
	}

	return "val";
};

ObjectHasher.transformVal = function (val) {
	if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === "object") {
		if (val instanceof Array) {
			return val.map(ObjectHasher.handleVal);
		} else {
			return ObjectHasher.mapToArray(val);
		}
	}

	return val.toString();
};

ObjectHasher.handleVal = function (val, key) {
	if (key) {
		return [ObjectHasher.getType(val), key, ObjectHasher.transformVal(val)];
	}

	return [ObjectHasher.getType(val), ObjectHasher.transformVal(val)];
};

ObjectHasher.mapToArray = function (obj) {
	return Object.keys(obj).sort().map(function (key) {
		return ObjectHasher.handleVal(obj[key], key);
	});
};

module.exports = ObjectHasher;

/***/ }),

/***/ "3Alq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

var scrollDirective = function scrollDirective() {
	return {
		compile: function compile() {
			return {
				post: function post(scope, elm, attrs) {
					var PUFFER = 30;

					var keepBottom = typeof attrs.keepbottom !== "undefined";
					var bottomRelative = typeof attrs.bottomRelative !== "undefined";

					var scrollWindow = typeof attrs.scrollWindow !== "undefined";

					var nativeElement = elm[0];

					if (nativeElement.tagName === "BODY" || scrollWindow) {
						elm = jQuery(window);
						nativeElement = document.body;
					}

					var scrollInfo;

					function getScrollHeight() {
						return nativeElement.scrollHeight;
					}

					function getScrollTop() {
						return elm.scrollTop();
					}

					function updateScrollInfo() {
						var scrollTop = getScrollTop();
						var scrollHeight = getScrollHeight();
						var scrollBottom = nativeElement.scrollHeight - elm.innerHeight() - scrollTop;

						scrollInfo = {
							atBottom: scrollBottom <= PUFFER,
							atTop: scrollTop <= PUFFER,
							scrollHeight: scrollHeight,
							scrollTop: scrollTop,
							scrollBottom: scrollBottom
						};
					}

					function scrollTop(scrollTo) {
						elm.scrollTop(scrollTo);
					}

					function reSyncBottomScroll(previousBottom) {
						var scrollTo = getScrollHeight() - elm.innerHeight() - previousBottom;
						scrollTop(scrollTo);
					}

					function addDOMListener() {
						if (!keepBottom && !bottomRelative) {
							return;
						}

						var runningTimer = false;
						elm.bind("DOMSubtreeModified", function () {
							if (runningTimer) {
								return;
							}

							var preModifyScrollInfo = scrollInfo;

							window.setTimeout(function () {
								runningTimer = false;

								updateScrollInfo();

								var heightDifference = preModifyScrollInfo.scrollHeight - scrollInfo.scrollHeight;

								if (heightDifference === 0) {
									return;
								}

								if (preModifyScrollInfo.atBottom && keepBottom) {
									console.info("Scroll to bottom");
									scrollTop(nativeElement.scrollHeight);
									return;
								}

								if (bottomRelative) {
									console.info("reSync Bottom Scroll");
									reSyncBottomScroll(preModifyScrollInfo.scrollBottom);
								}
							}, 25);

							runningTimer = true;
						});
					}

					addDOMListener();

					updateScrollInfo();

					var wasCalled = false;

					function evaluateCustomRule() {
						if (!attrs.custom || !attrs.atCustom) {
							return;
						}

						var scrollHeight = nativeElement.scrollHeight - elm.innerHeight();
						var scrollState = {
							scrollHeight: scrollHeight,
							scrolledHeight: elm.scrollTop(),
							height: elm.innerHeight(),
							percentage: elm.scrollTop() / scrollHeight,
							distance: scrollHeight - elm.scrollTop(),
							distancePercentage: (scrollHeight - elm.scrollTop()) / elm.innerHeight(),
							distanceTopPercentage: elm.scrollTop() / elm.innerHeight()
						};

						if (scope.$eval(attrs.custom, scrollState)) {
							if (!wasCalled) {
								scope.$eval(attrs.atCustom);
								wasCalled = true;
							}
						} else {
							wasCalled = false;
						}
					}

					elm.bind("scroll", function () {
						updateScrollInfo();

						if (scrollInfo.atBottom) {
							if (attrs.onbottom) {
								scope.$eval(attrs.onbottom);
							}
						}

						evaluateCustomRule();
					});
				}
			};
		}
	};
};

directivesModule.directive("scroll", scrollDirective);

/***/ }),

/***/ "3GPF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var passwordStrength = __webpack_require__("IeI8").default;

"use strict";

var h = __webpack_require__("S8e/").default;
var directivesModule = __webpack_require__("7Eh3");

function passwordSaver() {
	return {
		scope: {
			state: "=state"
		},
		transclude: true,
		restrict: "E",
		link: function link(scope, element, attrs, ctrl, transclude) {
			transclude(scope, function (clone) {
				element.append(clone);
			});

			scope.passwordValidations = [{
				validator: "passwordEmpty()",
				translation: "login.register.errors.passwordEmpty"
			}, {
				validator: "passwordToWeak()",
				translation: "login.register.errors.passwordWeak",
				onChange: 500
			}];

			scope.password2Validations = [{
				validator: "password2Empty()",
				translation: "login.register.errors.password2Empty"
			}, {
				validator: "noPasswordMatch()",
				translation: "login.register.errors.passwordNoMatch"
			}];

			scope.state = scope.state || {};

			scope.acceptIcon = function (value1, value2) {
				if (value1 === value2) {
					return "fa-check";
				}

				return "fa-times";
			};

			scope.passwordStrength = function () {
				return passwordStrength(scope.state.password);
			};

			scope.empty = function (val) {
				return val === "" || !h.isset(val);
			};

			scope.passwordEmpty = function () {
				return scope.empty(scope.state.password);
			};

			scope.passwordToWeak = function () {
				return scope.passwordStrength() < 1;
			};

			scope.password2Empty = function () {
				return scope.empty(scope.state.password2);
			};

			scope.noPasswordMatch = function () {
				return scope.state.password !== scope.state.password2;
			};
		}
	};
}

passwordSaver.$inject = [];

directivesModule.directive("passwordinput", passwordSaver);

/***/ }),

/***/ "3IhH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("YnzV");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function userimage() {
	return {
		transclude: false,
		scope: {
			userData: "=user"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true
	};
}

directivesModule.directive("userimage", userimage);

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Mbi2");
__webpack_require__("hWdg");
module.exports = __webpack_require__("VrXE");


/***/ }),

/***/ "4PxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_service__ = __webpack_require__("EFCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb__ = __webpack_require__("enoJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idb__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;



 // tslint:disable-line:no-unused-variable
var REINIT_CACHE_TIMEOUT = 2000;
var cachesDisabled = false;
var openDatabase = function () {
    return __WEBPACK_IMPORTED_MODULE_3_idb___default.a.open("whispeerCache", 10, function (upgradeDB) {
        var objectStore = upgradeDB.createObjectStore('cache', { keyPath: "id" });
        objectStore.createIndex("created", "created", { unique: false });
        objectStore.createIndex("used", "used", { unique: false });
        objectStore.createIndex("type", "type", { unique: false });
        objectStore.createIndex("size", "size", { unique: false });
    }).catch(function (e) {
        console.warn("Disabling indexedDB caching due to error", e);
        cachesDisabled = true;
        return Promise.reject(e);
    });
};
var initCache = function () { return cachesDisabled = false; };
try {
    indexedDB.deleteDatabase("whispeer");
}
catch (e) { }
var followCursorUntilDone = function (cursorPromise, action) {
    return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
        var cursor;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cursorPromise];
                case 1:
                    cursor = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!cursor) return [3 /*break*/, 4];
                    action(cursor);
                    return [4 /*yield*/, cursor.continue()];
                case 3:
                    cursor = _a.sent();
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/];
            }
        });
    }); });
};
var Cache = /** @class */ (function () {
    function Cache(name, options) {
        this.name = name;
        this.cacheDisabled = false;
        this.options = options || {};
        this.options.maxEntries = this.options.maxEntries || 100;
        this.options.maxBlobSize = this.options.maxBlobSize || 1 * 1024 * 1024;
    }
    Cache.deleteDatabase = function () {
        cachesDisabled = true;
        return __WEBPACK_IMPORTED_MODULE_3_idb___default.a.delete("whispeerCache").then(function () {
            setTimeout(function () {
                initCache();
            }, REINIT_CACHE_TIMEOUT);
        });
    };
    Cache.sumSize = function (arr) {
        return arr.reduce(function (prev, cur) {
            return prev + cur.size;
        }, 0);
    };
    Cache.prototype.store = function (id, data, blobs) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        if (blobs && !__WEBPACK_IMPORTED_MODULE_2__helper_helper__["default"].array.isArray(blobs)) {
            blobs = [blobs];
        }
        if (blobs && this.options.maxBlobSize !== -1 && Cache.sumSize(blobs) > this.options.maxBlobSize) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        var cacheEntry = {
            data: JSON.stringify(data),
            created: new Date().getTime(),
            used: new Date().getTime(),
            id: this.getID(id),
            type: this.name,
            size: 0,
            blobs: []
        };
        if (blobs) {
            cacheEntry.blobs = blobs;
            cacheEntry.size = Cache.sumSize(blobs);
        }
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        console.info("Storing in indexeddb " + this.getID(id));
                        tx = db.transaction('cache', 'readwrite');
                        tx.objectStore('cache').put(cacheEntry);
                        return [4 /*yield*/, tx.complete];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); }).catch(__WEBPACK_IMPORTED_MODULE_0__error_service__["errorServiceInstance"].criticalError);
    };
    Cache.prototype.contains = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"](false);
        }
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readonly");
                        return [4 /*yield*/, tx.objectStore("cache").count(this.name + "/" + id)];
                    case 2:
                        count = _a.sent();
                        db.close();
                        return [2 /*return*/, count > 0];
                }
            });
        }); });
    };
    Cache.prototype.get = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["reject"](new Error("Cache is disabled " + this.name));
        }
        /*
        var cacheResult = this._db.cache.where("id").equals(this.name + "/" + id);

        this._db.cache.where("id").equals(this.name + "/" + id).modify({ used: new Date().getTime() });
        */
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readonly");
                        return [4 /*yield*/, tx.objectStore("cache").get(this.name + "/" + id)];
                    case 2:
                        data = _a.sent();
                        if (typeof data === "undefined") {
                            throw new Error("cache miss for " + this.getID(id));
                        }
                        data.data = JSON.parse(data.data);
                        data.blobs = data.blobs || [];
                        data.blobs = data.blobs.map(function (blob) {
                            if (typeof blob === "string") {
                                return __WEBPACK_IMPORTED_MODULE_2__helper_helper__["default"].dataURItoBlob(blob);
                            }
                            return blob;
                        });
                        if (data.blobs.length === 1) {
                            data.blob = data.blobs[0];
                        }
                        db.close();
                        return [2 /*return*/, data];
                }
            });
        }); });
    };
    /**
     * get all cache entries as a dexie collection.<
     * @return {Bluebird<any>} Promise containing all cache entries as a dexie collection.
     */
    Cache.prototype.all = function () {
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]([]);
        }
        var entries = [];
        return this.cursorEach(function (cursor) { return entries.push(cursor.value); }, "readonly").then(function () { return entries; });
    };
    Cache.prototype.getID = function (id) {
        return this.name + "/" + id;
    };
    /**
     * delete a certain cache entry.
     * @param  {string}        id id of the entry
     * @return {Bluebird<any>}    [description]
     */
    Cache.prototype.delete = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readwrite");
                        return [4 /*yield*/, tx.objectStore("cache").delete(this.getID(id))];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cache.prototype.deleteAll = function () {
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        var deleteRequests = [];
        return this.cursorEach(function (cursor) { return deleteRequests.push(cursor.delete()); }, "readwrite").then(function () { return __WEBPACK_IMPORTED_MODULE_1_bluebird__["all"](deleteRequests); });
    };
    Cache.prototype.cursorEach = function (action, transactionType) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, cursorPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", transactionType);
                        cursorPromise = tx.objectStore("cache").index("type").openCursor(this.name);
                        return [4 /*yield*/, followCursorUntilDone(cursorPromise, action)];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cache.prototype.isDisabled = function () {
        return cachesDisabled || this.cacheDisabled;
    };
    Cache.disable = function () {
        cachesDisabled = true;
    };
    Cache.prototype.disable = function () {
        this.cacheDisabled = true;
    };
    return Cache;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cache);


/***/ }),

/***/ "5O0x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* friendsService
**/

var h = __webpack_require__("S8e/").default;
var Observer = __webpack_require__("SiYL");
var SecuredData = __webpack_require__("eRn5").default;
var Bluebird = __webpack_require__("fp6q");

var socket = __webpack_require__("8I7s").default;
var keyStore = __webpack_require__("IeOO").default;
var initService = __webpack_require__("EKxj");

var friends = [],
    requests = [],
    requested = [],
    ignored = [],
    removed = [],
    deleted = [],
    signedList,
    onlineFriends = {},
    friendsService,
    friendsServiceLoaded = false;

var friendsData = {
	requestsCount: 0,
	friendsCount: 0,
	requestedCount: 0
};

function updateCounters() {
	friendsData.friendsCount = friends.length;
	friendsData.requestsCount = requests.length;
	friendsData.requestedCount = requested.length;
}

function userOnline(uid, status) {
	onlineFriends[uid] = status;
	friendsService.notify(status, "online:" + uid);
}

function createBasicData(ownUser, otherUser) {
	var friendShipKey;

	//encr intermediate key w/ users cryptKey
	return keyStore.sym.asymEncryptKey(ownUser.getFriendsKey(), otherUser.getCryptKey()).then(function (_friendShipKey) {
		friendShipKey = _friendShipKey;
		var mainKey = ownUser.getMainKey();

		signedList.metaSetAttr(otherUser.getID(), friendShipKey);

		return Bluebird.all([SecuredData.load(undefined, {
			user: otherUser.getID()
		}, { type: "friendShip" }).sign(ownUser.getSignKey()), signedList.sign(ownUser.getSignKey()), keyStore.sym.symEncryptKey(friendShipKey, mainKey)]);
	}).spread(function (securedData, signedList) {
		var data = {
			signedList: signedList,
			meta: securedData,
			key: keyStore.upload.getKey(friendShipKey)
		};

		return {
			data: data,
			key: friendShipKey
		};
	});
}

function generateRemovalData(ownUser, otherUser) {
	return Bluebird.try(function () {
		var signedRemovalPromise = SecuredData.load(undefined, {
			initial: removed.indexOf(ownUser.getID()) === -1,
			user: otherUser.getID()
		}, { type: "removeFriend" }).sign(ownUser.getSignKey());

		signedList.metaRemoveAttr(otherUser.getID());

		var signedListPromise = signedList.sign(ownUser.getSignKey());

		return Bluebird.all([signedRemovalPromise, signedListPromise]);
	}).spread(function (signedRemoval, updatedSignedList) {
		return ownUser.generateNewFriendsKey().then(function (result) {
			return {
				signedRemoval: signedRemoval,
				updatedSignedList: updatedSignedList,
				signedKeys: result.updatedSignedKeys,
				newFriendsKey: result.newFriendsKey
			};
		});
	});
}

function addAsFriend(uid) {
	var otherUser,
	    friendShipKey,
	    userService = __webpack_require__("UuKm").default;
	return Bluebird.try(function () {
		return friendsService.awaitLoading();
	}).then(function () {
		return userService.get(uid);
	}).then(function (u) {
		otherUser = u;
		return createBasicData(userService.getOwn(), otherUser);
	}).then(function (result) {
		friendShipKey = result.key;

		var friendsKey = userService.getOwn().getFriendsKey();
		result.data.decryptors = keyStore.upload.getDecryptors([friendsKey], [friendShipKey]);

		return socket.emit("friends.add", result.data);
	}).then(function (result) {
		if (result.success) {
			otherUser.setFriendShipKey(friendShipKey);

			if (result.friends) {
				friends.push(uid);
				h.removeArray(requests, uid);
				friendsService.notify(uid, "new");
			} else {
				requested.push(uid);
				friendsService.notify(uid, "newRequested");
			}

			updateCounters();
		}
	});
}

socket.channel("friendRequest", function (e, requestData) {
	var uid = h.parseDecimal(requestData.uid);
	if (!h.containsOr(uid, requests, friends, requested)) {
		requests.push(uid);
		updateCounters();

		friendsService.notify(uid, "newRequest");
	}
});

socket.channel("friendAccept", function (e, requestData) {
	var uid = h.parseDecimal(requestData.uid);
	if (!h.containsOr(uid, requests, friends)) {
		friends.push(uid);
		h.removeArray(requested, uid);

		updateCounters();

		friendsService.notify(uid, "new");

		userOnline(uid, 2);
	}
});

socket.channel("friendOnlineChange", function (e, requestData) {
	userOnline(requestData.uid, requestData.status);
});

function checkAndRemove(uid) {
	var userService = __webpack_require__("UuKm").default;
	return Bluebird.try(function () {
		return Bluebird.all([userService.get(uid), socket.emit("friends.getSignedData", {
			uid: uid
		})]);
	}).spread(function (user, data) {
		var signedData = data.signedData;
		if (h.parseDecimal(signedData.user) !== userService.getOwn().getID() || signedData.initial === "false") {
			throw new Error("invalid signed removal");
		}

		return SecuredData.load(undefined, signedData, { type: "removeFriend" }).verify(user.getSignKey());
	}).then(function () {
		return friendsService.removeFriend(uid);
	});
}

function removeUnfriendedPersons() {
	var userService = __webpack_require__("UuKm").default;
	return Bluebird.try(function () {
		return userService.getMultiple(removed);
	}).then(function (removedFriends) {
		return removedFriends.reduce(function (previousPromise, friend) {
			return previousPromise.then(function () {
				return checkAndRemove(friend.getID());
			});
		}, Bluebird.resolve());
	});
}

var loadingPromise;

friendsService = {
	isLoaded: function isLoaded() {
		return friendsServiceLoaded;
	},
	ensureIsLoaded: function ensureIsLoaded(method) {
		if (!friendsService.isLoaded()) {
			throw new Error("friends service not yet loaded! Method: " + method);
		}
	},
	awaitLoading: function awaitLoading(cb) {
		return loadingPromise.nodeify(cb);
	},
	getUserFriends: function getUserFriends(uid, cb) {
		return Bluebird.try(function () {
			return socket.emit("friends.getUser", {
				userid: uid
			});
		}).then(function (result) {
			return result.friends;
		}).nodeify(cb);
	},
	removeFriend: function removeFriend(uid, cb) {
		friendsService.ensureIsLoaded("removeFriend");

		if (friends.indexOf(uid) === -1 && removed.indexOf(uid) === -1) {
			throw new Error("not a friend!");
		}

		var userService = __webpack_require__("UuKm").default,
		    circleService = __webpack_require__("silk");
		var otherUser,
		    ownUser = userService.getOwn(),
		    userCircles = circleService.inWhichCircles(uid);

		return Bluebird.try(function () {
			return userService.get(uid);
		}).then(function (u) {
			otherUser = u;

			return generateRemovalData(ownUser, otherUser, this);
		}).then(function (result) {
			return socket.emit("friends.remove", {
				uid: uid,
				signedRemoval: result.signedRemoval,
				signedList: result.updatedSignedList,
				signedKeys: result.signedKeys,
				newFriendsKey: keyStore.upload.getKey(result.newFriendsKey)
			});
		}).then(function (result) {
			if (result.success) {
				h.removeArray(friends, uid);
				h.removeArray(removed, uid);

				updateCounters();
				friendsService.notify(uid, "remove");
				userOnline(uid, -1);

				return circleService.loadAll();
			}

			throw new Error("could not remove friends");
		}).then(function () {
			return Bluebird.all(userCircles.map(function (circle) {
				return circle.removePersons([uid]);
			}));
		}).then(function () {
			//update profile for new friendsKey
			return ownUser.rebuildProfiles();
		}).nodeify(cb);
	},
	friendship: function friendship(uid, cb) {
		if (h.containsOr(uid, friends, requested)) {
			return Bluebird.resolve().nodeify(cb);
		}

		return addAsFriend(uid).nodeify(cb);
	},
	ignoreFriendShip: function ignoreFriendShip(uid, cb) {
		return Bluebird.try(function () {
			if (requests.indexOf(uid) > -1 && !h.containsOr(uid, friends, requested)) {
				return socket.emit("friends.ignore", { uid: uid });
			}

			throw new Error("no request Oo");
		}).then(function () {
			ignored.push(uid);
			h.removeArray(requests, uid);
			friendsService.notify(uid, "ignore");
			updateCounters();
		}).nodeify(cb);
	},
	acceptFriendShip: function acceptFriendShip(uid, cb) {
		if (requests.indexOf(uid) > -1 && !h.containsOr(uid, friends)) {
			return addAsFriend(uid).nodeify(cb);
		}
	},
	didIRequest: function didIRequest(uid) {
		friendsService.ensureIsLoaded("didIRequest");

		return h.containsOr(uid, friends, requested);
	},
	didOtherRequest: function didOtherRequest(uid) {
		friendsService.ensureIsLoaded("didOtherRequest");

		return h.containsOr(uid, friends, requests);
	},
	areFriends: function areFriends(uid) {
		friendsService.ensureIsLoaded("areFriends");

		return h.containsOr(uid, friends);
	},
	noRequests: function noRequests(uid) {
		friendsService.ensureIsLoaded("noRequests");

		return !h.containsOr(uid, friends, requested, requests);
	},
	getRequestStatus: function getRequestStatus(uid) {
		friendsService.ensureIsLoaded("getRequestStatus");

		if (friends.indexOf(uid) > -1) {
			return "friends";
		}

		if (requested.indexOf(uid) > -1) {
			return "requested";
		}

		if (requests.indexOf("uid") > -1) {
			return "accept";
		}

		return "request";
	},
	getRequests: function getRequests() {
		friendsService.ensureIsLoaded("getRequests");

		return requests.slice();
	},
	getFriends: function getFriends() {
		friendsService.ensureIsLoaded("getFriends");

		return friends.slice();
	},
	getRequested: function getRequested() {
		friendsService.ensureIsLoaded("getRequested");

		return requested.slice();
	},
	getUserFriendShipKey: function getUserFriendShipKey(uid) {
		friendsService.ensureIsLoaded("getUserFriendShipKey");

		return signedList.metaAttr(uid);
	},
	getUserForKey: function getUserForKey(realid) {
		friendsService.ensureIsLoaded("getUserForKey");

		var meta = signedList.metaGet(),
		    result;
		h.objectEach(meta, function (key, value) {
			if (value === realid) {
				result = h.parseDecimal(key);
			}
		});

		return result;
	},
	getAllFriendShipKeys: function getAllFriendShipKeys() {
		friendsService.ensureIsLoaded("getAllFriendShipKeys");

		var meta = signedList.metaGet(),
		    keys = [];
		h.objectEach(meta, function (key, value) {
			if (h.isInt(key)) {
				keys.push(value);
			}
		});

		return keys;
	},
	load: function load() {
		var userService = __webpack_require__("UuKm").default;

		return socket.definitlyEmit("friends.all", {}).then(function (data) {
			friends = data.friends.map(h.parseDecimal);
			requests = data.requests.map(h.parseDecimal);
			requested = data.requested.map(h.parseDecimal);
			ignored = data.ignored.map(h.parseDecimal);
			removed = data.removed.map(h.parseDecimal);
			deleted = data.deleted.map(h.parseDecimal);

			updateCounters();

			signedList = SecuredData.load(undefined, data.signedList || {}, { type: "signedFriendList" });

			var requestedOrFriends = signedList.metaKeys().map(h.parseDecimal);
			if (!h.arrayEqual(requestedOrFriends, requested.concat(friends).concat(removed).concat(deleted))) {
				throw new Error("unmatching arrays");
			}

			return userService.getOwnAsync().thenReturn(data);
		}).then(function (data) {
			if (data.signedList) {
				return signedList.verify(userService.getOwn().getSignKey(), "user");
			}
		}).then(function () {
			friendsServiceLoaded = true;

			var requestedOrFriends = signedList.metaKeys().map(h.parseDecimal);
			requestedOrFriends.forEach(function (uid) {
				keyStore.security.addEncryptionIdentifier(signedList.metaAttr(uid));
			});

			if (removed.length > 0) {
				return removeUnfriendedPersons();
			}
		});
	},
	onlineStatus: function onlineStatus(uid) {
		if (friends.indexOf(uid) === -1) {
			return -1;
		}

		return onlineFriends[uid] || 0;
	},
	data: friendsData
};

Observer.extend(friendsService);

loadingPromise = initService.awaitLoading().then(function () {
	return friendsService.load();
});

initService.awaitLoading().then(function () {
	return Bluebird.delay(500);
}).then(function () {
	return socket.definitlyEmit("friends.getOnline", {});
}).then(function (data) {
	h.objectEach(data.online, function (uid, status) {
		userOnline(uid, status);
	});
});

socket.channel("notify.signedList", function (e, data) {
	if (signedList.metaAttr("_signature") !== data._signature) {
		var userService = __webpack_require__("UuKm").default;
		var updatedSignedList = SecuredData.load(undefined, data, { type: "signedFriendList" });

		Bluebird.try(function () {
			return updatedSignedList.verify(userService.getOwn().getSignKey(), null, "user");
		}).then(function () {
			signedList = updatedSignedList;
		});
	}
});

module.exports = friendsService;

/***/ }),

/***/ "5sYn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var settings = __webpack_require__("Etis").default;

var Bluebird = __webpack_require__("fp6q");
var h = __webpack_require__("S8e/").default;
var errors = __webpack_require__("a86h");

function removePadding(val) {
	var isNumber = false;

	if (val.indexOf("num::") === 0) {
		isNumber = true;

		val = val.substr(5);
	}

	if (val.length % 128 !== 2) {
		throw new errors.InvalidDataError("padding size invalid");
	}

	var paddingIndex = val.indexOf("::");

	if (paddingIndex === -1) {
		throw new errors.InvalidDataError("no padding seperator found");
	}

	var unpadded = val.substr(paddingIndex + 2);

	if (isNumber) {
		return h.parseDecimal(unpadded);
	}

	return unpadded;
}

function checkAndFixString(val) {
	while (typeof val === "string" && val.lastIndexOf("::") > -1) {
		val = removePadding(val);
	}

	return val;
}

function checkAndFixObject(content) {
	h.objectEach(content, function (key, value) {
		if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
			checkAndFixObject(value);
		} else if (typeof value === "string") {
			content[key] = checkAndFixString(value);
		}
	});
}

module.exports = function () {
	return Bluebird.try(function () {
		var content = settings.getContent();

		checkAndFixObject(content);

		if (h.deepEqual(content, settings.getContent())) {
			return Bluebird.resolve(true);
		}

		settings.setContent(content);
		return settings.uploadChangedData().thenReturn(true);
	});
};

/***/ }),

/***/ "6CQq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("+DAV");

"use strict";
var jQuery = __webpack_require__("juYr");
var directivesModule = __webpack_require__("7Eh3");
directivesModule.directive("modal", function () {
	return {
		scope: {
			visible: "=show",
			loading: "=loading"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true,
		transclude: true,
		link: function link(scope) {
			var ESC = 27;
			var CLOSEKEYS = [ESC];

			scope.hide = function () {
				scope.visible = false;
			};

			scope.show = function () {
				scope.visible = true;
			};

			scope.toggle = function () {
				scope.visible = !scope.visible;
			};

			jQuery(document).keyup(function (e) {
				if (scope.visible && CLOSEKEYS.indexOf(e.keyCode) > -1) {
					scope.visible = false;
					scope.$applyAsync();
				}
			});
		}
	};
});

/***/ }),

/***/ "72mU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	var profileJSON = {
		"type": "object",
		"properties": {
			"basic": {
				"type": "object",
				"properties": {
					"firstname": {
						"type": "string"
					},
					"lastname": {
						"type": "string"
					}
				}
			},

			"image": {
				"type": "string",
				"pattern": /^(|data:image\/\w+;base64,[A-Za-z0-9+\/=]*)$/
			},

			"imageBlob": {
				"type": "object",
				"additionalProperties": false,
				"properties": {
					"imageHash": {
						"type": "string",
						"pattern": /^[A-Fa-f0-9]*$/
					},
					"blobid": {
						"type": "string",
						"pattern": /^[A-z0-9]*$/
					}
				}
			},

			"location": {
				"type": "object",
				"properties": {
					"road": {
						"type": "string"
					},
					"number": {
						"type": "string"
					},
					"town": {
						"type": "string"
					},
					"state": {
						"type": "string"
					},
					"country": {
						"type": "string"
					}
				}
			},

			"contact": {
				"type": "object",
				"properties": {
					"im": {
						"type": "Array",
						"items": {
							"type": "object",
							"properties": {
								"messenger": {
									"required": true,
									"type": "string",
									"enum": ["icq", "skype", "jabber"]
								},
								"address": {
									"type": "string"
								}
							}
						}
					},
					"mail": {
						"type": "Array",
						"items": {
							"type": "string",
							"format": "email"
						}
					},
					"telephone": {
						"type": "Array",
						"items": {
							"type": "object",
							"properties": {
								"where": {
									"type": "string"
								},
								"number": {
									"required": true,
									"type": "string",
									"format": "phone"
								}
							}
						}
					},
					"mobile": {
						"type": "Array",
						"items": {
							"type": "object",
							"properties": {
								"where": {
									"type": "string"
								},
								"number": {
									"required": true,
									"type": "string",
									"format": "phone"
								}
							}
						}
					},
					"website": {
						"type": "Array",
						"items": {
							"type": "string",
							"format": "url"
						}
					}
				}
			},

			"relationship": {
				"type": "object",
				"properties": {
					"partner": {
						"type": "object",
						"properties": {
							"user": {
								"type": "integer",
								"minimum": 1
							},
							"partnerSignature": {
								"type": "string",
								"hex": true
							}
						}
					},
					"since": {
						"type": "string",
						"format": "date",
						"after": "1900-01-01"
					},
					"status": {
						"type": "string",
						"enum": ["single", "relationship", "engaged", "married", "divorced", "widowed", "complicated", "open", "inlove"]
					}
				}
			},

			"relatives": {
				"type": "array",
				"items": {
					"type": "object",
					"properties": {
						"user": {
							"type": "integer"
						},
						"status": {
							"type": "string",
							"enum": ["sister", "brother", "mother", "father", "daughter", "son", "aunt", "uncle", "niece", "nephew", "femalecousin", "malecousin", "grandmother", "grandfather", "granddaughter", "grandson", "stepsister", "stepbrother", "stepmother", "stepfather", "stepdaughter", "stepson", "sister-in-law", "brother-in-law", "mother-in-law", "father-in-law", "daughter-in-law", "son-in-law"]
						}
					}
				}
			},

			"extended": {
				"type": "object",
				"properties": {
					"sex": {
						"type": "string",
						"enum": ["f", "m"]
					},
					"birthday": {
						"type": "string",
						"format": "date",
						"after": "1900-01-01"
					},
					"religion": {
						"type": "string"
					},
					"political": {
						"type": "string"
					}
				}
			},

			"knowledge": {
				"type": "object",
				"properties": {
					"education": {
						"type": "array",
						"items": {
							"type": "object",
							"properties": {
								"name": {
									"type": "string"
								},
								"startDate": {
									"type": "string",
									"format": "date"
								},
								"endDate": {
									"type": "string",
									"format": "date"
								},
								"edutype": {
									"type": "string"
								},
								"titles": {
									"type": "Array",
									"items": {
										"type": "object",
										"properties": {
											"name": {
												"required": true,
												"type": "string"
											},
											"date": {
												"type": "string",
												"format": "date"
											}
										}
									}
								}
							}
						}
					},
					"knowledge": {
						"type": "string"
					},
					"languages": {
						"type": "array",
						"items": {
							"type": "string"
						}
					}
				}
			},

			"jobs": {
				"type": "array",
				"items": {
					"type": "object",
					"properties": {
						"title": {
							"type": "string"
						},
						"company": {
							"type": "string"
						},
						"startDate": {
							"type": "string",
							"format": "date"
						},
						"endDate": {
							"type": "string",
							"format": "date"
						}
					}
				}
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = profileJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return profileJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "7Eh3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__("aeQg");

module.exports = angular.module("ssn.directives", []);

/***/ }),

/***/ "8+7v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _filterService = __webpack_require__("emzt");

var _filterService2 = _interopRequireDefault(_filterService);

var _imageUpload = __webpack_require__("BHBR");

var _imageUpload2 = _interopRequireDefault(_imageUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templateUrl = __webpack_require__("x//1");
var postService = __webpack_require__("0eEO");
var directivesModule = __webpack_require__("7Eh3");
var State = __webpack_require__("uJ4a");

function newPostDirective() {
	return {
		scope: {
			"inputI18nAttr": "@",
			"addClasses": "@",
			"wallUserId": "="
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: false,
		transclude: false,
		link: {
			pre: function pre($scope) {
				$scope.canSend = true;
				$scope.getFiltersByID = _filterService2.default.getFiltersByID;

				$scope.newPost = {
					text: "",
					readers: ["always:allfriends"],
					images: [],
					rotateImage: function rotateImage(index) {
						var image = $scope.newPost.images[index];
						image.rotate();
					},
					removeImage: function removeImage(index) {
						$scope.newPost.images.splice(index, 1);
					},
					addImages: _imageUpload2.default.fileCallback(function (files) {
						$scope.$applyAsync(function () {
							$scope.newPost.images = $scope.newPost.images.concat(files.map(function (file) {
								return new _imageUpload2.default(file);
							}));
						});
					})
				};

				var sendPostState = new State.default();
				$scope.sendPostState = sendPostState.data;

				$scope.setPostReaders = function (newSelection) {
					$scope.newPost.readers = newSelection;
				};

				$scope.sendPost = function () {
					var images = $scope.newPost.images,
					    wallUserId = 0;
					sendPostState.pending();

					if ($scope.newPost.text === "" && images.length === 0) {
						sendPostState.failed();
						return;
					}

					var visibleSelection = $scope.newPost.readers.slice();

					if ($scope.wallUserId) {
						wallUserId = $scope.wallUserId;
						visibleSelection.push("friends:" + wallUserId);
					}

					if ($scope.canSend) {
						$scope.canSend = false;

						postService.createPost($scope.newPost.text, visibleSelection, wallUserId, images).then(function () {
							$scope.newPost.text = "";
							$scope.newPost.images = [];
						}).catch(function (e) {
							console.error(e);
							sendPostState.failed();
						}).then(sendPostState.success.bind(sendPostState)).finally(function () {
							$scope.canSend = true;
							$scope.postActive = false;
						});
					}
				};
			}
		}
	};
}

newPostDirective.$inject = [];

directivesModule.directive("newpost", newPostDirective);

/***/ }),

/***/ "8I7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// EXTERNAL MODULE: ../node_modules/socket.io-client/lib/index.js
var lib = __webpack_require__("+1g+");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/asset/observer.ts
var observer = __webpack_require__("SiYL");

// CONCATENATED MODULE: ./js/services/blobUploader.service.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var blobUploader_service_BlobUploader = /** @class */ (function (_super) {
    __extends(BlobUploader, _super);
    function BlobUploader(socket, blob, blobid) {
        var _this = _super.call(this) || this;
        _this._doneBytes = 0;
        _this.upload = function () {
            if (!_this._uploadingPromise) {
                _this._uploadingPromise = _this._uploadPartUntilDone();
            }
            return _this._uploadingPromise;
        };
        _this._uploadPartUntilDone = function () {
            if (_this._doneBytes === _this._blob.size) {
                return bluebird["resolve"]();
            }
            return _this._uploadPart().then(function () {
                return _this._uploadPartUntilDone();
            });
        };
        _this._blob = blob;
        _this._blobid = blobid;
        _this._socket = socket;
        _this._reset();
        return _this;
    }
    BlobUploader.prototype._reset = function () {
        this._doneBytes = 0;
        this._partSize = BlobUploader.STARTPARTSIZE;
    };
    BlobUploader.sliceBlob = function (blob, start, end) {
        if (typeof blob.slice === "function") {
            return blob.slice(start, end);
        }
        if (typeof blob.webkitSlice === "function") {
            return blob.webkitSlice(start, end);
        }
        if (typeof blob.mozSlice === "function") {
            return blob.mozSlice(start, end);
        }
        return blob;
    };
    ;
    BlobUploader.prototype._halfSize = function () {
        this._partSize = Math.max(this._partSize / 2, BlobUploader.MINIMUMPARTSIZE);
    };
    ;
    BlobUploader.prototype._doubleSize = function () {
        this._partSize = Math.min(this._partSize * 2, BlobUploader.MAXIMUMPARTSIZE);
    };
    ;
    BlobUploader.prototype._uploadPart = function () {
        var _this = this;
        var uploadStarted = new Date().getTime(), uploadSize;
        return this._socket.awaitConnection().then(function () {
            var partToUpload = BlobUploader.sliceBlob(_this._blob, _this._doneBytes, _this._doneBytes + _this._partSize);
            uploadSize = partToUpload.size;
            var lastPart = _this._blob.size === _this._doneBytes + uploadSize;
            return _this._socket.emit("blob.uploadBlobPart", {
                blobid: _this._blobid,
                blobPart: partToUpload,
                doneBytes: _this._doneBytes,
                size: uploadSize,
                lastPart: lastPart
            });
        }).then(function (response) {
            if (response.reset) {
                console.warn("Restarting Upload");
                return _this._reset();
            }
            var uploadTook = new Date().getTime() - uploadStarted;
            if (uploadTook > BlobUploader.MAXIMUMTIME) {
                _this._halfSize();
            }
            else {
                _this._doubleSize();
            }
            _this._doneBytes += uploadSize;
            _this.notify(_this._doneBytes, "progress");
        }).catch(function (e) {
            console.error(e);
            _this._halfSize();
            return bluebird["delay"](5000);
        });
    };
    ;
    BlobUploader.MAXIMUMPARTSIZE = 1000 * 1000;
    BlobUploader.STARTPARTSIZE = 5 * 1000;
    BlobUploader.MINIMUMPARTSIZE = 1 * 1000;
    BlobUploader.MAXIMUMTIME = 2 * 1000;
    return BlobUploader;
}(observer["default"]));
/* harmony default export */ var blobUploader_service = (blobUploader_service_BlobUploader);

// EXTERNAL MODULE: ./js/services/location.manager.ts
var location_manager = __webpack_require__("02Tt");

// CONCATENATED MODULE: ./js/services/socket.service.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisconnectError", function() { return DisconnectError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerError", function() { return ServerError; });
var socket_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var APIVERSION = "0.0.4";
var debug = __webpack_require__("jcLW");


var config = __webpack_require__("b/6L");




var socketDebug = debug("whispeer:socket");
var socketError = debug("whispeer:socket:error");
var DisconnectError = helper["default"].createErrorType("disconnectedError");
var ServerError = helper["default"].createErrorType("serverError");
var socket_service_SOCKET_TIMEOUT = 60000;
var log = {
    timer: function (name) {
        var message = new Date().toLocaleTimeString() + ":" + name + "(" + Math.random() + ")";
        if (debug.enabled("whispeer:socket")) {
            console.time(message);
        }
        return message;
    },
    timerEnd: function (message) {
        if (debug.enabled("whispeer:socket")) {
            console.timeEnd(message);
        }
    }
};
var socket_service_SocketService = /** @class */ (function (_super) {
    socket_service___extends(SocketService, _super);
    function SocketService() {
        var _this = _super.call(this) || this;
        _this._interceptors = [];
        _this._domain = (config.https ? "https://" : "http://") + config.ws + ":" + config.wsPort;
        _this._autoReconnect = config.socket.autoReconnect;
        _this._autoConnect = config.socket.autoConnect;
        _this._lastRequestTime = 0;
        _this._loading = 0;
        _this.uploadObserver = new observer["default"]();
        _this._uploadingCounter = 0;
        _this.errors = {
            Disconnect: DisconnectError,
            Server: ServerError
        };
        _this.uploadBlob = function (blob, blobid, progress, cb) {
            if (_this._uploadingCounter > 3) {
                _this.uploadObserver.listenOnce(function () {
                    _this.uploadBlob(blob, blobid, progress, cb);
                }, "uploadFinished");
                return;
            }
            _this._uploadingCounter++;
            var uploader = new blobUploader_service(_this, blob, blobid);
            uploader.listen(function (doneBytes) {
                progress.progress(doneBytes);
            }, "progress");
            var uploadPromise = uploader.upload().then(function () {
                _this._uploadingCounter--;
                _this.uploadObserver.notify(blobid, "uploadFinished");
                _this.uploadObserver.notify(blobid, "uploadFinished:" + blobid);
            });
            return uploadPromise.nodeify(cb);
        };
        if (_this._autoConnect) {
            _this._connect();
        }
        if (_this._autoConnect && _this._autoReconnect) {
            window.setInterval(function () {
                try {
                    if (!_this._socket.connected) {
                        _this._socket.connect();
                    }
                }
                catch (e) {
                    socketError(e);
                }
            }, 10000);
        }
        return _this;
    }
    SocketService.prototype._connect = function () {
        var _this = this;
        this._socket = Object(lib["connect"])(this._domain, config.socket.options);
        this._socket.on("disconnect", function () {
            socketDebug("socket disconnected");
            _this._loading = 0;
            _this._uploadingCounter = 0;
        });
        this._socket.on("connect", function () {
            socketDebug("socket connected");
            _this.emit("whispeerPing", {});
            _this._socket.io.engine.on("heartbeat", function () {
                _this.notify(null, "heartbeat");
            });
        });
    };
    SocketService.prototype._emit = function (channel, request) {
        var _this = this;
        return new bluebird(function (resolve, reject) {
            var onDisconnect = function () {
                reject(new DisconnectError("Disconnected while sending"));
            };
            _this._socket.once("disconnect", onDisconnect);
            _this._socket.emit(channel, request, function (response) {
                _this._socket.off("disconnect", onDisconnect);
                resolve(response);
            });
        });
    };
    SocketService.prototype.getLoadingCount = function () {
        return this._loading;
    };
    ;
    SocketService.prototype.lastRequestTime = function () {
        return this._lastRequestTime;
    };
    ;
    SocketService.prototype.send = function (data) {
        this._socket.send(data);
    };
    SocketService.prototype.addInterceptor = function (interceptor) {
        this._interceptors.push(interceptor);
    };
    SocketService.prototype.isConnected = function () {
        return this._socket.connected;
    };
    SocketService.prototype.emit = function (channel, request, cb) {
        var _this = this;
        if (!this.isConnected()) {
            throw new DisconnectError("no connection");
        }
        var timer = log.timer("request on " + channel);
        request.version = APIVERSION;
        request.clientInfo = {"type":"browser","version":"0.3.15"};
        socketDebug("Request on " + channel, request);
        this._interceptors.forEach(function (interceptor) {
            if (interceptor.transformRequest) {
                request = interceptor.transformRequest(request);
            }
        });
        this._loading++;
        this.notify(null, "request");
        return this._emit(channel, request).timeout(socket_service_SOCKET_TIMEOUT).then(function (response) {
            socketDebug("Answer on " + channel, response);
            log.timerEnd(timer);
            if (response.alert) {
                alert(response.alert);
            }
            _this._lastRequestTime = response.serverTime;
            _this._interceptors.forEach(function (interceptor) {
                if (interceptor.transformResponse) {
                    response = interceptor.transformResponse(response, request);
                }
            });
            if (response.error) {
                socketError(response);
                throw new ServerError("server returned an error!", { response: response });
            }
            if (true) {
                if (response.isBusiness) {
                    Object(location_manager["goToBusiness"])();
                }
            }
            if (false) {
                if (response.loggedin && !response.isBusiness && !request.ignoreBusiness) {
                    goToSalesPage();
                }
            }
            return response;
        }).finally(function () {
            _this._loading--;
            _this.notify(null, "response");
        }).nodeify(cb);
    };
    SocketService.prototype.awaitNoRequests = function () {
        var _this = this;
        if (this._loading === 0) {
            return bluebird["resolve"]();
        }
        return new bluebird(function (resolve) {
            _this.listen(function () {
                if (_this._loading === 0) {
                    resolve();
                }
            }, "response");
        });
    };
    SocketService.prototype.awaitConnection = function () {
        var _this = this;
        return new bluebird(function (resolve) {
            if (_this.isConnected()) {
                resolve();
            }
            else {
                _this.once("connect", resolve);
            }
        });
    };
    SocketService.prototype.on = function (eventName, callback) {
        return this._socket.on(eventName, callback);
    };
    SocketService.prototype.once = function (eventName, callback) {
        return this._socket.once(eventName, callback);
    };
    /** definitly emits the request. might emit it multiple times! **/
    SocketService.prototype.definitlyEmit = function (channel, request) {
        var _this = this;
        var SOCKET_TIMEOUT = 10000;
        return this.awaitConnection().then(function () {
            return _this.emit(channel, request).timeout(SOCKET_TIMEOUT);
        }).catch(function (e) {
            console.error(e);
            return bluebird["delay"](500).then(function () {
                return _this.definitlyEmit(channel, request);
            });
        });
    };
    SocketService.prototype.channel = function (channel, callback) {
        this._socket.on(channel, function (data) {
            socketDebug("received data on " + channel);
            socketDebug(data);
            callback(null, data);
        });
    };
    SocketService.errors = {
        Disconnect: DisconnectError,
        Server: ServerError
    };
    return SocketService;
}(observer["default"]));
/* harmony default export */ var socket_service = __webpack_exports__["default"] = (new socket_service_SocketService());


/***/ }),

/***/ "95Br":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// EXTERNAL MODULE: ./js/asset/Progress.ts
var Progress = __webpack_require__("P6+u");

// EXTERNAL MODULE: ./js/asset/blobCache.ts
var blobCache = __webpack_require__("bMcU");

// EXTERNAL MODULE: ./js/services/socket.service.ts + 1 modules
var socket_service = __webpack_require__("8I7s");

// EXTERNAL MODULE: ./js/asset/observer.ts
var observer = __webpack_require__("SiYL");

// CONCATENATED MODULE: ./js/services/blobDownloader.service.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MAXIMUMPARTSIZE = 1000 * 1000;
var STARTPARTSIZE = 5 * 1000;
var MINIMUMPARTSIZE = 1 * 1000;
var MAXIMUMTIME = 2 * 1000;
var blobDownloader_service_BlobDownloader = /** @class */ (function (_super) {
    __extends(BlobDownloader, _super);
    function BlobDownloader(socket, blobid, type, progress) {
        var _this = _super.call(this) || this;
        _this.socket = socket;
        _this.blobid = blobid;
        _this.type = type;
        _this.blobParts = [];
        _this.partSize = STARTPARTSIZE;
        _this.doneBytes = 0;
        _this.done = false;
        _this.download = function () {
            if (!_this.downloadPromise) {
                _this.downloadPromise = _this.downloadPartsUntilDone();
            }
            return _this.downloadPromise;
        };
        _this.downloadPartsUntilDone = function () {
            if (_this.done) {
                _this.progress.setTotal(_this.doneBytes);
                _this.progress.progress(_this.doneBytes);
                return _this.concatParts();
            }
            return _this.downloadPart().then(function () {
                return _this.downloadPartsUntilDone();
            });
        };
        _this.progress = progress || new Progress["a" /* default */]();
        return _this;
    }
    BlobDownloader.prototype.halfSize = function () {
        this.partSize = Math.max(this.partSize / 2, MINIMUMPARTSIZE);
    };
    ;
    BlobDownloader.prototype.doubleSize = function () {
        this.partSize = Math.min(this.partSize * 2, MAXIMUMPARTSIZE);
    };
    ;
    BlobDownloader.prototype.concatParts = function () {
        return bluebird["resolve"]({
            blob: new Blob(this.blobParts, { type: this.type }),
            meta: this.meta
        });
    };
    BlobDownloader.prototype.downloadPart = function () {
        var _this = this;
        var uploadStarted = new Date().getTime();
        return this.socket.awaitConnection().then(function () {
            return _this.socket.emit("blob.getBlobPart", {
                blobid: _this.blobid,
                start: _this.doneBytes,
                size: _this.partSize
            });
        }).then(function (response) {
            var uploadTook = new Date().getTime() - uploadStarted;
            _this.blobParts.push(response.part);
            _this.doneBytes += response.part.byteLength;
            _this.progress.progress(_this.doneBytes);
            if (uploadTook > MAXIMUMTIME) {
                _this.halfSize();
            }
            else {
                _this.doubleSize();
            }
            _this.done = response.last;
            _this.meta = response.meta;
            _this.notify(_this.doneBytes, "progress");
        }).catch(function (e) {
            if (e instanceof socket_service["ServerError"]) {
                var response = e.extra.response;
                if (helper["default"].hasErrorId(response, 71)) {
                    return bluebird["reject"](e);
                }
            }
            console.error(e);
            _this.halfSize();
            return bluebird["delay"](5000);
        });
    };
    ;
    return BlobDownloader;
}(observer["default"]));
/* harmony default export */ var blobDownloader_service = (blobDownloader_service_BlobDownloader);

// EXTERNAL MODULE: ./js/asset/Queue.ts
var Queue = __webpack_require__("iTly");

// CONCATENATED MODULE: ./js/services/blobService.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unpath", function() { return unpath; });
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var blobService__this = this;

var debug = __webpack_require__("jcLW");





var initService = __webpack_require__("EKxj");

var keyStore = __webpack_require__("+1JK");
var knownBlobURLs = {};
var downloadBlobQueue = new Queue["a" /* default */](5);
downloadBlobQueue.start();
var debugName = "whispeer:blobService";
var blobServiceDebug = debug(debugName);
var time = function (name) {
    if (debug.enabled(debugName)) {
        // eslint-disable-next-line no-console
        console.time(name);
    }
};
var timeEnd = function (name) {
    if (debug.enabled(debugName)) {
        // eslint-disable-next-line no-console
        console.timeEnd(name);
    }
};
var unpath = function (path) {
    var index = Math.max(path.lastIndexOf("/"), path.lastIndexOf("\\")) + 1;
    return {
        directory: path.substr(0, index),
        name: path.substr(index)
    };
};
var blobService_MyBlob = /** @class */ (function () {
    function MyBlob(blobData, blobID, options) {
        this.blobData = blobData;
        options = options || {};
        if (blobID) {
            this.blobID = blobID;
            this.uploaded = true;
        }
        else {
            this.uploaded = false;
        }
        this.meta = options.meta || {};
        this.key = this.meta._key || this.meta.key;
        this.decrypted = options.decrypted || !this.key;
        this.uploadProgress = new Progress["a" /* default */]({ total: this.getSize() });
        this.encryptProgress = new Progress["a" /* default */]({ total: this.getSize() });
        this.decryptProgress = new Progress["a" /* default */]({ total: this.getSize() });
    }
    MyBlob.prototype.isDecrypted = function () {
        return this.decrypted;
    };
    MyBlob.prototype.isUploaded = function () {
        return this.uploaded;
    };
    MyBlob.prototype.getSize = function () {
        return this.blobData.size;
    };
    MyBlob.prototype.getMeta = function () {
        return this.meta;
    };
    MyBlob.prototype.getArrayBuffer = function () {
        var _this = this;
        if (this.blobData.originalUrl) {
            var _a = unpath(this.blobData.originalUrl), directory = _a.directory, name_1 = _a.name;
            return blobCache["a" /* default */].readFileAsArrayBuffer(directory, name_1);
        }
        return new bluebird(function (resolve) {
            var reader = new FileReader();
            if (reader.addEventListener) {
                reader.addEventListener("loadend", resolve);
            }
            else {
                reader.onloadend = resolve;
            }
            reader.readAsArrayBuffer(_this.blobData);
        }).then(function (event) {
            var target = event.currentTarget || event.target;
            return target.result;
        });
    };
    MyBlob.prototype.encryptAndUpload = function (key) {
        var _this = this;
        return bluebird["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var blobKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.encrypt()];
                    case 1:
                        blobKey = _a.sent();
                        return [4 /*yield*/, keyStore.sym.symEncryptKey(blobKey, key)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.upload()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, blobKey];
                }
            });
        }); });
    };
    MyBlob.prototype.encrypt = function () {
        var _this = this;
        return bluebird["resolve"]().then(function () {
            if (_this.uploaded || !_this.decrypted) {
                throw new Error("trying to encrypt an already encrypted or public blob. add a key decryptor if you want to give users access");
            }
            return bluebird["all"]([
                keyStore.sym.generateKey(null, "blob key"),
                _this.getArrayBuffer()
            ]);
        }).spread(function (key, buf) {
            _this.key = key;
            time("blobencrypt" + (_this.blobID || _this.preReservedID));
            return keyStore.sym.encryptArrayBuffer(buf, _this.key, function (progress) {
                _this.encryptProgress.progress(_this.getSize() * progress);
            });
        }).then(function (encryptedData) {
            _this.encryptProgress.progress(_this.getSize());
            timeEnd("blobencrypt" + (_this.blobID || _this.preReservedID));
            blobServiceDebug(encryptedData.byteLength);
            _this.decrypted = false;
            _this.blobData = new Blob([encryptedData], { type: _this.blobData.type });
            return _this.key;
        });
    };
    MyBlob.prototype.decrypt = function (originalSize) {
        var _this = this;
        if (this.decrypted) {
            return bluebird["resolve"]();
        }
        return bluebird["try"](function () {
            return _this.getArrayBuffer();
        }).then(function (encryptedData) {
            time("blobdecrypt" + _this.blobID);
            return keyStore.sym.decryptArrayBuffer(encryptedData, _this.key, function (progress) {
                _this.decryptProgress.progress(_this.getSize() * progress);
            });
        }).then(function (decryptedData) {
            _this.decryptProgress.progress(_this.getSize());
            timeEnd("blobdecrypt" + _this.blobID);
            var unpaddedData = originalSize > 0 ? decryptedData.slice(0, originalSize) : decryptedData;
            _this.decrypted = true;
            _this.blobData = new Blob([unpaddedData], { type: _this.blobData.type });
            return blobCache["a" /* default */].store(_this).catch(function (e) {
                console.log("Could not store blob", e);
                return _this.toURL();
            });
        });
    };
    MyBlob.prototype.toURL = function () {
        var _this = this;
        return bluebird["try"](function () {
            if (_this.blobData.localURL) {
                return _this.blobData.localURL;
            }
            if (typeof window.URL !== "undefined") {
                return window.URL.createObjectURL(_this.blobData);
            }
            if (typeof webkitURL !== "undefined") {
                return window.webkitURL.createObjectURL(_this.blobData);
            }
            return bluebird["fromCallback"](function (cb) {
                helper["default"].blobToDataURI(_this.blobData, cb);
            });
        }).catch(function () {
            return "";
        });
    };
    MyBlob.prototype.upload = function () {
        var _this = this;
        return bluebird["try"](function () {
            if (_this.uploaded) {
                return _this.blobID;
            }
            return _this.reserveID();
        }).then(function (blobid) {
            return socket_service["default"].uploadBlob(_this.blobData, blobid, _this.uploadProgress);
        }).then(function () {
            _this.uploaded = true;
            return _this.blobID;
        });
    };
    MyBlob.prototype.getBlobID = function () {
        return this.blobID;
    };
    MyBlob.prototype.getBlobData = function () {
        return this.blobData;
    };
    MyBlob.prototype.reserveID = function () {
        var _this = this;
        return bluebird["try"](function () {
            var meta = _this.meta;
            meta._key = _this.key;
            meta.one = 1;
            if (_this.preReservedID) {
                return socket_service["default"].definitlyEmit("blob.fullyReserveID", {
                    blobid: _this.preReservedID,
                    meta: meta
                });
            }
            return socket_service["default"].definitlyEmit("blob.reserveBlobID", {
                meta: meta
            });
        }).then(function (data) {
            if (data.blobid) {
                _this.blobID = data.blobid;
                return _this.blobID;
            }
        });
    };
    MyBlob.prototype.preReserveID = function () {
        var _this = this;
        return bluebird["try"](function () {
            return socket_service["default"].emit("blob.preReserveID", {});
        }).then(function (data) {
            if (data.blobid) {
                _this.preReservedID = data.blobid;
                return data.blobid;
            }
            throw new Error("got no blobid");
        });
    };
    MyBlob.prototype.getHash = function () {
        return this.getArrayBuffer().then(function (buf) {
            return keyStore.hash.hashArrayBuffer(buf);
        });
    };
    return MyBlob;
}());
var loadBlob = function (blobID, type, progress, size) {
    var decryptProgressStub = new Progress["a" /* default */]({ total: size });
    var downloadProgress = new Progress["a" /* default */]({ total: size });
    progress.addDepend(downloadProgress);
    progress.addDepend(decryptProgressStub);
    return downloadBlobQueue.enqueue(1, function () { return bluebird["try"](function () { return __awaiter(blobService__this, void 0, void 0, function () {
        var data, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, initService.awaitLoading()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, new blobDownloader_service(socket_service["default"], blobID, type, downloadProgress).download()];
                case 2:
                    data = _a.sent();
                    blob = new blobService_MyBlob(data.blob, blobID, { meta: data.meta });
                    if (blob.isDecrypted()) {
                        return [2 /*return*/, blobCache["a" /* default */].store(blob).catch(function () { return blob.toURL(); })];
                    }
                    downloadProgress.progress(downloadProgress.getTotal());
                    progress.removeDepend(decryptProgressStub);
                    progress.addDepend(blob.decryptProgress);
                    return [2 /*return*/, blob.decrypt(size)];
            }
        });
    }); }); });
};
var getBlob = function (blobID, type, downloadProgress, estimatedSize) {
    if (!knownBlobURLs[blobID]) {
        knownBlobURLs[blobID] = loadBlob(blobID, type, downloadProgress, estimatedSize);
    }
    return knownBlobURLs[blobID];
};
var blobService = {
    createBlob: function (blob) {
        return new blobService_MyBlob(blob);
    },
    isBlobLoaded: function (blobID) {
        return blobCache["a" /* default */].isLoaded(blobID);
    },
    getBlobUrl: function (blobID, type, estimatedSize, progress) {
        if (progress === void 0) { progress = new Progress["a" /* default */](); }
        return blobCache["a" /* default */].getBlobUrl(blobID).catch(function () {
            return getBlob(blobID, type, progress, estimatedSize);
        });
    },
};
/* harmony default export */ var services_blobService = __webpack_exports__["default"] = (blobService);


/***/ }),

/***/ "9wYx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

var fileDirective = function fileDirective() {
	return {
		link: function link(scope, elm, attrs) {
			elm.bind("change", scope.$eval(attrs.file));
		}
	};
};

directivesModule.directive("file", fileDirective);

/***/ }),

/***/ "BHBR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screenSize_service__ = __webpack_require__("KEBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fileUpload_service__ = __webpack_require__("jZtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blobService__ = __webpack_require__("95Br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_Queue__ = __webpack_require__("iTly");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var imageLib = __webpack_require__("zF0Z");
var canvasToBlob = __WEBPACK_IMPORTED_MODULE_0_bluebird__["promisify"](__WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].canvasToBlob.bind(__WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"]));
var PREVIEWSDISABLED = false;
var defaultOptions = {
    minimumSizeDifference: 1024,
    sizes: [
        {
            name: "lowest",
            restrictions: {
                maxWidth: 640,
                maxHeight: 480
            }
        },
        {
            name: "middle",
            restrictions: {
                maxWidth: 1280,
                maxHeight: 720
            }
        },
        {
            name: "highest",
            restrictions: {
                maxWidth: 2560,
                maxHeight: 1440
            }
        }
    ],
    gifSizes: [
        {
            name: "lowest",
            restrictions: {
                maxWidth: 640,
                maxHeight: 480
            }
        },
        {
            name: "highest"
        }
    ],
    gif: true,
    encrypt: true,
    extraInfo: {}
};
/* TODO:
    - maximum size for a resolution
    - original: enable, remove meta-data (exif etc.)
*/
if (__WEBPACK_IMPORTED_MODULE_2__screenSize_service__["default"].mobile) {
    defaultOptions.sizes = defaultOptions.sizes.filter(function (size) {
        return size.name !== "highest";
    });
}
var uploadQueue = new __WEBPACK_IMPORTED_MODULE_5__asset_Queue__["a" /* default */](3);
uploadQueue.start();
var resizeQueue = new __WEBPACK_IMPORTED_MODULE_5__asset_Queue__["a" /* default */](1);
resizeQueue.start();
var sizeDiff = function (a, b) {
    return a.blob.getSize() - b.blob.getSize();
};
var sizeSorter = function (a, b) {
    return sizeDiff(b, a);
};
var ImageUpload = /** @class */ (function (_super) {
    __extends(ImageUpload, _super);
    function ImageUpload(file, options) {
        var _this = _super.call(this, file, options || defaultOptions) || this;
        _this.rotation = "0";
        _this.convertForGallery = function () {
            return {
                upload: _this,
                highest: {
                    loading: false,
                    loaded: true,
                    url: _this.getUrl()
                },
                lowest: {
                    loading: false,
                    loaded: true,
                    url: _this.getUrl()
                }
            };
        };
        _this.rotate = function () {
            return _this.generatePreviews().then(function (previews) {
                var newDegree = "0";
                switch (_this.rotation) {
                    case "0":
                        newDegree = "90";
                        break;
                    case "90":
                        newDegree = "180";
                        break;
                    case "180":
                        newDegree = "270";
                        break;
                }
                _this.rotation = newDegree;
                _this.previewUrl = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].toUrl(previews[newDegree]);
                return previews[newDegree];
            });
        };
        _this.generatePreviews = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].cacheResult(function () {
            if (PREVIEWSDISABLED) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["reject"](new Error("Previews are disabled"));
            }
            return ImageUpload.imageLibLoad(__WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].toUrl(_this.file), {
                maxHeight: 200, canvas: true
            }).then(function (img) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["all"]([
                    canvasToBlob(img, "image/jpeg"),
                    canvasToBlob(ImageUpload.rotate90(img), "image/jpeg"),
                    canvasToBlob(ImageUpload.rotate180(img), "image/jpeg"),
                    canvasToBlob(ImageUpload.rotate270(img), "image/jpeg")
                ]);
            }).spread(function (preview0, preview90, preview180, preview270) {
                _this.previewUrl = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].toUrl(preview0);
                return {
                    "0": preview0,
                    "90": preview90,
                    "180": preview180,
                    "270": preview270,
                };
            });
        });
        _this.getPreviewUrl = function () {
            return _this.previewUrl || _this.getUrl();
        };
        _this.getUrl = function () {
            if (!PREVIEWSDISABLED) {
                _this.generatePreviews();
            }
            _this.url = _this.url || __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].toUrl(_this.file);
            _this.previewUrl = _this.previewUrl || _this.url;
            return _this.url;
        };
        _this.upload = function (encryptionKey) {
            if (!_this.blobs) {
                throw new Error("usage error: prepare was not called!");
            }
            if (_this.options.encrypt && !encryptionKey) {
                throw new Error("No encryption key given");
            }
            return uploadQueue.enqueue(1, function () {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](_this.blobs).bind(_this).map(function (blobWithMetaData) {
                    console.info("Uploading blob");
                    if (_this.options.encrypt) {
                        return _this.uploadAndEncryptPreparedBlob(encryptionKey, blobWithMetaData.blob);
                    }
                    return _this.uploadPreparedBlob(blobWithMetaData.blob);
                });
            });
        };
        _this._createSizeData = function (size) {
            return resizeQueue.enqueue(1, function () {
                return _this._resizeFile(size).then(function (resizedImage) {
                    return ImageUpload.blobToDataSet(__WEBPACK_IMPORTED_MODULE_4__blobService__["default"].createBlob(resizedImage.blob)).then(function (data) {
                        data.content.gif = _this.isGif;
                        data.content.width = resizedImage.width;
                        data.content.height = resizedImage.height;
                        return __assign({}, data, { size: size });
                    });
                });
            });
        };
        _this.prepare = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].cacheResult(function () {
            _this.isGif = !!_this.file.type.match(/image.gif/i);
            var sizes = _this.isGif ? _this.options.gifSizes : _this.options.sizes;
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](sizes)
                .map(_this._createSizeData)
                .then(_this._removeUnnededBlobs);
        });
        _this._removeUnnededBlobs = function (blobs) {
            var lastBlob, result = {};
            _this.blobs = blobs.sort(sizeSorter).filter(function (blob) {
                var keep = !lastBlob || _this.isGif || sizeDiff(lastBlob, blob) > _this.options.minimumSizeDifference;
                if (keep) {
                    lastBlob = blob;
                }
                result[blob.size.name] = lastBlob;
                return keep;
            });
            return result;
        };
        _this.getImage = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].cacheResult(function () {
            return ImageUpload.imageLibLoad(_this.getUrl());
        });
        _this._resizeFile = function (sizeOptions) {
            var options = __assign({}, sizeOptions.restrictions || {}, { canvas: true });
            return _this.getImage().then(function (img) {
                if (_this.isGif && !sizeOptions.restrictions) {
                    return {
                        blob: _this.file,
                        width: img.width,
                        height: img.height
                    };
                }
                if (options.square) {
                    img = imageLib.scale(img, {
                        contain: true,
                        aspectRatio: 1
                    });
                }
                var canvas = ImageUpload.rotate(imageLib.scale(img, options), _this.rotation);
                return canvasToBlob(canvas, "image/jpeg").then(function (blob) {
                    return {
                        blob: blob,
                        width: canvas.width,
                        height: canvas.height
                    };
                });
            });
        };
        if (!ImageUpload.isImage(file)) {
            throw new Error("not an image!");
        }
        if (file.type.match(/image.gif/) && !_this.options.gif) {
            throw new Error("no gifs supported!");
        }
        return _this;
    }
    ImageUpload.isImage = function (file) {
        return file.type.match(/image.*/);
    };
    ImageUpload.imageLibLoad = function (file, options) {
        return new __WEBPACK_IMPORTED_MODULE_0_bluebird__(function (resolve, reject) {
            imageLib(file, function (canvas) {
                if (canvas.type === "error") {
                    reject(canvas);
                }
                else {
                    resolve(canvas);
                }
            }, options);
        });
    };
    ImageUpload.rotate = function (img, angle) {
        switch (angle) {
            case "0":
                return img;
            case "90":
                return ImageUpload.rotate90(img);
            case "180":
                return ImageUpload.rotate180(img);
            case "270":
                return ImageUpload.rotate270(img);
        }
        return img;
    };
    ;
    ImageUpload.rotateInternal = function (angle, img, flipRatio) {
        var canvas = document.createElement("canvas");
        if (flipRatio) {
            canvas.width = img.height;
            canvas.height = img.width;
        }
        else {
            canvas.width = img.width;
            canvas.height = img.height;
        }
        var diff = canvas.width - canvas.height;
        var newCtx = canvas.getContext("2d");
        if (newCtx === null) {
            throw new Error("could not initialize canvas context");
        }
        newCtx.translate(canvas.width / 2, canvas.height / 2);
        newCtx.rotate(angle);
        newCtx.translate(-canvas.width / 2, -canvas.height / 2);
        newCtx.drawImage(img, flipRatio ? diff / 2 : 0, flipRatio ? -diff / 2 : 0);
        return canvas;
    };
    ;
    ImageUpload.rotate90 = function (img) {
        var angle = Math.PI / 2;
        return ImageUpload.rotateInternal(angle, img, true);
    };
    ;
    ImageUpload.rotate180 = function (img) {
        var angle = Math.PI;
        return ImageUpload.rotateInternal(angle, img, false);
    };
    ;
    ImageUpload.rotate270 = function (img) {
        var angle = 3 * Math.PI / 2;
        return ImageUpload.rotateInternal(angle, img, true);
    };
    ;
    return ImageUpload;
}(__WEBPACK_IMPORTED_MODULE_3__fileUpload_service__["a" /* default */]));
/* harmony default export */ __webpack_exports__["default"] = (ImageUpload);


/***/ }),

/***/ "DhQo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	/*
 	message: {
 		meta: {
 			previousOwn: (int),
 			previousOther: (int),
 			sender: (int),
 			signature: (hex),
 			topicid: (int),
 			read: (bool)
 		}
 		content: {
 			key,
 			iv: (hex),
 			text: (hex),
 			signature: (hex)
 		}
 		}
 	*/

	var messageJSON = {
		"type": "object",
		"properties": {
			"meta": {
				"type": "object",
				"properties": {
					"createTime": {
						"required": true,
						"type": "integer",
						"min": 1388718525297
					},
					"_parent": {
						"required": true,
						"type": "string"
					},
					"_sortCounter": {
						"type": "integer"
					},
					"_ownHash": {
						"required": true,
						"type": "string"
					},
					"_signature": {
						"required": true,
						"type": "string",
						"hex": true
					},
					"encrSignature": {
						"type": "string",
						"hex": true
					},

					"sender": {
						"type": "integer",
						"min": 1
					},
					"topicid": {
						"type": "integer",
						"min": 1
					},
					"read": {
						"type": "boolean"
					}
				}
			},
			"content": {
				"type": "object",
				"properties": {
					"iv": {
						"required": true,
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string"
					},
					"text": {
						"type": "string"
					}
				}
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = messageJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return messageJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "Dshm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "69d7c828e1f21d678365.worker.js");
};

/***/ }),

/***/ "EFCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorServiceInstance", function() { return errorServiceInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("jYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__("MCp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);


var ErrorService = /** @class */ (function () {
    function ErrorService() {
        var _this = this;
        this.criticalError = function (e) {
            return _this.logError(e);
        };
        this.logError = function (e) {
            if (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](e);
            }
        };
    }
    ErrorService.prototype.failOnErrorPromise = function (state, promise) {
        var _this = this;
        return promise.then(function () {
            state.success();
        }).catch(function (e) {
            state.failed();
            _this.criticalError(e);
        });
    };
    ;
    ErrorService.prototype.failOnError = function (state) {
        var _this = this;
        return function (e) {
            if (e) {
                state.failed();
                _this.criticalError(e);
            }
            else {
                state.success();
            }
        };
    };
    return ErrorService;
}());
var errorServiceInstance = new ErrorService();
/* harmony default export */ __webpack_exports__["default"] = (errorServiceInstance);


/***/ }),

/***/ "EKxj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


console.warn("Whispeer startup at " + Date.now());
console.time("Spinner on Home");

var errorService = __webpack_require__("EFCD").errorServiceInstance;
var keyStore = __webpack_require__("+1JK");

var debug = __webpack_require__("jcLW");
var Observer = __webpack_require__("SiYL");
var Bluebird = __webpack_require__("fp6q");

var sessionService = __webpack_require__("0kGL").default;

var debugName = "whispeer:initService";

function time(name) {
	if (debug.enabled(debugName)) {
		console.time("init: " + name);
	}
}

function timeEnd(name) {
	if (debug.enabled(debugName)) {
		console.timeEnd("init: " + name);
	}
}

var initCallbacks = [],
    initService;

function loadData() {
	keyStore.security.blockPrivateActions();

	var promise = Bluebird.resolve().then(function () {
		time("runInitCallbacks");
		return Bluebird.all(initCallbacks.map(function (func) {
			return func();
		}));
	}).then(function () {
		timeEnd("runInitCallbacks");
		keyStore.security.allowPrivateActions();

		var migrationService = __webpack_require__("nkYK");
		migrationService();
		initService.notify("", "initDone");
		return null;
	});

	promise.catch(errorService.criticalError);

	return promise;
}

var loadingPromise = sessionService.awaitLogin().then(function () {
	return loadData();
});

initService = {
	/** get via api, also check cache in before!
 * @param domain: domain to get from
 */
	awaitLoading: function awaitLoading() {
		return loadingPromise;
	},
	registerCallback: function registerCallback(cb) {
		initCallbacks.push(cb);
	}
};

Observer.extend(initService);

module.exports = initService;

/***/ }),

/***/ "ERnO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");
var keyStore = __webpack_require__("+1JK");

var encryptedDataObject = function encryptedDataObject(data) {
	var encryptedData = data,
	    decryptedData;

	this.decrypt = function (cb) {
		if (decryptedData) {
			return Bluebird.resolve(decryptedData).nodeify(cb);
		}

		return keyStore.sym.decryptObject(encryptedData, 0).then(function (decryptedObj) {
			if (decryptedObj) {
				decryptedData = decryptedObj;

				return decryptedData;
			}

			throw new Error("could not decrypt");
		}).nodeify(cb);
	};
};

module.exports = encryptedDataObject;

/***/ }),

/***/ "EkNv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Cache__ = __webpack_require__("4PxX");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


function createLoader(_a) {
    var download = _a.download, load = _a.load, restore = _a.restore, getID = _a.getID, cacheName = _a.cacheName;
    var loading = {};
    var byId = {};
    var cache = new __WEBPACK_IMPORTED_MODULE_1__services_Cache__["a" /* default */](cacheName);
    var considerLoaded = function (id) {
        loading = __assign({}, loading);
        delete loading[id];
    };
    var cacheInMemory = function (id, instance) {
        byId = __assign({}, byId, (_a = {}, _a[id] = instance, _a));
        return instance;
        var _a;
    };
    var loadFromCache = function (id) {
        return cache.get(id)
            .then(function (cacheResponse) { return cacheResponse.data; })
            .then(restore)
            .then(function (instance) {
            cacheInMemory(id, instance);
            considerLoaded(id);
            return instance;
        });
    };
    var serverResponseToInstance = function (response, id) {
        return load(response)
            .then(function (cacheableData) { return cache.store(id, cacheableData).thenReturn(cacheableData); })
            .then(restore)
            .then(function (instance) { return cacheInMemory(id, instance); })
            .finally(function () { return considerLoaded(id); });
    };
    return _b = /** @class */ (function () {
            function ObjectLoader() {
            }
            ObjectLoader.getLoaded = function (id) {
                if (!ObjectLoader.isLoaded(id)) {
                    throw new Error("Not yet loaded: " + id);
                }
                return byId[id];
            };
            ObjectLoader.isLoaded = function (id) {
                return byId.hasOwnProperty(id);
            };
            // Throws
            ObjectLoader.getFromCache = function (id) {
                if (byId[id]) {
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](byId[id]);
                }
                return loadFromCache(id);
            };
            ObjectLoader.load = function (response) {
                var id = getID(response);
                if (byId[id]) {
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](byId[id]);
                }
                if (!loading[id]) {
                    loading = __assign({}, loading, (_a = {}, _a[id] = loadFromCache(id).catch(function () { return serverResponseToInstance(response, id); }), _a));
                }
                return loading[id];
                var _a;
            };
            ObjectLoader.get = function (id) {
                if (typeof id === "undefined" || id === null) {
                    throw new Error("Can't get object with id " + id + " - " + cacheName);
                }
                if (byId[id]) {
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](byId[id]);
                }
                if (!loading[id]) {
                    var promise = loadFromCache(id)
                        .catch(function () { return download(id).then(function (response) { return serverResponseToInstance(response, id); }); });
                    loading = __assign({}, loading, (_a = {}, _a[id] = promise, _a));
                }
                return loading[id];
                var _a;
            };
            return ObjectLoader;
        }()),
        _b.getAll = function () {
            return byId;
        },
        _b.removeLoaded = function (id) { return delete byId[id]; },
        _b.addLoaded = function (id, obj) {
            byId[id] = obj;
        },
        _b;
    var _b;
}
/* harmony default export */ __webpack_exports__["a"] = (createLoader);


/***/ }),

/***/ "Etis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__socket_service__ = __webpack_require__("8I7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_session_service__ = __webpack_require__("0kGL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mutableObjectLoader__ = __webpack_require__("H35O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_securedDataWithMetaData__ = __webpack_require__("eRn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_location_manager__ = __webpack_require__("02Tt");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var keyStore = __webpack_require__("+1JK");

var initService = __webpack_require__("EKxj");





var EncryptedData = __webpack_require__("ERnO");
var RELOAD_DELAY = 10000;
var notVisible = {
    encrypt: true,
    visibility: []
};
var privacyAttributes = ["birthday", "location", "relationship", "education", "work", "gender", "languages"];
var publicBranches = ["uiLanguage", "sound", "donate", "safety"];
var serverBranches = ["mailsEnabled", "friendsAccess"];
var defaultSettings = {
    privacy: {
        basic: {
            firstname: {
                encrypt: false,
                visibility: ["always:allfriends"]
            },
            lastname: {
                encrypt: false,
                visibility: ["always:allfriends"]
            }
        },
        imageBlob: {
            encrypt: false,
            visibility: []
        },
        location: notVisible,
        birthday: notVisible,
        relationship: notVisible,
        education: notVisible,
        work: notVisible,
        gender: notVisible,
        languages: notVisible
    },
    donate: {
        refused: false,
        later: 0
    },
    sharePosts: ["always:allfriends"],
    filterSelection: [],
    sound: {
        enabled: true
    },
    messages: {
        sendShortCut: "enter"
    },
    safety: {
        blockedUsers: []
    },
    uiLanguage: "en",
    friendsAccess: !Object(__WEBPACK_IMPORTED_MODULE_7__services_location_manager__["isBusinessVersion"])()
};
var isBranchPublic = function (branchName) {
    return publicBranches.indexOf(branchName) > -1;
};
var isBranchServer = function (branchName) {
    return serverBranches.indexOf(branchName) > -1;
};
var securedDataOptions = { type: "settings", removeEmpty: true };
var turnOldSettingsToNew = function (settings) {
    var result = {
        meta: { initialLanguage: undefined },
        content: {}
    };
    __WEBPACK_IMPORTED_MODULE_6__helper_helper__["default"].objectEach(settings, function (key, val) {
        if (isBranchPublic(key)) {
            result.meta[key] = val;
        }
        else {
            result.content[key] = val;
        }
    });
    return result;
};
var migrate = function (givenSettings) {
    console.warn("migrating settings to format 2");
    if (!givenSettings.ct) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](new __WEBPACK_IMPORTED_MODULE_5__asset_securedDataWithMetaData__["SecuredData"](givenSettings.content, givenSettings.meta, securedDataOptions, false));
    }
    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
        keyStore.security.allowPrivateActions();
        var oldSettings = new EncryptedData(givenSettings);
        return oldSettings.decrypt();
    }).then(function (decryptedSettings) {
        var _a = turnOldSettingsToNew(decryptedSettings), meta = _a.meta, content = _a.content;
        meta.initialLanguage = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["default"].getLanguageFromPath();
        var ownUser = __webpack_require__("UuKm").default.getOwn();
        var transformedSettings = new Settings(content, meta);
        return transformedSettings.getUpdatedData(ownUser.getSignKey(), ownUser.getMainKey());
    }).then(function (signedAndEncryptedSettings) {
        var settings = new __WEBPACK_IMPORTED_MODULE_5__asset_securedDataWithMetaData__["SecuredData"](signedAndEncryptedSettings.content, signedAndEncryptedSettings.meta, securedDataOptions, false);
        return __WEBPACK_IMPORTED_MODULE_1__socket_service__["default"].emit("settings.setSettings", {
            settings: signedAndEncryptedSettings,
        }).thenReturn(settings);
    });
};
var Settings = /** @class */ (function () {
    function Settings(content, meta, server) {
        if (server === void 0) { server = {}; }
        var _this = this;
        this.content = content;
        this.meta = meta;
        this.server = server;
        this.changed = false;
        this.getContent = function () { return _this.content; };
        this.getMeta = function () { return _this.meta; };
        this.getServer = function () { return _this.server; };
        this.getBranch = function (branchName) {
            if (isBranchServer(branchName)) {
                return _this.server[branchName];
            }
            if (isBranchPublic(branchName)) {
                return _this.meta[branchName];
            }
            return _this.content[branchName];
        };
        this.isChanged = function () { return _this.changed; };
        this.setBranch = function (branchName, value) {
            if (isBranchServer(branchName)) {
                _this.server[branchName] = value;
            }
            else if (isBranchPublic(branchName)) {
                _this.meta[branchName] = value;
            }
            else {
                _this.content[branchName] = value;
            }
            _this.changed = true;
        };
        this.update = function (content, meta, server) {
            _this.content = content;
            _this.meta = meta;
            _this.server = server;
            _this.changed = false;
        };
        this.getUpdatedData = function (signKey, encryptKey) {
            return __WEBPACK_IMPORTED_MODULE_5__asset_securedDataWithMetaData__["default"].createAsync(_this.content, _this.meta, securedDataOptions, signKey, encryptKey)
                .then(function (encryptedSettings) {
                return __assign({}, encryptedSettings, { server: _this.server });
            });
        };
    }
    return Settings;
}());
var loadSettings = function (givenSettings) {
    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
        return __awaiter(this, void 0, void 0, function () {
            var secured, ownUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, migrate(givenSettings)];
                    case 1:
                        secured = _a.sent();
                        return [4 /*yield*/, __webpack_require__("UuKm").default.getOwnAsync()];
                    case 2:
                        ownUser = _a.sent();
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_bluebird__["all"]([
                                secured.decrypt(),
                                secured.verifyAsync(ownUser.getSignKey(), "settings")
                            ])];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, {
                                content: secured.contentGet(),
                                meta: secured.metaGet(),
                                server: givenSettings.server
                            }];
                }
            });
        });
    });
};
var settings;
var SettingsService = /** @class */ (function (_super) {
    __extends(SettingsService, _super);
    function SettingsService() {
        var _this = _super.call(this) || this;
        _this.setDefaultLanguage = function (language) { return defaultSettings.uiLanguage = language; };
        _this.getContent = function () { return settings.getContent(); };
        _this.getBranchContent = function (branchName) { return settings.getBranch(branchName); };
        _this.getBranch = function (branchName) {
            if (!settings) {
                return defaultSettings[branchName];
            }
            var branchContent = _this.getBranchContent(branchName);
            if (typeof branchContent === "undefined") {
                return defaultSettings[branchName];
            }
            return branchContent;
        };
        _this.updateBranch = function (branchName, value) {
            settings.setBranch(branchName, value);
            _this.notify("", "updated");
        };
        _this.setPrivacy = function (privacy) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
                _this.updateBranch("privacy", privacy);
                return _this.uploadChangedData();
            }).then(function () {
                var userService = __webpack_require__("UuKm").default;
                return userService.getOwn().uploadChangedProfile();
            });
        };
        _this.removeCircle = function (id) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
                var privacy = _this.getBranch("privacy");
                privacyAttributes.forEach(function (safetyName) {
                    __WEBPACK_IMPORTED_MODULE_6__helper_helper__["default"].removeArray(privacy[safetyName].visibility, "circle:" + id);
                });
                __WEBPACK_IMPORTED_MODULE_6__helper_helper__["default"].removeArray(privacy.basic.firstname.visibility, "circle:" + id);
                __WEBPACK_IMPORTED_MODULE_6__helper_helper__["default"].removeArray(privacy.basic.lastname.visibility, "circle:" + id);
                return _this.setPrivacy(privacy);
            });
        };
        _this.uploadChangedData = function () {
            if (!settings.isChanged()) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](true);
            }
            var userService = __webpack_require__("UuKm").default;
            var ownUser = userService.getOwn();
            return settings.getUpdatedData(ownUser.getSignKey(), ownUser.getMainKey())
                .then(function (settings) { return __WEBPACK_IMPORTED_MODULE_1__socket_service__["default"].emit("settings.setSettings", { settings: settings }); })
                .then(function (result) { return result.success; });
        };
        _this.getBlockedUsers = function () { return _this.getBranch("safety").blockedUsers; };
        _this.setBlockedUsers = function (blockedUsers) {
            var safety = _this.getBranch("safety");
            _this.updateBranch("safety", __assign({}, safety, { blockedUsers: blockedUsers }));
            return _this.uploadChangedData();
        };
        _this.isBlockedSince = function (userID, time) {
            return !!_this.getBlockedUsers().find(function (_a) {
                var id = _a.id, since = _a.since;
                return userID === id && since < time;
            });
        };
        _this.isBlocked = function (userID) {
            return !!_this.getBlockedUsers().find(function (_a) {
                var id = _a.id;
                return userID === id;
            });
        };
        _this.getPrivacyAttribute = function (attr) {
            var b = _this.getBranch("privacy"), i, attrs = attr.split("."), cur = b;
            for (i = 0; i < attrs.length; i += 1) {
                if (cur[attrs[i]]) {
                    if (typeof cur[attrs[i]].encrypt !== "undefined") {
                        return cur[attrs[i]];
                    }
                    cur = cur[attrs[i]];
                }
            }
            throw new Error("could not find attribute settings");
        };
        _this.getPrivacyEncryptionStatus = function (attr) {
            return _this.getPrivacyAttribute(attr).encrypt;
        };
        _this.getPrivacyVisibility = function (attr) {
            var privacyAttribute = _this.getPrivacyAttribute(attr);
            if (privacyAttribute.encrypt) {
                return privacyAttribute.visibility;
            }
            else {
                return false;
            }
        };
        return _this;
    }
    return SettingsService;
}(__WEBPACK_IMPORTED_MODULE_2__asset_observer__["default"]));
;
/* harmony default export */ __webpack_exports__["default"] = (new SettingsService());
var SettingsLoader = /** @class */ (function (_super) {
    __extends(SettingsLoader, _super);
    function SettingsLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SettingsLoader;
}(Object(__WEBPACK_IMPORTED_MODULE_4__services_mutableObjectLoader__["c" /* default */])({
    download: function (_id, previousInstance) {
        return __WEBPACK_IMPORTED_MODULE_1__socket_service__["default"].awaitConnection()
            .then(function () { return __WEBPACK_IMPORTED_MODULE_1__socket_service__["default"].definitlyEmit("settings.get", {
            responseKey: "content",
            cacheSignature: previousInstance && previousInstance.getMeta()._signature
        }); })
            .then(function (response) { return response.content; });
    },
    load: function (response, previousInstance) {
        if (previousInstance && response.unChanged) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"]({
                content: previousInstance.getContent(),
                meta: previousInstance.getMeta(),
                server: response.content.server
            });
        }
        return loadSettings(response.content);
    },
    restore: function (_a, previousInstance) {
        var content = _a.content, meta = _a.meta, server = _a.server;
        if (previousInstance) {
            previousInstance.update(content, meta, server);
            return previousInstance;
        }
        return new Settings(content, meta, server);
    },
    shouldUpdate: function (event) {
        if (event === __WEBPACK_IMPORTED_MODULE_4__services_mutableObjectLoader__["b" /* UpdateEvent */].wake) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["delay"](RELOAD_DELAY).thenReturn(true);
        }
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](false);
    },
    getID: function () { return __WEBPACK_IMPORTED_MODULE_3__services_session_service__["default"].getUserID(); },
    cacheName: "settings"
})));
initService.registerCallback(function () {
    return SettingsLoader.get(__WEBPACK_IMPORTED_MODULE_3__services_session_service__["default"].getUserID())
        .then(function (loadedSettings) { return settings = loadedSettings; });
});


/***/ }),

/***/ "FISs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sjcl = __webpack_require__("kHLR");
var Bluebird = __webpack_require__("fp6q");

/**
* Wait until randomizer is ready.
* calls callback if randomizer is ready.
*/
var waitForReady = function waitForReady(callback) {
	if (sjcl.random.isReady()) {
		callback();
		return true;
	}

	waitForReady.waiting = true;

	sjcl.random.addEventListener("seeded", function () {
		waitForReady.waiting = false;
		waitForReady.ready = true;
		callback();
	});

	return false;
};

waitForReady.async = Bluebird.promisify(waitForReady);

waitForReady.ready = false;
waitForReady.waiting = false;

module.exports = waitForReady;

/***/ }),

/***/ "FLn8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
var stopEventDirective = function stopEventDirective() {
	return {
		restrict: "A",
		link: function link(scope, element, attr) {
			element.bind(attr.stopEvent, function (e) {
				e.stopPropagation();
			});
		}
	};
};

directivesModule.directive("stopEvent", stopEventDirective);

/***/ }),

/***/ "GiKV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// EXTERNAL MODULE: ./js/asset/observer.ts
var observer = __webpack_require__("SiYL");

// EXTERNAL MODULE: ./js/asset/securedDataWithMetaData.ts
var securedDataWithMetaData = __webpack_require__("eRn5");

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/services/socket.service.ts + 1 modules
var socket_service = __webpack_require__("8I7s");

// EXTERNAL MODULE: ./js/services/cachedObjectLoader.ts
var cachedObjectLoader = __webpack_require__("EkNv");

// CONCATENATED MODULE: ./js/messages/chatTitleUpdate.ts
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var chatTitleUpdate_TopicUpdate = /** @class */ (function () {
    function TopicUpdate(_a) {
        var content = _a.content, server = _a.server, meta = _a.meta, sender = _a.sender;
        var _this = this;
        this.setState = function (newState) {
            _this.state = __assign({}, _this.state, newState);
        };
        this.getID = function () {
            return _this._id;
        };
        this.getTime = function () {
            return helper["default"].parseDecimal(_this.securedData.metaAttr("time"));
        };
        this.isAfter = function (topicUpdate) {
            if (!topicUpdate) {
                return true;
            }
            return topicUpdate.getTime() < _this.getTime();
        };
        this.ensureParent = function (topic) {
            _this.securedData.checkParent(topic.getSecuredData());
        };
        this.ensureIsAfterTopicUpdate = function (topicUpdate) {
            _this.securedData.checkAfter(topicUpdate.getSecuredData());
        };
        this.getUserID = function () {
            return _this.userID;
        };
        this.getSecuredData = function () {
            return _this.securedData;
        };
        this.getMetaUpdate = function () {
            return _this.securedData.metaAttr("metaUpdate");
        };
        var content = content, meta = meta;
        this._id = server.id;
        this.securedData = new securedDataWithMetaData["SecuredData"](content, meta, { type: "topicUpdate" }, true);
        this.userID = meta.userID;
        this.state = {
            loading: false,
            timestamp: helper["default"].parseDecimal(meta.time),
            title: content.title,
            sender: sender
        };
    }
    return TopicUpdate;
}());
/* harmony default export */ var messages_chatTitleUpdate = (chatTitleUpdate_TopicUpdate);

// CONCATENATED MODULE: ./js/messages/chatChunk.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chatChunk_Chunk; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var chatChunk___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var chatChunk__this = this;

var validator = __webpack_require__("WZDP");



var debug = __webpack_require__("jcLW");
var userService = __webpack_require__("UuKm").default;


var keyStore = __webpack_require__("IeOO").default;
var sessionService = __webpack_require__("0kGL").default;

var debugName = "whispeer:chunk";
var chunkDebug = debug(debugName);
var CHUNK_SECURED_DATA_OPTIONS = {
    type: "topic",
    alternativeType: "chatChunk" // Allow for chatChunk already
};
var chatChunk_Chunk = /** @class */ (function (_super) {
    __extends(Chunk, _super);
    function Chunk(_a, chunkData) {
        var content = _a.content, server = _a.server, meta = _a.meta, receiverObjects = _a.receiverObjects;
        var _this = _super.call(this) || this;
        _this.chunkData = chunkData;
        _this.title = "";
        _this.create = function (_a) {
            var _b = _a.server, id = _b.id, chatID = _b.chatID;
            _this.id = id;
            _this.chatID = chatID;
            ChunkLoader.addLoaded(id, _this);
            ChunkLoader.removeLoaded(-1);
        };
        _this.getChatID = function () { return _this.chatID; };
        _this.getSecuredData = function () {
            return _this.securedData;
        };
        _this.getHash = function () {
            return _this.securedData.getHash();
        };
        _this.getID = function () {
            return helper["default"].parseDecimal(_this.id);
        };
        _this.getTime = function () {
            if (_this.createTime) {
                return _this.createTime;
            }
            return _this.getSecuredData().metaAttr("createTime");
        };
        _this.getKey = function () {
            return _this.securedData.metaAttr("_key");
        };
        _this.setLatestTitleUpdate = function (titleUpdate) {
            _this.titleUpdate = titleUpdate;
        };
        _this.ensureChunkChain = function (predecessor) {
            if (_this.getID() === predecessor.getID()) {
                return;
            }
            var predecessorID = _this.getPredecessorID();
            if (!predecessorID || !ChunkLoader.isLoaded(predecessorID)) {
                throw new Error("Chunk chain broken " + predecessorID);
            }
            var predecessorChunk = ChunkLoader.getLoaded(predecessorID);
            predecessorChunk.verifyParent(_this);
            predecessorChunk.ensureChunkChain(predecessor);
        };
        _this.verifyParent = function (chunk) {
            chunk.getSecuredData().checkParent(_this.getSecuredData());
        };
        _this.getReceivers = function () {
            return _this.receiverObjects;
        };
        _this.getPartners = function () {
            return _this.receiverObjects.filter(function (receiverObject) {
                return !receiverObject.user.isOwn() || _this.receiverObjects.length === 1;
            });
        };
        _this.getPartnerDisplay = function (maxDisplay) {
            if (maxDisplay === void 0) { maxDisplay = 3; }
            var partners = _this.getPartners();
            if (partners.length <= maxDisplay) {
                return partners;
            }
            return partners.slice(0, maxDisplay - 1);
        };
        _this.getReceiver = function () {
            return _this.receiver;
        };
        _this.getAdmins = function () {
            return _this.admins;
        };
        _this.getReceiverIDs = function () {
            return _this.receiver;
        };
        _this.getTitle = function () {
            if (_this.titleUpdate) {
                return _this.titleUpdate.state.title;
            }
            return _this.title;
        };
        _this.setTitle = function (title) {
            _this.title = title;
        };
        _this.isAdmin = function (user) {
            return _this.getAdmins().indexOf(user.getID()) > -1;
        };
        _this.amIAdmin = function () {
            return _this.isAdmin(userService.getOwn());
        };
        _this.getCreator = function () {
            return helper["default"].parseDecimal(_this.securedData.metaAttr("creator"));
        };
        _this.hasPredecessor = function () {
            return !!_this.predecessorID;
        };
        _this.getPredecessorID = function () {
            if (!_this.hasPredecessor()) {
                return null;
            }
            return helper["default"].parseDecimal(_this.predecessorID);
        };
        _this.getPredecessor = function () {
            if (!_this.hasPredecessor()) {
                return bluebird["resolve"](null);
            }
            return ChunkLoader.get(_this.getPredecessorID()).catch(function (err) {
                console.log(err);
                return null;
            }, socket_service["default"].errors.Server);
        };
        _this.setSuccessor = function (successorID) {
            _this.successorID = successorID;
            chunkDebug("Set successor of chunk ", _this.getID(), " succ: ", successorID);
            _this.notify({ successorID: successorID }, "successor");
        };
        _this.hasKnownSuccessor = function () {
            return !!_this.successorID;
        };
        _this.getLoadedSuccessor = function () {
            if (!_this.hasKnownSuccessor()) {
                return;
            }
            return ChunkLoader.getLoaded(_this.successorID);
        };
        _this.getSuccessor = function () {
            if (_this.successorID) {
                return ChunkLoader.get(_this.successorID);
            }
            return socket_service["default"].emit("chat.chunk.successor", { id: _this.getID() }).then(function (response) {
                if (!response.chunk) {
                    return;
                }
                return ChunkLoader.load(response.chunk).then(function (successorChunk) {
                    if (successorChunk.getPredecessorID() !== _this.getID()) {
                        throw new Error("server returned invalid successor chunk");
                    }
                    return successorChunk;
                });
            });
        };
        var err = validator.validate("topic", meta);
        if (err) {
            throw err;
        }
        meta.receiver.sort();
        _this.securedData = securedDataWithMetaData["default"].createRaw(content, meta, CHUNK_SECURED_DATA_OPTIONS);
        _this.id = server.id;
        _this.chatID = server.chatID;
        _this.predecessorID = server.predecessorID;
        _this.createTime = server.createTime;
        _this.receiver = _this.securedData.metaAttr("receiver").map(helper["default"].parseDecimal);
        var metaAdmins = _this.securedData.metaAttr("admins");
        var creator = _this.securedData.metaAttr("creator");
        _this.admins = (metaAdmins ? metaAdmins : [creator]).map(helper["default"].parseDecimal);
        if (_this.securedData.hasContent()) {
            _this.title = _this.securedData.contentGet().title;
        }
        else {
            _this.title = "";
        }
        _this.receiverObjects = receiverObjects;
        var predecessorID = _this.getPredecessorID();
        if (predecessorID && ChunkLoader.isLoaded(predecessorID)) {
            ChunkLoader.getLoaded(predecessorID).setSuccessor(_this.getID());
        }
        return _this;
    }
    Chunk.loadChunkChain = function (newChunk, oldChunk) {
        if (newChunk.getID() === oldChunk.getID()) {
            return bluebird["resolve"]();
        }
        if (newChunk.getPredecessorID() === oldChunk.getID()) {
            return bluebird["resolve"]();
        }
        return newChunk.getPredecessor().then(function (pred) {
            if (!pred) {
                return;
            }
            if (pred.getID() === oldChunk.getID()) {
                return;
            }
            return Chunk.loadChunkChain(pred, oldChunk);
        });
    };
    Chunk.createRawData = function (receiver, _a) {
        var _this = this;
        var _b = _a.content, content = _b === void 0 ? {} : _b, _c = _a.meta, meta = _c === void 0 ? {} : _c, givenKey = _a.givenKey, predecessorChunk = _a.predecessorChunk;
        return bluebird["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var receiverIDs, receiverObjects, receiverObjectsExceptOwn, givenInfo, _a, cryptInfo, chunkKey, _b, chunkMeta, secured, cData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        receiverIDs = receiver.map(function (val) { return helper["default"].parseDecimal(val); });
                        if (receiverIDs.indexOf(sessionService.getUserID()) === -1) {
                            receiverIDs.push(sessionService.getUserID());
                        }
                        return [4 /*yield*/, userService.getMultiple(receiverIDs)];
                    case 1:
                        receiverObjects = _c.sent();
                        receiverObjectsExceptOwn = receiverObjects.filter(function (receiver) { return !receiver.isOwn(); });
                        givenInfo = { cryptInfo: { receiverKeys: {}, keys: [] }, chunkKey: givenKey };
                        if (!givenKey) return [3 /*break*/, 2];
                        _b = givenInfo;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, Chunk.cryptInfo(receiverObjectsExceptOwn)];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        _a = _b, cryptInfo = _a.cryptInfo, chunkKey = _a.chunkKey;
                        receiverIDs.sort();
                        chunkMeta = chatChunk___assign({}, meta, { createTime: new Date().getTime(), receiver: receiverIDs, creator: userService.getOwn().getID() });
                        secured = securedDataWithMetaData["default"].createRaw(content, chunkMeta, { type: "topic" });
                        if (predecessorChunk) {
                            secured.setParent(predecessorChunk.getSecuredData());
                        }
                        return [4 /*yield*/, secured.signAndEncrypt(userService.getOwn().getSignKey(), chunkKey)];
                    case 5:
                        cData = _c.sent();
                        return [2 /*return*/, Object.assign({
                                chunk: cData,
                            }, cryptInfo)];
                }
            });
        }); });
    };
    ;
    Chunk.createChunkKey = function () {
        return keyStore.sym.generateKey(null, "chunkMain").then(function (chunkKey) {
            return keyStore.sym.symEncryptKey(chunkKey, userService.getOwn().getMainKey()).thenReturn(chunkKey);
        });
    };
    Chunk.cryptInfo = function (receiverObjectsExceptOwn) { return __awaiter(chatChunk__this, void 0, void 0, function () {
        var receiverKeys, chunkKey, cryptKeys, cryptKeysData, cryptInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    receiverKeys = {};
                    return [4 /*yield*/, Chunk.createChunkKey()];
                case 1:
                    chunkKey = _a.sent();
                    return [4 /*yield*/, bluebird["all"](receiverObjectsExceptOwn.map(function (receiverObject) {
                            var crypt = receiverObject.getCryptKey();
                            return keyStore.sym.asymEncryptKey(chunkKey, crypt);
                        }))];
                case 2:
                    cryptKeys = _a.sent();
                    cryptKeysData = keyStore.upload.getKeys(cryptKeys);
                    receiverObjectsExceptOwn.forEach(function (receiver, index) {
                        receiverKeys[receiver.getID()] = cryptKeys[index];
                    });
                    cryptInfo = {
                        keys: cryptKeysData.concat([keyStore.upload.getKey(chunkKey)]),
                        receiverKeys: receiverKeys,
                    };
                    return [2 /*return*/, { cryptInfo: cryptInfo, chunkKey: chunkKey }];
            }
        });
    }); };
    return Chunk;
}(observer["default"]));

observer["default"].extend(chatChunk_Chunk);
var decryptAndVerifyTitleUpdate = function (titleUpdate) {
    return bluebird["try"](function () { return __awaiter(chatChunk__this, void 0, void 0, function () {
        var content, meta, server, securedData, sender;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!titleUpdate) {
                        return [2 /*return*/];
                    }
                    content = titleUpdate.content, meta = titleUpdate.meta, server = titleUpdate.server;
                    securedData = securedDataWithMetaData["default"].load(content, meta, { type: "topicUpdate" });
                    return [4 /*yield*/, userService.get(meta.userID)];
                case 1:
                    sender = _a.sent();
                    return [4 /*yield*/, bluebird["all"]([
                            securedData.decrypt(),
                            sender.isNotExistingUser() ? false : securedData.verify(sender.getSignKey())
                        ])];
                case 2:
                    _a.sent();
                    return [2 /*return*/, {
                            content: securedData.contentGet(),
                            meta: securedData.metaGet(),
                            server: server
                        }];
            }
        });
    }); });
};
var ChunkLoader = /** @class */ (function (_super) {
    __extends(ChunkLoader, _super);
    function ChunkLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChunkLoader;
}(Object(cachedObjectLoader["a" /* default */])({
    cacheName: "chunk",
    download: function (id) { return socket_service["default"].emit("chat.chunk.get", { id: id }); },
    restore: function (_a) {
        var meta = _a.meta, content = _a.content, server = _a.server, titleUpdate = _a.titleUpdate;
        return bluebird["try"](function () {
            return __awaiter(this, void 0, void 0, function () {
                var loadReceiverPromise, creator, chunk, _a, _b, chatTitleUpdate, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            loadReceiverPromise = userService.getMultipleFormatted(meta.receiver.sort().map(helper["default"].parseDecimal));
                            return [4 /*yield*/, userService.get(meta.creator)];
                        case 1:
                            creator = _e.sent();
                            if (!creator.isNotExistingUser()) {
                                keyStore.security.addEncryptionIdentifier(meta._key);
                            }
                            else {
                                // TODO data.disabled = true;
                            }
                            _a = chatChunk_Chunk.bind;
                            _b = {
                                meta: meta,
                                content: content,
                                server: server
                            };
                            return [4 /*yield*/, loadReceiverPromise];
                        case 2:
                            chunk = new (_a.apply(chatChunk_Chunk, [void 0, (_b.receiverObjects = _e.sent(),
                                    _b)]))();
                            if (!titleUpdate) return [3 /*break*/, 4];
                            _c = messages_chatTitleUpdate.bind;
                            _d = {
                                content: titleUpdate.content,
                                meta: titleUpdate.meta,
                                server: titleUpdate.server
                            };
                            return [4 /*yield*/, userService.get(titleUpdate.meta.userID)];
                        case 3:
                            chatTitleUpdate = new (_c.apply(messages_chatTitleUpdate, [void 0, (_d.sender = _e.sent(),
                                    _d)]))();
                            chunk.setLatestTitleUpdate(chatTitleUpdate);
                            _e.label = 4;
                        case 4: return [2 /*return*/, chunk];
                    }
                });
            });
        });
    },
    load: function (_a) {
        var content = _a.content, meta = _a.meta, server = _a.server, latestTitleUpdate = _a.latestTitleUpdate;
        return bluebird["try"](function () {
            return __awaiter(this, void 0, void 0, function () {
                var securedData, creator, titleUpdate;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            securedData = securedDataWithMetaData["default"].load(content, meta, CHUNK_SECURED_DATA_OPTIONS);
                            return [4 /*yield*/, userService.get(securedData.metaAttr("creator"))];
                        case 1:
                            creator = _a.sent();
                            return [4 /*yield*/, decryptAndVerifyTitleUpdate(latestTitleUpdate)];
                        case 2:
                            titleUpdate = _a.sent();
                            return [4 /*yield*/, bluebird["all"]([
                                    securedData.decrypt(),
                                    creator.isNotExistingUser() ? false : securedData.verify(creator.getSignKey())
                                ])];
                        case 3:
                            _a.sent();
                            return [2 /*return*/, {
                                    content: securedData.contentGet(),
                                    meta: securedData.metaGet(),
                                    server: server,
                                    titleUpdate: titleUpdate
                                }];
                    }
                });
            });
        });
    },
    getID: function (response) { return response.server.id; }
})));
/* harmony default export */ var chatChunk = __webpack_exports__["b"] = (ChunkLoader);


/***/ }),

/***/ "H35O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SYMBOL_UNCHANGED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_socket_service__ = __webpack_require__("8I7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Cache__ = __webpack_require__("4PxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_error_service__ = __webpack_require__("EFCD");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var UpdateEvent;
(function (UpdateEvent) {
    UpdateEvent[UpdateEvent["wake"] = 0] = "wake";
    UpdateEvent[UpdateEvent["blink"] = 1] = "blink";
})(UpdateEvent || (UpdateEvent = {}));
var SYMBOL_UNCHANGED = Symbol("UNCHANGED");
var LONG_APP_PAUSE = 2 * 60 * 1000;
var LONG_DISCONNECT = 60 * 1000;
function createLoader(_a) {
    var download = _a.download, load = _a.load, restore = _a.restore, getID = _a.getID, cacheName = _a.cacheName, shouldUpdate = _a.shouldUpdate;
    var loading = {};
    var byId = {};
    var cache = new __WEBPACK_IMPORTED_MODULE_2__services_Cache__["a" /* default */](cacheName);
    var considerLoaded = function (id) {
        loading = __assign({}, loading);
        delete loading[id];
    };
    var cacheInMemory = function (id, instance, lastUpdated) {
        byId = __assign({}, byId, (_a = {}, _a[id] = { instance: instance, lastUpdated: lastUpdated, updating: false }, _a));
        var _a;
    };
    var loadFromCache = function (id) {
        var lastUpdated = Date.now();
        return cache.get(id)
            .then(function (cacheResponse) {
            lastUpdated = cacheResponse.created;
            return cacheResponse.data;
        })
            .then(function (cachedData) { return restore(cachedData, null); })
            .then(function (instance) {
            cacheInMemory(id, instance, lastUpdated);
            considerLoaded(id);
            scheduleInstanceUpdate(UpdateEvent.wake, id);
            return instance;
        });
    };
    var serverResponseToInstance = function (response, id, activeInstance) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            return __awaiter(this, void 0, void 0, function () {
                var loadedData, instance;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, load(response, activeInstance)];
                        case 1:
                            loadedData = _a.sent();
                            if (loadedData === SYMBOL_UNCHANGED) {
                                return [2 /*return*/, activeInstance];
                            }
                            if (loadedData instanceof Symbol) {
                                throw new Error("invalid symbol returned by load " + cacheName);
                            }
                            return [4 /*yield*/, cache.store(id, loadedData)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, restore(loadedData, activeInstance)];
                        case 3:
                            instance = _a.sent();
                            if (activeInstance && activeInstance !== instance) {
                                console.warn("Restore should update active instance");
                            }
                            cacheInMemory(id, instance, Date.now());
                            return [2 /*return*/, instance];
                    }
                });
            });
        }).finally(function () { return considerLoaded(id); });
    };
    var updateInstance = function (id, instance) {
        return download(id, instance).then(function (response) {
            return serverResponseToInstance(response, id, instance);
        });
    };
    var scheduleInstanceUpdate = function (event, id) {
        var _a = byId[id], instance = _a.instance, lastUpdated = _a.lastUpdated, updating = _a.updating;
        if (updating) {
            console.info("Not updating instance because update is already running " + cacheName + "/" + id);
            return;
        }
        byId[id].updating = true;
        shouldUpdate(event, instance, lastUpdated).then(function (shouldUpdate) {
            if (shouldUpdate) {
                console.info("Schedule " + cacheName + " instance " + id + " update with event " + UpdateEvent[event]);
                return updateInstance(id, instance).then(function () {
                    return byId[id].lastUpdated = Date.now();
                });
            }
        }).catch(__WEBPACK_IMPORTED_MODULE_3__services_error_service__["default"].criticalError).finally(function () { return byId[id].updating = false; });
        return;
    };
    var scheduleInstancesUpdate = function (event) {
        console.info("Schedule " + cacheName + " instances update with event " + UpdateEvent[event]);
        Object.keys(byId)
            .forEach(function (id) { return scheduleInstanceUpdate(event, id); });
    };
    var lastHeartbeat = Date.now();
    __WEBPACK_IMPORTED_MODULE_1__services_socket_service__["default"].listen(function () { return lastHeartbeat = Date.now(); }, "heartbeat");
    __WEBPACK_IMPORTED_MODULE_1__services_socket_service__["default"].on("connect", function () {
        console.info("connect at " + Date.now() + " after " + (Date.now() - lastHeartbeat));
        if (Date.now() - lastHeartbeat > LONG_DISCONNECT) {
            scheduleInstancesUpdate(UpdateEvent.wake);
        }
        else {
            scheduleInstancesUpdate(UpdateEvent.blink);
        }
        lastHeartbeat = Date.now();
    });
    var pauseStarted = 0;
    document.addEventListener("pause", function () { return pauseStarted = Date.now(); }, false);
    document.addEventListener("resume", function () {
        console.info("ended pause at " + Date.now() + " after " + (Date.now() - pauseStarted));
        if (Date.now() - pauseStarted > LONG_APP_PAUSE) {
            scheduleInstancesUpdate(UpdateEvent.wake);
        }
        else {
            scheduleInstancesUpdate(UpdateEvent.blink);
        }
    }, false);
    return _b = /** @class */ (function () {
            function ObjectLoader() {
            }
            ObjectLoader.getLoaded = function (id) {
                if (!ObjectLoader.isLoaded(id)) {
                    throw new Error("Not yet loaded: " + id);
                }
                return byId[id].instance;
            };
            ObjectLoader.isLoaded = function (id) {
                return byId.hasOwnProperty(id);
            };
            ObjectLoader.load = function (source) {
                var id = getID(source);
                if (byId[id]) {
                    serverResponseToInstance(source, id, byId[id].instance);
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](byId[id].instance);
                }
                if (!loading[id]) {
                    loading = __assign({}, loading, (_a = {}, _a[id] = loadFromCache(id)
                        .catch(function () { return serverResponseToInstance(source, id, null); }), _a));
                }
                return loading[id];
                var _a;
            };
            ObjectLoader.updateCache = function (id, cacheableData) {
                return cache.store(id, cacheableData);
            };
            // Throws
            ObjectLoader.getFromCache = function (id) {
                if (byId[id]) {
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](byId[id].instance);
                }
                return loadFromCache(id);
            };
            ObjectLoader.get = function (id) {
                if (typeof id === "undefined" || id === null) {
                    throw new Error("Can't get object with id " + id + " - " + cacheName);
                }
                if (byId[id]) {
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](byId[id].instance);
                }
                if (!loading[id]) {
                    var promise = loadFromCache(id)
                        .catch(function () { return download(id, null).then(function (response) { return serverResponseToInstance(response, id, null); }); });
                    loading = __assign({}, loading, (_a = {}, _a[id] = promise, _a));
                }
                return loading[id];
                var _a;
            };
            return ObjectLoader;
        }()),
        _b.getAll = function () {
            return byId;
        },
        _b.removeLoaded = function (id) { return delete byId[id]; },
        _b.addLoaded = function (id, obj) {
            byId[id] = { instance: obj, lastUpdated: Date.now(), updating: false };
        },
        _b;
    var _b;
}
/* harmony default export */ __webpack_exports__["c"] = (createLoader);


/***/ }),

/***/ "HTZX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* BaseDirective
**/
__webpack_require__("6CQq");
__webpack_require__("o75H");
__webpack_require__("T6de");
__webpack_require__("Ywdf");
__webpack_require__("f6fo");
__webpack_require__("l/Gk");
__webpack_require__("yDzV");
__webpack_require__("3Alq");
__webpack_require__("9wYx");
__webpack_require__("FLn8");
__webpack_require__("zbu2");
__webpack_require__("ZTFq");
__webpack_require__("uX9v");
__webpack_require__("Z7zX");
__webpack_require__("YBg2");
__webpack_require__("XkYz");
__webpack_require__("3IhH");
__webpack_require__("hrpu");
__webpack_require__("QXd/");
__webpack_require__("016n");
__webpack_require__("3GPF");
__webpack_require__("JsBY");
__webpack_require__("QDVP");
__webpack_require__("qPM5");
__webpack_require__("fuD8");
__webpack_require__("s4FU");
__webpack_require__("VqRR");
__webpack_require__("UBvI");
__webpack_require__("/d+L");
__webpack_require__("lkMv");
__webpack_require__("8+7v");
__webpack_require__("YvxE");
__webpack_require__("SLbN");
__webpack_require__("QAA+");
__webpack_require__("J4Zh");
__webpack_require__("sciG");
__webpack_require__("07dH");
__webpack_require__("S/Pn");

/***/ }),

/***/ "HXS4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__("aeQg");
module.exports = angular.module("ssn.runners", []);

/***/ }),

/***/ "IJod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./js/services/Cache.ts
var Cache = __webpack_require__("4PxX");

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// CONCATENATED MODULE: ./js/services/Storage.ts


var LOCALSTORAGE_ERROR_DE = "Fehler!\n Kann Daten nicht lokal speichern!\n whispeer funktioniert ohne lokale Datenspeicherung (localstorage) nicht.\n Bitte aktivier es oder bitte uns um Hilfe: feedback@whispeer.de";
var LOCALSTORAGE_ERROR_EN = "Error!\n Can't store data locally!\n whispeer does not work without localstorage.\n Please enable it or ask us for help: feedback@whispeer.de";
var checkLocalStorage = function () {
    var rand = Math.random();
    try {
        localStorage.setItem("check-" + rand, "check-" + rand);
        if (localStorage.getItem("check-" + rand) === "check-" + rand) {
            localStorage.removeItem("check-" + rand);
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
};
if (!checkLocalStorage) {
    if (helper["default"].getLanguageFromPath() === "de") {
        alert(LOCALSTORAGE_ERROR_DE);
    }
    else {
        alert(LOCALSTORAGE_ERROR_EN);
    }
}
var Storage_Storage = /** @class */ (function () {
    function Storage(prefix) {
        var _this = this;
        this.get = function (key) {
            return localStorage.getItem(_this.calculateKey(key));
        };
        this.set = function (key, data) {
            return localStorage.setItem(_this.calculateKey(key), data);
        };
        this.remove = function (key) {
            return localStorage.removeItem(_this.calculateKey(key));
        };
        this.clear = function () {
            var usedKeys = Object.keys(localStorage);
            usedKeys.filter(function (key) {
                return key.indexOf(this._prefix) === 0;
            }, _this).forEach(function (key) {
                localStorage.setItem(key, "");
            });
            return bluebird["resolve"]();
        };
        this.save = function () {
            return bluebird["resolve"]();
        };
        this.calculateKey = function (key) {
            return _this._prefix + "." + key;
        };
        this.awaitLoading = function () { return bluebird["resolve"](); };
        this._prefix = prefix;
    }
    return Storage;
}());
/* harmony default export */ var services_Storage = (Storage_Storage);

// CONCATENATED MODULE: ./js/services/storage.service.ts
/* harmony export (immutable) */ __webpack_exports__["checkLocalStorage"] = storage_service_checkLocalStorage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageInfo", function() { return storageInfo; });
/* harmony export (immutable) */ __webpack_exports__["promoteMainWindow"] = promoteMainWindow;
/* harmony export (immutable) */ __webpack_exports__["withPrefix"] = withPrefix;


function storage_service_checkLocalStorage() {
    try {
        localStorage.setItem("localStorageTest", "localStorageTest");
        localStorage.removeItem("localStorageTest");
        return true;
    }
    catch (e) {
        return false;
    }
}
var storages = [];
var storageInfo = {
    Cache: new Cache["a" /* default */]("localStorage"),
    hasLocalStorage: storage_service_checkLocalStorage(),
    broken: false
};
function promoteMainWindow() {
    window.top.whispeerGetStorage = function (prefix) {
        return this.storages[prefix];
    };
}
function withPrefix(prefix) {
    if (!storages[prefix]) {
        try {
            storages[prefix] = new services_Storage(prefix);
        }
        catch (e) {
            storageInfo.broken = true;
        }
    }
    return storages[prefix];
}


/***/ }),

/***/ "IeI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function (password) {
    if (!password) {
        return 0;
    } // obsolete when completely turned to ts
    var strength = 1;
    /*
        >=7  +1*1
        >=10 +1
        >=13 +1
        >=16 +1
        >=20 +1
        Gross&Klein +2
        1 Sonderzeichen +1
        1 Sonderzeichen +1
        Zahl +1
    */
    if (password.length < 8) {
        return 0;
    } // Greater than 8 chars minimum!
    if (password.length >= 10) {
        strength += 1;
    } // Longer than 10 chars
    if (password.length >= 13) {
        strength += 2;
    } // Longer than 13 chars
    if (password.length >= 16) {
        strength += 2;
    } // Longer than 16 chars
    if (password.length >= 20) {
        strength += 1;
    } // Longer than 20 chars
    if ((password.match(/[a-z]/)) && (password.match(/[A-Z]/))) {
        strength += 1;
    } // Mix of upper and lower chars
    if (password.match(/\d+/)) {
        strength += 1;
    } // Contains a number
    if (password.match(/[+,!,@,#,$,%,\^,&,*,?,_,~,\-]/)) {
        strength += 1;
    } // Contains a special chars
    return strength;
});


/***/ }),

/***/ "IeOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestKey_service__ = __webpack_require__("eGOm");

var keyStore = __webpack_require__("+1JK");
keyStore.upload.setKeyGet(__WEBPACK_IMPORTED_MODULE_0__requestKey_service__["a" /* default */].getKey);
/* harmony default export */ __webpack_exports__["default"] = (keyStore);


/***/ }),

/***/ "J4Zh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

var templateUrl = __webpack_require__("c6u2");

var displayFileDirective = function displayFileDirective() {
	return {
		scope: {
			"file": "=file"
		},
		transclude: true,
		restrict: "E",
		templateUrl: templateUrl,
		link: function link() {}
	};
};

directivesModule.directive("displayFile", displayFileDirective);

/***/ }),

/***/ "JsBY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_blobService__ = __webpack_require__("95Br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_error_service__ = __webpack_require__("EFCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_screenSize_service__ = __webpack_require__("KEBJ");





var jQuery = __webpack_require__("juYr");
var templateUrl = __webpack_require__("vgEd");
var directivesModule = __webpack_require__("7Eh3");
function imageGallery() {
    function loadImage(data) {
        var blobid = data.blobID;
        if (data.loaded) {
            return;
        }
        data.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            return __WEBPACK_IMPORTED_MODULE_1__services_blobService__["default"].getBlobUrl(blobid, "image/jpeg", 0);
        }).then(function (url) {
            data.loading = false;
            data.loaded = true;
            data.url = url;
        }).catch(__WEBPACK_IMPORTED_MODULE_2__services_error_service__["default"].criticalError);
    }
    function loadImagePreviews(images) {
        images.forEach(function (image) {
            if (image.upload) {
                return;
            }
            if (image.lowest.width && image.lowest.height && !image.lowest.loaded) {
                var canvas = document.createElement("canvas");
                canvas.width = image.lowest.width;
                canvas.height = image.lowest.height;
                image.lowest.url = canvas.toDataURL();
            }
            loadImage(image.lowest);
        });
    }
    return {
        scope: {
            "images": "="
        },
        restrict: "E",
        templateUrl: templateUrl,
        link: function (scope) {
            var previewChunk = 4;
            if (__WEBPACK_IMPORTED_MODULE_3__services_screenSize_service__["default"].mobile) {
                previewChunk = 2;
            }
            scope.preview = previewChunk;
            scope.$watch("images", function () {
                if (scope.images && scope.images.length > 0) {
                    loadImagePreviews(scope.images.slice(0, scope.preview));
                }
            });
            scope.loadMoreImages = function () {
                scope.preview = parseInt(scope.preview, 10);
                loadImagePreviews(scope.images.slice(scope.preview, scope.preview + previewChunk));
                scope.preview += previewChunk;
            };
            var runningGifs = false;
            scope.modal = false;
            scope.runGif = function (index) {
                return index === scope.imageIndex && runningGifs;
            };
            scope.viewImage = function (index) {
                scope.modalImage = scope.images[index];
                if (scope.modalImage.lowest.gif) {
                    runningGifs = scope.imageIndex !== index || !runningGifs;
                }
                else if (__WEBPACK_IMPORTED_MODULE_3__services_screenSize_service__["default"].mobile) {
                    return;
                }
                else {
                    runningGifs = false;
                    scope.modal = true;
                }
                scope.imageIndex = index;
                if (!scope.modalImage.highest) {
                    scope.modalImage.highest = scope.modalImage.middle || scope.modalImage.lowest;
                }
                if (!scope.modalImage.upload) {
                    loadImage(scope.modalImage.highest);
                }
            };
            var KEYS = {
                LEFT: 37,
                RIGHT: 39,
                J: 74,
                K: 75,
                UP: 38,
                DOWN: 40
            };
            var NEXTKEYS = [KEYS.DOWN, KEYS.J, KEYS.RIGHT];
            var PREVKEYS = [KEYS.UP, KEYS.K, KEYS.LEFT];
            jQuery(document).keyup(function (e) {
                if (scope.modal) {
                    if (NEXTKEYS.indexOf(e.keyCode) > -1) {
                        scope.imageIndex = Math.min(scope.imageIndex + 1, scope.images.length - 1);
                        e.preventDefault();
                    }
                    if (PREVKEYS.indexOf(e.keyCode) > -1) {
                        scope.imageIndex = Math.max(scope.imageIndex - 1, 0);
                        e.preventDefault();
                    }
                    scope.viewImage(scope.imageIndex);
                    scope.$applyAsync();
                }
            });
        }
    };
}
directivesModule.directive("gallery", [imageGallery]);


/***/ }),

/***/ "K6VQ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./00001-regenerateFriendsKeys": "ym3/",
	"./00001-regenerateFriendsKeys.js": "ym3/",
	"./00002-fixBrokenSettings": "5sYn",
	"./00002-fixBrokenSettings.js": "5sYn",
	"./migrationExample": "eahS",
	"./migrationExample.js": "eahS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "K6VQ";

/***/ }),

/***/ "KEBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asset_observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("juYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ScreenSizeService = /** @class */ (function (_super) {
    __extends(ScreenSizeService, _super);
    function ScreenSizeService() {
        var _this = _super.call(this) || this;
        _this.updateMobile = function () {
            var width = window.top.document.documentElement.clientWidth;
            var mobile = width < 1025;
            if (mobile !== _this.mobile) {
                _this.mobile = mobile;
                setTimeout(function () {
                    _this.notify(mobile);
                });
            }
        };
        jQuery(window.top).on("resize", _this.updateMobile);
        _this.updateMobile();
        return _this;
    }
    return ScreenSizeService;
}(__WEBPACK_IMPORTED_MODULE_0__asset_observer__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (new ScreenSizeService());


/***/ }),

/***/ "OY2u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WorkerPool = __webpack_require__("ZeLu");
var bluebird = __webpack_require__("fp6q");
var chelper = __webpack_require__("nZLN");
var config = __webpack_require__("b/6L");

function getEntropy() {
	try {
		var ab;

		// get cryptographically strong entropy depending on runtime environment
		if (window && Uint32Array) {
			ab = new Uint32Array(32);
			if (window.crypto && window.crypto.getRandomValues) {
				window.crypto.getRandomValues(ab);
			} else if (window.msCrypto && window.msCrypto.getRandomValues) {
				window.msCrypto.getRandomValues(ab);
			} else {
				return false;
			}

			return ab;
		}
	} catch (e) {
		console.error(e);
	}

	return false;
}

function addEntropy(theWorker, callback) {
	var entropy = getEntropy();

	if (entropy) {
		theWorker.runTask({ randomNumber: entropy, entropy: 1024 }).then(callback);
	} else {
		throw new Error("no entropy from browser ... browser too old");
	}
}

var workerCount = 4;

if (navigator.hardwareConcurrency) {
	workerCount = Math.max(navigator.hardwareConcurrency - 1, workerCount);
}

//Promise, numberOfWorkers, workerPath, setupMethod, requireOverRide
var workers = new WorkerPool(bluebird, workerCount, {
	setupMethod: addEntropy,
	workerScriptOverride: config.workerScript || false
});

var sjclWorker = {
	hash: function hash(toHash) {
		return workers.schedule({
			isHash: true,
			toHash: toHash
		});
	},
	stringify: function stringify(content, version, hash) {
		return workers.schedule({
			stringify: true,
			content: content,
			version: version,
			hash: hash
		});
	},
	asym: {
		generateCryptKey: function generateCryptKey(curve) {
			var data = {
				asym: true,
				generate: true,
				crypt: true
			};

			if (curve) {
				data.curve = curve;
			}

			return workers.schedule(data);
		},
		generateSignKey: function generateSignKey(curve) {
			var data = {
				asym: true,
				generate: true,
				crypt: false,
				curve: curve
			};

			return workers.schedule(data);
		},
		kem: function kem(publicKey) {
			var data = {
				asym: true,
				generate: false,
				action: "kem",

				curve: chelper.getCurveName(publicKey._curve),
				x: publicKey._point.x.toString(),
				y: publicKey._point.y.toString()
			};

			return workers.schedule(data);
		},
		unkem: function unkem(privateKey, tag) {
			var data = {
				asym: true,
				generate: false,
				action: "unkem",

				curve: chelper.getCurveName(privateKey._curve),
				exponent: privateKey._exponent.toString(),
				tag: chelper.bits2hex(tag)
			};

			return workers.schedule(data);
		},
		sign: function sign(privateKey, toSign) {
			var data = {
				asym: true,
				generate: false,
				action: "sign",

				curve: chelper.getCurveName(privateKey._curve),
				exponent: privateKey._exponent.toString(),
				toSign: chelper.bits2hex(toSign)
			};

			return workers.schedule(data);
		},
		verify: function verify(publicKey, signature, hash) {
			var data = {
				asym: true,
				generate: false,
				action: "verify",

				curve: chelper.getCurveName(publicKey._curve),
				point: {
					x: publicKey._point.x.toString(),
					y: publicKey._point.y.toString()
				},

				signature: chelper.bits2hex(signature),
				hash: chelper.bits2hex(hash)
			};

			return workers.schedule(data);
		}
	},
	sym: {
		encrypt: function encrypt(key, message, progressListener) {
			var data = {
				"key": key,
				"message": message,

				"asym": false,
				"encrypt": true
			};

			return workers.schedule(data, progressListener);
		},
		decrypt: function decrypt(key, message, progressListener) {
			var data = {
				"key": key,
				"message": message,

				"asym": false,
				"encrypt": false
			};

			return workers.schedule(data, progressListener);
		}
	}
};

module.exports = sjclWorker;

/***/ }),

/***/ "P6+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress(options) {
        var _this = _super.call(this) || this;
        _this.done = 0;
        _this.donePercentage = 0;
        _this.data = { progress: 0 };
        _this._parseOptions = function () {
            if (_this.options) {
                _this.total = _this.options.total;
                if (_this.options.depends) {
                    _this._listenDepends(_this.options.depends);
                }
            }
        };
        _this._listenDepends = function (depends) {
            _this.depends = depends;
            depends.forEach(function (depend) {
                depend.listen(_this.recalculate.bind(_this), "progress");
            });
        };
        _this.removeDepend = function (depend) {
            if (!_this.depends && _this.total) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].removeArray(_this.depends, depend);
            _this.recalculate();
        };
        _this.addDepend = function (depend) {
            if (!_this.depends && _this.total) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.depends = _this.depends || [];
            _this.depends.push(depend);
            depend.listen(_this.recalculate.bind(_this), "progress");
            _this.recalculate();
        };
        _this.progressDelta = function (delta) {
            if (_this.depends) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.done += delta;
            _this.recalculate();
        };
        _this.progress = function (done) {
            if (_this.depends) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.done = done;
            _this.recalculate();
        };
        _this.setTotal = function (total) {
            if (_this.depends) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.total = total;
            _this.recalculate();
        };
        _this.reset = function () {
            _this.done = 0;
            _this.recalculate();
        };
        _this.joinDepends = function () {
            var done = 0, total = 0;
            _this.depends.forEach(function (depend) {
                done += depend.getDone();
                total += depend.getTotal() || 0;
            });
            _this.done = done;
            _this.total = total;
        };
        _this.getDone = function () {
            return _this.done;
        };
        _this.getTotal = function () {
            return _this.total;
        };
        _this.getProgress = function () {
            return _this.donePercentage;
        };
        _this.recalculate = function () {
            if (_this.depends) {
                _this.joinDepends();
            }
            if (!_this.total) {
                return;
            }
            _this.donePercentage = _this.done / _this.total;
            _this.donePercentage = Math.min(_this.donePercentage, 1);
            _this.data.progress = _this.donePercentage;
            _this.notify(_this.donePercentage, "progress");
        };
        _this.options = options;
        _this._parseOptions();
        return _this;
    }
    return Progress;
}(__WEBPACK_IMPORTED_MODULE_0__observer__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Progress);


/***/ }),

/***/ "QAA+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("uLQx");
var directivesModule = __webpack_require__("7Eh3");

function loadingindicatorDirective() {
	"use strict";

	return {
		transclude: true,
		scope: {},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true,
		link: function link(scope, iElement, iAttrs) {
			if (iAttrs.color) {
				scope.color = iAttrs.color;
			} else {
				scope.color = "black";
			}
		}
	};
}

directivesModule.directive("loadingindicator", loadingindicatorDirective);

/***/ }),

/***/ "QDVP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var h = __webpack_require__("S8e/").default;
var directivesModule = __webpack_require__("7Eh3");
var directive = function directive($window, localize) {
	var ONEHOUR = 60 * 60 * 1000;
	var HALFHOUR = ONEHOUR / 2;
	var ONEMINUTE = 60 * 1000;

	function getDifferenceString(diff) {
		var minutes = Math.floor(diff % ONEHOUR / ONEMINUTE);

		if (diff < ONEMINUTE) {
			return localize.getLocalizedString("date.time.justNow");
		}

		if (diff < 2 * ONEMINUTE) {
			return localize.getLocalizedString("date.time.oneMinuteAgo");
		}

		if (diff <= HALFHOUR) {
			return localize.getLocalizedString("date.time.minutesAgo", {
				minutes: minutes
			});
		}
	}

	function timestampDiffNow(timestamp) {
		return new Date().getTime() - timestamp;
	}

	var getLocalTime = function getLocalTime(date) {
		var time = date.toLocaleTimeString();
		var stripped = time.match(/^[^:]+(:\d\d){2} *(am|pm|)\b/i);

		if (stripped && stripped.length > 0) {
			return stripped[0];
		}

		return time;
	};

	function toDateString(input, noDayDisplay) {
		if (input) {
			var date = new Date(h.parseDecimal(input));
			var diff = timestampDiffNow(h.parseDecimal(input));

			if (diff < HALFHOUR) {
				return getDifferenceString(diff);
			}

			if (noDayDisplay) {
				return getLocalTime(date);
			}

			return date.toLocaleDateString() + " " + getLocalTime(date);
		} else {
			return "";
		}
	}

	return {
		scope: {
			time: "=smartDate"
		},
		link: function link(scope, element, attrs) {
			var previousResult;
			function updateDateString() {
				var result = toDateString(scope.time, attrs.smartDateNoDay !== undefined);

				if (result !== previousResult) {
					element.text(result);
				}

				previousResult = result;
			}

			updateDateString();

			scope.$watch(function () {
				return scope.time;
			}, updateDateString);

			var time = h.parseDecimal(scope.time);
			if (time > 999999) {
				var diff = timestampDiffNow(time);

				if (diff > HALFHOUR) {
					$window.setInterval(updateDateString, 24 * 60 * 60 * 1000);
				} else if (diff > ONEMINUTE) {
					$window.setInterval(updateDateString, 30 * 1000);
				} else {
					$window.setInterval(updateDateString, 1000);
				}
			}
		}
	};
};

directive.$inject = ["$window", "localize"];

directivesModule.directive("smartDate", directive);

/***/ }),

/***/ "QXd/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("uazT");
var errorService = __webpack_require__("EFCD").errorServiceInstance;

"use strict";

var directivesModule = __webpack_require__("7Eh3");
var Bluebird = __webpack_require__("fp6q");

function qrScannerDirective($timeout) {
	return {
		scope: {
			callback: "&",
			state: "="
		},
		restrict: "E",
		templateUrl: templateUrl,
		link: function link(scope, iElement) {
			var destroyed = false,
			    theStream;

			function captureToCanvas() {
				if (!scope.state.read && !destroyed) {
					Bluebird.try(function () {
						return new Bluebird(function (resolve) {
							__webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Tw3P")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
						});
					}).then(function (qrreader) {
						var width = 800;
						var height = 600;

						var gCanvas = document.createElement("canvas");
						gCanvas.width = width;
						gCanvas.height = height;

						var gCtx = gCanvas.getContext("2d");
						gCtx.clearRect(0, 0, width, height);

						gCtx.drawImage(iElement.find("video")[0], 0, 0);

						var code = qrreader.decodeCanvas(gCanvas);

						scope.state.read = true;
						try {
							theStream.stop();
						} catch (e) {
							console.error(e);
						}

						scope.callback({ code: code });
					}).catch(function (e) {
						console.error("Canvas loading failed", e);
						$timeout(captureToCanvas, 500);
					});
				}
			}

			function initializeReader() {
				if (destroyed) {
					return;
				}

				var moz = false;

				return Bluebird.try(function () {
					if (window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
						return new Bluebird(function (resolve) {
							window.MediaStreamTrack.getSources(resolve);
						});
					}
				}).then(function (sources) {
					if (destroyed) {
						return;
					}

					var constraints = {
						audio: false,
						video: true
					};

					if (sources) {
						var environmentSources = sources.filter(function (data) {
							return data.kind === "video" && data.facing === "environment";
						});

						if (environmentSources.length === 1) {
							constraints.video = { optional: [{ sourceId: environmentSources[0].id }] };
						}
					}

					return new Bluebird(function (resolve, reject) {
						if (navigator.getUserMedia) {
							navigator.getUserMedia(constraints, resolve, reject);
						} else if (navigator.webkitGetUserMedia) {
							navigator.webkitGetUserMedia(constraints, resolve, reject);
						} else if (navigator.mozGetUserMedia) {
							moz = true;
							navigator.mozGetUserMedia(constraints, resolve, reject);
						}
					});
				}).then(function (stream) {
					if (destroyed) {
						return;
					}

					scope.state.noDevice = false;
					theStream = stream;
					var v = iElement.find("video")[0];

					if (moz) {
						v.mozSrcObject = stream;
						v.play();
					} else {
						v.src = window.webkitURL.createObjectURL(stream);
					}

					$timeout(captureToCanvas, 500);
				}).catch(function (e) {
					errorService.criticalError(e);

					if (e.name === "DevicesNotFoundError") {
						scope.state.noDevice = true;

						$timeout(initializeReader, 1000);
					}
				});
			}

			scope.$on("$destroy", function () {
				if (theStream) {
					theStream.stop();
				}
				destroyed = true;
			});

			scope.state = scope.state || {};

			scope.state.available = !!(navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia);
			scope.state.noDevice = false;
			scope.state.read = false;
			scope.state.reset = function () {
				if (scope.state.read) {
					scope.state.read = false;
					initializeReader();
				}
			};

			if (scope.state.enabled) {
				initializeReader();
			} else {
				scope.$watch(function () {
					return scope.state.enabled;
				}, function (isEnabled) {
					if (isEnabled) {
						initializeReader();
					}
				});
			}
		}
	};
}

qrScannerDirective.$inject = ["$timeout"];

directivesModule.directive("qrScanner", qrScannerDirective);

/***/ }),

/***/ "RXrU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var localizationLoader = __webpack_require__("iuSa").default;
var h = __webpack_require__("S8e/").default;
var Localize = __webpack_require__("n8tu").default;
var withPrefix = __webpack_require__("IJod").withPrefix;

var availableLanguages = ["en", "de"];

localizationLoader.setAvailableLanguages(availableLanguages);
localizationLoader.setFallBackLanguage(availableLanguages[0]);

var lang = h.getLanguageFromPath();
var pathLanguageAvailable = availableLanguages.indexOf(lang) > -1;

var localize = new Localize(pathLanguageAvailable ? lang : null);

if (false) {
	localize.loadOptionalLocaleExtension("assets/js/i18n/l_business_");

	var companyID = withPrefix("whispeer.token").get("companyID");

	if (companyID) {
		localize.loadOptionalLocaleExtension("assets/js/i18n/companies/l_" + companyID + "_");
	}
}

module.exports = localize;

/***/ }),

/***/ "Reu1":
/***/ (function(module, exports) {

var path = 'directives/person.html';
var html = "<div class=person> <userimage class=person-userimage data-user=userData></userimage> <div class=person-data> <p class=person-username><span class=\"person-status status\" data-status={{userData.online}}></span><strong><a ui-sref=\"app.user.info({identifier: userData.names.nickname})\">{{userData.name}}</a></strong></p> <p class=person-similar data-ng-show=\"!userData.me && !userData.notExisting\" data-i18n=\"friends.mutualFriends|count={{userData.basic.mutualFriends.length}}\"></p> <p class=person-similar data-ng-show=userData.notExisting> <i class=\"fa fa-frown-o\"></i> <span data-i18n=profile.notFound></span> </p> <p class=person-action data-ng-transclude></p> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "S/Pn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__ = __webpack_require__("GiKV");
var templateUrl = __webpack_require__("cnt8");


var directivesModule = __webpack_require__("7Eh3");
var BurstDifferenceComponentController = /** @class */ (function () {
    function BurstDifferenceComponentController() {
    }
    BurstDifferenceComponentController.prototype.differentDay = function () {
        if (this.noDates || !this.chat || !this.chat.getLatestChunk) {
            return false;
        }
        if (this.burst && this.previousBurst) {
            return !this.burst.sameDay(this.previousBurst);
        }
        return true;
    };
    BurstDifferenceComponentController.prototype.differentChunk = function () {
        if (!this.chat || !this.chat.getLatestChunk) {
            return false;
        }
        if (this.burst && this.previousBurst) {
            return !this.burst.sameChunk(this.previousBurst);
        }
        if (this.previousBurst) {
            return this.previousBurst.getChunkID() !== this.chat.getLatestChunk();
        }
        return true;
    };
    BurstDifferenceComponentController.prototype.chunksBetweenBursts = function () {
        if (!this.previousBurst) {
            return [];
        }
        var currentChunkID = this.burst ? this.burst.getChunkID() : this.chat.getLatestChunk();
        return this.getChunksBetween(__WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(currentChunkID), __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(this.previousBurst.getChunkID())).reverse();
    };
    BurstDifferenceComponentController.prototype.addedReceiver = function (chunk) {
        var currentReceiveers = chunk.getReceivers();
        var previousReceiveers = __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(chunk.getPredecessorID()).getReceivers();
        return currentReceiveers.filter(function (partner) { return previousReceiveers.indexOf(partner) === -1; });
    };
    BurstDifferenceComponentController.prototype.removedReceiver = function (chunk) {
        var currentReceiveers = chunk.getReceivers();
        var previousReceiveers = __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(chunk.getPredecessorID()).getReceivers();
        return previousReceiveers.filter(function (partner) { return currentReceiveers.indexOf(partner) === -1; });
    };
    BurstDifferenceComponentController.prototype.changedTitle = function (chunk) {
        var currentTitle = chunk.getTitle();
        var previousTitle = __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(chunk.getPredecessorID()).getTitle();
        if (currentTitle !== previousTitle) {
            return currentTitle;
        }
    };
    BurstDifferenceComponentController.prototype.getCreator = function (chunk) {
        return chunk.getReceivers().find(function (user) { return user.id === chunk.getCreator(); });
    };
    BurstDifferenceComponentController.prototype.getChunksBetween = function (newerChunk, olderChunk) {
        if (newerChunk.getID() === olderChunk.getID()) {
            return [];
        }
        var predecessor = __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(newerChunk.getPredecessorID());
        return [newerChunk].concat(this.getChunksBetween(predecessor, olderChunk));
    };
    BurstDifferenceComponentController.prototype.hasPreviousChunk = function () {
        return Boolean(this.previousBurst);
    };
    BurstDifferenceComponentController.prototype.receiver = function () {
        if (this.burst) {
            return __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(this.burst.getChunkID()).getPartners();
        }
        return __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(this.chat.getLatestChunk()).getPartners();
    };
    BurstDifferenceComponentController.prototype.getTime = function () {
        if (this.burst) {
            return this.burst.firstItem().getTime();
        }
        var latestChunk = __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(this.chat.getLatestChunk());
        return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["default"].parseDecimal(latestChunk.getTime());
    };
    BurstDifferenceComponentController.prototype.getChunk = function () {
        var burstChunkID = this.burst ? this.burst.getChunkID() : this.chat.getLatestChunk();
        return __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(burstChunkID);
    };
    BurstDifferenceComponentController.prototype.hasTitleDifference = function () {
        if (!this.previousBurst) {
            return false;
        }
        var burstChunk = this.getChunk();
        var previousBurstChunk = __WEBPACK_IMPORTED_MODULE_1__messages_chatChunk__["b" /* default */].getLoaded(this.previousBurst.getChunkID());
        return burstChunk.getTitle() !== previousBurstChunk.getTitle();
    };
    BurstDifferenceComponentController.prototype.getTitle = function () {
        this.getChunk().getTitle();
    };
    Object.defineProperty(BurstDifferenceComponentController, "$inject", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    return BurstDifferenceComponentController;
}());
var burstDifferenceComponent = {
    templateUrl: templateUrl,
    controller: BurstDifferenceComponentController,
    controllerAs: "$ctrl",
    bindings: {
        chat: "<",
        burst: "<",
        previousBurst: "<",
        noDates: "<"
    }
};
directivesModule.component("burstDifference", burstDifferenceComponent);


/***/ }),

/***/ "S8e/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, process) {
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        // eslint-disable-next-line no-undef
        return global;
    }
}
var glob = getGlobal();
var uuidPattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
var uuidRegexPattern = uuidPattern.replace(/x/g, "[a-fA-F0-9]").replace(/y/g, "[89abAB]");
var uuidRegex = new RegExp(uuidRegexPattern);
/** contains general helper functions */
var helper = {
    executeOnce: function (func) {
        var val;
        return function () {
            if (!val) {
                val = func();
            }
            return val;
        };
    },
    ensurePromise: function (p, cb) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return p.resolve(cb.apply(void 0, args));
        };
    },
    hasErrorId: function (response, id) {
        var errorData = response.errorData;
        return Object.keys(errorData).some(function (key) {
            return errorData[key].id === id;
        });
    },
    createErrorType: function (name) {
        function CustomError(message, extra) {
            var error = Error.call(this, message);
            this.name = name;
            this.extra = extra;
            this.message = error.message;
            this.stack = error.stack;
        }
        CustomError.prototype = Object.create(Error.prototype);
        CustomError.prototype.constructor = CustomError;
        return CustomError;
    },
    cacheResult: function (func) {
        var result;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!result) {
                result = func.apply(this, args);
            }
            return result;
        };
    },
    cacheUntilSettled: function (func) {
        var resultPromise;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!resultPromise) {
                resultPromise = func.apply(this, args);
            }
            resultPromise.finally(function () {
                resultPromise = null;
            });
            return resultPromise;
        };
    },
    randomIntFromInterval: function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
    generateUUID: function () {
        /* eslint-disable no-bitwise */
        var d = new Date().getTime();
        var uuid = uuidPattern.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
        });
        /* eslint-enable no-bitwise */
        return uuid;
    },
    repeatUntilTrue: function (Promise, func, delay) {
        function repeatFunc() {
            return func().then(function (res) {
                if (!res) {
                    return Promise.delay(delay).then(function () {
                        return repeatFunc();
                    });
                }
            });
        }
        return repeatFunc();
    },
    encodeParameters: function (parameters) {
        var keys = Object.keys(parameters);
        if (keys.length === 0) {
            return "";
        }
        var result = "?";
        keys.forEach(function (key) {
            result += key;
            if (parameters[key] !== null) {
                result += "=" + parameters[key];
            }
            result += "&";
        });
        result = result.substr(0, result.length - 1);
        return result;
    },
    getWeekNumber: function (d) {
        // Copy date so don't modify original
        d = new Date(+d);
        d.setHours(0, 0, 0);
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        // Get first day of year
        var yearStart = new Date(d.getFullYear(), 0, 1).getTime();
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
        // Return array of year and week number
        return weekNo;
    },
    getLanguageFromPath: function () {
        return window.top.location.pathname.split("/")[1];
    },
    or: function (v1, v2) {
        return v1 || v2;
    },
    and: function (v1, v2) {
        return v1 && v2;
    },
    not: function (func) {
        return function () {
            return !func.apply(this, arguments);
        };
    },
    addAfterHook: function (func, hook, thisArg) {
        return function () {
            func.apply(thisArg, arguments);
            hook.apply(thisArg, arguments);
        };
    },
    concatBuffers: function () {
        var bufs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            bufs[_i] = arguments[_i];
        }
        var len = 0, offset = 0;
        bufs.forEach(function (buf) {
            len += buf.byteLength;
        });
        var tmp = new Uint8Array(len);
        bufs.forEach(function (buf) {
            tmp.set(new Uint8Array(buf), offset);
            offset += buf.byteLength;
        });
        return tmp.buffer;
    },
    debouncePromise: function (Bluebird, func, time) {
        var timer = null;
        return function () {
            var args = arguments;
            if (timer) {
                clearTimeout(timer);
            }
            var promise = new Bluebird(function (resolve) {
                timer = setTimeout(function () {
                    resolve();
                }, time);
            }).then(function () {
                return func.apply(null, args);
            });
            return promise;
        };
    },
    debounce: function (func, time) {
        var timeout, args;
        return function () {
            args = arguments;
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                func.apply(null, args);
            }, time);
        };
    },
    promisify: function (Promise, cb) {
        return new Promise(function (resolve, reject) {
            try {
                cb(function (e, result) {
                    if (e) {
                        reject(e);
                    }
                    else {
                        resolve(result);
                    }
                });
            }
            catch (e) {
                reject(e);
            }
        });
    },
    joinArraysToObject: function (config) {
        var result = [];
        var len = config[Object.keys(config)[0]].length;
        if (len === 0) {
            return result;
        }
        var i;
        for (i = 0; i < len; i += 1) {
            result.push({});
        }
        helper.objectEach(config, function (key, arrVal) {
            if (arrVal.length !== len) {
                throw new Error("arrays need to have the same length");
            }
            arrVal.forEach(function (val, index) {
                result[index][key] = val;
            });
        });
        return result;
    },
    capitaliseFirstLetter: function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    lowercaseFirstLetter: function (string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    },
    objectifyResult: function (name, cb) {
        return function (e, result) {
            var data = {};
            if (e) {
                cb(e);
            }
            else {
                data[name] = result;
                cb(null, data);
            }
        };
    },
    array: {
        isArray: function (arr) {
            return Object.prototype.toString.call(arr) === "[object Array]";
        },
        first: function (arr) {
            return arr[0];
        },
        last: function (arr) {
            return arr[arr.length - 1];
        },
        find: function (arr, func) {
            var results = arr.filter(func);
            if (results.length === 1) {
                return results[0];
            }
        },
        spreadByArray: function (toSpread, attributeNames) {
            var res = {};
            toSpread.forEach(function (val, index) {
                res[attributeNames[index]] = val;
            });
            return res;
        },
        contains: function (arr, element) {
            return arr.indexOf(element) > -1;
        },
        flatten: function (arr) {
            var i, result = [];
            for (i = 0; i < arr.length; i += 1) {
                if (arr[i] instanceof Array) {
                    result = result.concat(helper.array.flatten(arr[i]));
                }
                else {
                    result.push(arr[i]);
                }
            }
            return result;
        }
    },
    object: {
        deepSet: function (obj, partials, value) {
            obj = obj || {};
            if (partials.length === 0) {
                return value;
            }
            var curPartial = obj;
            partials.forEach(function (part, index) {
                if (index === partials.length - 1) {
                    curPartial[part] = value;
                }
                if (!curPartial[part]) {
                    curPartial[part] = {};
                }
            });
            return obj;
        },
        deepHas: function (obj, partials) {
            var hasDeep = true, currentPartial = obj;
            partials.forEach(function (partial) {
                if (currentPartial.hasOwnProperty(partial)) {
                    currentPartial = currentPartial[partial];
                }
                else {
                    hasDeep = false;
                }
            });
            return hasDeep;
        },
        deepGet: function (obj, partials) {
            var currentPart = obj, depth = 0, previousPart;
            if (partials.length === 0) {
                return {
                    depth: 0,
                    value: obj
                };
            }
            partials.forEach(function (partial) {
                if (typeof currentPart[partial] !== "undefined") {
                    previousPart = currentPart;
                    currentPart = currentPart[partial];
                    depth += 1;
                }
            });
            return {
                depth: depth,
                value: currentPart,
                parentValue: previousPart
            };
        },
        multipleFlatJoin: function (objs) {
            var result = {};
            function doJoin(base, obj) {
                helper.objectEach(obj, function (key, value) {
                    if (base.hasOwnProperty(key) && value !== base[key]) {
                        throw new Error("attribute already set!");
                    }
                    else {
                        result[key] = value;
                    }
                });
            }
            objs.map(function (e) {
                doJoin(result, e);
            });
            return result;
        }
    },
    pad: function (str, max) {
        str = str.toString();
        return str.length < max ? helper.pad("0" + str, max) : str;
    },
    canvasToBlob: function (canvas, type, cb) {
        canvas.toBlob(function (blob) {
            cb(null, blob);
        }, type);
    },
    blobToDataURI: function (blob, cb) {
        var reader = new FileReader();
        reader.onload = function () {
            cb(null, reader.result);
        };
        reader.readAsDataURL(blob);
    },
    dataURItoBlob: function (dataURI) {
        if (glob.atob && glob.Blob && glob.ArrayBuffer && glob.Uint8Array) {
            try {
                // convert base64 to raw binary data held in a string
                // doesn't handle URLEncoded DataURIs
                var byteString = atob(dataURI.split(",")[1]);
                // separate out the mime component
                var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                try {
                    return new Blob([ab], { type: mimeString });
                }
                catch (e) {
                    // TypeError old chrome and FF
                    window.BlobBuilder = window.BlobBuilder ||
                        window.WebKitBlobBuilder ||
                        window.MozBlobBuilder ||
                        window.MSBlobBuilder;
                    if (e.name === "TypeError" && window.BlobBuilder) {
                        var bb = new window.BlobBuilder();
                        bb.append([ab]);
                        return bb.getBlob(mimeString);
                    }
                    return false;
                }
            }
            catch (e) {
                return false;
            }
        }
        else {
            return false;
        }
    },
    /** calls all listeners */
    callListener: function (listener, arg1) {
        var i;
        for (i = 0; i < listener.length; i += 1) {
            try {
                listener[i](null, arg1);
            }
            catch (e) {
                console.log(e);
            }
        }
    },
    aggregateOnce: function (delayTime, callFunction) {
        var timerStarted = false;
        function doLoad() {
            timerStarted = false;
            callFunction();
        }
        return function () {
            if (!timerStarted) {
                timerStarted = true;
                window.setTimeout(doLoad, delayTime);
            }
        };
    },
    FullFiller: function () {
        var running = false, waiters = [];
        var success = false, failure = false, error;
        this.finish = function (e) {
            failure = !!e;
            success = !e;
            error = e;
            helper.callEach(waiters, [error]);
        };
        this.success = function () {
            if (!success && !failure) {
                success = true;
                helper.callEach(waiters);
            }
        };
        this.fail = function (e) {
            if (!success && !failure) {
                failure = true;
                error = e;
                helper.callEach(waiters, [error]);
            }
        };
        this.isSuccess = function () {
            return success;
        };
        this.start = function (cb) {
            if (!running && !success && !failure) {
                running = true;
                cb();
            }
        };
        this.await = function (cb) {
            if (success || failure) {
                cb(error);
            }
            else {
                waiters.push(cb);
            }
        };
    },
    delayMultiplePromise: function (Bluebird, delayTime, loadFunction, maxOnce) {
        var idsToLoad = [];
        var loadPromises = {}, loaderPromise;
        function doLoad() {
            var identifiers = idsToLoad.splice(0, maxOnce || idsToLoad.length);
            return loadFunction(identifiers).then(function (results) {
                loaderPromise = null;
                return results;
            }).map(function (result, i) {
                var id = identifiers[i];
                delete loadPromises[id];
                return {
                    id: id,
                    result: result
                };
            });
        }
        function getLoaderPromise() {
            if (!loaderPromise) {
                loaderPromise = Bluebird.delay(delayTime)
                    .then(function () { return doLoad(); });
            }
            return loaderPromise;
        }
        function awaitNextLoad(identifier) {
            return getLoaderPromise()
                .filter(function (res) { return res.id === identifier; })
                .then(function (remainingResults) {
                return remainingResults.length === 0 ?
                    awaitNextLoad(identifier) :
                    remainingResults[0].result;
            });
        }
        return function (identifier) {
            if (!loadPromises[identifier]) {
                idsToLoad.push(identifier);
                loadPromises[identifier] = awaitNextLoad(identifier);
            }
            return loadPromises[identifier];
        };
    },
    delayMultiple: function (delayTime, loadFunction, maxOnce) {
        var timerStarted = false;
        var idsToLoad = [];
        var loadListeners = {};
        function doLoad() {
            var identifier = idsToLoad.splice(0, maxOnce || idsToLoad.length);
            loadFunction(identifier, function (err, results) {
                if (err) {
                    throw err;
                }
                var i, curIdentifier, curListener;
                for (i = 0; i < results.length; i += 1) {
                    curIdentifier = identifier[i];
                    curListener = loadListeners[curIdentifier];
                    helper.callListener(curListener, results[i]);
                    delete loadListeners[curIdentifier];
                }
                if (idsToLoad.length === 0) {
                    timerStarted = false;
                }
                else {
                    window.setTimeout(doLoad, delayTime);
                }
            });
        }
        return function (identifier, cb) {
            if (loadListeners[identifier]) {
                loadListeners[identifier].push(cb);
            }
            else {
                loadListeners[identifier] = [cb];
                idsToLoad.push(identifier);
                if (!timerStarted) {
                    timerStarted = true;
                    window.setTimeout(doLoad, delayTime);
                }
            }
        };
    },
    setGeneralState: function (state, obj) {
        obj.saving = false;
        obj.success = false;
        obj.failure = false;
        switch (state) {
            case "saving":
                obj.saving = true;
                break;
            case "success":
                obj.success = true;
                break;
            case "failure":
            default:
                obj.failure = true;
                break;
        }
    },
    stringifyCertainAttributes: function (obj, attributes) {
        var attr, result = {};
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                if (attributes.indexOf(attr) > -1) {
                    result[attr] = JSON.stringify(obj[attr]);
                }
                else {
                    if (typeof obj[attr] === "object") {
                        throw new Error("value should not be stringified but is object");
                    }
                    result[attr] = obj[attr];
                }
            }
        }
        return result;
    },
    unStringifyCertainAttributes: function (obj, attributes) {
        var attr, result = {};
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                if (attributes.indexOf(attr) > -1) {
                    result[attr] = JSON.parse(obj[attr]);
                }
                else {
                    result[attr] = obj[attr];
                }
            }
        }
        return result;
    },
    newElement: function (Constructor) {
        return function (e) {
            return new Constructor(e);
        };
    },
    arraySubtract: function (original, subtractor) {
        var i, result = [];
        for (i = 0; i < original.length; i += 1) {
            if (subtractor.indexOf(original[i]) === -1) {
                result.push(original[i]);
            }
        }
        return result;
    },
    arrayUnique: function (arr) {
        var hashMap = {}, i, name, l = arr.length, result = [];
        for (i = 0; i < l; i += 1) {
            if (arr[i]) {
                hashMap[arr[i]] = arr[i];
            }
        }
        for (name in hashMap) {
            if (hashMap.hasOwnProperty(name)) {
                result.push(hashMap[name]);
            }
        }
        return result;
    },
    arrayEqual: function (arr1, arr2) {
        return arr1.length === arr2.length && helper.arraySubtract(arr1, arr2).length === 0 && helper.arraySubtract(arr2, arr1).length === 0;
    },
    deepEqual: function (obj1, obj2) {
        if (obj1 === obj2) {
            return true;
        }
        else if (typeof obj1 === "object" && typeof obj2 === "object") {
            var keys1 = Object.keys(obj1), keys2 = Object.keys(obj2);
            if (!helper.arrayEqual(keys1, keys2)) {
                return false;
            }
            var i, cur;
            for (i = 0; i < keys1.length; i += 1) {
                cur = keys1[i];
                if (!helper.deepEqual(obj1[cur], obj2[cur])) {
                    return false;
                }
            }
        }
        else {
            return false;
        }
        return true;
    },
    deepCopyArray: function (arr, depth) {
        var result = [], i;
        for (i = 0; i < arr.length; i += 1) {
            result[i] = helper.deepCopyObj(arr[i], depth - 1);
        }
        return result;
    },
    deepCopyObj: function (obj, depth) {
        if (typeof obj !== "object") {
            return obj;
        }
        if (depth < 0) {
            throw new Error("too deep");
        }
        if (obj instanceof Array) {
            return helper.deepCopyArray(obj, depth);
        }
        var attr, value, result = {};
        // Extend the base object
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                value = obj[attr];
                result[attr] = helper.deepCopyObj(value, depth - 1);
            }
        }
        return result;
    },
    extend: function (target, extender, depth, removeEmpty) {
        function shouldDeleteAttribute(value) {
            if (!removeEmpty) {
                return false;
            }
            return value === "" || value === null || (typeof value === "object" && Object.keys(value).length === 0);
        }
        if (!target) {
            return extender;
        }
        if (depth < 0) {
            throw new Error("too deep");
        }
        var attr, given, added;
        // Extend the base object
        for (attr in extender) {
            if (extender.hasOwnProperty(attr)) {
                target[attr] = target[attr] || {};
                given = target[attr];
                added = extender[attr];
                if (added !== undefined) {
                    if (typeof given === "object" && typeof added === "object" && !(added instanceof Array)) {
                        helper.extend(given, added, depth - 1, removeEmpty);
                    }
                    else {
                        target[attr] = added;
                    }
                    if (shouldDeleteAttribute(target[attr])) {
                        delete target[attr];
                    }
                }
            }
        }
        return target;
    },
    extendNoOverwrite: function (target, extender) {
        helper.objectEach(extender, function (key, value) {
            if (typeof target[key] === "undefined") {
                target[key] = helper.deepCopyObj(value);
            }
            else if (typeof target[key] === "object") {
                helper.extendNoOverwrite(target[key], value);
            }
        });
    },
    parseDecimal: function (e) {
        return parseInt(e, 10);
    },
    assert: function (bool) {
        if (!bool) {
            throw new Error("assertion not met!");
        }
    },
    qm: function (attr) {
        return function (obj) {
            return obj[attr];
        };
    },
    nop: function () { },
    objectJoin: function (obj1, obj2) {
        var result = {};
        helper.objectEach(obj1, function (key, value) {
            if (obj2.hasOwnProperty(key) && value !== obj2[key]) {
                if (typeof value === "object" && typeof obj2[key] === "object") {
                    result[key] = helper.objectJoin(value, obj2[key]);
                }
                else {
                    throw new Error("attribute set in both!");
                }
            }
            else {
                result[key] = value;
            }
        });
        helper.objectEach(obj2, function (key, value) {
            if (!obj1.hasOwnProperty(key)) {
                result[key] = value;
            }
        });
        return result;
    },
    objectEach: function (obj, cb, thisArg) {
        var attr;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                cb.call(thisArg, attr, obj[attr]);
            }
        }
    },
    copyObj: function (obj) {
        var newObj = {}, attr;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                newObj[attr] = obj[attr];
            }
        }
        return newObj;
    },
    containsOr: function (value) {
        var i;
        for (i = 1; i < arguments.length; i += 1) {
            if (arguments[i].indexOf(value) > -1) {
                return true;
            }
        }
        return false;
    },
    arrayToObject: function (arr, func) {
        var i, res = {};
        for (i = 0; i < arr.length; i += 1) {
            res[func(arr[i], i)] = arr[i];
        }
        return res;
    },
    removeArray: function (arr, val) {
        if (!arr) {
            return [];
        }
        var ax;
        while ((ax = arr.indexOf(val)) !== -1) {
            arr.splice(ax, 1);
        }
        return arr;
    },
    callEach: function (listener, args, returnFunction) {
        if (returnFunction === void 0) { returnFunction = function () { }; }
        var result;
        listener.forEach(function (theListener) {
            try {
                var currentResult = theListener.apply(null, args);
                if (result) {
                    result = returnFunction(result, currentResult);
                }
                else {
                    result = currentResult;
                }
            }
            catch (e) {
                console.log(e);
            }
        });
        return result;
    },
    objectMap: function (obj, func, thisArg) {
        var attr, res = {}, result;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                result = func.call(thisArg, obj[attr], attr);
                if (result) {
                    res[attr] = result;
                }
            }
        }
        return res;
    },
    setAll: function (obj, value) {
        var attr;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                if (typeof obj[attr] === "object") {
                    helper.setAll(obj, value);
                }
                else {
                    obj[attr] = value;
                }
            }
        }
    },
    deepGet: function (obj, key) {
        var i;
        var cur = obj;
        if (typeof key === "string") {
            key = [key];
        }
        if (!cur) {
            return;
        }
        for (i = 0; i < key.length; i += 1) {
            if (cur[key[i]]) {
                cur = cur[key[i]];
            }
            else {
                return;
            }
        }
        return cur;
    },
    deepSet: function (obj, key, value) {
        var toSet = key.pop();
        var branch = helper.deepGet(obj, key);
        if (branch) {
            branch[toSet] = value;
        }
        else {
            return false;
        }
    },
    toUrl: function (file) {
        var url;
        if (file.localURL) {
            return file.localURL;
        }
        if (typeof URL !== "undefined") {
            url = URL.createObjectURL(file);
        }
        else if (typeof webkitURL !== "undefined") {
            url = webkitURL.createObjectURL(file);
        }
        return url;
    },
    deepSetCreate: function (obj, keys, value) {
        var changed = false, cur = obj;
        keys.forEach(function (key, index) {
            if (index + 1 < keys.length) {
                if (!cur[key]) {
                    cur[key] = {};
                }
                cur = cur[key];
            }
            else if (cur[key] !== value) {
                cur[key] = helper.deepCopyObj(value);
                changed = true;
            }
        });
        return changed;
    },
    validateObjects: function validateObjectsF(reference, data, noValueCheck) {
        var key;
        for (key in data) {
            if (data.hasOwnProperty(key)) {
                if (!reference[key]) {
                    return false;
                }
                if (!noValueCheck) {
                    if (typeof reference[key] === "object") {
                        if (!helper.validateObjects(reference[key], data[key])) {
                            return false;
                        }
                    }
                    else if (typeof reference[key] === "function") {
                        if (!reference[key](data[key])) {
                            return false;
                        }
                    }
                    else if (reference[key] !== true) {
                        return false;
                    }
                }
            }
        }
        return true;
    },
    /** chars for a sid */
    codeChars: ["Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Y", "X", "C", "V", "B", "N", "M", "q", "w", "e", "r", "t", "z", "u", "i", "o", "p", "a", "s", "d", "f", "g", "h", "j", "k", "l", "y", "x", "c", "v", "b", "n", "m", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
    /** get a file names extension */
    getExtension: function (filename) {
        var i = filename.lastIndexOf(".");
        return (i < 0) ? "" : filename.substr(i);
    },
    /** get a filenames name */
    getName: function (filename) {
        var i = filename.lastIndexOf(".");
        return (i < 0) ? filename : filename.substr(0, i);
    },
    /** just a function which moves on in step */
    passFunction: function () {
        this.apply(null, arguments);
    },
    /** order a certain ass-array correctly
    * @param object object to sort
    * @param order correct order (normal array)
    * @param getFunction which func to call on objects to get their "value"
    * @return ordered object
    */
    orderCorrectly: function (object, order, getFunction) {
        var i, j, results = [];
        for (i = 0; i < order.length; i += 1) {
            for (j = 0; j < object.length; j += 1) {
                if (object[j][getFunction]() === order[i]) {
                    results.push(object[j]);
                    object.splice(j, 1);
                    break;
                }
            }
        }
        return results;
    },
    isUUID: function (uuid) {
        return helper.isString(uuid) && uuid.match(uuidRegex);
    },
    /** is data an integer?
    * @param data value to check for int value
    * @return bool is integer?
    */
    isInt: function (data) {
        var y = parseInt(data, 10);
        if (isNaN(y)) {
            return false;
        }
        return y.toString() === data.toString();
    },
    /** is data an id?*/
    isID: function (data) {
        if (helper.isInt(data)) {
            data = parseInt(data, 10);
            return (data > 0);
        }
        return false;
    },
    isRealID: function (data) {
        if (typeof data !== "string") {
            return false;
        }
        var parts = data.split(":");
        if (parts.length !== 2) {
            return false;
        }
        if (parts[1].length !== 64) {
            return false;
        }
        if (!helper.isNickname(parts[0]) && !helper.isMail(parts[0])) {
            return false;
        }
        return true;
    },
    /** is data a valid nickname? */
    isNickname: function (data) {
        return (helper.isString(data) && data.length !== 0 && !!data.match(/^[A-z][A-z0-9]*$/));
    },
    /** is data an e-mail? */
    isMail: function (data) {
        var regex = /^.+@.+$/;
        return (helper.isString(data) && data.length !== 0 && regex.test(data));
    },
    /** is data a session Key (hex value with certain length) */
    isSessionKey: function (data) {
        return (helper.isset(data) && (data.length === 64 || data.length === 32) && helper.isHex(data));
    },
    isPassword: function (data) {
        return (helper.isHex(data) && data.length === 64);
    },
    isCurve: function (data) {
        if (data === "c256" || data === "256") {
            return true;
        }
        //TODO!
        return false;
    },
    isBase64: function (data) {
        return (helper.isset(data) && typeof data === "string" && !!data.match(/^[A-Za-z0-9\+\/=]|=[^=]|={3,}$/));
    },
    isSignature: function (data) {
        return helper.isHex(data);
    },
    isHex: function (data) {
        return (helper.isset(data) && typeof data === "string" && !!data.match(/^[A-Fa-f0-9]*$/));
    },
    /** typeof val == object? */
    isObject: function (val) {
        return (typeof val === "object");
    },
    /** is val set (not null/undefined) */
    isString: function (val) {
        return (val !== undefined && val !== null && typeof val === "string");
    },
    /** is val set (not null/undefined) */
    isset: function (val) {
        return (val !== undefined && val !== null);
    },
    /** checks if an array is set and attributes in that array are set.
    * @param arrayName the array to check
    * @param other attributes to check for
    * checks if arrayName[1][2][3][4]... is set where 1-inf are the given attributes.
    * helper function
    * @author Nilos
    */
    arraySet: function (arrayName) {
        var i = 1;
        var memory;
        if (helper.isset(arrayName)) {
            memory = arrayName;
        }
        else {
            return false;
        }
        for (i = 1; i < arguments.length; i += 1) {
            if (helper.isset(memory[arguments[i]])) {
                memory = memory[arguments[i]];
            }
            else {
                return false;
            }
        }
        return true;
    },
    nT: function (cb) {
        var nT = function nTf() {
            var args = arguments;
            if (typeof process !== "undefined") {
                process.nextTick(function () {
                    cb.apply(this, args);
                });
            }
            else {
                cb.apply(this, args);
            }
        };
        return nT;
    },
    /** step function
    * throws given errors
    * passes on all other stuff to given function
    */
    sF: function (cb) {
        var mysf = function sfFunction(err) {
            if (err) {
                console.log(err.stack);
                this(err);
                return;
            }
            var args = []; // empty array
            var i;
            // copy all other arguments we want to "pass through"
            for (i = 1; i < arguments.length; i += 1) {
                args.push(arguments[i]);
            }
            return cb.apply(this, args);
        };
        mysf.getRealFunction = function () {
            return cb;
        };
        return mysf;
    },
    /** handle Error function for step
    * passes given errors to callback but only those!
    * throws other errors.
    */
    hE: function (cb, errors) {
        return function (err) {
            if (err) {
                console.log(err);
                var passToNext = false;
                if (errors instanceof Array) {
                    var i;
                    for (i = 0; i < errors.length; i += 1) {
                        if (err instanceof errors[i]) {
                            passToNext = true;
                        }
                    }
                }
                else {
                    passToNext = err instanceof errors;
                }
                if (!passToNext) {
                    this(err);
                    return;
                }
            }
            return cb.apply(this, arguments);
        };
    },
    emptyUnion: function (arr1, arr2) {
        return helper.arraySubtract(arr1, arr2).length === arr1.length && helper.arraySubtract(arr2, arr1).length === arr2.length;
    },
    /** is needle in haystack? */
    inArray: function (haystack, needle) {
        var i = 0;
        for (i = 0; i < haystack.length; i += 1) {
            if (haystack[i] === needle) {
                return true;
            }
        }
        return false;
    },
    firstCapital: function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (helper);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac"), __webpack_require__("pBGv")))

/***/ }),

/***/ "SLbN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

function newPostDirective() {
	return {
		restrict: "A",
		replace: false,
		transclude: false,
		link: function link($scope, element) {
			element.on("click", "a,button", function () {
				$scope.closeSidebar();
				$scope.$applyAsync();
			});
		}
	};
}

directivesModule.directive("closeSidebar", newPostDirective);

/***/ }),

/***/ "Sef5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($injector, scope) {
	scope.selectResult = function (result) {
		scope.hide();

		scope.callback({ selected: result });
	};
};

/***/ }),

/***/ "SiYL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");


var afterHooks = [];
var Observer = /** @class */ (function () {
    function Observer() {
        this._listeners = {};
        this._listenersOnce = {};
    }
    Observer.addAfterHook = function (listener) {
        afterHooks.push(listener);
    };
    ;
    Observer.prototype.listenOnce = function (fn, type) {
        type = type || "any";
        if (typeof this._listenersOnce[type] === "undefined") {
            this._listenersOnce[type] = [];
        }
        this._listenersOnce[type].push(fn);
    };
    Observer.prototype.listenPromise = function (type) {
        var that = this;
        return new __WEBPACK_IMPORTED_MODULE_0_bluebird__(function (resolve) {
            that.listenOnce(resolve, type);
        });
    };
    Observer.prototype.listen = function (fn, type) {
        type = type || "any";
        if (typeof this._listeners[type] === "undefined") {
            this._listeners[type] = [];
        }
        this._listeners[type].push(fn);
    };
    Observer.prototype.notify = function (data, type, returnF) {
        type = type || "any";
        if (!returnF) {
            returnF = function () { };
        }
        var listeners = this._listeners[type] || [];
        var listenersOnce = this._listenersOnce[type] || [];
        var subscribers = (listeners).concat(listenersOnce);
        this._listenersOnce[type] = [];
        var result = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].callEach(subscribers, [data], returnF);
        if (type !== "any") {
            result = returnF(this.notify(data), result);
        }
        __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].callEach(afterHooks);
        return result;
    };
    Observer.extend = function (obj) {
        var internalObserver = new Observer();
        obj.notify = internalObserver.notify.bind(internalObserver);
        obj.listenOnce = internalObserver.listenOnce.bind(internalObserver);
        obj.listenPromise = internalObserver.listenPromise.bind(internalObserver);
        obj.listen = internalObserver.listen.bind(internalObserver);
    };
    return Observer;
}());
/* harmony default export */ __webpack_exports__["default"] = (Observer);
var extend = function (obj) {
    Observer.extend(obj);
};


/***/ }),

/***/ "T6de":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("Reu1");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function personDirective() {
	return {
		transclude: true,
		scope: {
			userData: "=user"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true
	};
}

directivesModule.directive("person", personDirective);

/***/ }),

/***/ "TTsU":
/***/ (function(module, exports) {

var path = 'directives/voicemailPlayer.html';
var html = "<div class=voicemail> <button class=radial-progress data-ng-click=$ctrl.toggle()> <div class=\"circle circle-with-icon\"> <i class=\"fa fa-fw fa-play\" data-ng-if=!$ctrl.isPlaying()></i> <i class=\"fa fa-fw fa-pause\" data-ng-if=$ctrl.isPlaying()></i> </div> </button> <loading-progress data-get-progress=$ctrl.getProgress data-ng-if=\"$ctrl.isLoading() && !$ctrl.isLoaded()\"></loading-progress> <div class=voicemail--info> <div class=voicemail--position> <span id=position>00:00</span> / {{ $ctrl.getDuration() * 1000 | date: 'mm:ss' }} </div> <div class=voicemail--size data-ng-if=!$ctrl.isLoaded()> {{ $ctrl.getSize() }} </div> <div class=voicemail--progress data-ng-show=$ctrl.isLoaded()></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "UBvI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
directive to update href references
**/

var directivesModule = __webpack_require__("7Eh3");
var angular = __webpack_require__("aeQg");

function whispeerSref($state, $rootScope, localize) {
	return {
		restrict: "A",
		link: function link(scope, element, attrs) {
			var link = attrs.whispeerSref,
			    params,
			    stateName;

			function parseStateRef(ref) {
				var parsed;
				parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);

				if (!parsed || parsed.length !== 4) {
					throw new Error("Invalid state ref '" + ref + "'");
				}

				return {
					state: parsed[1],
					paramExpr: parsed[3]
				};
			}

			function updateHref() {
				params.locale = localize.getLanguage();

				var destination = $state.href(stateName, params);

				element.attr("href", destination);
			}

			function checkActiveState() {
				if ($state.current.name === stateName) {
					element.addClass(attrs.whispeerSrefActive);
				} else {
					element.removeClass(attrs.whispeerSrefActive);
				}
			}

			var ref = parseStateRef(link);
			stateName = ref.state;

			if (ref.paramExpr) {
				scope.$watch(ref.paramExpr, function (newValue) {
					params = newValue;
					updateHref();
				}, true);
				params = angular.copy(scope.$eval(ref.paramExpr));
			} else {
				params = {};
			}

			$rootScope.$on("localizeResourcesUpdates", updateHref);

			updateHref();

			if (attrs.whispeerSrefActive) {
				$rootScope.$on("$stateChangeSuccess", checkActiveState);
				checkActiveState();
			}
		}
	};
}

directivesModule.directive("whispeerSref", ["$state", "$rootScope", "localize", whispeerSref]);

/***/ }),

/***/ "UuKm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/services/socket.service.ts + 1 modules
var socket_service = __webpack_require__("8I7s");

// EXTERNAL MODULE: ./js/services/session.service.ts
var session_service = __webpack_require__("0kGL");

// EXTERNAL MODULE: ./js/services/error.service.ts
var error_service = __webpack_require__("EFCD");

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// EXTERNAL MODULE: ./js/asset/state.ts
var state = __webpack_require__("uJ4a");

// EXTERNAL MODULE: ./js/services/blobService.ts + 1 modules
var blobService = __webpack_require__("95Br");

// EXTERNAL MODULE: ./js/users/profile.ts
var users_profile = __webpack_require__("YX39");

// EXTERNAL MODULE: ./js/services/settings.service.ts
var settings_service = __webpack_require__("Etis");

// EXTERNAL MODULE: ./js/services/filter.service.ts
var filter_service = __webpack_require__("emzt");

// EXTERNAL MODULE: ./js/services/location.manager.ts
var location_manager = __webpack_require__("02Tt");

// EXTERNAL MODULE: ./js/services/mutableObjectLoader.ts
var mutableObjectLoader = __webpack_require__("H35O");

// EXTERNAL MODULE: ./js/services/requestKey.service.ts
var requestKey_service = __webpack_require__("eGOm");

// EXTERNAL MODULE: ./js/services/cachedObjectLoader.ts
var cachedObjectLoader = __webpack_require__("EkNv");

// EXTERNAL MODULE: ./js/asset/securedDataWithMetaData.ts
var securedDataWithMetaData = __webpack_require__("eRn5");

// CONCATENATED MODULE: ./js/users/signedKeys.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var keyStoreService = __webpack_require__("+1JK");
var SignedKeysLoader = /** @class */ (function (_super) {
    __extends(SignedKeysLoader, _super);
    function SignedKeysLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SignedKeysLoader;
}(Object(cachedObjectLoader["a" /* default */])({
    cacheName: "signedKeys",
    getID: function (_a) {
        var _signature = _a.signedKeys._signature, signKey = _a.signKey;
        return signKey + "-" + _signature;
    },
    download: function () { throw new Error("profile get by id is not implemented"); },
    load: function (_a) {
        var signedKeys = _a.signedKeys, signKey = _a.signKey;
        var securedData = securedDataWithMetaData["default"].load(undefined, signedKeys, { type: "signedKeys" });
        return securedData.verifyAsync(signKey).then(function () {
            return securedData.metaGet();
        });
    },
    restore: function (signedKeysCache) {
        var signedKeys = new securedDataWithMetaData["SecuredData"](undefined, signedKeysCache, { type: "signedKeys" }, true);
        var friends = signedKeys.metaAttr("friends");
        var crypt = signedKeys.metaAttr("crypt");
        keyStoreService.security.addEncryptionIdentifier(friends);
        keyStoreService.security.addEncryptionIdentifier(crypt);
        return signedKeys;
    }
})));


// EXTERNAL MODULE: ./js/crypto/trustManager.ts
var trustManager = __webpack_require__("1mek");

// CONCATENATED MODULE: ./js/users/user.ts
var user___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var initService = __webpack_require__("EKxj");

var user_keyStoreService = __webpack_require__("+1JK");










var friendsService = __webpack_require__("5O0x");

var RELOAD_DELAY = 10 * 1000;
var RELOAD_OWN_DELAY = 5 * 1000;
var advancedBranches = ["location", "birthday", "relationship", "education", "work", "gender", "languages"];
var advancedDefaults = {
    location: {},
    birthday: {},
    relationship: {},
    education: [],
    work: {},
    gender: {},
    languages: []
};
function applicableParts(scope, privacy, profile) {
    var result = {};
    if (privacy === undefined || profile === undefined) {
        throw new Error("dafuq");
    }
    helper["default"].objectEach(privacy, function (key, val) {
        if (profile[key]) {
            if (typeof val.encrypt !== "undefined") {
                if (!val.encrypt || val.visibility.indexOf(scope) > -1) {
                    result[key] = profile[key];
                }
            }
            else {
                result[key] = applicableParts(scope, val, profile[key]);
            }
        }
    });
    return result;
}
function applicablePublicParts(privacy, profile) {
    var result = {};
    if (privacy === undefined || profile === undefined) {
        throw new Error("dafuq");
    }
    helper["default"].objectEach(privacy, function (key, value) {
        if (profile[key]) {
            if (typeof value.encrypt !== "undefined") {
                if (!value.encrypt) {
                    result[key] = profile[key];
                }
            }
            else {
                result[key] = applicablePublicParts(value, profile[key]);
            }
        }
    });
    return result;
}
function getAllProfileTypes(privacySettings) {
    var profileTypes = [];
    advancedBranches.forEach(function (branch) {
        if (privacySettings[branch].encrypt) {
            profileTypes = profileTypes.concat(privacySettings[branch].visibility);
        }
    });
    if (privacySettings.basic.firstname.encrypt) {
        profileTypes = profileTypes.concat(privacySettings.basic.firstname.visibility);
    }
    if (privacySettings.basic.lastname.encrypt) {
        profileTypes = profileTypes.concat(privacySettings.basic.lastname.visibility);
    }
    return helper["default"].arrayUnique(profileTypes);
}
function deleteCache() {
    return bluebird["try"](function () {
        return new bluebird(function (resolve) {
            var deleteRequest = indexedDB.deleteDatabase("whispeerCache");
            deleteRequest.onerror = resolve;
            deleteRequest.onsuccess = resolve;
        });
    });
}
var user_User = /** @class */ (function () {
    function User(userData, signedKeys, profiles) {
        var _this = this;
        this.profiles = {
            private: [],
            me: null,
            public: null,
        };
        this.addFriendState = new state["default"]();
        this.ignoreFriendState = new state["default"]();
        this.data = {};
        this.update = function (_a) {
            var mutualFriends = _a.mutualFriends, mail = _a.mail, migrationState = _a.migrationState, profiles = _a.profiles;
            _this.mutualFriends = mutualFriends;
            _this.mail = mail;
            _this.migrationState = migrationState;
            _this.profiles = profiles;
            _this.data.mutualFriends = _this.mutualFriends;
            _this.setNames();
            advancedBranches.map(function (branch) {
                _this.data.advanced[branch] = _this.getAdvancedAttribute(branch);
            });
        };
        this.setNames = function () {
            var names = _this.getName();
            _this.data.name = names.name;
            _this.data.names = names;
            _this.data.basic.shortname = names.shortname;
        };
        this.isBlocked = function () {
            return settings_service["default"].isBlocked(_this.id);
        };
        this.setData = function () {
            _this.data = {
                notExisting: false,
                user: _this,
                id: _this.id,
                trustLevel: 0,
                signatureValid: true,
                fingerprint: user_keyStoreService.format.fingerPrint(_this.signKey),
                addFriendState: _this.addFriendState.data,
                ignoreFriendState: _this.ignoreFriendState.data,
                me: _this.isOwn(),
                other: !_this.isOwn(),
                online: friendsService.onlineStatus(_this.getID()) || 0,
                basic: {
                    age: "?",
                    location: "?",
                    mutualFriends: [],
                    url: "user/" + _this.nickname,
                    image: "assets/img/user.png"
                },
                advanced: {}
            };
        };
        this.attachListener = function () {
            if (_this.isOwn()) {
                _this.friendsKey = _this.signedKeys.metaAttr("friends");
            }
            else {
                friendsService.awaitLoading().then(function () {
                    if (friendsService.didOtherRequest(_this.id)) {
                        _this.friendsKey = _this.signedKeys.metaAttr("friends");
                    }
                    if (friendsService.didIRequest(_this.id)) {
                        _this.friendShipKey = friendsService.getUserFriendShipKey(_this.id);
                    }
                });
            }
            friendsService.listen(function (status) {
                _this.data.online = status;
            }, "online:" + _this.getID());
            friendsService.awaitLoading().then(function () {
                _this.data.added = friendsService.didIRequest(_this.getID());
                _this.data.isMyFriend = friendsService.areFriends(_this.getID());
                friendsService.listen(function () {
                    _this.data.added = friendsService.didIRequest(_this.getID());
                    _this.data.isMyFriend = friendsService.areFriends(_this.getID());
                });
            });
            settings_service["default"].listen(function () { return _this.setNames(); }, "updated");
        };
        this.generateNewFriendsKey = function () {
            var newFriendsKey;
            return bluebird["try"](function () {
                if (!_this.isOwn()) {
                    throw new Error("not my own user");
                }
                //generate new key
                return user_keyStoreService.sym.generateKey(null, "friends");
            }).then(function (_newFriendsKey) {
                newFriendsKey = _newFriendsKey;
                //encrypt with all friendShipKeys
                var keys = friendsService.getAllFriendShipKeys();
                var keysPromises = keys.map(function (key) {
                    return user_keyStoreService.sym.symEncryptKey(newFriendsKey, key);
                });
                return bluebird["all"]([
                    bluebird["all"](keysPromises),
                    user_keyStoreService.sym.symEncryptKey(newFriendsKey, _this.mainKey),
                    //encrypt old friends key with new friends key
                    user_keyStoreService.sym.symEncryptKey(_this.friendsKey, newFriendsKey),
                ]);
            }).then(function () {
                //update signedKeys
                _this.signedKeys.metaSetAttr("friends", newFriendsKey);
                return _this.signedKeys.getUpdatedData(_this.signKey);
            }).then(function (updatedSignedKeys) {
                _this.friendsKey = newFriendsKey;
                return {
                    updatedSignedKeys: updatedSignedKeys,
                    newFriendsKey: newFriendsKey
                };
            });
        };
        this.setFriendShipKey = function (key) {
            if (!_this.friendShipKey) {
                _this.friendShipKey = key;
            }
        };
        /** profile management */
        // there is mainly one profile: the "me" profile, containing all data.
        // this profile is always updated when we edit the profile.
        // every other profile is a smaller part of this profile and is generated
        // after updating the "me" profile (or at other times - e.g. when settings change)
        /* gets a given profile attribute to value
        * @param attribute attribute to set
        * @param cb
        */
        this.getProfileAttribute = function (attribute) {
            if (_this.profiles.me) {
                return _this.profiles.me.getAttribute(attribute);
            }
            var profiles = _this.profiles.private.concat([_this.profiles.public]);
            var values = profiles.map(function (profile) {
                return profile.getAttribute(attribute);
            }).filter(function (value) {
                return typeof value !== "undefined" && value !== "";
            });
            if (values.length === 0) {
                return "";
            }
            values.sort(function (val1, val2) {
                if (typeof val1 === "object" && typeof val2 === "object") {
                    return Object.keys(val2).length - Object.keys(val1).length;
                }
                return 0;
            });
            return values[0];
        };
        /** uses the me profile to generate new profiles */
        this.rebuildProfiles = function () {
            var scopes, privacySettings;
            return bluebird["try"](function () {
                if (!_this.isOwn()) {
                    throw new Error("update on another user failed");
                }
                privacySettings = settings_service["default"].getBranch("privacy");
                scopes = getAllProfileTypes(privacySettings);
                return filter_service["default"].filterToKeys(scopes);
            }).then(function (keys) {
                var profile = _this.profiles.me.getFull();
                var scopeData = helper["default"].joinArraysToObject({
                    name: scopes,
                    key: keys.slice(0, keys.length - 1)
                });
                var pub = new users_profile["b" /* default */]({ content: applicablePublicParts(privacySettings, profile) }, { isPublicProfile: true });
                var pubPromise = pub.sign(_this.getSignKey());
                var privatePromises = scopeData.map(function (scope) {
                    var newProfile = new users_profile["b" /* default */]({
                        content: applicableParts(scope.name, privacySettings, profile)
                    });
                    return newProfile.signAndEncrypt(_this.getSignKey(), scope.key);
                });
                return bluebird["all"]([
                    pubPromise,
                    bluebird["all"](privatePromises)
                ]);
            }).spread(function (pub, profileData) {
                return {
                    pub: pub,
                    priv: profileData
                };
            });
        };
        this.setMail = function (newMail, cb) {
            if (newMail === _this.mail) {
                return bluebird["resolve"]().nodeify(cb);
            }
            return socket_service["default"].emit("user.mailChange", { mail: newMail }).then(function () {
                _this.mail = newMail;
            }).nodeify(cb);
        };
        /** uploads all profiles (also recreates them) */
        this.uploadChangedProfile = function (cb) {
            return bluebird["try"](function () {
                return bluebird["all"]([
                    _this.rebuildProfiles(),
                    _this.profiles.me.signAndEncrypt(_this.getSignKey(), _this.getMainKey())
                ]);
            }).spread(function (profileData, myProfile) {
                profileData.me = myProfile;
                return socket_service["default"].emit("user.profile.update", profileData);
            }).then(function () {
                _this.profiles.me.updated();
                return _this.loadBasicData();
            }).nodeify(cb);
        };
        /* sets a given profile attribute to value
        * @param attribute attribute to set
        * @param value value of the attribute
        * @param cb
        */
        this.setProfileAttribute = function (attribute, value) {
            return _this.profiles.me.setAttribute(attribute, value);
        };
        this.removeProfileAttribute = function (attribute) {
            return _this.profiles.me.removeAttribute(attribute);
        };
        this.getFingerPrint = function () {
            return user_keyStoreService.format.fingerPrint(_this.getSignKey());
        };
        this.setAdvancedProfile = function (advancedProfile, cb) {
            return bluebird["resolve"](advancedBranches).map(function (branch) {
                return _this.profiles.me.setAttribute(branch, advancedProfile[branch]);
            }).nodeify(cb);
        };
        /** end profile management */
        this.verifyFingerPrint = function (fingerPrint) {
            return bluebird["try"](function () {
                if (fingerPrint !== user_keyStoreService.format.fingerPrint(_this.getSignKey())) {
                    throw new Error("wrong code");
                }
                return trustManager["default"].verifyUser(_this);
            }).then(function () {
                _this.data.trustLevel = 2;
            });
        };
        this.createBackupKey = function () {
            var outerKey;
            return bluebird["try"](function () {
                return initService.awaitLoading();
            }).then(function () {
                return user_keyStoreService.sym.createBackupKey(_this.mainKey);
            }).then(function (backupKeyData) {
                var decryptors = backupKeyData.decryptors;
                var innerKey = backupKeyData.innerKey;
                outerKey = backupKeyData.outerKey;
                return socket_service["default"].emit("user.backupKey", {
                    innerKey: innerKey,
                    decryptors: decryptors
                });
            }).then(function (data) {
                if (data.error) {
                    throw new Error("server error");
                }
                return user_keyStoreService.format.base32(outerKey);
            });
        };
        this.getTrustLevel = function () {
            var trust = trustManager["default"].getKeyData(_this.getSignKey());
            if (trust.isOwn()) {
                return -1;
            }
            if (trust.isVerified()) {
                return 2;
            }
            if (trust.isWhispeerVerified() || trust.isNetworkVerified()) {
                return 1;
            }
            return 0;
        };
        this.changePassword = function (newPassword) {
            return bluebird["try"](function () {
                if (!_this.isOwn()) {
                    throw new Error("not my own user");
                }
                var ownKeys = { main: _this.mainKey, sign: _this.signKey };
                return bluebird["all"]([
                    user_keyStoreService.security.makePWVerifiable(ownKeys, newPassword),
                    user_keyStoreService.random.hex(16),
                    user_keyStoreService.sym.pwEncryptKey(_this.mainKey, newPassword),
                    deleteCache(),
                ]);
            }).spread(function (signedOwnKeys, salt, decryptor) {
                return socket_service["default"].emit("user.changePassword", {
                    signedOwnKeys: signedOwnKeys,
                    password: {
                        salt: salt,
                        hash: user_keyStoreService.hash.hashPW(newPassword, salt),
                    },
                    decryptor: decryptor
                });
            }).then(function () {
                session_service["default"].setPassword(newPassword);
            });
        };
        this.loadFullData = function () {
            return _this.loadBasicData();
        };
        this.getFriends = function (cb) {
            return friendsService.getUserFriends(_this.getID(), cb);
        };
        this.loadImage = function () {
            var blob = _this.getProfileAttribute("imageBlob");
            if (!blob) {
                _this.data.basic.image = "assets/img/user.png";
                return;
            }
            return blobService["default"].getBlobUrl(blob.blobid, blob.type || "image/png", 0).then(function (url) {
                return Object(location_manager["isIOS"])() ?
                    url.replace("file://", "") : url;
            }).then(function (imageUrl) {
                _this.data.basic.image = imageUrl;
            }).catch(function (e) { return error_service["default"].criticalError(e); });
        };
        this.loadBasicData = function () {
            _this.data.trustLevel = _this.getTrustLevel();
            _this.loadImage();
            return bluebird["resolve"]();
        };
        this.setMigrationState = function (migrationState, cb) {
            return socket_service["default"].emit("user.setMigrationState", {
                migrationState: migrationState
            }).nodeify(cb);
        };
        this.getMigrationState = function () {
            return bluebird["resolve"](_this.migrationState);
        };
        this.isOwn = function () {
            return _this.getID() === session_service["default"].getUserID();
        };
        this.getNickOrMail = function () {
            return _this.nickname || _this.mail;
        };
        this.getMainKey = function () {
            return _this.mainKey;
        };
        this.getSignKey = function () {
            return _this.signKey;
        };
        this.getCryptKey = function () {
            return _this.cryptKey;
        };
        this.getFriendShipKey = function () {
            return _this.friendShipKey;
        };
        this.getContactKey = function () {
            return _this.friendShipKey || _this.cryptKey;
        };
        this.getFriendsKey = function () {
            return _this.friendsKey;
        };
        this.getID = function () {
            return parseInt(_this.id, 10);
        };
        this.getNickname = function () {
            return _this.nickname;
        };
        this.getMail = function () {
            return _this.mail;
        };
        this.getSearchName = function () {
            var basic = _this.getProfileAttribute("basic") || {};
            var nickname = _this.getNickname();
            var searchNames = [nickname];
            if (basic.firstname) {
                searchNames.push(basic.firstname);
            }
            if (basic.lastname) {
                searchNames.push(basic.lastname);
            }
            return searchNames.join(" ").toLowerCase();
        };
        this.getLongName = function () {
            var basic = _this.getProfileAttribute("basic") || {};
            var nickname = _this.getNickname();
            if (basic.firstname && basic.lastname) {
                return basic.firstname + " " + basic.lastname;
            }
            if (basic.firstname || basic.lastname) {
                return basic.firstname || basic.lastname;
            }
            return nickname;
        };
        this.getName = function () {
            var basic = _this.getProfileAttribute("basic") || {};
            var nickname = _this.getNickname();
            if (_this.isBlocked()) {
                return {
                    name: nickname,
                    originalName: _this.getLongName(),
                    searchName: _this.getSearchName(),
                    firstname: "",
                    lastname: "",
                    nickname: nickname,
                    shortname: nickname,
                };
            }
            return {
                name: _this.getLongName(),
                searchName: _this.getSearchName(),
                firstname: basic.firstname || "",
                lastname: basic.lastname || "",
                nickname: nickname,
                shortname: basic.firstname || basic.lastname || nickname
            };
        };
        this.ignoreFriendShip = function () {
            _this.ignoreFriendState.pending();
            if (!_this.isOwn()) {
                friendsService.ignoreFriendShip(_this.getID(), error_service["default"].failOnError(_this.ignoreFriendState));
            }
            else {
                _this.ignoreFriendState.failed();
            }
        };
        this.acceptFriendShip = function () {
            _this.addFriendState.pending();
            if (!_this.isOwn()) {
                friendsService.acceptFriendShip(_this.getID(), error_service["default"].failOnError(_this.addFriendState));
            }
            else {
                _this.addFriendState.failed();
            }
        };
        this.isNotExistingUser = function () {
            return false;
        };
        this.removeAsFriend = function () {
            if (!_this.isOwn()) {
                friendsService.removeFriend(_this.getID(), error_service["default"].criticalError);
            }
            else {
                _this.addFriendState.failed();
            }
        };
        this.addAsFriend = function () {
            _this.addFriendState.pending();
            if (!_this.isOwn()) {
                friendsService.friendship(_this.getID(), error_service["default"].failOnError(_this.addFriendState));
            }
            else {
                _this.addFriendState.failed();
            }
        };
        this.id = helper["default"].parseDecimal(userData.id);
        this.mainKey = userData.mainKey;
        this.signedKeys = signedKeys;
        //all keys we get from the signedKeys object:
        this.signKey = this.signedKeys.metaAttr("sign");
        this.cryptKey = this.signedKeys.metaAttr("crypt");
        this.nickname = userData.nickname;
        var mutualFriends = userData.mutualFriends, mail = userData.mail, _a = userData.migrationState, migrationState = _a === void 0 ? 0 : _a;
        this.setData();
        this.update({ mutualFriends: mutualFriends, mail: mail, migrationState: migrationState, profiles: profiles });
        this.attachListener();
    }
    User.prototype.getAdvancedAttribute = function (branch) {
        var result = this.getProfileAttribute(branch);
        if (branch === "gender" && typeof result === "string") {
            return helper["default"].deepCopyObj({ gender: result });
        }
        return helper["default"].deepCopyObj(result || advancedDefaults[branch], 3);
    };
    return User;
}());
function loadProfileInfo(profileInfo, signKey, isPublic) {
    if (isPublic === void 0) { isPublic = false; }
    return users_profile["a" /* ProfileLoader */].load(__assign({}, profileInfo, { isPublic: isPublic,
        signKey: signKey }));
}
var getProfiles = function (userData, signKey, isMe) {
    return bluebird["try"](function () {
        return __awaiter(this, void 0, void 0, function () {
            var profiles, _a, priv, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        profiles = {
                            public: null,
                            private: null,
                            me: null
                        };
                        if (!!isMe) return [3 /*break*/, 5];
                        if (!userData.profile.pub) return [3 /*break*/, 2];
                        userData.profile.pub.profileid = userData.profile.pub.profileid || userData.id;
                        _a = profiles;
                        return [4 /*yield*/, loadProfileInfo(userData.profile.pub, signKey, true)];
                    case 1:
                        _a.public = _d.sent();
                        _d.label = 2;
                    case 2:
                        profiles.private = [];
                        if (!(userData.profile.priv && userData.profile.priv instanceof Array)) return [3 /*break*/, 4];
                        priv = userData.profile.priv;
                        _b = profiles;
                        return [4 /*yield*/, bluebird["resolve"](priv)
                                .map(function (profile) { return loadProfileInfo(profile, signKey); })];
                    case 3:
                        _b.private = _d.sent();
                        _d.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        _c = profiles;
                        return [4 /*yield*/, loadProfileInfo(userData.profile.me, signKey)];
                    case 6:
                        _c.me = _d.sent();
                        _d.label = 7;
                    case 7: return [2 /*return*/, profiles];
                }
            });
        });
    });
};
var deletedUserName = "Deleted user";
var user_NotExistingUser = /** @class */ (function () {
    function NotExistingUser(identifier) {
        this.isBlocked = function () { return false; };
        this.getID = function () { return -1; };
        this.generateNewFriendsKey = function () { return bluebird["reject"](new Error("not my own user")); };
        this.isNotExistingUser = function () { return true; };
        this.loadBasicData = function () { return bluebird["resolve"](); };
        this.loadFullData = function () { return bluebird["resolve"](); };
        this.isOwn = function () { return false; };
        this.rebuildProfiles = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getFingerPrint = function () { throw new Error("not implemented for NotExistingUser"); };
        this.createBackupKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getTrustLevel = function () { throw new Error("not implemented for NotExistingUser"); };
        this.loadImage = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getMigrationState = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getNickOrMail = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getMainKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getSignKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getCryptKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getFriendShipKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getContactKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getFriendsKey = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getNickname = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getMail = function () { throw new Error("not implemented for NotExistingUser"); };
        this.getName = function () { throw new Error("not implemented for NotExistingUser"); };
        this.ignoreFriendShip = function () { throw new Error("not implemented for NotExistingUser"); };
        this.acceptFriendShip = function () { throw new Error("not implemented for NotExistingUser"); };
        this.removeAsFriend = function () { throw new Error("not implemented for NotExistingUser"); };
        this.addAsFriend = function () { throw new Error("not implemented for NotExistingUser"); };
        this.changePassword = function () { throw new Error("not implemented for NotExistingUser"); };
        this.data = {
            trustLevel: -1,
            notExisting: true,
            basic: {
                shortname: deletedUserName,
                image: "assets/img/user.png"
            },
            name: deletedUserName,
            user: this
        };
        if (typeof identifier === "number") {
            this.data.id = identifier;
        }
    }
    return NotExistingUser;
}());

var improveKeyAccess = function (keys, identifier) {
    return UserLoader.get(session_service["default"].getUserID()).then(function (ownUser) {
        if (!ownUser || ownUser.getNickOrMail() !== identifier) {
            throw new Error("user changed so no improvement update!");
        }
        return bluebird["all"](keys.map(function (keyID) {
            return user_keyStoreService.sym.symEncryptKey(keyID, ownUser.getMainKey());
        }));
    }).then(function () {
        return socket_service["default"].emit("key.addFasterDecryptors", {
            keys: user_keyStoreService.upload.getDecryptors(keys)
        });
    });
};
var improvementListener = function (identifier) {
    var improve = [];
    user_keyStoreService.addImprovementListener(function (rid) {
        improve.push(rid);
        if (improve.length === 1) {
            bluebird["delay"](5000).then(function () {
                var keys = improve;
                improve = [];
                return improveKeyAccess(keys, identifier);
            }).catch(error_service["default"].criticalError);
        }
    });
};
function enhanceOwnUser(userData) {
    var nickname = userData.nickname;
    var mainKey = userData.mainKey;
    var signKey = userData.signedKeys.sign;
    user_keyStoreService.setKeyGenIdentifier(nickname);
    improvementListener(nickname);
    user_keyStoreService.sym.registerMainKey(mainKey);
    user_keyStoreService.security.verifyWithPW(userData.signedOwnKeys, {
        main: mainKey,
        sign: signKey
    });
    user_keyStoreService.security.addEncryptionIdentifier(mainKey);
    user_keyStoreService.security.addEncryptionIdentifier(signKey);
    trustManager["default"].setOwnSignKey(signKey);
    bluebird["all"]([
        requestKey_service["a" /* default */].getKey(signKey),
        requestKey_service["a" /* default */].getKey(mainKey)
    ]).then(function () {
        requestKey_service["a" /* default */].cacheKey(signKey, "user-sign-" + nickname, requestKey_service["a" /* default */].MAXCACHETIME);
        requestKey_service["a" /* default */].cacheKey(mainKey, "user-main-" + nickname, requestKey_service["a" /* default */].MAXCACHETIME);
    });
}
var loadUserInfo = function (identifiers) {
    return socket_service["default"].definitlyEmit("user.getMultiple", { identifiers: identifiers })
        .then(function (_a) {
        var users = _a.users;
        return users;
    });
};
var getUserInfoDelayed = helper["default"].delayMultiplePromise(bluebird, 1000, loadUserInfo, 20);
var getUserInfoNow = helper["default"].delayMultiplePromise(bluebird, 50, loadUserInfo, 10);
var profilesLoaded = function (signKey, profiles) {
    var pub = profiles.pub;
    var priv = profiles.priv || [];
    return users_profile["a" /* ProfileLoader */].isLoaded(signKey + "-" + pub.meta._signature) && priv.reduce(function (prev, privProfile) {
        return prev && users_profile["a" /* ProfileLoader */].isLoaded(signKey + "-" + privProfile.meta._signature);
    }, true);
};
var isSameInfo = function (userData, previousInstance) {
    if (previousInstance instanceof user_NotExistingUser || userData.userNotExisting) {
        return false;
    }
    var userID = previousInstance.getID();
    var isMe = session_service["default"].isOwnUserID(userID);
    if (isMe) {
        return false;
    }
    var signKey = previousInstance.getSignKey();
    var signedKeys = userData.signedKeys, profile = userData.profile, rest = __rest(userData, ["signedKeys", "profile"]);
    if (!SignedKeysLoader.isLoaded(signKey + "-" + signedKeys._signature)) {
        return false;
    }
    if (!profilesLoaded(signKey, profile)) {
        return false;
    }
    if (Object.keys(rest).length !== 3) {
        return false;
    }
    return rest.id === previousInstance.id &&
        rest.nickname === previousInstance.nickname &&
        helper["default"].deepEqual(rest.mutualFriends, previousInstance.mutualFriends);
};
var UserLoader = /** @class */ (function (_super) {
    user___extends(UserLoader, _super);
    function UserLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserLoader;
}(Object(mutableObjectLoader["c" /* default */])({
    download: function (id, previousInstance) {
        return socket_service["default"].awaitConnection()
            .then(function () { return previousInstance ? getUserInfoDelayed(id) : getUserInfoNow(id); });
    },
    load: function (userData, previousInstance) {
        if (previousInstance && isSameInfo(userData, previousInstance)) {
            return bluebird["resolve"](mutableObjectLoader["a" /* SYMBOL_UNCHANGED */]);
        }
        return bluebird["resolve"](userData);
    },
    restore: function (userData, previousInstance) {
        if (previousInstance) {
            if (previousInstance instanceof user_NotExistingUser && userData.userNotExisting) {
                return previousInstance;
            }
            if (previousInstance instanceof user_User && !userData.userNotExisting) {
                return bluebird["try"](function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var userID, isMe, signKey, mutualFriends, mail, migrationState, profiles;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    userID = previousInstance.getID();
                                    isMe = session_service["default"].isOwnUserID(userID);
                                    signKey = previousInstance.getSignKey();
                                    mutualFriends = userData.mutualFriends, mail = userData.mail, migrationState = userData.migrationState;
                                    return [4 /*yield*/, getProfiles(userData, signKey, isMe)];
                                case 1:
                                    profiles = _a.sent();
                                    previousInstance.update({ mutualFriends: mutualFriends, mail: mail, migrationState: migrationState, profiles: profiles });
                                    return [2 /*return*/, previousInstance];
                            }
                        });
                    });
                });
            }
            console.warn("previous instance is not a user but current data is. Reloading");
            Object(location_manager["reloadApp"])();
            return previousInstance;
        }
        return bluebird["try"](function () {
            return __awaiter(this, void 0, void 0, function () {
                var userID, isMe, signKey, nickname, signedKeys, profiles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (userData.userNotExisting) {
                                return [2 /*return*/, new user_NotExistingUser(userData.identifier)];
                            }
                            if (userData.error === true) {
                                return [2 /*return*/, new user_NotExistingUser()];
                            }
                            userID = helper["default"].parseDecimal(userData.id);
                            isMe = session_service["default"].isOwnUserID(userID);
                            if (isMe) {
                                enhanceOwnUser(userData);
                            }
                            signKey = userData.signedKeys.sign;
                            nickname = userData.nickname;
                            if (!isMe) {
                                trustManager["default"].addNewUsers({ key: signKey, userid: userID, nickname: nickname });
                            }
                            return [4 /*yield*/, SignedKeysLoader.load({ signedKeys: userData.signedKeys, signKey: signKey })];
                        case 1:
                            signedKeys = _a.sent();
                            return [4 /*yield*/, getProfiles(userData, signKey, isMe)];
                        case 2:
                            profiles = _a.sent();
                            return [2 /*return*/, new user_User(userData, signedKeys, profiles)];
                    }
                });
            });
        });
    },
    shouldUpdate: function (event, instance) {
        if (session_service["default"].isOwnUserID(instance.getID())) {
            return bluebird["delay"](RELOAD_OWN_DELAY).thenReturn(true);
        }
        if (event === mutableObjectLoader["b" /* UpdateEvent */].wake) {
            return bluebird["delay"](RELOAD_DELAY).thenReturn(true);
        }
        return bluebird["resolve"](false);
    },
    getID: function (userData) { return userData.id.toString(); },
    cacheName: "user"
})));
/* harmony default export */ var users_user = (UserLoader);

// CONCATENATED MODULE: ./js/users/userService.ts




var sjcl = __webpack_require__("kHLR");
var userService_initService = __webpack_require__("EKxj");
function loadUser(identifier) {
    return users_user.get(identifier);
}
var userService = {
    /** search your friends */
    queryFriends: function (query) {
        return bluebird["try"](function () {
            return socket_service["default"].emit("user.searchFriends", {
                text: query,
                known: []
            });
        }).then(function (data) {
            return data.results;
        }).map(function (user) {
            return users_user.load(user);
        });
    },
    /** search for a user
    * @param query query string to search for
    * @param cb user objects
    */
    query: function (query, cb) {
        return userService_initService.awaitLoading().then(function () {
            return socket_service["default"].definitlyEmit("user.search", {
                text: query,
                known: []
            });
        }).then(function (data) {
            return data.results;
        }).map(function (user) {
            return users_user.load(user);
        }).nodeify(cb);
    },
    /** load a user
    * @param identifier identifier of the user (id, nickname or mail)
    * @param cb called with results
    * this function is asynchronous and returns immediatly. requests are also batched.
    */
    get: function (identifier, cb) {
        return loadUser(identifier).nodeify(cb);
    },
    /** load a user
    * @param identifiers identifier array of the users (id, nickname or mail)
    * @param cb called with results
    * this function is asynchronous and returns immediatly. requests are also batched.
    */
    getMultiple: function (identifiers, cb) {
        return bluebird["resolve"](identifiers).map(function (id) {
            return loadUser(id);
        }).nodeify(cb);
    },
    /** gets multiple users and loads their basic data.
    * @param identifiers identifier of users to load
    * @param cb called with users data.
    */
    getMultipleFormatted: function (identifiers, cb) {
        return bluebird["try"](function () {
            return userService.getMultiple(identifiers);
        }).map(function (user) {
            return user.loadBasicData().thenReturn(user);
        }).then(function (users) {
            return users.map(function (user) {
                return user.data;
            });
        }).nodeify(cb);
    },
    /** get own user. synchronous */
    getOwn: function () { return users_user.getLoaded(session_service["default"].getUserID()); },
    getOwnAsync: function () { return users_user.get(session_service["default"].getUserID()); }
};
userService_initService.registerCallback(function () {
    return users_user.get(session_service["default"].getUserID()).catch(function (e) {
        if (e instanceof sjcl.exception.corrupt) {
            alert("Password did not match. Logging out");
            session_service["default"].logout();
            return new bluebird(function () { });
        }
        return bluebird["reject"](e);
    });
});
/* harmony default export */ var users_userService = __webpack_exports__["default"] = (userService);


/***/ }),

/***/ "VRY8":
/***/ (function(module, exports) {

var path = 'directives/search.html';
var html = "<div class=\"search search--single {{addClasses}}\"> <form class=search-form> <input type=text class=\"search-query input--custom\" data-ng-class=\"{'search--activeRadius': results.length > 0 && isVisible()}\" data-i18n-attr={{inputI18nAttr}} data-ng-click=show($event) data-ng-keydown=keydown($event) data-ng-change=queryChange() data-ng-model=query data-onfocus=show()> </form> <div class=search-resultsDrop data-ng-show=isVisible() data-ng-class=\"{'search-resultsDrop--addBorder': query.length > 0}\"> <div class=search-resultsDrop-spinner data-ng-if=searching> <loadingindicator></loadingindicator> <p class=noMargin-bottom data-i18n=search.searching></p> </div> <div class=search-resultsDrop-content data-ng-include=\"'search/' + searchTemplate + 'Search.html'\"></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "VqRR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var screenSizeService = __webpack_require__("KEBJ").default;

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function mobileDirective() {
	return {
		scope: false,
		restrict: "A",
		link: function link(scope) {
			scope.mobile = screenSizeService.mobile;
			screenSizeService.listen(function (mobile) {
				scope.mobile = mobile;
			});
		}
	};
}

directivesModule.directive("mobile", [mobileDirective]);

/***/ }),

/***/ "VrXE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.startup = new Date().getTime();

window.jQuery = __webpack_require__("juYr");

__webpack_require__("ckIU");
__webpack_require__("eUia");

"use strict";

var angular = __webpack_require__("aeQg");
var app = __webpack_require__("obS/");
__webpack_require__("tFpQ");
__webpack_require__("HTZX");

angular.element(document).ready(function () {
   var $html = angular.element(document.documentElement);
   angular.bootstrap($html, [app.name], { strictDi: true });
   // Because of RequireJS we need to bootstrap the app app manually
   // and Angular Scenario runner won"t be able to communicate with our app
   // unless we explicitely mark the container as app holder
   // More info: https://groups.google.com/forum/#!msg/angular/yslVnZh9Yjk/MLi3VGXZLeMJ
   $html.addClass("ng-app");
});

/***/ }),

/***/ "WZDP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	"use strict";

	var h;

	var validations = {};

	function doValidate(ref, data) {
		if (ref) {
			var theError;
			/*amanda.validate(data, ref, function (err) {
   	theError = err;
   });*/

			return theError;
		} else {
			throw new Error("unregistered validation");
		}
	}

	var validator = {
		addAttribute: function addAttribute(name, cb) {
			// jsonSchemaValidator.addAttribute(name, cb);
		},
		register: function register(name, obj) {
			if (validations[name]) {
				throw new Error("double registered validations: " + name);
			}

			validations[name] = obj;
		},
		validate: function validate(name, data) {
			if (validations[name]) {
				var result = doValidate(validations[name], data);
				if (result) {
					console.error(result);
				}
				return result;
			} else {
				throw new Error("unregistered validation: " + name);
			}
		}
	};

	function amandaLoaded(am, helper, profileV, profileEncryptedV, postV, messageV, topicV, topicCreateV, circleV) {
		h = helper;

		validator.register("profile", profileV);
		validator.register("profileEncrypted", profileEncryptedV);
		validator.register("post", postV);
		validator.register("message", messageV);
		validator.register("topic", topicV);
		validator.register("topicCreate", topicCreateV);
		validator.register("circle", circleV);

		/**
   * EvenAttribute
   *
   * @param {string} property
   * @param {any} propertyValue
   * @param {any} attributeValue
   * @param {object} propertyAttributes
   * @param {function} callback
   */
		var hexAttribute = function hexAttribute(property, propertyValue, attributeValue, propertyAttributes, callback) {

			// If ‘even: true’
			if (attributeValue) {
				if (!h.isHex(propertyValue)) {
					this.addError();
				}
			}

			// Continue...
			return callback();
		};
	}

	var modules = [];

	modules.push(__webpack_require__("vMUg"));
	modules.push(__webpack_require__("S8e/"));
	modules.push(__webpack_require__("72mU"));
	modules.push(__webpack_require__("lCst"));
	modules.push(__webpack_require__("w2wy"));
	modules.push(__webpack_require__("DhQo"));
	modules.push(__webpack_require__("fndX"));
	modules.push(__webpack_require__("uidW"));
	modules.push(__webpack_require__("aQ1d"));

	amandaLoaded.apply(null, modules);

	module.exports = validator;
})();

/***/ }),

/***/ "WfiL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sjcl = __webpack_require__("kHLR");
var h = __webpack_require__("S8e/").default;
var errors = __webpack_require__("a86h");
var helper = {
	hash: function hash(text) {
		return helper.bits2hex(sjcl.hash.sha256.hash(text));
	},
	hashPW: function hashPW(pw, salt) {
		return helper.bits2hex(sjcl.hash.sha256.hash(pw + salt));
	},
	getCurveName: function getCurveName(curve) {
		var curcurve;
		for (curcurve in sjcl.ecc.curves) {
			if (sjcl.ecc.curves.hasOwnProperty(curcurve)) {
				if (sjcl.ecc.curves[curcurve] === curve) {
					return curcurve;
				}
			}
		}

		throw new Error("curve not existing");
	},
	getCurve: function getCurve(curveName) {
		if (typeof curveName !== "string" || curveName.substr(0, 1) !== "c") {
			curveName = "c" + curveName;
		}

		if (sjcl.ecc.curves[curveName]) {
			return sjcl.ecc.curves[curveName];
		}

		throw new Error("invalidCurve");
	},
	hex2bits: function hex2bits(t) {
		if (t instanceof Array) {
			return t;
		}

		if (h.isHex(t)) {
			return sjcl.codec.hex.toBits(t);
		}

		//TODO
		throw new errors.InvalidHexError();
	},
	bits2hex: function bits2hex(t) {
		if (typeof t === "string") {
			return t;
		}

		return sjcl.codec.hex.fromBits(t);
	},
	sjclPacket2Object: function sjclPacket2Object(decoded) {
		var result = {
			ct: helper.bits2hex(decoded.ct),
			iv: helper.bits2hex(decoded.iv)
		};

		if (decoded.salt) {
			result.salt = helper.bits2hex(decoded.salt);
		}

		return result;
	},
	Object2sjclPacket: function Object2sjclPacket(data) {
		if (typeof data.salt === "string") {
			data.salt = helper.hex2bits(data.salt);
		}

		if (typeof data.iv === "string") {
			data.iv = helper.hex2bits(data.iv);
		}

		if (typeof data.ct === "string") {
			data.ct = helper.hex2bits(data.ct);
		}

		return sjcl.json.encode(data);
	}
};

module.exports = helper;

/***/ }),

/***/ "XkYz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errorService = __webpack_require__("EFCD").errorServiceInstance;
var settingsService = __webpack_require__("Etis").default;

"use strict";
var Bluebird = __webpack_require__("fp6q");
var directivesModule = __webpack_require__("7Eh3");
var advancedsendDirective = function advancedsendDirective() {
	return {
		link: function link(scope, element, attrs) {
			Bluebird.try(function () {
				var messages = settingsService.getBranch("messages");
				function send() {
					scope.$eval(attrs.advancedsend);
					scope.$applyAsync();
				}

				element.bind("keydown keypress", function (event) {
					if (event.which === 13) {
						if (messages.sendShortCut === "ctrlEnter") {
							if (event.ctrlKey) {
								send();
								event.preventDefault();
							}
						}

						if (messages.sendShortCut === "enter") {
							if (!event.ctrlKey && !event.shiftKey) {
								send();
								event.preventDefault();
							}
						}
					}
				});
			}).catch(errorService.criticalError);
		}
	};
};

advancedsendDirective.$inject = [];

directivesModule.directive("advancedsend", advancedsendDirective);

/***/ }),

/***/ "YBg2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

function focusMeDirective($timeout) {
	return {
		scope: { trigger: "=focusMe" },
		link: function link(scope, element) {
			scope.$watch("trigger", function (value) {
				if (value === true) {
					$timeout(function () {
						element[0].focus();
					});
				}
			});
		}
	};
}

focusMeDirective.$inject = ["$timeout"];

directivesModule.directive("focusMe", focusMeDirective);

/***/ }),

/***/ "YFD0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var h = __webpack_require__("S8e/").default;
var config = __webpack_require__("b/6L");
var Observer = __webpack_require__("SiYL");
var keyStore = __webpack_require__("+1JK");
var chelper = __webpack_require__("WfiL");
var Bluebird = __webpack_require__("fp6q");
var loaded = false,
    changed = false,
    isLoaded = {};

isLoaded.promise = new Bluebird(function (resolve) {
	isLoaded.promiseResolve = resolve;
});

function dataSetToHash(signature, hash, key) {
	var data = {
		signature: chelper.bits2hex(signature),
		signatureHash: chelper.bits2hex(hash),
		key: key
	};

	return keyStore.hash.hashObjectOrValueHex(data, config.hashVersion);
}

/*
	user:  signedKeys, signedFriendList, profile
	me: circle, trustManager, settings
	message: topic, message
	post: post, comment

	noCache: friendShip, removeFriend
*/

var types = {
	me: {
		maxCount: -1,
		saveID: true
	},
	user: {
		maxCount: 500,
		saveID: true
	},
	post: {
		maxCount: 100,
		saveID: false
	}
};

var cacheTypes = {
	signatureCache: "noCache",

	signedFriendList: "user",

	circle: "me",
	trustManager: "noCache",
	settings: "noCache",

	topicUpdate: "noCache",

	post: "post",
	postPrivate: "post",

	topic: "noCache",
	message: "noCache",

	profile: "noCache",
	signedKeys: "noCache",

	comment: "noCache",
	friendShip: "noCache",
	removeFriend: "noCache"
};

var Database = function Database(type, options) {
	this._type = type;

	this._maxCount = options.maxCount;
	this._saveID = options.saveID;

	this._signatures = {};
};

Database.prototype.getType = function () {
	return this._type;
};

Database.prototype.getCacheEntry = function (id) {
	var entry = {};
	if (this._maxCount > -1) {
		entry.date = new Date().getTime();
	}

	if (this._saveID && id) {
		entry.id = id;
	}

	return entry;
};

Database.prototype.allEntries = function () {
	return this.allSignatures().map(function (signatureHash) {
		var entry = h.deepCopyObj(this.getEntry(signatureHash));
		entry.signatureHash = signatureHash;
		return entry;
	}, this);
};

Database.prototype.getEntry = function (signatureHash) {
	return this._signatures[signatureHash];
};

Database.prototype.joinEntries = function (entries) {
	entries.forEach(function (entry) {
		var signatureHash = entry.signatureHash;

		delete entry.signatureHash;

		if (!this._signatures[signatureHash]) {
			this._signatures[signatureHash] = entry;
		}
	}, this);
};

Database.prototype.deleteByID = function (id) {
	if (!this._saveID || !id) {
		return;
	}

	this.allEntries().filter(function (entry) {
		return entry.id === id;
	}).forEach(function (entry) {
		this.deleteEntry(entry.signatureHash);
	}, this);
};

Database.prototype.deleteEntry = function (signatureHash) {
	delete this._signatures[signatureHash];
};

Database.prototype.addSignature = function (signature, hash, key, id) {
	if (!h.isRealID(key) || !h.isSignature(chelper.bits2hex(signature))) {
		throw new Error("invalid input");
	}

	var sHash = dataSetToHash(signature, hash, key);

	changed = true;

	this.deleteByID(id);
	this._signatures[sHash] = this.getCacheEntry(id);

	this.cleanUp();
};

Database.prototype.hasEntry = function (signatureHash) {
	if (this._signatures[signatureHash]) {
		return true;
	}

	return false;
};

Database.prototype.hasSignature = function (signature, hash, key) {
	var sHash = dataSetToHash(signature, hash, key);
	return this.hasEntry(sHash);
};

Database.prototype.cleanUp = function () {
	if (this._maxCount === -1) {
		return;
	}

	var entries = this.allEntries();
	if (entries.length <= this._maxCount) {
		return;
	}

	console.log("Cleaning up database of type " + this._type + " (" + entries.length + ")");

	entries.sort(function (a, b) {
		return a.date - b.date;
	});

	entries.slice(0, entries.length - this._maxCount).forEach(function (entry) {
		this.deleteEntry(entry.signatureHash);
	}, this);
};

Database.prototype.allSignatures = function () {
	return Object.keys(this._signatures);
};

var allDatabases = [];
h.objectEach(types, function (name, val) {
	types[name] = new Database(name, val);
	allDatabases.push(types[name]);
});

var signatureCache = {
	awaitLoading: function awaitLoading() {
		return isLoaded.promise;
	},
	/**
  * Has the signature cache changed? (was a signature added/removed?)
  */
	isChanged: function isChanged() {
		return changed;
	},
	resetChanged: function resetChanged() {
		changed = false;
	},
	isLoaded: function isLoaded() {
		return loaded;
	},
	/**
  * Load a given signature cache
  * @param signatureCacheData signature cache data to load.
  * @param ownKey own signing key
  */
	load: function load(signatureCacheData, ownKey) {
		if (signatureCacheData.internalHashVersion !== config.hashVersion) {
			console.warn("resetting signature cache to upgrade to new hash version");
			signatureCache.initialize(ownKey);

			return;
		}

		if (signatureCacheData.me !== ownKey) {
			console.warn("not my signature cache");
			signatureCache.initialize(ownKey);

			return;
		}

		signatureCacheData.databases.forEach(function (db) {
			if (!types[db.type]) {
				return;
			}

			types[db.type].joinEntries(db.entries);
		});

		signatureCache.initialize(ownKey);
	},
	/**
  * Initialize cache
  * @param ownKey id of the own sign key
  */
	initialize: function initialize() {
		loaded = true;

		isLoaded.promiseResolve();
	},
	/**
  * Get the signed updated version of this signature cache
  */
	getUpdatedVersion: function getUpdatedVersion() {
		if (!loaded) {
			return Bluebird.reject("Signature Cache not yet loaded!");
		}

		var databases = allDatabases.map(function (db) {
			return {
				type: db.getType(),
				entries: db.allEntries()
			};
		});

		var data = {
			internalHashVersion: config.hashVersion,
			databases: databases
		};

		return Bluebird.resolve(data);
	},
	/**
  * Check if a signature is in the cache
  * @param signature the signature to check for
  * @param hash hash that was signed
  * @param key key that was used to sign the signature
  */
	isValidSignatureInCache: function isValidSignatureInCache(signature, hash, key) {
		var sHash = dataSetToHash(signature, hash, key);

		return allDatabases.filter(function (database) {
			return database.hasEntry(sHash);
		}).length > 0;
	},
	/**
  * Add a valid signature to the cache.
  * @param signature the signature to add
  * @param hash the hash that was signed by the signature
  * @param key the key used to verify the signature
  * @param type type of the signed object
  * @param (id) id of the signed object
  */
	addValidSignature: function addValidSignature(signature, hash, key, type, id) {
		if (!h.isRealID(key) || !h.isSignature(chelper.bits2hex(signature))) {
			throw new Error("invalid input");
		}

		var reducedType = cacheTypes[type];

		if (!reducedType) {
			console.warn("unknown type: " + type);
			return;
		}

		if (reducedType === "noCache") {
			return;
		}

		if (id) {
			id = type + "-" + id;
		}

		var db = types[reducedType];
		db.addSignature(signature, hash, key, id);
	}
};

Observer.extend(signatureCache);

module.exports = signatureCache;

/***/ }),

/***/ "YX39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_securedDataWithMetaData__ = __webpack_require__("eRn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_cachedObjectLoader__ = __webpack_require__("EkNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_observer__ = __webpack_require__("SiYL");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var validator = __webpack_require__("WZDP");




var PROFILE_SECUREDDATA_OPTIONS = {
    type: "profile",
    removeEmpty: true,
    encryptDepth: 1
};
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile(data, options) {
        var _this = _super.call(this) || this;
        _this.checkProfile = function () {
            var err = validator.validate("profile", _this.securedData.contentGet());
            if (err) {
                throw err;
            }
        };
        _this.getID = function () {
            if (!_this.id) {
                return;
            }
            return _this.isPublicProfile ? "public-" + _this.id : "private-" + _this.id;
        };
        _this.sign = function (signKey, cb) {
            if (!_this.isPublicProfile) {
                throw new Error("please encrypt private profiles!");
            }
            return _this.securedData.sign(signKey).then(function (signedMeta) {
                return {
                    content: _this.securedData.contentGet(),
                    meta: signedMeta
                };
            }).nodeify(cb);
        };
        _this.signAndEncrypt = function (signKey, cryptKey) {
            if (_this.isPublicProfile) {
                throw new Error("no encrypt for public profiles!");
            }
            return _this.securedData.signAndEncrypt(signKey, cryptKey);
        };
        _this.updated = function () {
            return _this.securedData.updated();
        };
        _this.changed = function () {
            return _this.securedData.isChanged();
        };
        _this.setFullProfile = function (data) {
            _this.securedData.contentSet(data);
        };
        _this.setAttribute = function (attr, value) {
            _this.securedData.contentSetAttr(attr, value);
            return __WEBPACK_IMPORTED_MODULE_2_bluebird__["resolve"]();
        };
        _this.removeAttribute = function (attr) {
            _this.securedData.contentRemoveAttr(attr);
        };
        _this.getFull = function () {
            return _this.securedData.contentGet();
        };
        _this.getAttribute = function (attrs) {
            return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["default"].deepGet(_this.securedData.contentGet(), attrs);
        };
        options = options || {};
        _this.isPublicProfile = options.isPublicProfile === true;
        _this.securedData = new __WEBPACK_IMPORTED_MODULE_1__asset_securedDataWithMetaData__["SecuredData"](data.content, data.meta, PROFILE_SECUREDDATA_OPTIONS, true);
        _this.checkProfile();
        if (data.profileid) {
            _this.id = data.profileid;
        }
        return _this;
    }
    return Profile;
}(__WEBPACK_IMPORTED_MODULE_4__asset_observer__["default"]));
/* harmony default export */ __webpack_exports__["b"] = (Profile);
var ProfileLoader = /** @class */ (function (_super) {
    __extends(ProfileLoader, _super);
    function ProfileLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProfileLoader;
}(Object(__WEBPACK_IMPORTED_MODULE_3__services_cachedObjectLoader__["a" /* default */])({
    cacheName: "profile",
    getID: function (_a) {
        var meta = _a.meta, signKey = _a.signKey;
        return signKey + "-" + meta._signature;
    },
    download: function () { throw new Error("profile get by id is not implemented"); },
    load: function (_a) {
        var content = _a.content, meta = _a.meta, isPublic = _a.isPublic, signKey = _a.signKey;
        var securedData = isPublic ?
            new __WEBPACK_IMPORTED_MODULE_1__asset_securedDataWithMetaData__["SecuredData"](content, meta, PROFILE_SECUREDDATA_OPTIONS, true) :
            __WEBPACK_IMPORTED_MODULE_1__asset_securedDataWithMetaData__["default"].load(content, meta, PROFILE_SECUREDDATA_OPTIONS);
        return __WEBPACK_IMPORTED_MODULE_2_bluebird__["all"]([
            securedData.verifyAsync(signKey),
            isPublic ? null : securedData.decrypt()
        ]).then(function () { return ({
            profile: {
                content: securedData.contentGet(),
                meta: securedData.metaGet(),
            },
            options: {
                signKey: signKey,
                isPublic: isPublic
            }
        }); });
    },
    restore: function (_a) {
        var profile = _a.profile, options = _a.options;
        return new Profile(profile, options);
    }
})));



/***/ }),

/***/ "YnzV":
/***/ (function(module, exports) {

var path = 'directives/userimage.html';
var html = "<div class=\"userimage-wrap u-circle\" data-trustlevel={{userData.trustLevel}} data-trust-hint> <img class=\"userimage-picture u-circle\" data-ng-src={{userData.basic.image}} alt={{userData.name}} /> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "YvxE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("sbg5");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function newPostDirective() {
	return {
		scope: {},
		restrict: "E",
		templateUrl: templateUrl,
		replace: false,
		transclude: false,
		controller: "ssn.inviteController"
	};
}

newPostDirective.$inject = [];

directivesModule.directive("invitebuttons", newPostDirective);

/***/ }),

/***/ "Ywdf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
var strgEnterDirective = function strgEnterDirective() {
	return {
		link: function link(scope, element, attrs) {
			element.bind("keydown keypress", function (event) {
				if (event.which === 13 && event.ctrlKey) {
					scope.$eval(attrs.strgEnter);
					scope.$applyAsync();

					event.preventDefault();
				}
			});
		}
	};
};

directivesModule.directive("strgEnter", strgEnterDirective);

/***/ }),

/***/ "Z7zX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("cA1Q");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function savebuttonDirective() {
	return {
		transclude: true,
		scope: {
			state: "=state"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true,
		link: function link(scope, iElement, iAttrs) {
			scope.successIcon = "fa-check-circle";
			scope.initIcon = "fa-check-circle";
			scope.failureIcon = "fa-times-circle";

			if (iAttrs.initicon) {
				scope.initIcon = iAttrs.initicon;
			}

			if (iAttrs.successicon) {
				scope.successIcon = iAttrs.successicon;
			}

			if (iAttrs.failureicon) {
				scope.failureIcon = iAttrs.failureicon;
			}

			if (typeof iAttrs.noiniticon !== "undefined") {
				delete scope.initIcon;
			}
		}
	};
}

directivesModule.directive("savebutton", savebuttonDirective);

/***/ }),

/***/ "ZTFq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
var autofocusDirective = function autofocusDirective() {
	return {
		link: function link(scope, elm, attr) {
			if (!attr.autofocus) {
				elm.focus();
			} else {
				scope.$watch(attr.autofocus, function (val) {
					if (val) {
						window.setTimeout(function () {
							elm.focus();
						});
					}
				});
			}
		}
	};
};

directivesModule.directive("autofocus", autofocusDirective);

/***/ }),

/***/ "ZeLu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Worker = __webpack_require__("yQ0X");

/** constructor for worker pool
*   @param Promise a promise implementation
*   @param numberOfWorkers the number of workers you want to run in parallel
*   @param optional setupMethod a function to call after the worker is created.
*   @param requireOverRide the path to require, if it can not be determined automatically.
*/
var WorkerPool = function WorkerPool(Promise, numberOfWorkers, options) {
	this._Promise = Promise;
	this._numberOfWorkers = numberOfWorkers;
	this._numberOfRunningWorkers = 0;

	this._options = options || {};

	this._queue = [];
	this._workers = [];

	this._setupMethod = this._options.setupMethod;
	this._setupDone = typeof this._setupMethod !== "function";
	this._setupRunning = false;

	this._createNewWorker();
};

WorkerPool.prototype._createNewWorker = function () {
	if (this._workers.length < this._numberOfWorkers) {
		var newWorker = new Worker(this._Promise, this._options.workerScriptOverride);
		newWorker.onFree(this._onFree.bind(this, newWorker));
		this._workers.push(newWorker);
	}
};

WorkerPool.prototype._onFree = function (worker) {
	if (this._workers.length > this._numberOfWorkers) {
		//remove from workers
		return;
	}

	if (this._setupRunning) {
		return;
	}

	if (!this._setupDone) {
		var that = this;
		this._setupRunning = true;
		this._setupMethod(worker, function () {
			that._setupRunning = false;
			that._setupDone = true;
			that._onFree(worker);
		});

		return;
	}

	this._runFromQueue();
};

WorkerPool.prototype._runFromQueue = function () {
	this._workers.forEach(function (worker) {
		if (!worker.isBusy() && this._queue.length > 0) {
			var current = this._queue.shift();

			worker.runIfFree(current.task, current.metaListener).then(current.resolve, current.reject);
		}
	}, this);
};

WorkerPool.prototype._saveCallBack = function (task, metaListener, resolve, reject) {
	this._queue.push({
		task: task,
		metaListener: metaListener,
		resolve: resolve,
		reject: reject
	});
};

/** schedule a new task
*   @param the task to schedule
*   @param metaListener a listener for meta information (e.g. progress)
*/
WorkerPool.prototype.schedule = function (task, metaListener) {
	this._createNewWorker();

	var waitPromise = new this._Promise(this._saveCallBack.bind(this, task, metaListener));
	this._runFromQueue();
	return waitPromise;
};

/** close all workers. finish remaining tasks first */
WorkerPool.prototype.drain = function () {
	this.setNumberOfWorkers(0);
};

WorkerPool.prototype.setNumberOfWorkers = function (numberOfWorkers) {
	this._numberOfWorkers = numberOfWorkers;

	if (numberOfWorkers > this._numberOfWorkers) {
		for (var i = 0; i < this._queue.length; i += 1) {
			this._createNewWorker();
		}
	}
};

module.exports = WorkerPool;

/***/ }),

/***/ "a86h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function extendError(ParentErrorClass, name) {
	if (ParentErrorClass.prototype instanceof Error || ParentErrorClass === Error) {
		var F = function F() {};
		var CustomError = function CustomError(message, data) {
			var _this = this;

			var tmp = new ParentErrorClass(message);
			tmp.name = this.name = name || "Error";

			_this.data = data;
			_this.stack = tmp.stack;
			_this.message = tmp.message;
			_this.name = name;

			return _this;
		};
		var SubClass = function SubClass() {};
		SubClass.prototype = ParentErrorClass.prototype;
		F.prototype = CustomError.prototype = new SubClass();
		CustomError.prototype.constructor = CustomError;

		return CustomError;
	} else {
		throw new Error("our error should inherit from error!");
	}
}

var InvalidDataError = extendError(Error, "InvalidDataError");
var InvalidHexError = extendError(InvalidDataError, "InvalidHexError");
var InvalidFilter = extendError(InvalidDataError, "InvalidFilter");

var SecurityError = extendError(Error, "SecurityError");
var AccessViolation = extendError(SecurityError, "AccessViolation");
var DecryptionError = extendError(SecurityError, "DecryptionError");
var ValidationError = extendError(SecurityError, "ValidationError");

var LoginError = extendError(Error, "LoginError");

module.exports = {
	SecurityError: SecurityError,
	AccessViolation: AccessViolation,
	DecryptionError: DecryptionError,
	ValidationError: ValidationError,

	InvalidDataError: InvalidDataError,
	InvalidHexError: InvalidHexError,
	InvalidFilter: InvalidFilter,

	LoginError: LoginError
};

/***/ }),

/***/ "aQ1d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	/*
 	circle: {
 		key,
 		content,
 		iv
 	}
 */

	var circleJSON = {
		"type": "object",
		"properties": {
			"meta": {
				"type": "object",
				"required": true,
				"properties": {
					"users": {
						"type": "array",
						"items": {
							"type": "integer"
						}
					},
					"circleKey": {
						"required": true,
						"type": "string"
					}
				}
			},
			"content": {
				"type": "object",
				"required": true,
				"extends": "encryptedData",
				"properties": {}
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = circleJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return circleJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "b/6L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var h = __webpack_require__("S8e/").default;
var baseConfig = __webpack_require__("1IZJ");
var config = __webpack_require__("+070");

module.exports = h.extend(h.extend({}, baseConfig), config);

/***/ }),

/***/ "bMcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Cache__ = __webpack_require__("4PxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);



var cache = new __WEBPACK_IMPORTED_MODULE_0__services_Cache__["a" /* default */]("blobs");
var uriToBlob = function (blob) {
    if (typeof blob === "string") {
        return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].dataURItoBlob(blob);
    }
    return blob;
};
var knownBlobUrls = {};
var blobCache = {
    store: function (blob) { return cache.store(blob.getBlobID(), blob.getMeta(), blob.getBlobData()).thenReturn(blob.toURL()); },
    readFileAsArrayBuffer: function (dir, name) { return __WEBPACK_IMPORTED_MODULE_2_bluebird__["reject"]("We are not on a device. Can't read file " + dir + " " + name); },
    moveFileToBlob: function (dir, name, blobID) { return __WEBPACK_IMPORTED_MODULE_2_bluebird__["reject"]("We are not on a device. Can't move file " + dir + " " + name + " (blobID: " + blobID + ")"); },
    getBlobUrl: function (blobID) {
        if (!knownBlobUrls[blobID]) {
            knownBlobUrls[blobID] = cache.get(blobID).then(function (data) {
                if (typeof data.blob === "undefined" || data.blob === false) {
                    throw new Error("cache invalid!");
                }
                return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].toUrl(uriToBlob(data.blob));
            });
        }
        return knownBlobUrls[blobID];
    },
    isLoaded: function (blobID) { return cache.contains(blobID); },
    clear: function () { return cache.deleteAll(); }
};
/* harmony default export */ __webpack_exports__["a"] = (blobCache);


/***/ }),

/***/ "bZZ3":
/***/ (function(module, exports) {

var path = 'directives/createcircle.html';
var html = "<button class=\"btn btn--primary\" data-ng-if=\"name.length > 0\" data-ng-click=createCircle(name) data-i18n=views.circles.createCircle></button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "c6u2":
/***/ (function(module, exports) {

var path = 'directives/displayFile.html';
var html = "<div class=displayFile> <ng-transclude></ng-transclude> <span class=displayFile__icon data-ng-switch=file.type> <i class=\"fa fa-file-pdf-o fa-5x\" data-ng-switch-when=application/pdf></i> <i class=\"fa fa-file-o fa-5x\" data-ng-switch-default></i> </span> <p class=displayFile__name> {{file.name}} </p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "cA1Q":
/***/ (function(module, exports) {

var path = 'directives/saveButton.html';
var html = "<button data-ng-class=\"{'btn-saveButton--success': state.success || state.init, 'btn-saveButton--operation': state.pending, 'btn-saveButton--failure': state.failed}\" class=\"btn btn--saveButton\"> <i data-ng-if=\"state.success && successIcon\" class=\"fa fa-fw {{successIcon}}\"></i> <i data-ng-if=\"state.init && initIcon\" class=\"fa fa-fw {{initIcon}}\"></i> <i data-ng-if=\"state.failed && failureIcon\" class=\"fa fa-fw {{failureIcon}}\"></i> <i data-ng-if=state.pending class=\"saveButton-spinner fa fa-fw fa-spinner fa-spin\"></i> <span ng-transclude></span> </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ckIU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keyStore = __webpack_require__("IeOO").default;
var socketService = __webpack_require__("8I7s").default;

var interceptor = {
	transformResponse: function transformResponse(response) {
		if (!response.keys) {
			return response;
		}

		response.keys.forEach(function (key) {
			keyStore.upload.addKey(key);
		});

		return response;
	}
};

socketService.addInterceptor(interceptor);

/***/ }),

/***/ "cnt8":
/***/ (function(module, exports) {

var path = 'directives/burstDifference.html';
var html = "<div class=burst-date data-ng-if=$ctrl.differentDay()> <span class=burst-date-text data-ng-if=$ctrl.hasPreviousChunk()> {{ $ctrl.getTime() | date }} </span> <span class=burst-date-text data-ng-if=!$ctrl.hasPreviousChunk() data-i18n=messages.endOfStream> <span data-for=date> {{ $ctrl.getTime() | date }} </span> </span> </div> <div data-ng-if=$ctrl.differentChunk()> <div class=burst-date data-ng-if=!$ctrl.hasPreviousChunk()> <span class=burst-date-text> <span data-i18n=messages.burstDifferences.usersInChat></span><br/> <span data-ng-repeat=\"user in $ctrl.receiver()\"> {{ user.name }} <br/> </span> </span> </div> <div data-ng-repeat=\"chunk in $ctrl.chunksBetweenBursts()\"> <div class=burst-date data-ng-if=\"$ctrl.addedReceiver(chunk).length > 0\"> <span class=burst-date-text> <span data-i18n=messages.burstDifferences.addedUsers> <span data-for=name>{{ $ctrl.getCreator(chunk).name }}</span> </span><br/> <span data-ng-repeat=\"user in $ctrl.addedReceiver(chunk)\"> {{ user.name }} <br/> </span> </span> </div> <div class=burst-date data-ng-if=\"$ctrl.removedReceiver(chunk).length > 0\"> <span class=burst-date-text> <span data-i18n=messages.burstDifferences.removedUsers> <span data-for=name>{{ $ctrl.getCreator(chunk).name }}</span> </span><br/> <span data-ng-repeat=\"user in $ctrl.removedReceiver(chunk)\"> {{ user.name }} <br/> </span> </span> </div> <div class=burst-date data-ng-if=$ctrl.changedTitle(chunk)> <span class=burst-date-text> <span data-i18n=messages.burstDifferences.changedTitle> <span data-for=name>{{ $ctrl.getCreator(chunk).name }}</span> </span><br/> {{ $ctrl.changedTitle(chunk) }} </span> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "eGOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__socket_service__ = __webpack_require__("8I7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cache__ = __webpack_require__("4PxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__("S8e/");




var debug = __webpack_require__("jcLW");
var keyStore = __webpack_require__("+1JK");
var MAXCACHETIME = 7 * 24 * 60 * 60 * 1000;
var keyStoreDebug = debug("whispeer:keyStore");
var THROTTLE = 20;
var RequestKeyService = /** @class */ (function () {
    function RequestKeyService() {
        var _this = this;
        this.MAXCACHETIME = MAXCACHETIME;
        this.cleanCache = function () {
            return _this.keyCache.all().each(function (cacheEntry) {
                var data = JSON.parse(cacheEntry.data);
                if (data.removeAfter < new Date().getTime()) {
                    keyStoreDebug("remove by time: " + data.removeAfter);
                    _this.keyCache.delete(cacheEntry.id.split("/")[1]);
                }
            });
        };
        this.removeByObjectId = function (keyID, objectID) {
            //remove keys with same objectID
            return _this.keyCache.all().each(function (cacheEntry) {
                var data = JSON.parse(cacheEntry.data);
                if (objectID === data.objectID && keyID !== data.key.realid) {
                    keyStoreDebug("remove by object id: " + objectID);
                    return _this.keyCache.delete(_this.idTransform(keyID));
                }
            });
        };
        this.loadKeys = function (identifiers, cb) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
                var toLoadIdentifiers = identifiers.filter(function (e) {
                    return !keyStore.upload.isKeyLoaded(e);
                });
                if (toLoadIdentifiers.length === 0) {
                    return identifiers;
                }
                return __WEBPACK_IMPORTED_MODULE_1__socket_service__["default"].definitlyEmit("key.getMultiple", {
                    loaded: [],
                    realids: identifiers
                }).thenReturn(identifiers);
            }).nodeify(cb);
        };
        this.getKey = function (keyID, cb) {
            if (typeof keyID !== "string") {
                throw new Error("not a valid key realid: " + keyID);
            }
            if (keyStore.upload.isKeyLoaded(keyID)) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"]().nodeify(cb);
            }
            keyStoreDebug("loading key: " + keyID);
            return _this.keyCache.get(_this.idTransform(keyID)).then(function (cacheEntry) {
                if (cacheEntry.data.removeAfter < new Date().getTime()) {
                    keyStoreDebug("Remove Key from Cache " + keyID);
                    _this.keyCache.delete(keyID);
                }
                keyStore.upload.addKey(cacheEntry.data.key);
            }).catch(function () {
                keyStoreDebug("key cache miss: " + keyID);
                return _this.delayAsync(keyID);
            }).nodeify(cb);
        };
        this.cacheKey = function (realID, objectID, time) {
            time = Math.min(time, MAXCACHETIME);
            return _this.removeByObjectId(realID, objectID).then(function () {
                var keyData = keyStore.upload.getExistingKey(realID);
                if (!keyData) {
                    keyStoreDebug("Could not cache key yet " + realID);
                    return;
                }
                return _this.keyCache.store(_this.idTransform(realID), {
                    key: keyData,
                    objectID: objectID,
                    removeAfter: new Date().getTime() + time
                });
            });
        };
        window.setTimeout(this.cleanCache, 30 * 1000);
        window.setInterval(this.cleanCache, 10 * 60 * 1000);
        this.keyCache = new __WEBPACK_IMPORTED_MODULE_2__Cache__["a" /* default */]("keys");
        this.delay = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["default"].delayMultiple(THROTTLE, this.loadKeys);
        this.delayAsync = __WEBPACK_IMPORTED_MODULE_0_bluebird__["promisify"](this.delay);
    }
    RequestKeyService.prototype.idTransform = function (ID) {
        return ID;
    };
    return RequestKeyService;
}());
/* harmony default export */ __webpack_exports__["a"] = (new RequestKeyService());


/***/ }),

/***/ "eRn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecuredData", function() { return SecuredData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");


var keyStore = __webpack_require__("+1JK");
var errors = __webpack_require__("a86h");
var config = __webpack_require__("b/6L");

var attributesNeverVerified = ["_signature", "_hashObject"];
/** crypted content with metadata
        @param content the content to handle either encrypted or decrypted
        @param meta metadata for the content
        @param isDecrypted whether the content is decrypted
*/
var SecuredData = /** @class */ (function () {
    function SecuredData(content, meta, options, isDecrypted) {
        var _this = this;
        this.blockDisallowedAttributes = function (data) {
            if (data._contentHash || data._key || data._signature || data._version) {
                throw new Error("content hash/key should not be provided by outside world");
            }
        };
        this.hasContent = function () {
            return _this._hasContent;
        };
        this.getHash = function () {
            return _this._updated.meta._ownHash;
        };
        this.getKey = function () {
            return _this.original.meta._key;
        };
        this.sign = function (signKey, cb) {
            var toSign = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(_this._updated.meta);
            var hashVersion = config.hashVersion;
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
                toSign._version = 1;
                toSign._type = _this.type;
                toSign._hashVersion = hashVersion;
                //do not sign attributes which should not be verified
                _this.attributesNotVerified.forEach(function (attr) {
                    delete toSign[attr];
                });
                if (_this._updated.paddedContent || _this._updated.content) {
                    var hashContent = _this._updated.paddedContent || _this._updated.content;
                    return keyStore.hash.hashObjectOrValueHexAsync(hashContent).then(function (contentHash) {
                        toSign._contentHash = contentHash;
                        //create new ownHash
                        delete toSign._ownHash;
                        return keyStore.hash.hashObjectOrValueHexAsync(toSign);
                    }).then(function (ownHash) {
                        toSign._ownHash = ownHash;
                    });
                }
            }).then(function () {
                return keyStore.sign.signObject(toSign, signKey, hashVersion);
            }).then(function (signature) {
                toSign._signature = signature;
                return toSign;
            }).nodeify(cb);
        };
        this.getUpdatedData = function (signKey, cb) {
            return _this.verify(signKey).then(function () {
                if (_this._hasContent) {
                    keyStore.security.addEncryptionIdentifier(_this.original.meta._key);
                    return _this.signAndEncrypt(signKey, _this.original.meta._key);
                }
                return _this.sign(signKey);
            }).nodeify(cb);
        };
        /** sign and encrypt this object.
                pads and then encrypts our content.
                adds contentHash, key id and version to metaData and signs meta data.
                @param signKey key to use for signing
                @param cb callback(cryptedData, metaData),
        */
        this.signAndEncrypt = function (signKey, cryptKey) {
            if (!_this._hasContent) {
                throw new Error("can only sign and not encrypt");
            }
            if (_this.original.meta._key && _this.original.meta._key !== cryptKey) {
                throw new Error("can not re-encrypt an old object with new key!");
            }
            return keyStore.hash.addPaddingToObject(_this._updated.content, 128).then(function (paddedContent) {
                _this._updated.paddedContent = paddedContent;
                _this._updated.meta._key = keyStore.correctKeyIdentifier(cryptKey);
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["all"]([
                    keyStore.sym.encryptObject(paddedContent, cryptKey, _this.encryptDepth),
                    _this.sign(signKey)
                ]);
            }).spread(function (cryptedData, meta) {
                _this._updated.meta = meta;
                return {
                    content: cryptedData,
                    meta: meta
                };
            });
        };
        this.hasType = function (type) {
            if (type === _this.type) {
                return true;
            }
            if (_this.alternativeType && _this.alternativeType === type) {
                return true;
            }
            return false;
        };
        /** verify the decrypted data
                decrypts data if necessary
                @param signKey key to check signature against
                @param id id for signature caching
                @throw SecurityError: contenthash or signature wrong
        */
        this.verifyAsync = function (signKey, id) {
            //check contentHash is correct
            //check signature is correct
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"]().then(function () {
                var metaCopy = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(_this.original.meta);
                _this.attributesNotVerified.forEach(function (attr) {
                    delete metaCopy[attr];
                });
                if (!_this.hasType(metaCopy._type)) {
                    // eslint-disable-next-line no-debugger
                    debugger;
                    throw new errors.SecurityError("invalid object type. is: " + metaCopy._type + " should be: " + _this.type);
                }
                if (typeof metaCopy._hashVersion === "number") {
                    metaCopy._hashVersion = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].parseDecimal(metaCopy._hashVersion);
                }
                var hashVersion = 1;
                if (metaCopy._hashVersion) {
                    hashVersion = metaCopy._hashVersion;
                }
                else if (metaCopy._v2 && metaCopy._v2 !== "false") {
                    hashVersion = 2;
                }
                return keyStore.sign.verifyObject(_this.original.meta._signature, metaCopy, signKey, hashVersion, id);
            }).then(function (correctSignature) {
                if (!correctSignature) {
                    alert("Bug: signature did not match (" + _this.original.meta._type + ") Please report this bug!");
                    throw new errors.SecurityError("signature did not match " + _this.original.meta._type);
                }
                return _this.verifyContentHash();
            }).then(function () {
                return true;
            });
        };
        this.verify = function (signKey, cb, id) {
            return _this.verifyAsync(signKey, id).nodeify(cb);
        };
        this.updated = function () {
            _this.changed = false;
        };
        this._decrypt = function () {
            if (!_this.decryptionPromise) {
                _this.decryptionPromise = keyStore.sym.decryptObject(_this.original.encryptedContent, _this.encryptDepth, undefined, _this.original.meta._key).then(function (decryptedData) {
                    _this.decrypted = true;
                    _this.original.paddedContent = decryptedData;
                    _this.original.content = keyStore.hash.removePaddingFromObject(decryptedData, 128);
                    _this._updated.content = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(_this.original.content);
                    return _this.verifyContentHash();
                });
            }
            return _this.decryptionPromise;
        };
        this.decrypt = function (cb) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"]().then(function () {
                if (_this._hasContent && !_this.decrypted) {
                    return _this._decrypt();
                }
            }).then(function () {
                if (!_this._hasContent) {
                    return;
                }
                return _this.original.content;
            }).nodeify(cb);
        };
        this.verifyContentHash = function () {
            if (!_this._hasContent || !_this.decrypted) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"]();
            }
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
                return keyStore.hash.hashObjectOrValueHexAsync(_this.original.paddedContent || _this.original.content);
            }).then(function (hash) {
                if (hash !== _this.original.meta._contentHash) {
                    throw new errors.SecurityError("content hash did not match");
                }
            });
        };
        this.isChanged = function () { return _this.changed; };
        this.isEncrypted = function () { return !_this.decrypted; };
        this.isDecrypted = function () { return _this.decrypted; };
        this.contentGet = function () { return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(_this._updated.content); };
        this.metaGet = function () { return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(_this._updated.meta); };
        this.metaHasAttr = function (attr) { return _this._updated.meta.hasOwnProperty(attr); };
        this.metaKeys = function () { return Object.keys(_this._updated.meta).filter(function (key) { return key[0] !== "_"; }); };
        this.metaAttr = function (attr) { return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(_this._updated.meta[attr]); };
        /** sets the whole content to the given data
                @param newContent new value for this objects content
        */
        this.contentSet = function (newContent) {
            _this._hasContent = _this.changed = true;
            _this._updated.content = newContent;
        };
        /** set a certain attribute in the content object
                @param attr attribute to set
                @param value value to set attribute to
        */
        this.contentSetAttr = function (attr, value) {
            if (typeof _this._updated.content !== "object") {
                throw new Error("our content is not an object");
            }
            _this._updated.content[attr] = value;
            _this.changed = true;
        };
        this.contentRemoveAttr = function (attr) {
            if (typeof _this._updated.content !== "object") {
                throw new Error("our content is not an object");
            }
            delete _this._updated.content[attr];
            _this.changed = true;
        };
        /** sets the whole metaData to the given data
                @param newMetaData new value for this objects metaData
        */
        this.metaSet = function (newMetaData) {
            _this.blockDisallowedAttributes(newMetaData);
            _this.changed = true;
            _this._updated.meta = newMetaData;
        };
        this.metaRemoveAttr = function (attr) {
            if (attr[0] === "_") {
                throw new Error("private attributes should not be provided by outside world");
            }
            _this.changed = true;
            delete _this._updated.meta[attr];
        };
        this.metaSetAttr = function (attr, value) {
            if (attr[0] === "_") {
                throw new Error("private attributes should not be provided by outside world");
            }
            _this.changed = true;
            _this._updated.meta[attr] = value;
        };
        /** set a certain attribute in the meta object
                @param attrs [] list of which attribute to set
                @param value value to set attribute to
        */
        this.metaAdd = function (attrs, value) {
            _this.changed = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepSetCreate(_this._updated.meta, attrs, value);
        };
        this.setParent = function (parentSecuredData) {
            _this._updated.meta._parent = parentSecuredData.getHash();
        };
        this.checkParent = function (expectedParent) {
            if (_this._updated.meta._parent !== expectedParent.getHash()) {
                throw new errors.SecurityError("wrong parent. is: " + _this._updated.meta._parent + " should be: " + expectedParent.getHash());
            }
        };
        this.getRelationshipCounter = function () {
            return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].parseDecimal(_this._updated.meta._sortCounter || 0);
        };
        this.setAfterRelationShip = function (afterSecuredData) {
            _this._updated.meta._sortCounter = afterSecuredData.getRelationshipCounter() + 1;
        };
        this.checkAfter = function (securedData) {
            if (_this.getRelationshipCounter() < securedData.getRelationshipCounter()) {
                throw new errors.SecurityError("wrong ordering. " + _this.getRelationshipCounter() + " should be after " + securedData.getRelationshipCounter());
            }
        };
        this.checkBefore = function (securedData) {
            if (_this.getRelationshipCounter() > securedData.getRelationshipCounter()) {
                throw new errors.SecurityError("wrong ordering. " + _this.getRelationshipCounter() + " should be before " + securedData.getRelationshipCounter());
            }
        };
        //we need to somehow ensure that we have the correct object type.
        if (!options || typeof options.type !== "string") {
            throw new Error("need a type for security!");
        }
        this.type = options.type;
        this.alternativeType = options.alternativeType;
        this.encryptDepth = options.encryptDepth || 0;
        this.attributesNotVerified = options.attributesNotVerified || [];
        this.attributesNotVerified.filter(function (val) { return val.match(/^A-z0-9$/); });
        this.attributesNotVerified = attributesNeverVerified.concat(this.attributesNotVerified);
        this.decrypted = isDecrypted;
        this._hasContent = true;
        this.original = {
            meta: meta || {}
        };
        if (typeof content === "undefined") {
            this._hasContent = false;
        }
        else if (isDecrypted) {
            this.original.content = content;
        }
        else {
            this.original.encryptedContent = content;
        }
        this._updated = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].deepCopyObj(this.original);
    }
    return SecuredData;
}());

var api = {
    createPromisified: function (content, meta, options, signKey, cryptKey) {
        var securedData, securedDataPromise;
        securedDataPromise = __WEBPACK_IMPORTED_MODULE_0_bluebird__["fromCallback"](function (cb) {
            securedData = api.create(content, meta, options, signKey, cryptKey, cb);
        });
        return {
            promise: securedDataPromise,
            data: securedData
        };
    },
    createAsync: function (content, meta, options, signKey, cryptKey) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["fromCallback"](function (cb) {
            api.create(content, meta, options, signKey, cryptKey, cb);
        });
    },
    create: function (content, meta, options, signKey, cryptKey, cb) {
        var secured = api.createRaw(content, meta, options);
        __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"]().delay(1).then(function () {
            return secured.signAndEncrypt(signKey, cryptKey);
        }).nodeify(cb);
        return secured;
    },
    load: function (content, meta, options) {
        return new SecuredData(content, meta, options, false);
    },
    createRaw: function (content, meta, options) {
        return new SecuredData(content, meta, options, true);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (api);


/***/ }),

/***/ "eUia":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sessionService = __webpack_require__("0kGL").default;
var socketService = __webpack_require__("8I7s").default;

var interceptor = {

	transformResponse: function transformResponse(response, request) {
		if (request.sid && !response.logedin) {
			sessionService.logout();
		}
		return response;
	},

	transformRequest: function transformRequest(request) {
		request.sid = sessionService.getSID();
		return request;
	}
};

socketService.addInterceptor(interceptor);

/***/ }),

/***/ "eahS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");

module.exports = function ($injector, cb) {
	return Bluebird.try(function () {
		return;
	}).then(function () {
		return true;
	}).nodeify(cb);
};

/***/ }),

/***/ "emzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyStore_service__ = __webpack_require__("IeOO");

var errors = __webpack_require__("a86h");

var circleService = __webpack_require__("silk");
var localize = __webpack_require__("RXrU");
var FilterService = /** @class */ (function () {
    function FilterService() {
        var _this = this;
        this.alwaysAvailableFilter = ["allfriends"];
        this.getFiltersByID = function (ids) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](ids).map(_this.getFilterByID.bind(_this));
        };
    }
    FilterService.prototype.alwaysFilterToKey = function (filter) {
        var userService = __webpack_require__("UuKm").default;
        switch (filter) {
            case "allfriends":
                return userService.getOwn().getFriendsKey();
            case "everyone":
                //we do not encrypt it anyhow .... this needs to be checked in before!
                throw new Error("should never be here");
            default:
                throw new errors.InvalidFilter("unknown always value");
        }
    };
    FilterService.prototype.circleFilterToKey = function (filter) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            return circleService.loadAll();
        }).then(function () {
            return circleService.get(filter).getKey();
        });
    };
    FilterService.prototype.userFilterToKey = function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            var userService = __webpack_require__("UuKm").default;
            return userService.get(user);
        }).then(function (user) {
            return user.getContactKey();
        });
    };
    FilterService.prototype.friendsFilterToKey = function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            var userService = __webpack_require__("UuKm").default;
            return userService.get(user);
        }).then(function (user) {
            return user.getFriendsKey();
        });
    };
    FilterService.prototype.filterToKeys = function (filters, cb) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            var userService = __webpack_require__("UuKm").default;
            var filterPromises = filters.map(function (filter) {
                var map = filter.split(":");
                switch (map[0]) {
                    case "friends":
                        return _this.friendsFilterToKey(map[1]);
                    case "always":
                        return _this.alwaysFilterToKey(map[1]);
                    case "circle":
                        return _this.circleFilterToKey(map[1]);
                    case "user":
                        return _this.userFilterToKey(map[1]);
                    default:
                        throw new errors.InvalidFilter("unknown group");
                }
            });
            filterPromises.push(userService.getOwn().getMainKey());
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["all"](filterPromises);
        }).nodeify(cb);
    };
    FilterService.prototype.getCircleByID = function (id) {
        return circleService.loadAll().then(function () {
            var circle = circleService.get(id).data;
            return {
                name: circle.name,
                id: "circle:" + circle.id,
                sref: "app.circles.show({circleid: " + circle.id + "})",
                count: circle.userids.length
            };
        });
    };
    FilterService.prototype.getFriendsFilterByID = function (id) {
        var userService = __webpack_require__("UuKm").default;
        return userService.get(id).then(function (user) {
            return {
                name: localize.getLocalizedString("directives.friendsOf", { name: user.data.name }),
                id: "friends:" + user.data.id,
                sref: "app.user({identifier: " + user.data.id + "})"
            };
        });
    };
    FilterService.prototype.getAlwaysByID = function (id) {
        var userService = __webpack_require__("UuKm").default;
        if (id !== "allfriends") {
            throw new Error("Invalid Always id");
        }
        var key = userService.getOwn().getFriendsKey();
        return {
            name: localize.getLocalizedString("directives.allfriends"),
            id: "always:" + id,
            sref: "app.friends",
            count: __WEBPACK_IMPORTED_MODULE_1__keyStore_service__["default"].upload.getKeyAccessCount(key) - 1
        };
    };
    FilterService.prototype.getFilterByID = function (id) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            var colon = id.indexOf(":");
            var domain = id.substr(0, colon + 1);
            var domainID = id.substr(colon + 1);
            if (domain === "always:") {
                return _this.getAlwaysByID(domainID);
            }
            else if (domain === "circle:") {
                return _this.getCircleByID(domainID);
            }
            else if (domain === "friends:") {
                return _this.getFriendsFilterByID(domainID);
            }
        });
    };
    FilterService.prototype.getAllFilters = function () {
        var _this = this;
        var alwaysAvailable = this.alwaysAvailableFilter.map(function (e) {
            return _this.getAlwaysByID(e);
        });
        return circleService.loadAll().then(function () {
            var circles = circleService.data.circles;
            var circle = circles.map(function (e) {
                return {
                    name: e.name,
                    id: "circle:" + e.id,
                    count: e.userids.length
                };
            });
            return alwaysAvailable.concat(circle);
        });
    };
    return FilterService;
}());
/* harmony default export */ __webpack_exports__["default"] = (new FilterService());


/***/ }),

/***/ "f6fo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
var directive = function directive($timeout) {
	return {
		link: function link(scope, elm, attrs) {
			elm.bind("focus", function () {
				$timeout(function () {
					scope.$eval(attrs.onfocus);
				});
			});
		}
	};
};

directive.$inject = ["$timeout"];

directivesModule.directive("onfocus", directive);

/***/ }),

/***/ "fiwE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
The MIT License

Copyright (c) 2012-2013 Coding Smackdown TV, http://codingsmackdown.tv
Changes by Nils Thenhausen (2014-2015), http://whispeer.com
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Enjoy!
*/

/*
* An AngularJS Localization Service
*
* Written by Jim Lavin
* http://codingsmackdown.tv
* Changes by Nils Thenhausen, http://whispeer.com
*/

var angular = __webpack_require__("aeQg");
var Localize = __webpack_require__("n8tu").default;
var localize = __webpack_require__("RXrU");
var jQuery = __webpack_require__("juYr");

function toReplacementObject(values) {
	var result = {};
	values.forEach(function (val) {
		var index = val.indexOf("=");

		result[val.substr(0, index)] = val.substr(index + 1, val.length);
	});

	return result;
}

function turnTagIntoElementArray(tag, i18nElements) {
	var attr,
	    k,
	    tags = [tag];
	for (attr in i18nElements) {
		if (i18nElements.hasOwnProperty(attr)) {
			for (k = 0; k < tags.length; k += 1) {
				if (typeof tags[k] === "string" && tags[k].indexOf(Localize.getReplacementString(attr)) > -1) {
					var result = tags[k].split(Localize.getReplacementString(attr));
					tags.splice(k, 1, result[0], i18nElements[attr], result[1]);
				}
			}
		}
	}

	return tags;
}

var _module = angular.module("localization", []);

// localization service responsible for retrieving resource files from the server and
// managing the translation dictionary
_module.provider("localize", function () {
	this.$get = ["$rootScope", function ($rootScope) {
		localize.listen(function () {
			$rootScope.$broadcast("localizeResourcesUpdates");
		}, "localizeResourcesUpdates");

		localize.initLocalizedResources();

		return localize;
	}];
});

// simple translation filter
// usage {{ TOKEN | i18n }}
_module.filter("i18n", ["localize", function () {
	var filter = function filter(input) {
		return localize.getLocalizedString(input);
	};
	filter.$stateful = true;
	return filter;
}]);

_module.filter("l", ["localize", function () {
	var filter = function filter(input) {
		return localize.getLocalizedString(input);
	};
	filter.$stateful = true;
	return filter;
}]);

var i18nDirective = function i18nDirective($compile, directiveName, allowHtml) {
	var directive = {
		restrict: "EAC",
		updateText: function updateText(scope, elm, token, i18nElements) {
			var values = token.split("|");

			i18nElements = i18nElements || [];

			// construct the tag to insert into the element
			var tag = localize.getLocalizedString(values.shift(), toReplacementObject(values));
			// update the element only if data was returned
			if (!tag) {
				return;
			}

			elm.html("");

			var tags = turnTagIntoElementArray(tag, i18nElements);

			tags.forEach(function (cur) {
				if (typeof cur === "string") {
					elm.append(allowHtml === true ? cur : document.createTextNode(cur));
				} else {
					cur.forEach(function (element) {
						elm.append(element.clone());
					});
				}
			});

			$compile(elm.contents())(scope);
		},

		compile: function compile(elm) {
			var elements = {};

			var children = elm.children();
			var k, child, attr;

			//get the html of all children
			for (k = 0; k < children.length; k += 1) {
				child = jQuery(children[k]);

				attr = child.attr("data-for");

				elements[attr] = elements[attr] || [];
				elements[attr].push(child);
			}

			elm.html("");

			return function (scope, elm, attrs) {
				scope.$on("localizeResourcesUpdates", function () {
					directive.updateText(scope, elm, attrs[directiveName], elements);
				});

				attrs.$observe(directiveName, function () {
					directive.updateText(scope, elm, attrs[directiveName], elements);
				});
			};
		}
	};

	return directive;
};

// translation directive that can handle dynamic strings
// updates the text value of the attached element
// usage <span data-i18n="TOKEN" ></span>
// or
// <span data-i18n="TOKEN|VALUE1|VALUE2" ></span>
_module.directive("i18n", ["$compile", "localize", function ($compile) {
	return i18nDirective($compile, "i18n", false);
}]);

_module.directive("i18nHtml", ["$compile", "localize", function ($compile) {
	return i18nDirective($compile, "i18nHtml", true);
}]);

// translation directive that can handle dynamic strings
// updates the attribute value of the attached element
// usage <span data-i18n-attr="TOKEN|ATTRIBUTE" ></span>
// or
// <span data-i18n-attr="TOKEN|ATTRIBUTE|VALUE1|VALUE2" ></span>
_module.directive("i18nAttr", ["localize", function () {
	var i18nAttrDirective = {
		restrict: "EAC",
		updateText: function updateText(elm, token) {
			var values = token.split("|"),
			    key = values.shift(),
			    attr = values.shift();
			// construct the tag to insert into the element
			var tag = localize.getLocalizedString(key, toReplacementObject(values));
			// update the element only if data was returned
			if (!tag) {
				return;
			}

			// insert the text into the atribute
			elm.attr(attr, tag);
		},
		link: function link(scope, elm, attrs) {
			scope.$on("localizeResourcesUpdates", function () {
				i18nAttrDirective.updateText(elm, attrs.i18nAttr);
			});

			attrs.$observe("i18nAttr", function (value) {
				i18nAttrDirective.updateText(elm, value);
			});
		}
	};

	return i18nAttrDirective;
}]);

/***/ }),

/***/ "fndX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	/*
 	topic: {
 		createTime: (int)
 		key: key,
 		receiver: [{identifier, key}],
 		creator: (int),
 		newest (int),
 		unread: (bool)
 	}
 */

	var topicJSON = {
		"name": "Topic",
		"type": "object",
		"properties": {
			"createTime": {
				"required": true,
				"type": "number",
				"min": 1376244464102
			},
			"_key": {
				"required": true,
				"type": "string"
			},
			"receiver": {
				"required": true,
				"type": "array",
				"items": {
					"type": "int"
				}
			},
			"creator": {
				"type": "number",
				"min": 1
			},
			"unread": {
				"type": "array",
				"items": {
					"type": "int"
				}
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = topicJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return topicJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "fuD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var multipleTemplateUrl = __webpack_require__("zDWf");
var singleTemplateUrl = __webpack_require__("VRY8");

"use strict";

var singleSearch = __webpack_require__("Sef5");
var multiSearch = __webpack_require__("rcaN");
var directivesModule = __webpack_require__("7Eh3");

var lastSearchOpened = 0;

function searchDirective($injector) {
	return {
		scope: {
			"callback": "&",
			"inputI18nAttr": "@",
			"searchTemplate": "@",
			"addClasses": "@",
			//multi-search
			"selectDropTemplate": "@",
			"base": "@",
			"initialValues": "&"
		},
		restrict: "E",
		templateUrl: function templateUrl(iElement, iAttrs) {
			if (typeof iAttrs.multiple !== "undefined") {
				return multipleTemplateUrl;
			}

			return singleTemplateUrl;
		},
		replace: false,
		transclude: false,
		link: function link(scope, iElement, iAttrs) {
			var thisSearchOpened = 0;
			var SearchSupplierClass = $injector.get(iAttrs.supplier);
			var searchSupplier = new SearchSupplierClass();
			scope.selectDropTemplate = scope.selectDropTemplate || "default";

			scope.filter = [];
			scope.filter.push(function (results) {
				if (!iAttrs.filter) {
					return results;
				}

				var filter = scope.$parent.$eval(iAttrs.filter);

				return results.filter(function (result) {
					return filter.indexOf(result.id) === -1;
				});
			});

			scope.applyFilterToResults = function (results) {
				scope.filter.forEach(function (filter) {
					results = filter(results);
				});

				return results;
			};

			var oldQuery = "";
			/* attribute to define if we want multiple results or one */
			scope.query = "";
			scope.results = [];
			scope.unFilteredResults = [];

			/** open search element or not **/
			var isVisible = false,
			    initialized = false;

			function initialize() {
				if (!initialized) {
					initialized = true;
					scope.queryChange(true);
				}
			}

			if (typeof iAttrs.keepOpenOnBlur === "undefined") {
				/* close on body click */
				jQuery(document.body).click(function () {
					scope.hide();
					scope.$applyAsync();
				});
			}

			scope.isVisible = function () {
				return isVisible && lastSearchOpened === thisSearchOpened;
			};

			scope.hide = function () {
				isVisible = false;

				initialize();
			};

			scope.show = function ($event) {
				if ($event) {
					$event.stopPropagation();
				}

				lastSearchOpened = thisSearchOpened = new Date().getTime();

				isVisible = true;
				initialize();
			};

			/** suchergebnisse laden */
			scope.searching = false;

			scope.queryChange = function (noDiffNecessary) {
				var currentQuery = scope.query;

				if (oldQuery !== currentQuery) {
					scope.show();
				}

				if (noDiffNecessary || oldQuery !== currentQuery) {
					oldQuery = scope.query;
					scope.searching = true;

					searchSupplier.search(scope.query).then(function (results) {
						if (currentQuery === scope.query) {
							scope.searching = false;

							scope.unFilteredResults = results;
							scope.results = scope.applyFilterToResults(scope.unFilteredResults);
						}
					}).catch(function (error) {
						if (currentQuery === scope.query) {
							console.error(error);
							scope.searching = false;

							scope.unFilteredResults = [];
							scope.results = [];
						}
					});
				}
			};

			scope.$on("hide", function () {
				scope.hide();
			});

			scope.$on("resetSearch", function () {
				scope.query = "";
				scope.queryChange(true);
			});

			/** suchergebnisse markieren */
			scope.current = 0;

			function addCurrent(val) {
				scope.setCurrent(scope.current + val);
			}

			scope.setCurrent = function (val) {
				scope.current = val;

				scope.current = Math.min(scope.current, scope.results.length - 1);
				scope.current = Math.max(0, scope.current);
			};

			/** key stuff */

			var UP = [38, 33];
			var DOWN = [40, 34];
			var SELECT = [13];
			var CLOSE = [27];

			scope.keydown = function (e) {
				if (CLOSE.indexOf(e.keyCode) > -1) {
					scope.hide();
				}

				if (UP.indexOf(e.keyCode) > -1) {
					addCurrent(-1);
					e.preventDefault();
				}

				if (DOWN.indexOf(e.keyCode) > -1) {
					addCurrent(1);
					e.preventDefault();
				}

				if (SELECT.indexOf(e.keyCode) > -1 && scope.results[scope.current]) {
					scope.selectResult(scope.results[scope.current]);
					e.preventDefault();
				}
			};

			if (typeof iAttrs.multiple !== "undefined") {
				multiSearch($injector, scope, iElement, iAttrs);
			} else {
				singleSearch($injector, scope, iElement, iAttrs);
			}
		}
	};
}

searchDirective.$inject = ["$injector"];

directivesModule.directive("search", searchDirective);

/***/ }),

/***/ "hWdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("jYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);

var windowG = window;
windowG.jQuery = __webpack_require__("juYr");
var angular = __webpack_require__("aeQg");
var angularPlugin = __webpack_require__("2laJ");
__WEBPACK_IMPORTED_MODULE_0_raven_js__["config"]("https://fbe86ea09967450fa14f299f23038a96@errors.whispeer.de/9", {
    release: {"type":"browser","version":"0.3.15"}.version,
    autoBreadcrumbs: false,
    environment: "" + "production"
})
    .addPlugin(angularPlugin, angular)
    .install();


/***/ }),

/***/ "hrpu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

function accessibleClick() {
	return {
		restrict: "A",
		replace: false,
		scope: {
			accessibleClick: "&"
		},
		link: function link(scope, element) {
			var SELECT = [13];
			element.on("click", function () {
				scope.accessibleClick();
			});

			element.on("keypress", function (e) {
				if (SELECT.indexOf(e.keyCode) > -1) {
					scope.accessibleClick();
					scope.$applyAsync();
				}
			});

			element.attr("tabIndex", "0");
			element.attr("role", "button");
		}
	};
}

accessibleClick.$inject = [];

directivesModule.directive("accessibleClick", accessibleClick);

/***/ }),

/***/ "iTly":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);


var Queue = /** @class */ (function () {
    function Queue(maxWeight) {
        this.maxWeight = maxWeight;
        this.queue = [];
        this.run = false;
        this.runningWeight = 0;
    }
    Queue.prototype.enqueue = function (weight, task) {
        var _this = this;
        var promise = new __WEBPACK_IMPORTED_MODULE_0_bluebird__(function (resolve, reject) {
            _this.queue.push({
                task: task,
                weight: weight,
                resolve: resolve,
                reject: reject
            });
            _this.runTasks();
        });
        return promise;
    };
    Queue.prototype.runTasks = function () {
        if (!this.run) {
            return;
        }
        var nextTask;
        while (this.queue.length > 0 && this.runningWeight < this.maxWeight) {
            nextTask = this.queue.shift();
            this.runTask(nextTask);
        }
    };
    Queue.prototype.runTask = function (task) {
        var _this = this;
        this.runningWeight += task.weight;
        task.task().then(function (result) { task.resolve(result); }, function (error) { task.reject(error); }).finally(function () {
            _this.runningWeight -= task.weight;
            _this.runTasks();
        });
    };
    Queue.prototype.start = function () {
        this.run = true;
        this.runTasks();
    };
    return Queue;
}());
/* harmony default export */ __webpack_exports__["a"] = (Queue);


/***/ }),

/***/ "iuSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__("MCp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);

var LocalizationLoader = /** @class */ (function () {
    function LocalizationLoader() {
        var _this = this;
        this.fallBackLanguage = "en-US";
        this.location = "assets/js/i18n/l_";
        this.availableLanguages = [];
        this.getLanguageUrl = function (location, language) {
            return "" + location + language + ".json";
        };
        this.updateLanguageOnFail = function (language) {
            return language.length > 2 ? language.substr(0, 2) : _this.fallBackLanguage;
        };
        this.retryOnFail = function (language) {
            var otherLanguage = _this.updateLanguageOnFail(language);
            if (otherLanguage !== language) {
                return _this.loadLanguage(otherLanguage);
            }
            throw new Error("no localization found!");
        };
        this.loadOptionalLocaleExtension = function (location) {
            var url = _this.getLanguageUrl(location, _this.loadedLanguage);
            return fetch(url)
                .then(function (response) { return response.json(); })
                .catch(function (e) {
                console.warn("Failed loading language file " + url, e);
                return {};
            });
        };
        this.loadLanguage = function (language) {
            language = language.toLowerCase();
            if (!_this.fallBackLanguage || _this.availableLanguages.length === 0) {
                throw new Error("Localization module not initialized correctly");
            }
            if (_this.availableLanguages.indexOf(language) === -1) {
                return _this.retryOnFail(language);
            }
            _this.loadedLanguage = language;
            return fetch(_this.getLanguageUrl(_this.location, language))
                .then(function (response) { return response.json(); });
        };
        this.setFallBackLanguage = function (_fallBackLanguage) {
            return _this.fallBackLanguage = _fallBackLanguage;
        };
        this.setAvailableLanguages = function (_availableLanguages) {
            return _this.availableLanguages = _availableLanguages;
        };
    }
    return LocalizationLoader;
}());
/* harmony default export */ __webpack_exports__["default"] = (new LocalizationLoader());


/***/ }),

/***/ "j5T1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");
var SecuredData = __webpack_require__("eRn5").default;

var userService = __webpack_require__("UuKm").default;
var socket = __webpack_require__("8I7s").default;

var CommentModel = function CommentModel(data, parentPost) {
	var theComment = this;
	this._secured = SecuredData.load(data.content, data.meta, { type: "comment" });

	this._parentPost = parentPost;
	this._id = data.id;

	this.data = {
		loaded: false,
		sender: null,
		time: this._secured.metaAttr("createTime"),
		delete: function _delete() {
			theComment.delete();
		}
	};
};

CommentModel.prototype.delete = function () {
	return socket.emit("posts.comment.delete", {
		comment: this._id,
		post: this._parentPost.getID()
	}).bind(this).then(function () {
		return this._parentPost.removeComment(this);
	});
};

CommentModel.prototype.getSecured = function () {
	return this._secured;
};

CommentModel.prototype.load = function (previousComment, cb) {
	var theComment = this;
	return Bluebird.try(function () {
		return Bluebird.all([theComment._secured.decrypt(), theComment.getSender()]);
	}).spread(function (content, sender) {
		theComment.data.sender = sender.data;
		theComment.data.text = content.comment;

		if (previousComment) {
			theComment._secured.checkAfter(previousComment.getSecured());
		}

		theComment._secured.checkParent(theComment._parentPost.getSecured());
		return theComment._secured.verify(sender.getSignKey());
	}).then(function () {
		theComment.data.loaded = true;
	}).nodeify(cb);
};

CommentModel.prototype.getSender = function () {
	return userService.get(this._secured.metaAttr("sender")).then(function (user) {
		return user.loadBasicData().thenReturn(user);
	});
};

CommentModel.create = function (text, parentPost, cb) {
	return Bluebird.try(function () {
		var comments = parentPost.getComments();

		var s = SecuredData.createPromisified({
			comment: text
		}, {
			postID: parentPost.getID(),
			createTime: new Date().getTime(),
			sender: userService.getOwn().getID()
		}, { type: "comment" }, userService.getOwn().getSignKey(), parentPost.getKey());

		s.data.setParent(parentPost.getSecured());

		if (comments.length !== 0) {
			s.data.setAfterRelationShip(comments[comments.length - 1].getSecured());
		}

		return s.promise;
	}).then(function (commentData) {
		return socket.emit("posts.comment.create", {
			postID: parentPost.getID(),
			comment: commentData
		});
	}).nodeify(cb);
};

module.exports = CommentModel;

/***/ }),

/***/ "jZtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// EXTERNAL MODULE: ./js/asset/Progress.ts
var Progress = __webpack_require__("P6+u");

// EXTERNAL MODULE: ./js/services/blobService.ts + 1 modules
var blobService = __webpack_require__("95Br");

// EXTERNAL MODULE: ./js/asset/blobCache.ts
var blobCache = __webpack_require__("bMcU");

// EXTERNAL MODULE: ./js/asset/Queue.ts
var Queue = __webpack_require__("iTly");

// CONCATENATED MODULE: ./js/services/fileTransferQueue.ts

/* Queue that ensures one file transfer at a time.  */
var queue = new Queue["a" /* default */](1);
queue.start();

// CONCATENATED MODULE: ./js/services/fileUpload.service.ts
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var defaultUploadOptions = {
    encrypt: true,
    extraInfo: {}
};
var encryptionQueue = new Queue["a" /* default */](500 * 1000);
encryptionQueue.start();
var fileUpload_service_FileUpload = /** @class */ (function () {
    function FileUpload(file, options) {
        var _this = this;
        this.file = file;
        this.getProgress = function () {
            return _this.progress.getProgress();
        };
        this.uploadAndEncryptPreparedBlob = function (encryptionKey, blob) {
            _this.progress.addDepend(blob.uploadProgress);
            _this.progress.addDepend(blob.encryptProgress);
            return encryptionQueue.enqueue(blob.getSize(), function () {
                return blob.encryptAndUpload(encryptionKey);
            });
        };
        this.uploadPreparedBlob = function (blob) {
            _this.progress.addDepend(blob.uploadProgress);
            return blob.upload();
        };
        this.upload = function (encryptionKey) {
            if (!_this.blob) {
                throw new Error("usage error: prepare was not called!");
            }
            return queue.enqueue(1, function () {
                console.info("Uploading blob");
                if (_this.options.encrypt) {
                    return _this.uploadAndEncryptPreparedBlob(encryptionKey, _this.blob);
                }
                return _this.uploadPreparedBlob(_this.blob);
            }).then(function (keys) {
                if (_this.file.originalUrl) {
                    var _a = Object(blobService["unpath"])(_this.file.originalUrl), directory = _a.directory, name_1 = _a.name;
                    return blobCache["a" /* default */].moveFileToBlob(directory, name_1, _this.blob.getBlobID()).then(function () { return keys; });
                }
                return keys;
            });
        };
        this.prepare = helper["default"].cacheResult(function () {
            return FileUpload.blobToDataSet(_this.blob).then(function (data) {
                data.content = __assign({}, data.content, _this.getInfo());
                return data;
            });
        });
        this.getInfo = function () {
            return __assign({ name: _this.file.name, size: _this.file.size, type: _this.file.type }, _this.options.extraInfo);
        };
        this.getFile = function () {
            return _this.file;
        };
        this.getName = function () {
            return _this.file.name;
        };
        this.progress = new Progress["a" /* default */]();
        this.blob = blobService["default"].createBlob(file);
        this.options = options || defaultUploadOptions;
    }
    FileUpload.blobToDataSet = function (blob) {
        return bluebird["all"]([blob.preReserveID(), blob.getHash()]).spread(function (blobID, hash) {
            return {
                blob: blob,
                content: {
                    blobHash: hash
                },
                meta: {
                    blobID: blobID
                }
            };
        });
    };
    FileUpload.fileCallback = function (cb) {
        return function (e) {
            cb(Array.prototype.slice.call(e.target.files));
            try {
                e.target.value = null;
            }
            catch (ex) {
                console.log(ex);
            }
        };
    };
    return FileUpload;
}());
/* harmony default export */ var fileUpload_service = __webpack_exports__["a"] = (fileUpload_service_FileUpload);


/***/ }),

/***/ "l/Gk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
var templateUrl = __webpack_require__("141t");

function commentDirective() {
	"use strict";

	return {
		transclude: true,
		scope: {
			comment: "=comment"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true
	};
}

directivesModule.directive("comment", commentDirective);

/***/ }),

/***/ "lCst":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	var profileEncryptedJSON = {
		"type": "object",
		"properties": {
			"basic": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"image": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"location": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"contact": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"relationship": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"relatives": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"extended": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"knowledge": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},

			"jobs": {
				"type": "object",
				"properties": {
					"iv": {
						"type": "string",
						"hex": true
					},
					"ct": {
						"type": "string",
						"hex": true
					}
				}
			},
			"key": {
				"type": "string"
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = profileEncryptedJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return profileEncryptedJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "lkMv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
var h = __webpack_require__("S8e/").default;

var BOTTOM_PADDING = 10;

function growDirective($timeout) {
	return {
		restrict: "A",
		link: function link(scope, element, attributes) {
			var parent = element.parent();
			var initialHeight = parent.innerHeight;

			function ensureSafeCSS() {
				element.css({
					overflow: "hidden",
					resize: "none",
					transition: "none"
				});
			}

			var resetCSS = h.debounce(function () {
				element.css({
					overflow: "",
					resize: "",
					transition: ""
				});
			}, 50);

			/* this does not work with transitions */
			function updateHeight() {
				ensureSafeCSS();

				parent.height(0);
				var height = element[0].scrollHeight;

				if (height >= initialHeight) {
					height = height + BOTTOM_PADDING;
				}

				height = Math.max(height, initialHeight);
				height = Math.min(parseInt(attributes.maximumHeight, 10), height);
				parent.innerHeight(height);

				resetCSS();
			}

			element.on("keydown keyup paste", updateHeight);

			scope.$watch(function () {
				return scope[attributes.grow];
			}, function (isActive) {
				if (isActive) {
					$timeout(function () {
						initialHeight = parent.innerHeight();
						updateHeight();
					});
				} else if (isActive === false) {
					parent.innerHeight("");
				}
			});
		}
	};
}

directivesModule.directive("grow", ["$timeout", growDirective]);

/***/ }),

/***/ "llow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cache__ = __webpack_require__("4PxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_securedDataWithMetaData__ = __webpack_require__("eRn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_service__ = __webpack_require__("0kGL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__ = __webpack_require__("1mek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mutableObjectLoader__ = __webpack_require__("H35O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_socket_service__ = __webpack_require__("8I7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_userService__ = __webpack_require__("UuKm");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var errors = __webpack_require__("a86h");

var initService = __webpack_require__("EKxj");




var signatureCache = __webpack_require__("YFD0");
var debug = __webpack_require__("jcLW");
var STORESIGNATURECACHEINTERVAL = 30000;
var debugName = "whispeer:trustService";
var trustServiceDebug = debug(debugName);
function time(name) {
    if (debug.enabled(debugName)) {
        console.time(name);
    }
}
function timeEnd(name) {
    if (debug.enabled(debugName)) {
        console.timeEnd(name);
    }
}
var loadTrustInfo = function (data) {
    return __WEBPACK_IMPORTED_MODULE_7__users_userService__["default"].getOwnAsync().then(function (ownUser) {
        var ownKey = ownUser.getSignKey();
        if (!data) {
            var userid = ownUser.getID();
            var nickname = ownUser.getNickname();
            return {
                nicknames: (_a = {},
                    _a[nickname] = ownKey,
                    _a),
                ids: (_b = {},
                    _b[userid] = ownKey,
                    _b),
                me: ownKey,
                keys: (_c = {},
                    _c[ownKey] = Object(__WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__["userToDataSet"])({ key: ownKey, userid: userid, nickname: nickname }, __WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__["trustStates"].OWN),
                    _c),
                signature: ""
            };
        }
        if (data.me !== ownKey) {
            throw new errors.SecurityError("not my trust database");
        }
        var givenDatabase = __WEBPACK_IMPORTED_MODULE_2__asset_securedDataWithMetaData__["default"].load(undefined, data, __WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__["TRUST_SECURED_OPTIONS"]);
        return givenDatabase.verifyAsync(ownKey, "user")
            .then(function () { return Object(__WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__["transformLegacy"])(givenDatabase.metaGet()); });
        var _a, _b, _c;
    });
};
var signatureCacheObject = new __WEBPACK_IMPORTED_MODULE_1__Cache__["a" /* default */]("signatureCache");
var TrustService = /** @class */ (function () {
    function TrustService() {
        this.storeSignatureCache = function () {
            if (signatureCache.isChanged()) {
                trustServiceDebug("Storing signature cache!");
                time("storedSignatureCache");
                signatureCache.resetChanged();
                signatureCache.getUpdatedVersion().then(function (updatedVersion) {
                    return signatureCacheObject.store(__WEBPACK_IMPORTED_MODULE_3__session_service__["default"].getUserID().toString(), updatedVersion);
                }).then(function () {
                    timeEnd("storedSignatureCache");
                });
            }
        };
        window.setInterval(this.storeSignatureCache, STORESIGNATURECACHEINTERVAL);
        this.waitForLogin();
    }
    TrustService.prototype.waitForLogin = function () {
        __WEBPACK_IMPORTED_MODULE_3__session_service__["default"].awaitLogin().then(function () {
            time("getSignatureCache");
            return signatureCacheObject.get(__WEBPACK_IMPORTED_MODULE_3__session_service__["default"].getUserID().toString()).catch(function () {
                return;
            });
        }).then(function (signatureCacheData) {
            timeEnd("getSignatureCache");
            if (signatureCacheData) {
                signatureCache.load(signatureCacheData.data);
            }
            else {
                signatureCache.initialize();
            }
        });
    };
    return TrustService;
}());
var TrustStoreLoader = /** @class */ (function (_super) {
    __extends(TrustStoreLoader, _super);
    function TrustStoreLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TrustStoreLoader;
}(Object(__WEBPACK_IMPORTED_MODULE_5__services_mutableObjectLoader__["c" /* default */])({
    download: function (_id, previousInstance) {
        return __WEBPACK_IMPORTED_MODULE_6__services_socket_service__["default"].awaitConnection()
            .then(function () { return __WEBPACK_IMPORTED_MODULE_6__services_socket_service__["default"].definitlyEmit("trustManager.get", {
            responseKey: "content",
            cacheSignature: previousInstance && previousInstance.getSignature()
        }); })
            .then(function (response) { return response.content; });
    },
    load: function (response, previousInstance) {
        if (previousInstance && response.unChanged) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](__WEBPACK_IMPORTED_MODULE_5__services_mutableObjectLoader__["a" /* SYMBOL_UNCHANGED */]);
        }
        return loadTrustInfo(response.content);
    },
    restore: function (content, previousInstance) {
        if (previousInstance) {
            previousInstance.update(content);
            return previousInstance;
        }
        return new __WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__["TrustStore"](content);
    },
    shouldUpdate: function () { return __WEBPACK_IMPORTED_MODULE_0_bluebird__["resolve"](true); },
    getID: function () { return __WEBPACK_IMPORTED_MODULE_3__session_service__["default"].getUserID(); },
    cacheName: "trustStore"
})));
initService.registerCallback(function () {
    return TrustStoreLoader.get(__WEBPACK_IMPORTED_MODULE_3__session_service__["default"].getUserID())
        .then(function (trustStore) { return __WEBPACK_IMPORTED_MODULE_4__crypto_trustManager__["default"].setTrustStore(trustStore); });
});
new TrustService();


/***/ }),

/***/ "n8tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asset_observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localization_loader__ = __webpack_require__("iuSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Localize = /** @class */ (function (_super) {
    __extends(Localize, _super);
    function Localize(baseLanguage) {
        var _this = _super.call(this) || this;
        _this.dictionary = {};
        _this.dictionaryExtensions = [];
        _this.resourceFileLoaded = false;
        _this.language = window.navigator.language;
        _this.extend = function (dictionary) {
            _this.dictionaryExtensions.push(dictionary);
            _this.notify(_this.language, "localizeResourcesUpdates");
        };
        _this.loadOptionalLocaleExtension = function (location) {
            return _this.loadedPromise
                .then(function () { return __WEBPACK_IMPORTED_MODULE_1__localization_loader__["default"].loadOptionalLocaleExtension(location); })
                .then(function (dictionary) { return _this.extend(dictionary); });
        };
        // loads the language resource file from the server
        _this.initLocalizedResources = function () {
            _this.resourceFileLoaded = false;
            __WEBPACK_IMPORTED_MODULE_1__localization_loader__["default"].loadLanguage(_this.language).then(function (dict) {
                _this.dictionary = dict;
                _this.resourceFileLoaded = true;
                _this.notify(_this.language, "localizeResourcesUpdates");
                _this.onloadedCallback();
            });
        };
        _this.getLanguage = function () { return __WEBPACK_IMPORTED_MODULE_1__localization_loader__["default"].loadedLanguage || _this.language; };
        _this.setLocales = function (_dictionary) {
            this.resourceFileLoaded = true;
            this.dictionary = _dictionary;
        };
        // allows setting of language on the fly
        _this.setLanguage = function (value) {
            if (this.language !== value) {
                this.language = value;
                this.initLocalizedResources();
            }
        };
        _this.parsePluralizationMatcher = function (pluralMatcher) {
            var pluralPart = pluralMatcher.split(".."), min, max;
            if (pluralPart.length === 1) {
                min = parseInt(pluralPart[0], 10);
                max = min;
            }
            else if (pluralPart.length === 2) {
                min = parseInt(pluralPart[0], 10);
                max = parseInt(pluralPart[1], 10);
            }
            if (isNaN(min) && isNaN(max)) {
                return false;
            }
            if (isNaN(min)) {
                min = -Infinity;
            }
            if (isNaN(max)) {
                max = Infinity;
            }
            return { min: min, max: max };
        };
        _this.matchesPluralization = function (pluralMatcher, count) {
            var parsed = this.parsePluralizationMatcher(pluralMatcher);
            return parsed && parsed.min <= count && parsed.max >= count;
        };
        _this.getDictionaryValue = function (value) {
            var keys = value.split(".");
            return [_this.dictionary].concat(_this.dictionaryExtensions).reverse().map(function (dictionary) {
                return keys
                    .reduce(function (prev, attr) { return prev[attr] ? prev[attr] : prev; }, dictionary);
            }).find(function (val) { return typeof val === "string"; });
        };
        // checks the dictionary for a localized resource string
        _this.getLocalizedString = function (value, replacements) {
            if (!_this.resourceFileLoaded) {
                return "";
            }
            var entry = _this.getDictionaryValue(value);
            if (typeof entry === "undefined" || typeof entry === "object") {
                return Localize.invalidTranslation(value);
            }
            if (!replacements) {
                return entry;
            }
            return Object.keys(replacements).reduce(function (prev, element) {
                return prev.replace(Localize.getFullReplacer(element), replacements[element]);
            }, entry);
        };
        if (baseLanguage) {
            _this.language = baseLanguage;
        }
        _this.loadedPromise = new __WEBPACK_IMPORTED_MODULE_2_bluebird__(function (resolve) {
            _this.onloadedCallback = resolve;
        });
        return _this;
    }
    Localize.invalidTranslation = function (value) {
        console.warn("Invalid Translation:" + value);
        return "Missing Translation: " + value;
    };
    Localize.getReplacementString = function (replacer) {
        return "{" + replacer + "}";
    };
    Localize.escapeRegExp = function (string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    };
    Localize.regExpFromString = function (string, mode) {
        return new RegExp(Localize.escapeRegExp(string), mode);
    };
    Localize.getFullReplacer = function (replacer) {
        return Localize.regExpFromString(Localize.getReplacementString(replacer));
    };
    return Localize;
}(__WEBPACK_IMPORTED_MODULE_0__asset_observer__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Localize);


/***/ }),

/***/ "nZLN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sjcl = __webpack_require__("kHLR");
var chelper = {
	getCurveName: function getCurveName(curve) {
		var curcurve;
		for (curcurve in sjcl.ecc.curves) {
			if (sjcl.ecc.curves.hasOwnProperty(curcurve)) {
				if (sjcl.ecc.curves[curcurve] === curve) {
					return curcurve;
				}
			}
		}

		throw "curve not existing";
	},
	getCurve: function getCurve(curveName) {
		if (typeof curveName !== "string" || curveName.substr(0, 1) !== "c") {
			curveName = "c" + curveName;
		}

		if (sjcl.ecc.curves[curveName]) {
			return sjcl.ecc.curves[curveName];
		}

		throw new Error("invalid curve");
	},
	isHex: function isHex(data) {
		return data && typeof data === "string" && !!data.match(/^[A-Fa-f0-9]*$/);
	},
	hex2bits: function hex2bits(t) {
		if (t instanceof Array) {
			return t;
		}

		return sjcl.codec.hex.toBits(t);
	},
	bits2hex: function bits2hex(t) {
		if (typeof t === "string") {
			return t;
		}

		return sjcl.codec.hex.fromBits(t);
	}
};

module.exports = chelper;

/***/ }),

/***/ "nkYK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");
var h = __webpack_require__("S8e/").default;

var errorService = __webpack_require__("EFCD").errorServiceInstance;

var migrations = ["regenerateFriendsKeys", "fixBrokenSettings"];

function runMigration(ownUser, migrationState) {
	return Bluebird.try(function () {
		var migration = __webpack_require__("K6VQ")("./" + h.pad("" + (migrationState + 1), 5) + "-" + migrations[migrationState]);
		return migration();
	}).then(function (success) {
		if (!success) {
			console.error("Migration failed " + migrationState, success);
			//AUTSCH!
		} else {
			return ownUser.setMigrationState(migrationState + 1);
		}
	});
}

var doMigration = function doMigration() {
	var ownUser = __webpack_require__("UuKm").default.getOwn(),
	    migrationState;

	if (ownUser) {
		ownUser.getMigrationState().then(function (state) {
			migrationState = h.parseDecimal(state) || 0;
			if (migrationState < migrations.length) {
				return runMigration(ownUser, migrationState);
			}
		}).catch(errorService.criticalError);
	}
};

module.exports = doMigration;

/***/ }),

/***/ "o75H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
directive to eat clicks.
stops event default, mainly necessary for links
**/

var jQuery = __webpack_require__("juYr");
var directivesModule = __webpack_require__("7Eh3");

function eatClickDirective() {
	return function (scope, element) {
		jQuery(element).click(function (event) {
			event.preventDefault();
		});
	};
}

directivesModule.directive("eatClick", eatClickDirective);

/***/ }),

/***/ "obS/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__("aeQg");

__webpack_require__("RXrU");
__webpack_require__("Z7zX");
__webpack_require__("txTk");
__webpack_require__("fiwE");
__webpack_require__("llow");

module.exports = angular.module("ssn.recovery", ["ssn.directives", "ssn.runners", "localization"]);

/***/ }),

/***/ "pO06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InternalSymbol */
function copyOwnFrom(target, source) {
    Object.getOwnPropertyNames(source).forEach(function (propName) {
        Object.defineProperty(target, propName, Object.getOwnPropertyDescriptor(source, propName));
    });
    return target;
}
var InternalSymbol = /** @class */ (function () {
    function InternalSymbol(name, props) {
        this.name = name;
        if (props) {
            copyOwnFrom(this, props);
        }
        if (Object.freeze) {
            Object.freeze(this);
        }
    }
    InternalSymbol.prototype.toString = function () {
        return "|" + this.name + "|";
    };
    return InternalSymbol;
}());

var Enum = /** @class */ (function () {
    function Enum(obj) {
        if (Array.isArray(obj)) {
            obj.forEach(function (name) {
                this[name] = new InternalSymbol(name);
            }, this);
        }
        else {
            Object.keys(obj).forEach(function (name) {
                this[name] = new InternalSymbol(name, obj[name]);
            }, this);
        }
    }
    Enum.prototype.toString = function (symbol) {
        if (this.contains(symbol)) {
            return symbol.toString();
        }
        throw new Error("symbol not part of this enum");
    };
    ;
    Enum.prototype.fromString = function (name) {
        if (name.substr(0, 1) === "|" && name.substr(-1, 1) === "|") {
            var sym = this[name.substring(1, name.length - 1)];
            if (sym instanceof InternalSymbol) {
                return sym;
            }
        }
        return null;
    };
    ;
    Enum.prototype.symbols = function () {
        var _this = this;
        return Object.keys(this).map(function (key) { return _this[key]; });
    };
    ;
    Enum.prototype.symbolPosition = function (symbol) {
        return this.symbols().indexOf(symbol);
    };
    ;
    Enum.prototype.contains = function (sym) {
        return this[sym.name] === sym;
    };
    ;
    return Enum;
}());
/* harmony default export */ __webpack_exports__["a"] = (Enum);


/***/ }),

/***/ "qPM5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("bZZ3");
var circleService = __webpack_require__("silk");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function createcircle() {
	return {
		scope: {
			"name": "=",
			"afterCreate": "&"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: false,
		transclude: false,
		link: function link(scope) {
			scope.createCircle = function (name) {
				circleService.create(name).then(function (circle) {
					scope.afterCreate({
						circle: circle
					});
				});
			};
		}
	};
}

createcircle.$inject = [];

directivesModule.directive("createcircle", createcircle);

/***/ }),

/***/ "rcaN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var h = __webpack_require__("S8e/").default;

module.exports = function ($injector, scope, iElement) {
	var selectedIDs = [];
	scope.selectedElements = [];
	scope.previewCount = 0;
	scope.hiddenCount = 0;

	var $timeout = $injector.get("$timeout");

	function updatePreviewCount() {
		var PLUSWIDTH = 55;

		scope.previewCount = scope.selectedElements.length;

		var element = iElement.find(".search-form");

		var availableWidth = element.innerWidth();

		var MININPUTWIDTH = availableWidth * 0.4 > 100 ? availableWidth * 0.4 : 100;

		var selectedWidth = 0,
		    found = false;
		element.find(".search-result").slice(0, -1).each(function (i, e) {
			if (!found) {
				e = jQuery(e);

				var wasHidden = e.hasClass("ng-hide");

				e.removeClass("ng-hide");

				var elementWidth = e.outerWidth();
				var takenWidth = selectedWidth + elementWidth + MININPUTWIDTH + PLUSWIDTH;

				if (takenWidth > availableWidth && i !== 0) {
					scope.previewCount = Math.max(0, i);
					found = true;
				} else {
					selectedWidth += elementWidth;
				}

				if (wasHidden) {
					e.addClass("ng-hide");
				}
			}
		});

		scope.hiddenCount = Math.max(0, scope.selectedElements.length - scope.previewCount);
		scope.remainingWidth = availableWidth - selectedWidth - (scope.hiddenCount > 0 ? PLUSWIDTH : 0);
	}
	/* this has to run once since the input width would not be set for searches without selected elements */
	updatePreviewCount();

	function selectionUpdated() {
		$timeout(updatePreviewCount);

		scope.results = scope.applyFilterToResults(scope.unFilteredResults);
		scope.setCurrent(scope.current);
		scope.callback({ selected: selectedIDs });
	}

	function loadInitialSelection() {
		var initialPromise = scope.initialValues();
		if (initialPromise) {
			initialPromise.then(function (initialValues) {
				scope.selectedElements = initialValues.map(function (e) {
					return {
						result: e,
						id: e.id,
						name: e.name
					};
				});

				selectedIDs = initialValues.map(function (e) {
					return e.id;
				});

				selectionUpdated();
			});
		}
	}

	scope.filter.push(function (results) {
		return results.filter(function (result) {
			return selectedIDs.indexOf(result.id) === -1;
		});
	});

	scope.selectResult = function (result) {
		var name = result.name;
		var id = result.id;

		if (selectedIDs.indexOf(id) === -1) {
			scope.selectedElements.push({
				result: result,
				id: id,
				name: name
			});
			selectedIDs.push(id);

			scope.setCurrent(scope.current);
		}

		scope.query = "";
		scope.queryChange(true);

		selectionUpdated();
	};

	scope.markedForDeletion = -1;

	scope.removeSelection = function (index, $event) {
		if ($event) {
			$event.stopPropagation();
			$event.preventDefault();
		}

		scope.$emit("elementRemoved", scope.selectedElements[index]);
		scope.selectedElements.splice(index, 1);
		selectedIDs.splice(index, 1);
		scope.markedForDeletion = -1;

		selectionUpdated();
	};

	scope.$on("resetSearch", function () {
		scope.selectedElements = [];
		selectedIDs = [];
	});

	scope.$on("reloadInitialSelection", function () {
		loadInitialSelection();
	});

	loadInitialSelection();

	var BACKSPACE = [8];

	scope.keydown = h.addAfterHook(scope.keydown, function (e) {
		if (BACKSPACE.indexOf(e.keyCode) > -1 && scope.query.length === 0) {
			if (scope.markedForDeletion !== -1) {
				scope.removeSelection(scope.markedForDeletion);
			} else {
				scope.markedForDeletion = scope.selectedElements.length - 1;
			}

			e.preventDefault();
		}
	});

	scope.$watch(function () {
		return scope.isVisible();
	}, function (isVisible) {
		if (isVisible) {
			scope.showSelectedElements = false;
		}
	});

	scope.showSelectedElements = false;
	scope.doShowSelectedElements = function (bool) {
		scope.showSelectedElements = bool;
		scope.hide();
	};
};

/***/ }),

/***/ "s4FU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

function lazyiframeDirective() {
	return {
		restrict: "E",
		template: "",
		link: function link(scope, iElement, iAttrs) {
			var attributes = {},
			    attributesEmpty = [];

			Object.keys(iAttrs.$attr).filter(function (attr) {
				return attr.indexOf("ng") !== 0;
			}).map(function (attr) {
				return {
					key: attr,
					val: iAttrs.$attr[attr]
				};
			}).forEach(function (attr) {
				attributes[attr.val] = iAttrs[attr.key];
				attributesEmpty.push(attr.val);
			});

			function append() {
				iElement.append(jQuery("<iframe>").attr(attributes));

				attributesEmpty.forEach(function (attr) {
					iElement.removeAttr(attr);
				});
			}

			if (iAttrs.delay) {
				window.setTimeout(append, parseInt(iAttrs.delay, 10));
			} else {
				append();
			}
		}
	};
}

directivesModule.directive("lazyiframe", lazyiframeDirective);

/***/ }),

/***/ "sbg5":
/***/ (function(module, exports) {

var path = 'directives/inviteButtons.html';
var html = "<div class=inviteButtons-wrapper> <button data-ng-click=\"open('facebook')\" target=_blank class=\"btn shareButton shareButton--fb newsfeedView-shareButton\"> <i class=\"fa fa-facebook\"></i> <span>Facebook</span> </button> <button data-ng-click=\"open('twitter')\" target=_blank class=\"btn shareButton shareButton--tw newsfeedView-shareButton\"> <i class=\"fa fa-twitter\"></i> <span>Twitter</span> </button> <button data-ng-click=\"open('google')\" target=_blank class=\"btn shareButton shareButton--gp newsfeedView-shareButton\"> <i class=\"fa fa-google-plus\"></i> <span>Google+</span> </button> <button data-ng-click=\"open('reddit')\" target=_blank class=\"btn shareButton shareButton--rd newsfeedView-shareButton\"> <i class=\"fa fa-reddit\"></i> <span>Reddit</span> </button> <a whispeer-sref=app.invite.mail class=\"btn btn--primary shareButton newsfeedView-shareButton\"> <i class=\"fa fa-envelope\"></i> <span>E-Mail</span> </a> <a ui-sref=app.invite.link class=\"btn btn--primary shareButton newsfeedView-shareButton\"> <i class=\"fa fa-link\"></i> <span>Link</span> </a> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "sciG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

var templateUrl = __webpack_require__("vjt0");

var loadingProgressDirective = function loadingProgressDirective() {
	return {
		scope: {
			"getProgress": "=getProgress"
		},
		transclude: true,
		restrict: "E",
		templateUrl: templateUrl,
		link: function link() {}
	};
};

directivesModule.directive("loadingProgress", loadingProgressDirective);

/***/ }),

/***/ "silk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**.
* MessageService
**/

var h = __webpack_require__("S8e/").default;
var Observer = __webpack_require__("SiYL");
var SecuredData = __webpack_require__("eRn5").default;
var Bluebird = __webpack_require__("fp6q");

var socket = __webpack_require__("8I7s").default;
var keyStore = __webpack_require__("IeOO").default;
var initService = __webpack_require__("EKxj");

var settingsService = __webpack_require__("Etis").default;

var friendsService = __webpack_require__("5O0x");

var circles = {};
var circleArray = [];
var circleData = [];

function encryptKeyForUsers(key, users, cb) {
	return Bluebird.resolve(users).map(h.parseDecimal).map(function (userID) {
		if (!friendsService.getUserFriendShipKey(userID)) {
			throw new Error("no friend key for user: " + userID);
		}

		return friendsService.getUserFriendShipKey(userID);
	}).map(function (friendKey) {
		return keyStore.sym.symEncryptKey(key, friendKey).thenReturn(friendKey);
	}).nodeify(cb);
}

function generateNewKey(cb) {
	return keyStore.sym.generateKey(null, "CircleKey").then(function (key) {
		var userService = __webpack_require__("UuKm").default;
		var mainKey = userService.getOwn().getMainKey();

		return keyStore.sym.symEncryptKey(key, mainKey).thenReturn(key);
	}).nodeify(cb);
}

var Circle = function Circle(data) {
	var id = data.id,
	    theCircle = this,
	    persons = [];

	var circleSec = SecuredData.load(data.content, data.meta, { type: "circle" });
	var circleUsers = circleSec.metaAttr("users").map(h.parseDecimal);

	this.getID = function getIDF() {
		return id;
	};

	this.getUserIDs = function () {
		return circleUsers;
	};

	this.hasUser = function (uid) {
		return circleUsers.indexOf(h.parseDecimal(uid)) !== -1;
	};

	this.getKey = function () {
		return circleSec.metaAttr("circleKey");
	};

	this.remove = function (cb) {
		return settingsService.removeCircle().then(function () {
			return socket.emit("circle.delete", {
				remove: {
					circleid: id
				}
			});
		}).then(function () {
			var circle = circles[id];
			delete circles[id];
			h.removeArray(circleArray, circle);
			h.removeArray(circleData, circle.data);
		}).nodeify(cb);
	};

	this.setUser = function (uids, cb) {
		var newKey,
		    oldKey = circleSec.metaAttr("circleKey"),
		    removing = false,
		    friendKeys;

		return Bluebird.try(function () {
			uids = uids.map(h.parseDecimal);
			removing = h.arraySubtract(circleUsers, uids).length > 0;

			if (removing) {
				return generateNewKey();
			}

			return oldKey;
		}).then(function (_newKey) {
			newKey = _newKey;

			if (removing) {
				return keyStore.sym.symEncryptKey(oldKey, newKey).thenReturn(newKey);
			}

			return newKey;
		}).then(function (newKey) {
			if (removing) {
				return encryptKeyForUsers(newKey, uids);
			} else {
				return encryptKeyForUsers(newKey, h.arraySubtract(uids, circleUsers));
			}
		}).then(function (_friendKeys) {
			friendKeys = _friendKeys;
			circleSec.metaSet({
				users: uids,
				circleKey: newKey
			});

			var userService = __webpack_require__("UuKm").default;
			return circleSec.getUpdatedData(userService.getOwn().getSignKey());
		}).then(function (newData) {
			var update = {
				id: id,
				content: newData.content,
				meta: newData.meta
			};

			if (removing) {
				update.decryptors = keyStore.upload.getDecryptors([oldKey], [newKey]);
				update.key = keyStore.upload.getKey(newKey);
			} else {
				update.decryptors = keyStore.upload.getDecryptors([newKey], friendKeys);
			}

			return socket.emit("circle.update", { update: update });
		}).then(function () {
			//emit
			circleUsers = uids;
			persons = persons.filter(function (user) {
				return uids.indexOf(user.id) > -1;
			});
			theCircle.data.persons = persons;
			theCircle.data.userids = circleUsers;

			if (removing) {
				var userService = __webpack_require__("UuKm").default;
				var ownUser = userService.getOwn();

				//rebuild profiles
				return ownUser.uploadChangedProfile();
			}
		}).then(function () {
			return theCircle.loadPersons();
		}).nodeify(cb);
	};

	this.removePersons = function (uids, cb) {
		uids = uids.map(h.parseDecimal).filter(function (e) {
			return circleUsers.indexOf(e) > -1;
		});

		var users = circleUsers.filter(function (e) {
			return uids.indexOf(e) === -1;
		});

		this.setUser(users, cb);
	};

	this.addPersons = function (uids, cb) {
		return Bluebird.resolve(uids).bind(this).filter(function (uid) {
			return circleUsers.indexOf(uid) === -1;
		}).then(function (uids) {
			this.setUser(uids.concat(circleUsers), cb);
		});
	};

	this.load = function (cb) {
		var userService = __webpack_require__("UuKm").default;
		return Bluebird.all([circleSec.decrypt(), circleSec.verify(userService.getOwn().getSignKey(), undefined, id)]).spread(function (content) {
			keyStore.security.addEncryptionIdentifier(circleSec.metaAttr("circleKey"));
			theCircle.data.name = content.name;
		}).nodeify(cb);
	};

	this.loadPersons = function (cb, limit) {
		limit = limit || 20;
		limit = Math.min(h.parseDecimal(limit), 20);

		if (persons.length >= circleUsers.length) {
			return Bluebird.resolve().nodeify(cb);
		}

		return Bluebird.try(function () {
			var loadedIDs = persons.map(function (p) {
				return p.id;
			});
			var loadableUsers = circleUsers.filter(function (user) {
				return loadedIDs.indexOf(user) === -1;
			});

			var userService = __webpack_require__("UuKm").default;

			return userService.getMultiple(loadableUsers.slice(0, limit));
		}).map(function (user) {
			persons.push(user.data);

			return user.loadBasicData().thenReturn(user);
		}).nodeify(cb);
	};

	this.data = {
		id: id,
		userids: circleUsers,
		name: "",
		image: "assets/img/circle.png",
		persons: persons
	};

	Observer.extend(this);
};

var loadingPromise;

function makeCircle(data) {
	var circle = new Circle(data);
	var id = circle.getID();

	if (circles[id]) {
		return;
	}

	circles[id] = circle;
	circleArray.push(circle);
	circleData.push(circle.data);

	return circle;
}

var circleService = {
	data: {
		loaded: false,
		loading: false,
		circles: circleData
	},
	get: function get(id) {
		return circles[id];
	},
	inWhichCircles: function inWhichCircles(uid) {
		uid = h.parseDecimal(uid);

		return circleArray.filter(function (circle) {
			return circle.hasUser(uid);
		});
	},
	create: function create(name, users) {
		users = (users || []).map(h.parseDecimal);

		return generateNewKey().then(function (symKey) {
			return encryptKeyForUsers(symKey, users).then(function () {
				var userService = __webpack_require__("UuKm").default;
				var own = userService.getOwn();
				var mainKey = own.getMainKey();

				return SecuredData.createAsync({ name: name }, {
					users: users,
					circleKey: symKey
				}, { type: "circle" }, own.getSignKey(), mainKey);
			}).then(function (circleData) {
				var keyData = keyStore.upload.getKey(symKey);

				return socket.emit("circle.create", {
					circle: {
						key: keyData,
						content: circleData.content,
						meta: circleData.meta
					}
				});
			}).then(function (circleResponse) {
				var theCircle = makeCircle(circleResponse.created);
				return theCircle.load().thenReturn(theCircle);
			});
		});
	},
	reset: function reset() {
		circles = {};
		circleArray = [];
		circleData = [];

		circleService.data.circles = circleData;

		circleService.data.loading = false;
		circleService.data.loaded = false;
	},
	loadAll: function loadAll(cb) {
		if (!loadingPromise) {
			loadingPromise = Bluebird.try(function () {
				circleService.data.loading = false;

				return initService.awaitLoading();
			}).then(function () {
				return socket.definitlyEmit("circle.all", {});
			}).then(function (data) {
				if (data.circles) {
					return data.circles;
				} else {
					throw new Error("server did not return circles");
				}
			}).map(function (circleData) {
				var circle = makeCircle(circleData);
				return Bluebird.fromCallback(function (cb) {
					circle.load(cb);
				});
			}).then(function () {
				circleService.data.loading = false;
				circleService.data.loaded = true;
				circleService.notify("", "loaded");
			});
		}

		return loadingPromise.nodeify(cb);
	}
};

Observer.extend(circleService);

module.exports = circleService;

/***/ }),

/***/ "tFpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_state__ = __webpack_require__("uJ4a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Cache__ = __webpack_require__("4PxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_error_service__ = __webpack_require__("EFCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_keyStore_service__ = __webpack_require__("IeOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_session_service__ = __webpack_require__("0kGL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_socket_service__ = __webpack_require__("8I7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_userService__ = __webpack_require__("UuKm");










var controllerModule = __webpack_require__("obS/");
function recoveryController($scope) {
    var parts = window.location.pathname.split("/");
    var nick, recoveryCode;
    __WEBPACK_IMPORTED_MODULE_3__services_Cache__["a" /* default */].disable();
    parts = parts.filter(function (v) {
        return v !== "";
    });
    if (parts.length >= 3) {
        recoveryCode = parts.pop();
        nick = parts.pop();
        $scope.codeProvided = true;
    }
    $scope.manual = {
        code: ""
    };
    $scope.qr = {
        enabled: $scope.codeProvided
    };
    var savePasswordState = new __WEBPACK_IMPORTED_MODULE_2__asset_state__["default"]();
    $scope.savePasswordState = savePasswordState.data;
    var loadBackupKeyState = new __WEBPACK_IMPORTED_MODULE_2__asset_state__["default"]();
    $scope.loadBackupKeyState = loadBackupKeyState.data;
    $scope.pwValidationOptions = {
        validateOnCallback: true,
        hideOnInteraction: true
    };
    $scope.changePassword = {
        password: "",
        enabled: false
    };
    $scope.savePassword = function () {
        savePasswordState.pending();
        if ($scope.pwValidationOptions.checkValidations()) {
            savePasswordState.failed();
            return;
        }
        var savePromise = __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            return __WEBPACK_IMPORTED_MODULE_8__users_userService__["default"].getOwn().changePassword($scope.changePassword.password);
        }).then(function () {
            if (window.indexedDB) {
                window.indexedDB.deleteDatabase("whispeerCache");
            }
            __WEBPACK_IMPORTED_MODULE_6__services_session_service__["default"].saveSession();
            window.location.href = "/main";
        });
        __WEBPACK_IMPORTED_MODULE_4__services_error_service__["default"].failOnErrorPromise(savePasswordState, savePromise);
    };
    function doRecovery(key) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird__["try"](function () {
            __WEBPACK_IMPORTED_MODULE_5__services_keyStore_service__["default"].setKeyGenIdentifier(nick);
            var keyID = __WEBPACK_IMPORTED_MODULE_5__services_keyStore_service__["default"].sym.loadBackupKey(__WEBPACK_IMPORTED_MODULE_5__services_keyStore_service__["default"].format.unBase32(key));
            __WEBPACK_IMPORTED_MODULE_5__services_keyStore_service__["default"].setKeyGenIdentifier("");
            return __WEBPACK_IMPORTED_MODULE_7__services_socket_service__["default"].emit("recovery.useRecoveryCode", {
                code: recoveryCode,
                keyFingerPrint: keyID
            });
        }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_6__services_session_service__["default"].setLoginData(response.sid, response.userid);
            $scope.changePassword.enabled = true;
        });
    }
    $scope.fileUpload = function (e) {
        var file = e.target.files[0];
        if (!file.type.match(/image.*/i)) {
            return;
        }
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "Tw3P"))
            .then(function (qrreader) { return new __WEBPACK_IMPORTED_MODULE_0_bluebird__(function (resolve) { return qrreader.decode(__WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].toUrl(file), resolve); }); })
            .then(function (code) { return doRecovery(code).catch(__WEBPACK_IMPORTED_MODULE_4__services_error_service__["default"].criticalError); });
    };
    $scope.loadBackupKeyManual = function () {
        loadBackupKeyState.pending();
        var loadPromise = doRecovery($scope.manual.code);
        __WEBPACK_IMPORTED_MODULE_4__services_error_service__["default"].failOnErrorPromise(loadBackupKeyState, loadPromise);
    };
    $scope.backupKeyCallback = function (key) {
        return doRecovery(key).then(function (e) {
            if (e) {
                $scope.qr.reset();
            }
            return e;
        }).catch(__WEBPACK_IMPORTED_MODULE_4__services_error_service__["default"].criticalError);
    };
    var requestState = new __WEBPACK_IMPORTED_MODULE_2__asset_state__["default"]();
    $scope.request = {
        identifier: "",
        state: requestState.data,
        execute: function (identifier) {
            requestState.pending();
            var requestPromise = __WEBPACK_IMPORTED_MODULE_7__services_socket_service__["default"].emit("recovery.request", { identifier: identifier });
            __WEBPACK_IMPORTED_MODULE_4__services_error_service__["default"].failOnErrorPromise(requestState, requestPromise);
        }
    };
}
controllerModule.controller("ssn.recoveryController", ["$scope", recoveryController]);


/***/ }),

/***/ "txTk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");
var runnerModule = __webpack_require__("HXS4");
var Observer = __webpack_require__("SiYL").default;

runnerModule.run(["$rootScope", function ($rootScope) {
	"use strict";

	Bluebird.setScheduler(function (cb) {
		$rootScope.$evalAsync(cb);
	});

	Observer.addAfterHook(function () {
		$rootScope.$evalAsync();
	});
}]);

/***/ }),

/***/ "uJ4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enum__ = __webpack_require__("pO06");

var states = new __WEBPACK_IMPORTED_MODULE_0__enum__["a" /* default */](["INIT", "PENDING", "SUCCESS", "FAILED"]);
var State = /** @class */ (function () {
    function State() {
        this._state = states.INIT;
        this.data = {
            init: true,
            pending: false,
            success: false,
            failed: false
        };
    }
    State.prototype._turnOneDataTrue = function () {
        states.symbols().forEach(function (symbol) {
            var name = symbol.name.toLowerCase();
            if (this._state === symbol) {
                this.data[name] = true;
            }
            else {
                this.data[name] = false;
            }
        }, this);
    };
    ;
    State.prototype.success = function () {
        if (this._state === states.PENDING) {
            this._state = states.SUCCESS;
            this._turnOneDataTrue();
        }
    };
    ;
    State.prototype.failed = function () {
        if (this._state === states.PENDING) {
            this._state = states.FAILED;
            this._turnOneDataTrue();
        }
    };
    ;
    State.prototype.reset = function () {
        this._state = states.INIT;
        this._turnOneDataTrue();
    };
    ;
    State.prototype.pending = function () {
        this._state = states.PENDING;
        this._turnOneDataTrue();
    };
    ;
    State.prototype.isPending = function () {
        return this._state === states.PENDING;
    };
    ;
    State.prototype.isSuccess = function () {
        return this._state === states.SUCCESS;
    };
    ;
    State.prototype.isFailed = function () {
        return this._state === states.FAILED;
    };
    ;
    State.prototype.isInit = function () {
        return this._state === states.INIT;
    };
    ;
    State.prototype.getState = function () {
        return this._state;
    };
    ;
    State.prototype.getPossibleStates = function () {
        return states;
    };
    ;
    return State;
}());
/* harmony default export */ __webpack_exports__["default"] = (State);


/***/ }),

/***/ "uLQx":
/***/ (function(module, exports) {

var path = 'directives/loadingindicator.html';
var html = "<div class=loader data-ng-class=\"'loader-' + color\"> <div class=\"loader-bounce loader-bounce1\"></div> <div class=\"loader-bounce loader-bounce2\"></div> <div class=\"loader-bounce loader-bounce3\"></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "uPVY":
/***/ (function(module, exports) {

var path = 'directives/post.html';
var html = "<article class=post data-ng-class=\"{'post-visible-selection': post.visibleSelection.length > 0}\"> <aside class=post-meta> <a whispeer-sref=\"app.user.info({identifier: post.sender.names.nickname})\" class=post-userimage> <userimage data-user=post.sender></userimage> </a> <strong class=post-username> <a whispeer-sref=\"app.user.info({identifier: post.sender.names.nickname})\">{{post.sender.name}}</a> </strong> <span data-ng-if=post.walluser class=post-receiver> <i class=\"fa fa-caret-right\"></i> <strong class=post-receiver-name> <a whispeer-sref=\"app.user.info({identifier: post.walluser.names.nickname})\">{{post.walluser.name}}</a> </strong> </span> <a whispeer-sref=\"app.post({postID: post.id})\" class=post-link><i class=\"fa fa-link\"></i></a> </aside> <p class=post-content data-syntaxify=::post.content.text></p> <gallery data-images=post.images></gallery> <aside class=post-actions> <span class=post-date> <i class=\"fa fa-clock-o\"></i>&nbsp;<span class=post-date-time data-smart-date=post.time></span> </span> <div class=post-actions-buttons> <span data-accessible-click=toggleShowComments() class=\"post-action post-action-button\"><i class=\"fa fa-comment\"></i>&nbsp;<span data-i18n=wall.comments></span> ({{post.comments.length}})</span> <span data-ng-if=::post.removable data-accessible-click=removePost() class=\"post-action post-action-button post-action--pull-right\"> <i class=\"fa fa-times fa-fw\"></i>&nbsp;<span data-i18n=wall.remove></span> </span> <span data-ng-if=::post.visibleSelection class=post-action-visibility> <i class=\"fa fa-eye fa-fw\"></i> <span data-i18n=wall.post.visible></span> <span class=\"btn btn--xs btn--gray post-action-visibility-button\" data-ng-repeat=\"visibleFilterKey in post.visibleSelection\" data-ng-if=visibleFilterKey> <a whispeer-sref={{visibleFilterKey.sref}}>{{visibleFilterKey.name}}</a> </span> </span> </div> </aside> <aside class=post-comments ng-show=showComments> <ul class=post-comments-list> <li class=post-comments-loading data-ng-show=post.commentsLoading> <loadingindicator></loadingindicator> <p data-i18n=wall.commentsLoading></p> </li> <comment data-ng-show=!post.commentsLoading data-ng-repeat=\"comment in post.comments\" comment=comment></comment> </ul> <div class=clear-fix> <textarea class=post-newComment data-i18n-attr=wall.newComment|placeholder data-strg-enter=post.newComment.create(post.newComment.text) data-ng-model=post.newComment.text></textarea> <savebutton class=post-sendComment data-ng-click=post.newComment.create(post.newComment.text) data-state=post.newComment.state data-noiniticon> <span data-i18n=wall.postit.send></span> </savebutton> </div> </aside> </article> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "uX9v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");
function scrollToIDDirective() {
	return {
		restrict: "A",
		link: function link(scope, iElement, iAttrs) {
			iElement.click(function () {
				var elm,
				    hash = iAttrs.scrolltoid;

				if (elm = document.getElementById(hash)) {
					elm.scrollIntoView();
				}
			});
		}
	};
}
scrollToIDDirective.$inject = ["$location", "$anchorScroll"];
scrollToIDDirective.$name = "scrolltoid";

directivesModule.directive("scrolltoid", scrollToIDDirective);

/***/ }),

/***/ "uazT":
/***/ (function(module, exports) {

var path = 'directives/qrScanner.html';
var html = "<video data-ng-if=!state.read autoplay></video>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "uidW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	/*
 	topic: {
 		createTime: (int)
 		key: key,
 		receiver: [{identifier, key}],
 		creator: (int),
 		newest (int),
 		unread: (bool)
 	}
 */

	var topicJSON = {
		"name": "Topic",
		"type": "object",
		"extends": "securedData",
		//		"additionalProperties": false,
		"properties": {
			"createTime": {
				"required": true,
				"type": "number",
				"min": 1376244464102
			},
			"_key": {
				"required": true,
				"type": "string"
			},
			"receiver": {
				"required": true,
				"type": "array",
				"items": {
					"type": "integer",
					"min": 1
				}
			},
			"creator": {
				"required": true,
				"type": "number",
				"min": 1
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = topicJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return topicJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "vgEd":
/***/ (function(module, exports) {

var path = 'directives/gallery.html';
var html = "<modal show=modal loading=modalImage.highest.loading> <img class=modalContent-image data-ng-src={{modalImage.highest.url}} data-ng-if=!modalImage.highest.loading> <img class=modalContent-image data-ng-src={{modalImage.lowest.url}} data-ng-if=modalImage.highest.loading> <div class=modalContent-spinner data-ng-if=modalImage.highest.loading><loadingindicator data-color=white class=loader-shadow></loadingindicator></div> </modal> <div class=post-images> <div class=post-imageWrap data-ng-click=viewImage($index) data-image-gallery=images data-ng-repeat=\"image in images\" data-ng-if=\"$index < preview\"> <loading-progress data-get-progress=image.upload.getProgress></loading-progress> <img class=post-image data-ng-if=!runGif($index) data-ng-src={{image.lowest.url}}> <span class=\"post-image--play fa fa-play fa-2x\" data-ng-if=\"image.lowest.gif && !runGif($index)\"></span> <div data-ng-if=runGif($index)> <img class=post-image data-ng-src={{image.highest.url}} data-ng-if=!image.highest.loading> <img class=post-image data-ng-src={{image.lowest.url}} data-ng-if=image.highest.loading> <div class=modalContent-spinner data-ng-if=image.highest.loading><loadingindicator></loadingindicator></div> </div> </div> <button class=\"post-moreImages btn btn--inverse btn--noRadius\" data-ng-click=loadMoreImages() data-ng-if=\"images.length > preview\"> + {{images.length - preview}} </button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "vjt0":
/***/ (function(module, exports) {

var path = 'directives/loadingProgress.html';
var html = "<div data-ng-if=\"getProgress && getProgress() < 1\"> <div class=radial-progress data-progress=\"{{getProgress() * 100 | number: 0}}\"> <div class=circle> <div class=\"mask full\"> <div class=fill></div> </div> <div class=\"mask half\"> <div class=fill></div> <div class=\"fill fix\"></div> </div> <div class=shadow></div> <div class=inset></div> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "w2wy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function () {
	"use strict";

	/*
 	post: {
 		meta: {
 			contentHash,
 			time,
 			signature,
 			(key),
 			(receiver), //for a wallpost
 		}
 		content //padded!
 	}
 */

	var postJSON = {
		"name": "Post",
		"type": "object",
		"properties": {
			"meta": {
				"required": true,
				"type": "object",
				"extends": "securedDataContent",
				"properties": {
					"sender": {
						"required": true,
						"type": "integer"
					},
					"time": {
						"required": true,
						"type": "integer",
						"min": 1388714536420
					},
					"key": {
						"type": "object"
					},
					"walluser": {
						"type": "integer",
						"min": 1
					}
				}
			},
			"content": {
				"type": "object",
				"required": true,
				"extends": "encryptedData",
				"properties": {}
			}
		}
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = postJSON;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return postJSON;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})();

/***/ }),

/***/ "x//1":
/***/ (function(module, exports) {

var path = 'directives/newPost.html';
var html = "<div class=post id=newsfeedView-postForm> <div id=newsfeedView-postFormWrap> <div class=\"annotatedInput-container annotatedInput-container--button annotatedInput-container--hasBorder\"> <textarea data-grow=canSend data-maximum-height=250 data-strg-enter=sendPost() data-ng-model=newPost.text data-i18n-attr={{inputI18nAttr}} id=newsfeedView-shareText data-ng-disabled=!canSend class=annotatedInput-input data-ng-class=\"{'newsfeedView-shareText--fullBorder': newPost.text.length == 0 && newPost.images.length == 0}\"></textarea> <div class=\"uploadForm annotatedInput-button\" id=newsfeedView-shareText-addImages> <span class=\"uploadForm-button btn btn--input btn--noRadius\"> <i class=\"fa fa-camera fa-2x\" id=newsfeedView-addImageIcon></i> </span> <input class=uploadForm-theForm type=file multiple=multiple data-file=newPost.addImages> </div> </div> <div class=newsfeedView-post-fadingPart data-ng-class=\"{'newsfeedView-post-fadingPart--visible animate-heightAndOverflow': newPost.text.length > 0 || newPost.images.length > 0}\"> <search data-ng-if=!wallUserId data-multiple class=\"search--custom search--sideBorder\" data-supplier=filterSearchSupplier data-search-template=filter data-input-i18n-attr=wall.postit.receiver|placeholder id=newsfeedView-receivers data-callback=setPostReaders(selected) data-initial-values=getFiltersByID(newPost.readers) data-base=circle></search> <div id=newsfeed-newPostImages data-ng-class=\"{'animate-heightAndOverflow animate--fill newsfeedView-newPostImages--border': newPost.images.length > 0}\"> <div class=newsfeed-newPostImagePreview data-ng-repeat=\"image in newPost.images\"> <button class=\"newsfeed-newPostImageRemove fa fa-times-circle\" data-ng-click=newPost.removeImage($index)></button> <img class=newsfeed-newPostImage alt={{image.getName()}} data-ng-src={{image.getPreviewUrl()}} data-ng-click=newPost.rotateImage($index)> <progress class=newsfeed-newPostImageProgress value={{image.getProgress()*100}} max=100></progress> </div> </div> <savebutton class=btn--noRadius id=newsfeedView-submit data-ng-click=sendPost() data-state=sendPostState data-noiniticon data-ng-disabled=!canSend> <span data-i18n=wall.postit.send></span> </savebutton> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "yDzV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("uPVY");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function postDirective(localize) {
	return {
		transclude: true,
		scope: {
			post: "=post"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true,
		link: function link(scope) {
			scope.showComments = false;
			scope.toggleShowComments = function () {
				scope.showComments = !scope.showComments;
				scope.post.loadComments();
			};

			scope.removePost = function () {
				if (confirm(localize.getLocalizedString("wall.confirmRemovePost"))) {
					scope.post.remove();
				}
			};
		}
	};
}

directivesModule.directive("post", ["localize", postDirective]);

/***/ }),

/***/ "yQ0X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MyWorker = __webpack_require__("Dshm");
var Bluebird = __webpack_require__("fp6q");

var PromiseWorker = function PromiseWorker() {
	this._busy = true;

	this._worker = new MyWorker();

	this._taskQueue = [];
	this._freeListener = [];
	this._taskCallback = null;
	this._metaListener = null;

	this._worker.onmessage = this._workerMessage.bind(this);

	this._worker.postMessage({
		action: "setup"
	});
};

PromiseWorker.prototype._workerMessage = function (event) {
	var data = event.data.data;var type = event.data.type;
	if (type === "meta" && this._metaListener) {
		this._metaListener(data);
	} else if (type === "resultTask") {
		this._taskCallback.resolve(data);
		this._free();
	} else if (type === "setup") {
		this._free();
	} else if (type === "error") {
		this._taskCallback.reject(data);
		this._free();
	}
};

PromiseWorker.prototype.isBusy = function () {
	return this._busy;
};

PromiseWorker.prototype._lockFree = function () {
	var that = this;
	return new Bluebird(function (resolve) {
		that._taskQueue.push(resolve);
		that._checkQueues();
	});
};

PromiseWorker.prototype.runIfFree = function (data, metaListener) {
	if (!this._busy) {
		return this._run(data, metaListener);
	}

	return false;
};

PromiseWorker.prototype.onFree = function (cb) {
	this._freeListener.push(cb);
};

/** called when the worker is freed.
    - checks if there are any waiting tasks and runs them
    - if no waiting tasks exist calls free listener.
 */
PromiseWorker.prototype._free = function () {
	this._busy = false;
	this._taskCallback = null;
	this._metaListener = null;

	this._checkQueues();
};

PromiseWorker.prototype._checkQueues = function () {
	if (this._busy) {
		return;
	}

	if (this._taskQueue.length > 0) {
		this._busy = true;
		this._taskQueue.shift()();

		return;
	}

	this._freeListener.forEach(function (listener) {
		try {
			listener();
		} catch (e) {
			console.error(e);
		}
	});
};

PromiseWorker.prototype._saveCallbacks = function (resolve, reject) {
	this._taskCallback = {
		resolve: resolve,
		reject: reject
	};
};

PromiseWorker.prototype._run = function (data, metaListener) {
	this._busy = true;
	this._metaListener = metaListener;

	var waitPromise = new Bluebird(this._saveCallbacks.bind(this));
	this._worker.postMessage({
		action: "runTask",
		data: data
	});
	return waitPromise;
};

/** run a task as soon as the worker is free
    @param data data to sent to worker task
    @param metaListener callback for meta information
*/
PromiseWorker.prototype.runTask = function (data, metaListener) {
	return this._lockFree().then(this._run.bind(this, data, metaListener));
};

module.exports = PromiseWorker;

/***/ }),

/***/ "ym3/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");

var friendsService = __webpack_require__("5O0x");
var keyStore = __webpack_require__("IeOO").default;

function fixInvalidKey(invalidKey, friendsService) {
	var userid;

	return Bluebird.try(function () {
		userid = friendsService.getUserForKey(invalidKey);
		return friendsService.removeFriend(userid);
	}).then(function () {
		return friendsService.friendship(userid);
	}).then(function () {
		console.log("fixed invalid key: " + invalidKey);
	});
}

module.exports = function () {
	var friendsKeys;

	return friendsService.awaitLoading().then(function () {
		friendsKeys = friendsService.getAllFriendShipKeys();
		return keyStore.upload.preLoadMultiple(friendsKeys);
	}).then(function () {
		var invalidKeys = friendsKeys.filter(function (realid) {
			return !keyStore.upload.isKeyLoaded(realid);
		});

		if (invalidKeys.length === 0) {
			return true;
		} else {
			return invalidKeys.reduce(function (previous, invalidKey) {
				return previous.then(function () {
					return fixInvalidKey(invalidKey, friendsService);
				});
			}, Bluebird.resolve());
		}
	}).then(function () {
		return true;
	});
};

/***/ }),

/***/ "zDWf":
/***/ (function(module, exports) {

var path = 'directives/searchMultiple.html';
var html = "<div class=\"search search--multiple {{addClasses}}\"> <div class=search-form> <ul class=search-wrapper data-ng-class=\"{'search--activeRadius': results.length > 0 && isVisible()}\"> <li data-ng-repeat=\"element in selectedElements\" class=\"search-result btn btn--noRadius\" data-ng-show=\"$index<previewCount\"> <img class=search-result-image data-ng-if=\"element.result.basic.image.length > 0\" data-ng-src={{element.result.basic.image}} alt={{element.name}} /> <span class=search-result-name>{{element.name}}</span> <i class=\"search-result-remove fa fa-times-circle\" data-ng-click=\"removeSelection($index, $event)\"></i> </li><li class=\"search-result search-result--hiddenCount btn btn--noRadius\" data-ng-show=\"hiddenCount > 0\" data-ng-click=doShowSelectedElements(true)> <span class=search-result-name>+{{hiddenCount}}</span> </li><li class=search-input> <input type=text class=\"search-query input-custom\" data-i18n-attr={{inputI18nAttr}} data-ng-click=show($event) data-ng-keydown=keydown($event) data-ng-change=queryChange() data-ng-model=query data-onfocus=show() style=width:{};> </li> </ul> </div> <div class=search-resultsDrop data-ng-show=isVisible() data-ng-class=\"{'search-resultsDrop--addBorder': results.length > 0}\"> <div class=search-resultsDrop-spinner data-ng-if=searching> <loadingindicator></loadingindicator> <p class=noMargin-bottom data-i18n=search.searching></p> </div> <div class=search-resultsDrop-content data-ng-include=\"'search/' + searchTemplate + 'Search.html'\"></div> </div> <div class=\"dropdown search-selectedDrop\" data-ng-if=showSelectedElements data-ng-include=\"'search/' + selectDropTemplate  +'SelectDrop.html'\"> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "zbu2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Warning! This code manipulates the DOM, do only change with extra care as you might create Cross-Site-Scripting holes */

var jQuery = __webpack_require__("juYr");
var directivesModule = __webpack_require__("7Eh3");
var EmojifyConverter = __webpack_require__("dpCq");

var syntaxifyDirective = function syntaxifyDirective($timeout) {
	"use strict";

	var emojify = new EmojifyConverter();
	emojify.img_sets.apple.sheet = "/assets/img/sheet_apple_16.png";
	emojify.use_sheet = true;
	emojify.include_title = true;

	var ignoreAsLastCharacter = ["'", ")", "\"", "."];
	var linkElement = jQuery("<a>").attr("target", "_blank");
	var emojiElementOuter = jQuery("<span>").addClass("emoji-outer").addClass("emoji-sizer");
	var emojiElementInner = jQuery("<span>").addClass("emoji-inner").css("background", "url(" + emojify.img_sets.apple.sheet + ")");

	function appendUrl(elm, url, remainingTextCallback) {
		var i,
		    removeUntil = 0;
		for (i = -1; i > -5; i -= 1) {
			//if i:=-1 than i+1 would be 0 and thus the slice would be empty.
			var lastCharacter = url.slice(i, i + 1 || undefined);
			if (ignoreAsLastCharacter.indexOf(lastCharacter) === -1) {
				removeUntil = i + 1;
				break;
			}
		}

		var removedCharacters = "";

		if (removeUntil) {
			removedCharacters = url.slice(removeUntil);
			url = url.slice(0, removeUntil);
		}

		elm.append(linkElement.clone().attr("href", url).text(url));

		if (removeUntil) {
			remainingTextCallback(removedCharacters);
		}
	}

	function urlify(elm, text, remainingTextCallback) {
		/*
  /                                   # Start at the beginning of the text
  (?:ftp|http|https):\/\/              # Look for ftp, http, or https
  (?:                                  # Username:password combinations (optional)
  	[\w\.\-\+]+                        # A username
  	:{0,1}                             # an optional colon to separate the username and password
  	[\w\.\-\+]*@                       # A password
  )?
  (?:[a-z0-9\-\.]+)                    # The domain limiting it to just allowed characters
  (?::[0-9]+)?                         # Server port number
  (?:                                  # The path (optional)
  	\/(?:[\w#!:"'\)\.\?\+=&%@!\-\/\(]+)|  # or a forward slash followed by a full path
  	\?(?:[\w#!:"'\)\.\?\+=&%@!\-\/\(]+)  # or a question mark followed by key value pairs
  )?/
  */

		var urlRegex = /((?:http|https):\/\/(?:[\w\.\-\+]+:{0,1}[\w\.\-\+]*@)?(?:[a-z0-9\-\.]+)(?::[0-9]+)?(?:\/(?:[\w#!:"'\)\.,\?\+=&%@!\-\~\/\(]+)|\?(?:[\w#!:"'\)\.,\?\+=&%@!\-\~\/\(]+))?)(?!http)/;

		var urls = text.split(urlRegex);

		var i;
		for (i = 0; i < urls.length; i += 2) {
			remainingTextCallback(urls[i]);
			if (urls[i + 1]) {
				appendUrl(elm, urls[i + 1], remainingTextCallback);
			}
		}
	}

	function newlines(elm, text, remainingTextCallback) {
		var parts = text.split(/\r\n|\n\r|\r|\n|\w*\[br\]\w*/);

		var i,
		    br = jQuery("<br>");
		for (i = 0; i < parts.length; i += 1) {
			elm.append(remainingTextCallback(parts[i]));
			if (i !== parts.length - 1) {
				elm.append(br.clone());
			}
		}
	}

	function emojifyReplacer(elm, text, remainingTextCallback) {
		var replaced = emojify.replace_colons(emojify.replace_unified(text));
		replaced = replaced.replace(/<span class="emoji-outer emoji-sizer"><span class="emoji-inner"([^>]*)><\/span><\/span>/g, ":emoji:$1:emoji:");
		var splitted = replaced.split(":emoji:");

		splitted.forEach(function (text) {
			if (text.indexOf(emojify.img_sets.apple.sheet) === -1) {
				elm.append(remainingTextCallback(text));
				return;
			}

			//;background-position:67.5% 27.5%;background-size:4100%" title="disappointed_relieved"
			var positionMatch = text.match(/background-position:([^;^"]*)/);
			var sizeMatch = text.match(/background-size:([^;^"]*)/);
			var titleMatch = text.match(/title="([^"]*)"/);

			if (!positionMatch || !sizeMatch || !titleMatch) {
				elm.append(remainingTextCallback(text));
				return;
			}

			var position = positionMatch[1];
			var size = sizeMatch[1];
			var title = titleMatch[1];

			if (!position.match(/^[0-9\.% ]*$/) && !size.match(/^[0-9\.%]*$/)) {
				elm.append(remainingTextCallback(text));
				return;
			}

			elm.append(emojiElementOuter.clone().append(emojiElementInner.clone().css("background-position", position).css("background-size", size).attr("title", title)));
		});
	}

	function createTextNode(elm, text) {
		elm.append(document.createTextNode(text));
	}

	var syntaxifier = [urlify, newlines, emojifyReplacer, createTextNode];

	function callSyntaxifier(number, elm, text) {
		syntaxifier[number](elm, text, function (text) {
			callSyntaxifier(number + 1, elm, text);
		});
	}

	return {
		restrict: "A",
		link: function link(scope, elm, attrs) {
			if (attrs.syntaxify) {
				scope.$watch(attrs.syntaxify, function (text) {
					if (text) {
						elm.html("");
						callSyntaxifier(0, elm, text);
					}
				});
			} else {
				$timeout(function () {
					var text = elm.text();
					elm.html("");

					callSyntaxifier(0, elm, text);
				});
			}
		}
	};
};

syntaxifyDirective.$inject = ["$timeout"];

directivesModule.directive("syntaxify", syntaxifyDirective);

/***/ })

},[4]);


// WEBPACK FOOTER //
// recovery.67f08406.js